'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ReactDOM = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
var ReactDOM__namespace = /*#__PURE__*/_interopNamespace(ReactDOM);

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$3 = React__default["default"],
  k$3 = Symbol["for"]("react.element"),
  l$3 = Symbol["for"]("react.fragment"),
  m$3 = Object.prototype.hasOwnProperty,
  n$3 = f$3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  p$3 = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function q$3(c, a, g) {
  var b,
    d = {},
    e = null,
    h = null;
  void 0 !== g && (e = "" + g);
  void 0 !== a.key && (e = "" + a.key);
  void 0 !== a.ref && (h = a.ref);
  for (b in a) m$3.call(a, b) && !p$3.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
  return {
    $$typeof: k$3,
    type: c,
    key: e,
    ref: h,
    props: d,
    _owner: n$3.current
  };
}
reactJsxRuntime_production_min.Fragment = l$3;
reactJsxRuntime_production_min.jsx = q$3;
reactJsxRuntime_production_min.jsxs = q$3;

var reactJsxRuntime_development = {};

if (process.env.NODE_ENV !== "production") {
  (function () {

    var React = React__default["default"];

    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol["for"]('react.element');
    var REACT_PORTAL_TYPE = Symbol["for"]('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol["for"]('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol["for"]('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol["for"]('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol["for"]('react.provider');
    var REACT_CONTEXT_TYPE = Symbol["for"]('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol["for"]('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol["for"]('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol["for"]('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol["for"]('react.memo');
    var REACT_LAZY_TYPE = Symbol["for"]('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol["for"]('react.offscreen');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
      if (maybeIterable === null || _typeof(maybeIterable) !== 'object') {
        return null;
      }
      var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
      if (typeof maybeIterator === 'function') {
        return maybeIterator;
      }
      return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
      {
        {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          printWarning('error', format, args);
        }
      }
    }
    function printWarning(level, format, args) {
      // When changing this logic, you might want to also
      // update consoleWithStackDev.www.js as well.
      {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
          format += '%s';
          args = args.concat([stack]);
        } // eslint-disable-next-line react-internal/safe-string-coercion

        var argsWithFormat = args.map(function (item) {
          return String(item);
        }); // Careful: RN currently depends on this prefix

        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging

        Function.prototype.apply.call(console[level], console, argsWithFormat);
      }
    }

    // -----------------------------------------------------------------------------

    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing

    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.

    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

    var REACT_MODULE_REFERENCE;
    {
      REACT_MODULE_REFERENCE = Symbol["for"]('react.module.reference');
    }
    function isValidElementType(type) {
      if (typeof type === 'string' || typeof type === 'function') {
        return true;
      } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

      if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
        return true;
      }
      if (_typeof(type) === 'object' && type !== null) {
        if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE ||
        // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
          return true;
        }
      }
      return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
      var displayName = outerType.displayName;
      if (displayName) {
        return displayName;
      }
      var functionName = innerType.displayName || innerType.name || '';
      return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber

    function getContextName(type) {
      return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.

    function getComponentNameFromType(type) {
      if (type == null) {
        // Host root, text node or just invalid type.
        return null;
      }
      {
        if (typeof type.tag === 'number') {
          error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
        }
      }
      if (typeof type === 'function') {
        return type.displayName || type.name || null;
      }
      if (typeof type === 'string') {
        return type;
      }
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return 'Fragment';
        case REACT_PORTAL_TYPE:
          return 'Portal';
        case REACT_PROFILER_TYPE:
          return 'Profiler';
        case REACT_STRICT_MODE_TYPE:
          return 'StrictMode';
        case REACT_SUSPENSE_TYPE:
          return 'Suspense';
        case REACT_SUSPENSE_LIST_TYPE:
          return 'SuspenseList';
      }
      if (_typeof(type) === 'object') {
        switch (type.$$typeof) {
          case REACT_CONTEXT_TYPE:
            var context = type;
            return getContextName(context) + '.Consumer';
          case REACT_PROVIDER_TYPE:
            var provider = type;
            return getContextName(provider._context) + '.Provider';
          case REACT_FORWARD_REF_TYPE:
            return getWrappedName(type, type.render, 'ForwardRef');
          case REACT_MEMO_TYPE:
            var outerName = type.displayName || null;
            if (outerName !== null) {
              return outerName;
            }
            return getComponentNameFromType(type.type) || 'Memo';
          case REACT_LAZY_TYPE:
            {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }

          // eslint-disable-next-line no-fallthrough
        }
      }
      return null;
    }
    var assign = Object.assign;

    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
      {
        if (disabledDepth === 0) {
          /* eslint-disable react-internal/no-production-logging */
          prevLog = console.log;
          prevInfo = console.info;
          prevWarn = console.warn;
          prevError = console.error;
          prevGroup = console.group;
          prevGroupCollapsed = console.groupCollapsed;
          prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

          var props = {
            configurable: true,
            enumerable: true,
            value: disabledLog,
            writable: true
          }; // $FlowFixMe Flow thinks console is immutable.

          Object.defineProperties(console, {
            info: props,
            log: props,
            warn: props,
            error: props,
            group: props,
            groupCollapsed: props,
            groupEnd: props
          });
          /* eslint-enable react-internal/no-production-logging */
        }
        disabledDepth++;
      }
    }
    function reenableLogs() {
      {
        disabledDepth--;
        if (disabledDepth === 0) {
          /* eslint-disable react-internal/no-production-logging */
          var props = {
            configurable: true,
            enumerable: true,
            writable: true
          }; // $FlowFixMe Flow thinks console is immutable.

          Object.defineProperties(console, {
            log: assign({}, props, {
              value: prevLog
            }),
            info: assign({}, props, {
              value: prevInfo
            }),
            warn: assign({}, props, {
              value: prevWarn
            }),
            error: assign({}, props, {
              value: prevError
            }),
            group: assign({}, props, {
              value: prevGroup
            }),
            groupCollapsed: assign({}, props, {
              value: prevGroupCollapsed
            }),
            groupEnd: assign({}, props, {
              value: prevGroupEnd
            })
          });
          /* eslint-enable react-internal/no-production-logging */
        }
        if (disabledDepth < 0) {
          error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
        }
      }
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
      {
        if (prefix === undefined) {
          // Extract the VM specific prefix used by each line.
          try {
            throw Error();
          } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
          }
        } // We use the prefix to ensure our stacks line up with native stack frames.

        return '\n' + prefix + name;
      }
    }
    var reentry = false;
    var componentFrameCache;
    {
      var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
      componentFrameCache = new PossiblyWeakMap();
    }
    function describeNativeComponentFrame(fn, construct) {
      // If something asked for a stack inside a fake render, it should get ignored.
      if (!fn || reentry) {
        return '';
      }
      {
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) {
          return frame;
        }
      }
      var control;
      reentry = true;
      var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

      Error.prepareStackTrace = undefined;
      var previousDispatcher;
      {
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.

        ReactCurrentDispatcher.current = null;
        disableLogs();
      }
      try {
        // This should throw.
        if (construct) {
          // Something should be setting the props in the constructor.
          var Fake = function Fake() {
            throw Error();
          }; // $FlowFixMe

          Object.defineProperty(Fake.prototype, 'props', {
            set: function set() {
              // We use a throwing setter instead of frozen or non-writable props
              // because that won't throw in a non-strict mode function.
              throw Error();
            }
          });
          if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === 'object' && Reflect.construct) {
            // We construct a different control for this case to include any extra
            // frames added by the construct call.
            try {
              Reflect.construct(Fake, []);
            } catch (x) {
              control = x;
            }
            Reflect.construct(fn, [], Fake);
          } else {
            try {
              Fake.call();
            } catch (x) {
              control = x;
            }
            fn.call(Fake.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (x) {
            control = x;
          }
          fn();
        }
      } catch (sample) {
        // This is inlined manually because closure doesn't do it for us.
        if (sample && control && typeof sample.stack === 'string') {
          // This extracts the first frame from the sample that isn't also in the control.
          // Skipping one frame that we assume is the frame that calls the two.
          var sampleLines = sample.stack.split('\n');
          var controlLines = control.stack.split('\n');
          var s = sampleLines.length - 1;
          var c = controlLines.length - 1;
          while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
            // We expect at least one stack frame to be shared.
            // Typically this will be the root most one. However, stack frames may be
            // cut off due to maximum stack limits. In this case, one maybe cut off
            // earlier than the other. We assume that the sample is longer or the same
            // and there for cut off earlier. So we should find the root most frame in
            // the sample somewhere in the control.
            c--;
          }
          for (; s >= 1 && c >= 0; s--, c--) {
            // Next we find the first one that isn't the same which should be the
            // frame that called our sample function and the control.
            if (sampleLines[s] !== controlLines[c]) {
              // In V8, the first line is describing the message but other VMs don't.
              // If we're about to return the first line, and the control is also on the same
              // line, that's a pretty good indicator that our sample threw at same line as
              // the control. I.e. before we entered the sample frame. So we ignore this result.
              // This can happen if you passed a class to function component, or non-function.
              if (s !== 1 || c !== 1) {
                do {
                  s--;
                  c--; // We may still have similar intermediate frames from the construct call.
                  // The next one that isn't the same should be our match though.

                  if (c < 0 || sampleLines[s] !== controlLines[c]) {
                    // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                    var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                    // but we have a user-provided "displayName"
                    // splice it in to make the stack more readable.

                    if (fn.displayName && _frame.includes('<anonymous>')) {
                      _frame = _frame.replace('<anonymous>', fn.displayName);
                    }
                    {
                      if (typeof fn === 'function') {
                        componentFrameCache.set(fn, _frame);
                      }
                    } // Return the line we found.

                    return _frame;
                  }
                } while (s >= 1 && c >= 0);
              }
              break;
            }
          }
        }
      } finally {
        reentry = false;
        {
          ReactCurrentDispatcher.current = previousDispatcher;
          reenableLogs();
        }
        Error.prepareStackTrace = previousPrepareStackTrace;
      } // Fallback to just using the name if we couldn't make it throw.

      var name = fn ? fn.displayName || fn.name : '';
      var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
      {
        if (typeof fn === 'function') {
          componentFrameCache.set(fn, syntheticFrame);
        }
      }
      return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
      {
        return describeNativeComponentFrame(fn, false);
      }
    }
    function shouldConstruct(Component) {
      var prototype = Component.prototype;
      return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
      if (type == null) {
        return '';
      }
      if (typeof type === 'function') {
        {
          return describeNativeComponentFrame(type, shouldConstruct(type));
        }
      }
      if (typeof type === 'string') {
        return describeBuiltInComponentFrame(type);
      }
      switch (type) {
        case REACT_SUSPENSE_TYPE:
          return describeBuiltInComponentFrame('Suspense');
        case REACT_SUSPENSE_LIST_TYPE:
          return describeBuiltInComponentFrame('SuspenseList');
      }
      if (_typeof(type) === 'object') {
        switch (type.$$typeof) {
          case REACT_FORWARD_REF_TYPE:
            return describeFunctionComponentFrame(type.render);
          case REACT_MEMO_TYPE:
            // Memo may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
          case REACT_LAZY_TYPE:
            {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                // Lazy may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {}
            }
        }
      }
      return '';
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
      {
        if (element) {
          var owner = element._owner;
          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
          ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else {
          ReactDebugCurrentFrame.setExtraStackFrame(null);
        }
      }
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
      {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.

            try {
              // This is intentionally an invariant that gets caught. It's the same
              // behavior as without this statement except with a better message.
              if (typeof typeSpecs[typeSpecName] !== 'function') {
                // eslint-disable-next-line react-internal/prod-error-codes
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof(typeSpecs[typeSpecName]) + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
              }
              error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
              error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
              setCurrentlyValidatingElement(element);
              error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, _typeof(error$1));
              setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
              // Only monitor this failure once because there tends to be a lot of the
              // same error.
              loggedTypeFailures[error$1.message] = true;
              setCurrentlyValidatingElement(element);
              error('Failed %s type: %s', location, error$1.message);
              setCurrentlyValidatingElement(null);
            }
          }
        }
      }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

    function isArray(a) {
      return isArrayImpl(a);
    }

    /*
     * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
     * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
     *
     * The functions in this module will throw an easier-to-understand,
     * easier-to-debug exception with a clear errors message message explaining the
     * problem. (Instead of a confusing exception thrown inside the implementation
     * of the `value` object).
     */
    // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
      {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
      }
    } // $FlowFixMe only called in DEV, so void return is not possible.

    function willCoercionThrow(value) {
      {
        try {
          testStringCoercion(value);
          return false;
        } catch (e) {
          return true;
        }
      }
    }
    function testStringCoercion(value) {
      // If you ended up here by following an exception call stack, here's what's
      // happened: you supplied an object or symbol value to React (as a prop, key,
      // DOM attribute, CSS property, string ref, etc.) and when React tried to
      // coerce it to a string using `'' + value`, an exception was thrown.
      //
      // The most common types that will cause this exception are `Symbol` instances
      // and Temporal objects like `Temporal.Instant`. But any object that has a
      // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
      // exception. (Library authors do this to prevent users from using built-in
      // numeric operators like `+` or comparison operators like `>=` because custom
      // methods are needed to perform accurate arithmetic or comparison.)
      //
      // To fix the problem, coerce this object or symbol value to a string before
      // passing it to React. The most reliable way is usually `String(value)`.
      //
      // To find which value is throwing, check the browser or debugger console.
      // Before this exception was thrown, there should be `console.error` output
      // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
      // problem and how that type was used: key, atrribute, input value prop, etc.
      // In most cases, this console output also shows the component and its
      // ancestor components where the exception happened.
      //
      // eslint-disable-next-line react-internal/safe-string-coercion
      return '' + value;
    }
    function checkKeyStringCoercion(value) {
      {
        if (willCoercionThrow(value)) {
          error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
          return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
      }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
      key: true,
      ref: true,
      __self: true,
      __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    {
      didWarnAboutStringRefs = {};
    }
    function hasValidRef(config) {
      {
        if (hasOwnProperty.call(config, 'ref')) {
          var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
          if (getter && getter.isReactWarning) {
            return false;
          }
        }
      }
      return config.ref !== undefined;
    }
    function hasValidKey(config) {
      {
        if (hasOwnProperty.call(config, 'key')) {
          var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
          if (getter && getter.isReactWarning) {
            return false;
          }
        }
      }
      return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
      {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
          var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
          if (!didWarnAboutStringRefs[componentName]) {
            error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
            didWarnAboutStringRefs[componentName] = true;
          }
        }
      }
    }
    function defineKeyPropWarningGetter(props, displayName) {
      {
        var warnAboutAccessingKey = function warnAboutAccessingKey() {
          if (!specialPropKeyWarningShown) {
            specialPropKeyWarningShown = true;
            error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
          }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
          get: warnAboutAccessingKey,
          configurable: true
        });
      }
    }
    function defineRefPropWarningGetter(props, displayName) {
      {
        var warnAboutAccessingRef = function warnAboutAccessingRef() {
          if (!specialPropRefWarningShown) {
            specialPropRefWarningShown = true;
            error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
          }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
          get: warnAboutAccessingRef,
          configurable: true
        });
      }
    }
    /**
     * Factory method to create a new React element. This no longer adheres to
     * the class pattern, so do not use new to call it. Also, instanceof check
     * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
     * if something is a React Element.
     *
     * @param {*} type
     * @param {*} props
     * @param {*} key
     * @param {string|object} ref
     * @param {*} owner
     * @param {*} self A *temporary* helper to detect places where `this` is
     * different from the `owner` when React.createElement is called, so that we
     * can warn. We want to get rid of owner and replace string `ref`s with arrow
     * functions, and as long as `this` and owner are the same, there will be no
     * change in behavior.
     * @param {*} source An annotation object (added by a transpiler or otherwise)
     * indicating filename, line number, and/or other information.
     * @internal
     */

    var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
      var element = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: REACT_ELEMENT_TYPE,
        // Built-in properties that belong on the element
        type: type,
        key: key,
        ref: ref,
        props: props,
        // Record the component responsible for creating this element.
        _owner: owner
      };
      {
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.

        Object.defineProperty(element._store, 'validated', {
          configurable: false,
          enumerable: false,
          writable: true,
          value: false
        }); // self and source are DEV only properties.

        Object.defineProperty(element, '_self', {
          configurable: false,
          enumerable: false,
          writable: false,
          value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.

        Object.defineProperty(element, '_source', {
          configurable: false,
          enumerable: false,
          writable: false,
          value: source
        });
        if (Object.freeze) {
          Object.freeze(element.props);
          Object.freeze(element);
        }
      }
      return element;
    };
    /**
     * https://github.com/reactjs/rfcs/pull/107
     * @param {*} type
     * @param {object} props
     * @param {string} key
     */

    function jsxDEV(type, config, maybeKey, source, self) {
      {
        var propName; // Reserved names are extracted

        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.

        if (maybeKey !== undefined) {
          {
            checkKeyStringCoercion(maybeKey);
          }
          key = '' + maybeKey;
        }
        if (hasValidKey(config)) {
          {
            checkKeyStringCoercion(config.key);
          }
          key = '' + config.key;
        }
        if (hasValidRef(config)) {
          ref = config.ref;
          warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object

        for (propName in config) {
          if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
            props[propName] = config[propName];
          }
        } // Resolve default props

        if (type && type.defaultProps) {
          var defaultProps = type.defaultProps;
          for (propName in defaultProps) {
            if (props[propName] === undefined) {
              props[propName] = defaultProps[propName];
            }
          }
        }
        if (key || ref) {
          var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
          if (key) {
            defineKeyPropWarningGetter(props, displayName);
          }
          if (ref) {
            defineRefPropWarningGetter(props, displayName);
          }
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
      }
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
      {
        if (element) {
          var owner = element._owner;
          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
          ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else {
          ReactDebugCurrentFrame$1.setExtraStackFrame(null);
        }
      }
    }
    var propTypesMisspellWarningShown;
    {
      propTypesMisspellWarningShown = false;
    }
    /**
     * Verifies the object is a ReactElement.
     * See https://reactjs.org/docs/react-api.html#isvalidelement
     * @param {?object} object
     * @return {boolean} True if `object` is a ReactElement.
     * @final
     */

    function isValidElement(object) {
      {
        return _typeof(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
    }
    function getDeclarationErrorAddendum() {
      {
        if (ReactCurrentOwner$1.current) {
          var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
          if (name) {
            return '\n\nCheck the render method of `' + name + '`.';
          }
        }
        return '';
      }
    }
    function getSourceInfoErrorAddendum(source) {
      {
        if (source !== undefined) {
          var fileName = source.fileName.replace(/^.*[\\\/]/, '');
          var lineNumber = source.lineNumber;
          return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
      }
    }
    /**
     * Warn if there's no key explicitly set on dynamic arrays of children or
     * object keys are not valid. This allows us to keep track of children between
     * updates.
     */

    var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
      {
        var info = getDeclarationErrorAddendum();
        if (!info) {
          var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
          if (parentName) {
            info = "\n\nCheck the top-level render call using <" + parentName + ">.";
          }
        }
        return info;
      }
    }
    /**
     * Warn if the element doesn't have an explicit key assigned to it.
     * This element is in an array. The array could grow and shrink or be
     * reordered. All children that haven't already been validated are required to
     * have a "key" property assigned to it. Error statuses are cached so a warning
     * will only be shown once.
     *
     * @internal
     * @param {ReactElement} element Element that requires a key.
     * @param {*} parentType element's parent's type.
     */

    function validateExplicitKey(element, parentType) {
      {
        if (!element._store || element._store.validated || element.key != null) {
          return;
        }
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
          return;
        }
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.

        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
          // Give the component that originally created this child.
          childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        }
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
      }
    }
    /**
     * Ensure that every element either is passed in a static location, in an
     * array with an explicit keys property defined, or in an object literal
     * with valid key property.
     *
     * @internal
     * @param {ReactNode} node Statically passed child of any type.
     * @param {*} parentType node's parent's type.
     */

    function validateChildKeys(node, parentType) {
      {
        if (_typeof(node) !== 'object') {
          return;
        }
        if (isArray(node)) {
          for (var i = 0; i < node.length; i++) {
            var child = node[i];
            if (isValidElement(child)) {
              validateExplicitKey(child, parentType);
            }
          }
        } else if (isValidElement(node)) {
          // This element was passed in a valid location.
          if (node._store) {
            node._store.validated = true;
          }
        } else if (node) {
          var iteratorFn = getIteratorFn(node);
          if (typeof iteratorFn === 'function') {
            // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            if (iteratorFn !== node.entries) {
              var iterator = iteratorFn.call(node);
              var step;
              while (!(step = iterator.next()).done) {
                if (isValidElement(step.value)) {
                  validateExplicitKey(step.value, parentType);
                }
              }
            }
          }
        }
      }
    }
    /**
     * Given an element, validate that its props follow the propTypes definition,
     * provided by the type.
     *
     * @param {ReactElement} element
     */

    function validatePropTypes(element) {
      {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') {
          return;
        }
        var propTypes;
        if (typeof type === 'function') {
          propTypes = type.propTypes;
        } else if (_typeof(type) === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE ||
        // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) {
          propTypes = type.propTypes;
        } else {
          return;
        }
        if (propTypes) {
          // Intentionally inside to avoid triggering lazy initializers:
          var name = getComponentNameFromType(type);
          checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
          propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

          var _name = getComponentNameFromType(type);
          error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
          error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
        }
      }
    }
    /**
     * Given a fragment, validate that it can only be provided with fragment props
     * @param {ReactElement} fragment
     */

    function validateFragmentProps(fragment) {
      {
        var keys = Object.keys(fragment.props);
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if (key !== 'children' && key !== 'key') {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
            setCurrentlyValidatingElement$1(null);
            break;
          }
        }
        if (fragment.ref !== null) {
          setCurrentlyValidatingElement$1(fragment);
          error('Invalid attribute `ref` supplied to `React.Fragment`.');
          setCurrentlyValidatingElement$1(null);
        }
      }
    }
    var didWarnAboutKeySpread = {};
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
      {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.

        if (!validType) {
          var info = '';
          if (type === undefined || _typeof(type) === 'object' && type !== null && Object.keys(type).length === 0) {
            info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
          }
          var sourceInfo = getSourceInfoErrorAddendum(source);
          if (sourceInfo) {
            info += sourceInfo;
          } else {
            info += getDeclarationErrorAddendum();
          }
          var typeString;
          if (type === null) {
            typeString = 'null';
          } else if (isArray(type)) {
            typeString = 'array';
          } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
            typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
            info = ' Did you accidentally export a JSX literal instead of a component?';
          } else {
            typeString = _typeof(type);
          }
          error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.

        if (element == null) {
          return element;
        } // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)

        if (validType) {
          var children = props.children;
          if (children !== undefined) {
            if (isStaticChildren) {
              if (isArray(children)) {
                for (var i = 0; i < children.length; i++) {
                  validateChildKeys(children[i], type);
                }
                if (Object.freeze) {
                  Object.freeze(children);
                }
              } else {
                error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
              }
            } else {
              validateChildKeys(children, type);
            }
          }
        }
        {
          if (hasOwnProperty.call(props, 'key')) {
            var componentName = getComponentNameFromType(type);
            var keys = Object.keys(props).filter(function (k) {
              return k !== 'key';
            });
            var beforeExample = keys.length > 0 ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}' : '{key: someKey}';
            if (!didWarnAboutKeySpread[componentName + beforeExample]) {
              var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}';
              error('A props object containing a "key" prop is being spread into JSX:\n' + '  let props = %s;\n' + '  <%s {...props} />\n' + 'React keys must be passed directly to JSX without using spread:\n' + '  let props = %s;\n' + '  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
              didWarnAboutKeySpread[componentName + beforeExample] = true;
            }
          }
        }
        if (type === REACT_FRAGMENT_TYPE) {
          validateFragmentProps(element);
        } else {
          validatePropTypes(element);
        }
        return element;
      }
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.

    function jsxWithValidationStatic(type, props, key) {
      {
        return jsxWithValidation(type, props, key, true);
      }
    }
    function jsxWithValidationDynamic(type, props, key) {
      {
        return jsxWithValidation(type, props, key, false);
      }
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions

    var jsxs = jsxWithValidationStatic;
    reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development.jsx = jsx;
    reactJsxRuntime_development.jsxs = jsxs;
  })();
}

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = reactJsxRuntime_production_min;
} else {
  jsxRuntime.exports = reactJsxRuntime_development;
}

var common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$1 = red;

var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
var purple$1 = purple;

var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$1 = blue;

var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
var lightBlue$1 = lightBlue;

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$1 = green;

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$1 = orange;

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
var grey$1 = grey;

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage$1(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe if we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
  /* eslint-disable prefer-template */
  var url = 'https://mui.com/production-error/?code=' + code;
  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

var formatMuiErrorMessage = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': formatMuiErrorMessage$1
});

var THEME_ID = '$$material';

function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize$1(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);

var isDevelopment$2 = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */

  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here

  return undefined;
}
function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);
  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }
  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}
var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;
    this._insertTag = function (tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === undefined ? !isDevelopment$2 : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {}
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;
      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';
var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign$1 = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash(value, length) {
  return charat(value, 0) ^ 45 ? (((length << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}

/**
 * @param {string} value
 * @return {string}
 */
function trim(value) {
  return value.trim();
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof(value, search) {
  return value.indexOf(search);
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr(value, begin, end) {
  return value.slice(begin, end);
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen(value) {
  return value.length;
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof(value) {
  return value.length;
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append(value, array) {
  return array.push(value), value;
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine(array, callback) {
  return array.map(callback).join('');
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node(value, root, parent, type, props, children, length) {
  return {
    value: value,
    root: root,
    parent: parent,
    type: type,
    props: props,
    children: children,
    line: line,
    column: column,
    length: length,
    "return": ''
  };
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy(root, props) {
  return assign$1(node('', null, null, '', null, null, 0), root, {
    length: -root.length
  }, props);
}

/**
 * @return {number}
 */
function _char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10) column = 1, line--;
  return character;
}

/**
 * @return {number}
 */
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10) column = 1, line++;
  return character;
}

/**
 * @return {number}
 */
function peek() {
  return charat(characters, position);
}

/**
 * @return {number}
 */
function caret() {
  return position;
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice(begin, end) {
  return substr(characters, begin, end);
}

/**
 * @param {number} type
 * @return {number}
 */
function token(type) {
  switch (type) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc(value) {
  return characters = '', value;
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace(type) {
  while (character = peek()) if (character < 33) next();else break;
  return token(type) > 2 || token(character) > 3 ? '' : ' ';
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping(index, count) {
  while (--count && next())
  // not 0-9 A-F a-f
  if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter(type) {
  while (next()) switch (character) {
    // ] ) " '
    case type:
      return position;
    // " '
    case 34:
    case 39:
      if (type !== 34 && type !== 39) delimiter(character);
      break;
    // (
    case 40:
      if (type === 41) delimiter(type);
      break;
    // \
    case 92:
      next();
      break;
  }
  return position;
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter(type, index) {
  while (next())
  // //
  if (type + character === 47 + 10) break;
  // /*
  else if (type + character === 42 + 42 && peek() === 47) break;
  return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next());
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier(index) {
  while (!token(peek())) next();
  return slice(index, position);
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile(value) {
  return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value));
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character = 0;
  var type = '';
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters = type;
  while (scanning) switch (previous = character, character = next()) {
    // (
    case 40:
      if (previous != 108 && charat(characters, length - 1) == 58) {
        if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
        break;
      }
    // " ' [
    case 34:
    case 39:
    case 91:
      characters += delimit(character);
      break;
    // \t \n \r \s
    case 9:
    case 10:
    case 13:
    case 32:
      characters += whitespace(previous);
      break;
    // \
    case 92:
      characters += escaping(caret() - 1, 7);
      continue;
    // /
    case 47:
      switch (peek()) {
        case 42:
        case 47:
          append(comment(commenter(next(), caret()), root, parent), declarations);
          break;
        default:
          characters += '/';
      }
      break;
    // {
    case 123 * variable:
      points[index++] = strlen(characters) * ampersand;
    // } ; \0
    case 125 * variable:
    case 59:
    case 0:
      switch (character) {
        // \0 }
        case 0:
        case 125:
          scanning = 0;
        // ;
        case 59 + offset:
          if (ampersand == -1) characters = replace(characters, /\f/g, '');
          if (property > 0 && strlen(characters) - length) append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
          break;
        // @ ;
        case 59:
          characters += ';';
        // { rule/at-rule
        default:
          append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
          if (character === 123) if (offset === 0) parse(characters, root, reference, reference, props, rulesets, length, points, children);else switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
            // d l m s
            case 100:
            case 108:
            case 109:
            case 115:
              parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
              break;
            default:
              parse(characters, reference, reference, reference, [''], children, 0, points, children);
          }
      }
      index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
      break;
    // :
    case 58:
      length = 1 + strlen(characters), property = previous;
    default:
      if (variable < 1) if (character == 123) --variable;else if (character == 125 && variable++ == 0 && prev() == 125) continue;
      switch (characters += from(character), character * variable) {
        // &
        case 38:
          ampersand = offset > 0 ? 1 : (characters += '\f', -1);
          break;
        // ,
        case 44:
          points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
          break;
        // @
        case 64:
          // -
          if (peek() === 45) characters += delimit(next());
          atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
          break;
        // -
        case 45:
          if (previous === 45 && strlen(characters) == 2) variable = 0;
      }
  }
  return rulesets;
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [''];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index; ++i) for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x) if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x]))) props[k++] = z;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length);
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(_char()), substr(value, 2, -2), 0);
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration(value, root, parent, length) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length);
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize(children, callback) {
  var output = '';
  var length = sizeof(children);
  for (var i = 0; i < length; i++) output += callback(children[i], i, children, callback) || '';
  return output;
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify(element, index, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element["return"] = element["return"] || element.value;
    case COMMENT:
      return '';
    case KEYFRAMES:
      return element["return"] = element.value + '{' + serialize(element.children, callback) + '}';
    case RULESET:
      element.value = element.props.join(',');
  }
  return strlen(children = serialize(element.children, callback)) ? element["return"] = element.value + '{' + children + '}' : '';
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware(collection) {
  var length = sizeof(collection);
  return function (element, index, children, callback) {
    var output = '';
    for (var i = 0; i < length; i++) output += collection[i](element, index, children, callback) || '';
    return output;
  };
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet(callback) {
  return function (element) {
    if (!element.root) if (element = element["return"]) callback(element);
  };
}

var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // Use non-null assertion because we just checked that the cache `has` it
      // This allows us to remove `undefined` from the return value
      return cache.get(arg);
    }
    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var isBrowser$4 = typeof document !== 'undefined';
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;
  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }
    if (token(character)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;
  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character);
        break;
      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());
  return parsed;
};
var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11

var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent ||
  // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value,
    parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case

  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */ && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"

  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;
    if (
    // charcode for l
    value.charCodeAt(0) === 108 &&
    // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }
      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;
    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);
    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }
        return '';
      });
  }
};

/* import type { StylisPlugin } from './types' */

/*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/

var getServerStylisCache = isBrowser$4 ? undefined : weakMemoize(function () {
  return memoize$1(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];
var createCache = function /*: EmotionCache */
createCache(options
/*: Options */) {
  var key = options.key;
  if (isBrowser$4 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node
    /*: HTMLStyleElement */) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');
      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  /* : Node */

  var nodesToHydrate = [];
  if (isBrowser$4) {
    container = options.container || document.head;
    Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node
    /*: HTMLStyleElement */) {
      var attrib = node.getAttribute("data-emotion").split(' ');
      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }
      nodesToHydrate.push(node);
    });
  }
  var _insert;
  /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */

  var omnipresentPlugins = [compat, removeLabel];
  if (isBrowser$4) {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function /*: void */
    insert(selector
    /*: string */, serialized
    /*: SerializedStyles */, sheet
    /*: StyleSheet */, shouldCache
    /*: boolean */) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];
    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    };
    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
    var getRules = function /*: string */
    getRules(selector
    /*: string */, serialized
    /*: SerializedStyles */) {
      var name = serialized.name;
      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }
      return serverStylisCache[name];
    };
    _insert = function /*: string | void */
    _insert(selector
    /*: string */, serialized
    /*: SerializedStyles */, sheet
    /*: StyleSheet */, shouldCache
    /*: boolean */) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);
      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }
        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }
  var cache
  /*: EmotionCache */ = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs$3 = {exports: {}};

var reactIs_production_min$2 = {};

var b$2 = "function" === typeof Symbol && Symbol["for"],
  c$2 = b$2 ? Symbol["for"]("react.element") : 60103,
  d$2 = b$2 ? Symbol["for"]("react.portal") : 60106,
  e$2 = b$2 ? Symbol["for"]("react.fragment") : 60107,
  f$2 = b$2 ? Symbol["for"]("react.strict_mode") : 60108,
  g$2 = b$2 ? Symbol["for"]("react.profiler") : 60114,
  h$2 = b$2 ? Symbol["for"]("react.provider") : 60109,
  k$2 = b$2 ? Symbol["for"]("react.context") : 60110,
  l$2 = b$2 ? Symbol["for"]("react.async_mode") : 60111,
  m$2 = b$2 ? Symbol["for"]("react.concurrent_mode") : 60111,
  n$2 = b$2 ? Symbol["for"]("react.forward_ref") : 60112,
  p$2 = b$2 ? Symbol["for"]("react.suspense") : 60113,
  q$2 = b$2 ? Symbol["for"]("react.suspense_list") : 60120,
  r$2 = b$2 ? Symbol["for"]("react.memo") : 60115,
  t$2 = b$2 ? Symbol["for"]("react.lazy") : 60116,
  v$2 = b$2 ? Symbol["for"]("react.block") : 60121,
  w$1 = b$2 ? Symbol["for"]("react.fundamental") : 60117,
  x$1 = b$2 ? Symbol["for"]("react.responder") : 60118,
  y$1 = b$2 ? Symbol["for"]("react.scope") : 60119;
function z$1(a) {
  if ("object" === _typeof(a) && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c$2:
        switch (a = a.type, a) {
          case l$2:
          case m$2:
          case e$2:
          case g$2:
          case f$2:
          case p$2:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$2:
              case n$2:
              case t$2:
              case r$2:
              case h$2:
                return a;
              default:
                return u;
            }
        }
      case d$2:
        return u;
    }
  }
}
function A$1(a) {
  return z$1(a) === m$2;
}
reactIs_production_min$2.AsyncMode = l$2;
reactIs_production_min$2.ConcurrentMode = m$2;
reactIs_production_min$2.ContextConsumer = k$2;
reactIs_production_min$2.ContextProvider = h$2;
reactIs_production_min$2.Element = c$2;
reactIs_production_min$2.ForwardRef = n$2;
reactIs_production_min$2.Fragment = e$2;
reactIs_production_min$2.Lazy = t$2;
reactIs_production_min$2.Memo = r$2;
reactIs_production_min$2.Portal = d$2;
reactIs_production_min$2.Profiler = g$2;
reactIs_production_min$2.StrictMode = f$2;
reactIs_production_min$2.Suspense = p$2;
reactIs_production_min$2.isAsyncMode = function (a) {
  return A$1(a) || z$1(a) === l$2;
};
reactIs_production_min$2.isConcurrentMode = A$1;
reactIs_production_min$2.isContextConsumer = function (a) {
  return z$1(a) === k$2;
};
reactIs_production_min$2.isContextProvider = function (a) {
  return z$1(a) === h$2;
};
reactIs_production_min$2.isElement = function (a) {
  return "object" === _typeof(a) && null !== a && a.$$typeof === c$2;
};
reactIs_production_min$2.isForwardRef = function (a) {
  return z$1(a) === n$2;
};
reactIs_production_min$2.isFragment = function (a) {
  return z$1(a) === e$2;
};
reactIs_production_min$2.isLazy = function (a) {
  return z$1(a) === t$2;
};
reactIs_production_min$2.isMemo = function (a) {
  return z$1(a) === r$2;
};
reactIs_production_min$2.isPortal = function (a) {
  return z$1(a) === d$2;
};
reactIs_production_min$2.isProfiler = function (a) {
  return z$1(a) === g$2;
};
reactIs_production_min$2.isStrictMode = function (a) {
  return z$1(a) === f$2;
};
reactIs_production_min$2.isSuspense = function (a) {
  return z$1(a) === p$2;
};
reactIs_production_min$2.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e$2 || a === m$2 || a === g$2 || a === f$2 || a === p$2 || a === q$2 || "object" === _typeof(a) && null !== a && (a.$$typeof === t$2 || a.$$typeof === r$2 || a.$$typeof === h$2 || a.$$typeof === k$2 || a.$$typeof === n$2 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$2);
};
reactIs_production_min$2.typeOf = z$1;

var reactIs_development$2 = {};

if (process.env.NODE_ENV !== "production") {
  (function () {

    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
      if (_typeof(object) === 'object' && object !== null) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;
            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;
              default:
                var $$typeofType = type && type.$$typeof;
                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode

    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
      return _typeof(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    reactIs_development$2.AsyncMode = AsyncMode;
    reactIs_development$2.ConcurrentMode = ConcurrentMode;
    reactIs_development$2.ContextConsumer = ContextConsumer;
    reactIs_development$2.ContextProvider = ContextProvider;
    reactIs_development$2.Element = Element;
    reactIs_development$2.ForwardRef = ForwardRef;
    reactIs_development$2.Fragment = Fragment;
    reactIs_development$2.Lazy = Lazy;
    reactIs_development$2.Memo = Memo;
    reactIs_development$2.Portal = Portal;
    reactIs_development$2.Profiler = Profiler;
    reactIs_development$2.StrictMode = StrictMode;
    reactIs_development$2.Suspense = Suspense;
    reactIs_development$2.isAsyncMode = isAsyncMode;
    reactIs_development$2.isConcurrentMode = isConcurrentMode;
    reactIs_development$2.isContextConsumer = isContextConsumer;
    reactIs_development$2.isContextProvider = isContextProvider;
    reactIs_development$2.isElement = isElement;
    reactIs_development$2.isForwardRef = isForwardRef;
    reactIs_development$2.isFragment = isFragment;
    reactIs_development$2.isLazy = isLazy;
    reactIs_development$2.isMemo = isMemo;
    reactIs_development$2.isPortal = isPortal;
    reactIs_development$2.isProfiler = isProfiler;
    reactIs_development$2.isStrictMode = isStrictMode;
    reactIs_development$2.isSuspense = isSuspense;
    reactIs_development$2.isValidElementType = isValidElementType;
    reactIs_development$2.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$3.exports = reactIs_production_min$2;
} else {
  reactIs$3.exports = reactIs_development$2;
}

var reactIs$2 = reactIs$3.exports;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$2.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$2.Memo] = MEMO_STATICS;

var isBrowser$3 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false ||
  // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$3 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;
    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
      if (!isBrowser$3 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }
      current = current.next;
    } while (current !== undefined);
    if (!isBrowser$3 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var isDevelopment$1 = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== undefined) {
    return componentSelector;
  }
  switch (_typeof(interpolation)) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        var keyframes = interpolation;
        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }
        var serializedStyles = interpolation;
        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;
          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }
          var styles = serializedStyles.styles + ";";
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }
        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)

  var asString = interpolation;
  if (registered == null) {
    return asString;
  }
  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];
      if (_typeof(value) !== 'object') {
        var asString = value;
        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment$1) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && _typeof(args[0]) === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles += templateStringsArr[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name: name,
    styles: styles,
    next: cursor
  };
}

var isBrowser$2 = typeof document !== 'undefined';
var syncFallback = function syncFallback(create) {
  return create();
};
var useInsertionEffect = React__namespace['useInsertion' + 'Effect'] ? React__namespace['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$2 ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || React__namespace.useLayoutEffect;

var isBrowser$1 = typeof document !== 'undefined';

/* import { type EmotionCache } from '@emotion/utils' */
var EmotionCacheContext
/*: React.Context<EmotionCache | null> */ = /* #__PURE__ */React__namespace.createContext(
// we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache
/* <Props, Ref: React.Ref<*>> */(func
/*: (props: Props, cache: EmotionCache, ref: Ref) => React.Node */) /*: React.AbstractComponent<Props> */
{
  return /*#__PURE__*/React.forwardRef(function (props
  /*: Props */, ref
  /*: Ref */) {
    // the cache will never be null in the browser
    var cache = React.useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
if (!isBrowser$1) {
  withEmotionCache = function withEmotionCache
  /* <Props> */(func
  /*: (props: Props, cache: EmotionCache) => React.Node */) /*: React.StatelessFunctionalComponent<Props> */
  {
    return function (props
    /*: Props */) {
      var cache = React.useContext(EmotionCacheContext);
      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/React__namespace.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}
var ThemeContext = /* #__PURE__ */React__namespace.createContext({});

// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global
/*: React.AbstractComponent<
GlobalProps
> */ = /* #__PURE__ */withEmotionCache(function (props
/*: GlobalProps */, cache) {
  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, React__namespace.useContext(ThemeContext));
  if (!isBrowser$1) {
    var _ref;
    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }
    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);
    if (shouldCache) {
      return null;
    }
    return /*#__PURE__*/React__namespace.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything

  var sheetRef = React__namespace.useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false;
    var node
    /*: HTMLStyleElement | null*/ = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }
    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }
    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
      rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }
    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */

function css() /*: SerializedStyles */
{
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}

/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/

var keyframes = function /*: Keyframes */
keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */
/*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/

var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key
/*: string */) {
  return key !== 'theme';
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag
/*: ElementType */) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag
/*: PrivateStyledComponent<any> */, options
/*: StyledOptions | void */, isReal
/*: boolean */) {
  var shouldForwardProp;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName
    /*: string */) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }
  return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/

var isDevelopment = false;
var isBrowser = typeof document !== 'undefined';
var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
    serialized = _ref.serialized,
    isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });
  if (!isBrowser && rules !== undefined) {
    var _ref2;
    var serializedNames = serialized.name;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }
    return /*#__PURE__*/React__namespace.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }
  return null;
};
var createStyled$3
/*: CreateStyled */ = function createStyled
/*: CreateStyled */(tag
/*: any */, options
/* ?: StyledOptions */) {
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  /* return function<Props>(): PrivateStyledComponent<Props> { */

  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        styles.push(args[i], args[0][i]);
      }
    }
    var Styled
    /*: PrivateStyledComponent<Props> */ = withEmotionCache(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = React__namespace.useContext(ThemeContext);
      }
      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;
      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;
        if (finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      if (ref) {
        newProps.ref = ref;
      }
      return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/React__namespace.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && isDevelopment) {
          return 'NO_COMPONENT_SELECTOR';
        }
        return "." + targetClassName;
      }
    });
    Styled.withComponent = function (nextTag
    /*: StyledElementType<Props> */, nextOptions
    /* ?: StyledOptions */) {
      return createStyled(nextTag, _extends$1({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };
    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
var newStyled = createStyled$3.bind();
tags.forEach(function (tagName) {
  newStyled[tagName] = newStyled(tagName);
});

var propTypes = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min$1 = {};

var b$1 = "function" === typeof Symbol && Symbol["for"],
  c$1 = b$1 ? Symbol["for"]("react.element") : 60103,
  d$1 = b$1 ? Symbol["for"]("react.portal") : 60106,
  e$1 = b$1 ? Symbol["for"]("react.fragment") : 60107,
  f$1 = b$1 ? Symbol["for"]("react.strict_mode") : 60108,
  g$1 = b$1 ? Symbol["for"]("react.profiler") : 60114,
  h$1 = b$1 ? Symbol["for"]("react.provider") : 60109,
  k$1 = b$1 ? Symbol["for"]("react.context") : 60110,
  l$1 = b$1 ? Symbol["for"]("react.async_mode") : 60111,
  m$1 = b$1 ? Symbol["for"]("react.concurrent_mode") : 60111,
  n$1 = b$1 ? Symbol["for"]("react.forward_ref") : 60112,
  p$1 = b$1 ? Symbol["for"]("react.suspense") : 60113,
  q$1 = b$1 ? Symbol["for"]("react.suspense_list") : 60120,
  r$1 = b$1 ? Symbol["for"]("react.memo") : 60115,
  t$1 = b$1 ? Symbol["for"]("react.lazy") : 60116,
  v$1 = b$1 ? Symbol["for"]("react.block") : 60121,
  w = b$1 ? Symbol["for"]("react.fundamental") : 60117,
  x = b$1 ? Symbol["for"]("react.responder") : 60118,
  y = b$1 ? Symbol["for"]("react.scope") : 60119;
function z(a) {
  if ("object" === _typeof(a) && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c$1:
        switch (a = a.type, a) {
          case l$1:
          case m$1:
          case e$1:
          case g$1:
          case f$1:
          case p$1:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n$1:
              case t$1:
              case r$1:
              case h$1:
                return a;
              default:
                return u;
            }
        }
      case d$1:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m$1;
}
reactIs_production_min$1.AsyncMode = l$1;
reactIs_production_min$1.ConcurrentMode = m$1;
reactIs_production_min$1.ContextConsumer = k$1;
reactIs_production_min$1.ContextProvider = h$1;
reactIs_production_min$1.Element = c$1;
reactIs_production_min$1.ForwardRef = n$1;
reactIs_production_min$1.Fragment = e$1;
reactIs_production_min$1.Lazy = t$1;
reactIs_production_min$1.Memo = r$1;
reactIs_production_min$1.Portal = d$1;
reactIs_production_min$1.Profiler = g$1;
reactIs_production_min$1.StrictMode = f$1;
reactIs_production_min$1.Suspense = p$1;
reactIs_production_min$1.isAsyncMode = function (a) {
  return A(a) || z(a) === l$1;
};
reactIs_production_min$1.isConcurrentMode = A;
reactIs_production_min$1.isContextConsumer = function (a) {
  return z(a) === k$1;
};
reactIs_production_min$1.isContextProvider = function (a) {
  return z(a) === h$1;
};
reactIs_production_min$1.isElement = function (a) {
  return "object" === _typeof(a) && null !== a && a.$$typeof === c$1;
};
reactIs_production_min$1.isForwardRef = function (a) {
  return z(a) === n$1;
};
reactIs_production_min$1.isFragment = function (a) {
  return z(a) === e$1;
};
reactIs_production_min$1.isLazy = function (a) {
  return z(a) === t$1;
};
reactIs_production_min$1.isMemo = function (a) {
  return z(a) === r$1;
};
reactIs_production_min$1.isPortal = function (a) {
  return z(a) === d$1;
};
reactIs_production_min$1.isProfiler = function (a) {
  return z(a) === g$1;
};
reactIs_production_min$1.isStrictMode = function (a) {
  return z(a) === f$1;
};
reactIs_production_min$1.isSuspense = function (a) {
  return z(a) === p$1;
};
reactIs_production_min$1.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$1 || a === f$1 || a === p$1 || a === q$1 || "object" === _typeof(a) && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === n$1 || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v$1);
};
reactIs_production_min$1.typeOf = z;

var reactIs_development$1 = {};

if (process.env.NODE_ENV !== "production") {
  (function () {

    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
      if (_typeof(object) === 'object' && object !== null) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;
            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;
              default:
                var $$typeofType = type && type.$$typeof;
                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode

    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
      return _typeof(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    reactIs_development$1.AsyncMode = AsyncMode;
    reactIs_development$1.ConcurrentMode = ConcurrentMode;
    reactIs_development$1.ContextConsumer = ContextConsumer;
    reactIs_development$1.ContextProvider = ContextProvider;
    reactIs_development$1.Element = Element;
    reactIs_development$1.ForwardRef = ForwardRef;
    reactIs_development$1.Fragment = Fragment;
    reactIs_development$1.Lazy = Lazy;
    reactIs_development$1.Memo = Memo;
    reactIs_development$1.Portal = Portal;
    reactIs_development$1.Profiler = Profiler;
    reactIs_development$1.StrictMode = StrictMode;
    reactIs_development$1.Suspense = Suspense;
    reactIs_development$1.isAsyncMode = isAsyncMode;
    reactIs_development$1.isConcurrentMode = isConcurrentMode;
    reactIs_development$1.isContextConsumer = isContextConsumer;
    reactIs_development$1.isContextProvider = isContextProvider;
    reactIs_development$1.isElement = isElement;
    reactIs_development$1.isForwardRef = isForwardRef;
    reactIs_development$1.isFragment = isFragment;
    reactIs_development$1.isLazy = isLazy;
    reactIs_development$1.isMemo = isMemo;
    reactIs_development$1.isPortal = isPortal;
    reactIs_development$1.isProfiler = isProfiler;
    reactIs_development$1.isStrictMode = isStrictMode;
    reactIs_development$1.isSuspense = isSuspense;
    reactIs_development$1.isValidElementType = isValidElementType;
    reactIs_development$1.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min$1;
} else {
  reactIs$1.exports = reactIs_development$1;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;
  printWarning$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {/**/}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof(typeSpecs[typeSpecName]) + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes$1;

var ReactIs$1 = reactIs$1.exports;
var assign = objectAssign;
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;
var printWarning = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && _typeof(data) === 'object' ? data : {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (_typeof(propValue)) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = _typeof(propValue);
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$1.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;

var cache;
if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
  cache = createCache({
    key: 'css',
    prepend: true
  });
}
function StyledEngineProvider(props) {
  var injectFirst = props.injectFirst,
    children = props.children;
  return injectFirst && cache ? /*#__PURE__*/jsxRuntime.exports.jsx(CacheProvider, {
    value: cache,
    children: children
  }) : children;
}
process.env.NODE_ENV !== "production" ? StyledEngineProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: PropTypes.bool
} : void 0;

function isEmpty$2(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
  var styles = props.styles,
    _props$defaultTheme = props.defaultTheme,
    defaultTheme = _props$defaultTheme === void 0 ? {} : _props$defaultTheme;
  var globalStyles = typeof styles === 'function' ? function (themeInput) {
    return styles(isEmpty$2(themeInput) ? defaultTheme : themeInput);
  } : styles;
  return /*#__PURE__*/jsxRuntime.exports.jsx(Global, {
    styles: globalStyles
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
} : void 0;

/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$3(tag, options) {
  var stylesFactory = newStyled(tag, options);
  if (process.env.NODE_ENV !== 'production') {
    return function () {
      var component = typeof tag === 'string' ? "\"".concat(tag, "\"") : 'component';
      for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
        styles[_key] = arguments[_key];
      }
      if (styles.length === 0) {
        console.error(["MUI: Seems like you called `styled(".concat(component, ")()` without a `style` argument."), 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join('\n'));
      } else if (styles.some(function (style) {
        return style === undefined;
      })) {
        console.error("MUI: the styled(".concat(component, ")(...args) API requires all its args to be defined."));
      }
      return stylesFactory.apply(void 0, styles);
    };
  }
  return stylesFactory;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
var internal_processStyles = function internal_processStyles(tag, processor) {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};

var styledEngine = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': styled$3,
  internal_processStyles: internal_processStyles,
  ThemeContext: ThemeContext,
  keyframes: keyframes,
  css: css,
  StyledEngineProvider: StyledEngineProvider,
  GlobalStyles: GlobalStyles
});

// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function isPlainObject(item) {
  if (_typeof(item) !== 'object' || item === null) {
    return false;
  }
  var prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (!isPlainObject(source)) {
    return source;
  }
  var output = {};
  Object.keys(source).forEach(function (key) {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge$1(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends$1({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isPlainObject(source[key]) &&
      // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge$1(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

var deepmerge = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': deepmerge$1,
  isPlainObject: isPlainObject
});

var _excluded$A = ["values", "unit", "step"];
var sortBreakpointsValues = function sortBreakpointsValues(values) {
  var breakpointsAsArray = Object.keys(values).map(function (key) {
    return {
      key: key,
      val: values[key]
    };
  }) || [];
  // Sort in ascending order
  breakpointsAsArray.sort(function (breakpoint1, breakpoint2) {
    return breakpoint1.val - breakpoint2.val;
  });
  return breakpointsAsArray.reduce(function (acc, obj) {
    return _extends$1({}, acc, _defineProperty({}, obj.key, obj.val));
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
    values = _breakpoints$values === void 0 ? {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536 // large screen
    } : _breakpoints$values,
    _breakpoints$unit = breakpoints.unit,
    unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
    _breakpoints$step = breakpoints.step,
    step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
    other = _objectWithoutPropertiesLoose(breakpoints, _excluded$A);
  var sortedValues = sortBreakpointsValues(values);
  var keys = Object.keys(sortedValues);
  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }
  function down(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }
  function between(start, end) {
    var endIndex = keys.indexOf(end);
    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100).concat(unit, ")");
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    var keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return _extends$1({
    keys: keys,
    values: sortedValues,
    up: up,
    down: down,
    between: between,
    only: only,
    not: not,
    unit: unit
  }, other);
}

var shape = {
  borderRadius: 4
};
var shape$1 = shape;

var responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
var responsivePropType$1 = responsivePropType;

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge$1(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}

// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
var values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values$1[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  var theme = props.theme || {};
  if (Array.isArray(propValue)) {
    var themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (_typeof(propValue) === 'object') {
    var _themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      // key is breakpoint
      if (Object.keys(_themeBreakpoints.values || values$1).indexOf(breakpoint) !== -1) {
        var mediaKey = _themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        var cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  var output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject() {
  var breakpointsInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _breakpointsInput$key;
  var breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce(function (acc, key) {
    var breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce(function (acc, key) {
    var breakpointOutput = acc[key];
    var isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style);
}
function mergeBreakpointsInOrder(breakpointsInput) {
  var emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
  for (var _len = arguments.length, styles = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    styles[_key - 1] = arguments[_key];
  }
  var mergedOutput = [emptyBreakpoints].concat(styles).reduce(function (prev, next) {
    return deepmerge$1(prev, next);
  }, {});
  return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}

// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  // fixed value
  if (_typeof(breakpointValues) !== 'object') {
    return {};
  }
  var base = {};
  var breakpointsKeys = Object.keys(themeBreakpoints);
  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach(function (breakpoint, i) {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach(function (breakpoint) {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }
  return base;
}
function resolveBreakpointValues(_ref) {
  var breakpointValues = _ref.values,
    themeBreakpoints = _ref.breakpoints,
    customBase = _ref.base;
  var base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  var keys = Object.keys(base);
  if (keys.length === 0) {
    return breakpointValues;
  }
  var previous;
  return keys.reduce(function (acc, breakpoint, i) {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (_typeof(breakpointValues) === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }
    return acc;
  }, {});
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize$1(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage$1(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var capitalize = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': capitalize$1
});

function getPath(obj, path) {
  var checkVars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    var val = "vars.".concat(path).split('.').reduce(function (acc, item) {
      return acc && acc[item] ? acc[item] : null;
    }, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce(function (acc, item) {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal) {
  var userValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : propValueFinal;
  var value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style$2(options) {
  var prop = options.prop,
    _options$cssProperty = options.cssProperty,
    cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
    themeKey = options.themeKey,
    transform = options.transform;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  var fn = function fn(props) {
    if (props[prop] == null) {
      return null;
    }
    var propValue = props[prop];
    var theme = props.theme;
    var themeMapping = getPath(theme, themeKey) || {};
    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
      var value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, "".concat(prop).concat(propValueFinal === 'default' ? '' : capitalize$1(propValueFinal)), propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return _defineProperty({}, cssProperty, value);
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? _defineProperty({}, prop, responsivePropType$1) : {};
  fn.filterProps = [prop];
  return fn;
}

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var getCssProperties = memoize(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  var _prop$split = prop.split(''),
    _prop$split2 = _slicedToArray(_prop$split, 2),
    a = _prop$split2[0],
    b = _prop$split2[1];
  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
var paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
var spacingKeys = [].concat(marginKeys, paddingKeys);
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  var themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (typeof abs === 'string') {
        return abs;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error("MUI: Expected ".concat(propName, " argument to be a number or a string, got ").concat(abs, "."));
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (typeof abs === 'string') {
        return abs;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (!Number.isInteger(abs)) {
          console.error(["MUI: The `theme.".concat(themeKey, "` array type cannot be combined with non integer values.") + "You should either use an integer value that can be used as index, or define the `theme.".concat(themeKey, "` as a number.")].join('\n'));
        } else if (abs > themeSpacing.length - 1) {
          console.error(["MUI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.error(["MUI: The `theme.".concat(themeKey, "` value (").concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }
  return function () {
    return undefined;
  };
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  var abs = Math.abs(propValue);
  var transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === 'number') {
    return -transformed;
  }
  return "-".concat(transformed);
}
function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}
function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  var cssProperties = getCssProperties(prop);
  var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  var propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style$1(props, keys) {
  var transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(function (prop) {
    return resolveCssProperty(props, keys, prop, transformer);
  }).reduce(merge, {});
}
function margin(props) {
  return style$1(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== 'production' ? marginKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style$1(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== 'production' ? paddingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};

// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.

function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  }

  // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://m2.material.io/design/layout/understanding-layout.html
  var transform = createUnarySpacing({
    spacing: spacingInput
  });
  var spacing = function spacing() {
    for (var _len = arguments.length, argsInput = new Array(_len), _key = 0; _key < _len; _key++) {
      argsInput[_key] = arguments[_key];
    }
    if (process.env.NODE_ENV !== 'production') {
      if (!(argsInput.length <= 4)) {
        console.error("MUI: Too many arguments provided, expected between 0 and 4, got ".concat(argsInput.length));
      }
    }
    var args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(function (argument) {
      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  };
  spacing.mui = true;
  return spacing;
}

function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  var handlers = styles.reduce(function (acc, style) {
    style.filterProps.forEach(function (prop) {
      acc[prop] = style;
    });
    return acc;
  }, {});

  // false positive
  // eslint-disable-next-line react/function-component-definition
  var fn = function fn(props) {
    return Object.keys(props).reduce(function (acc, prop) {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? styles.reduce(function (acc, style) {
    return Object.assign(acc, style.propTypes);
  }, {}) : {};
  fn.filterProps = styles.reduce(function (acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  return fn;
}

function borderTransform(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return "".concat(value, "px solid");
}
function createBorderStyle(prop, transform) {
  return style$2({
    prop: prop,
    themeKey: 'borders',
    transform: transform
  });
}
var border = createBorderStyle('border', borderTransform);
var borderTop = createBorderStyle('borderTop', borderTransform);
var borderRight = createBorderStyle('borderRight', borderTransform);
var borderBottom = createBorderStyle('borderBottom', borderTransform);
var borderLeft = createBorderStyle('borderLeft', borderTransform);
var borderColor = createBorderStyle('borderColor');
var borderTopColor = createBorderStyle('borderTopColor');
var borderRightColor = createBorderStyle('borderRightColor');
var borderBottomColor = createBorderStyle('borderBottomColor');
var borderLeftColor = createBorderStyle('borderLeftColor');
var outline = createBorderStyle('outline', borderTransform);
var outlineColor = createBorderStyle('outlineColor');

// false positive
// eslint-disable-next-line react/function-component-definition
var borderRadius = function borderRadius(props) {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    var transformer = createUnaryUnit(props.theme, 'shape.borderRadius', 4, 'borderRadius');
    var styleFromPropValue = function styleFromPropValue(propValue) {
      return {
        borderRadius: getValue(transformer, propValue)
      };
    };
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== 'production' ? {
  borderRadius: responsivePropType$1
} : {};
borderRadius.filterProps = ['borderRadius'];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);

// false positive
// eslint-disable-next-line react/function-component-definition
var gap = function gap(props) {
  if (props.gap !== undefined && props.gap !== null) {
    var transformer = createUnaryUnit(props.theme, 'spacing', 8, 'gap');
    var styleFromPropValue = function styleFromPropValue(propValue) {
      return {
        gap: getValue(transformer, propValue)
      };
    };
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== 'production' ? {
  gap: responsivePropType$1
} : {};
gap.filterProps = ['gap'];

// false positive
// eslint-disable-next-line react/function-component-definition
var columnGap = function columnGap(props) {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    var transformer = createUnaryUnit(props.theme, 'spacing', 8, 'columnGap');
    var styleFromPropValue = function styleFromPropValue(propValue) {
      return {
        columnGap: getValue(transformer, propValue)
      };
    };
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  columnGap: responsivePropType$1
} : {};
columnGap.filterProps = ['columnGap'];

// false positive
// eslint-disable-next-line react/function-component-definition
var rowGap = function rowGap(props) {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    var transformer = createUnaryUnit(props.theme, 'spacing', 8, 'rowGap');
    var styleFromPropValue = function styleFromPropValue(propValue) {
      return {
        rowGap: getValue(transformer, propValue)
      };
    };
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  rowGap: responsivePropType$1
} : {};
rowGap.filterProps = ['rowGap'];
var gridColumn = style$2({
  prop: 'gridColumn'
});
var gridRow = style$2({
  prop: 'gridRow'
});
var gridAutoFlow = style$2({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = style$2({
  prop: 'gridAutoColumns'
});
var gridAutoRows = style$2({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = style$2({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = style$2({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = style$2({
  prop: 'gridTemplateAreas'
});
var gridArea = style$2({
  prop: 'gridArea'
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);

function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
var color = style$2({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
var bgcolor = style$2({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
var backgroundColor = style$2({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);

function sizingTransform(value) {
  return value <= 1 && value !== 0 ? "".concat(value * 100, "%") : value;
}
var width = style$2({
  prop: 'width',
  transform: sizingTransform
});
var maxWidth = function maxWidth(props) {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    var styleFromPropValue = function styleFromPropValue(propValue) {
      var _props$theme, _props$theme2;
      var breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || values$1[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') {
        return {
          maxWidth: "".concat(breakpoint).concat(props.theme.breakpoints.unit)
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ['maxWidth'];
var minWidth = style$2({
  prop: 'minWidth',
  transform: sizingTransform
});
var height = style$2({
  prop: 'height',
  transform: sizingTransform
});
var maxHeight = style$2({
  prop: 'maxHeight',
  transform: sizingTransform
});
var minHeight = style$2({
  prop: 'minHeight',
  transform: sizingTransform
});
style$2({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
style$2({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
var boxSizing = style$2({
  prop: 'boxSizing'
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);

var defaultSxConfig = {
  // borders
  border: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderTop: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderRight: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderBottom: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderLeft: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderColor: {
    themeKey: 'palette'
  },
  borderTopColor: {
    themeKey: 'palette'
  },
  borderRightColor: {
    themeKey: 'palette'
  },
  borderBottomColor: {
    themeKey: 'palette'
  },
  borderLeftColor: {
    themeKey: 'palette'
  },
  outline: {
    themeKey: 'borders',
    transform: borderTransform
  },
  outlineColor: {
    themeKey: 'palette'
  },
  borderRadius: {
    themeKey: 'shape.borderRadius',
    style: borderRadius
  },
  // palette
  color: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: 'palette',
    cssProperty: 'backgroundColor',
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: function transform(value) {
      return {
        '@media print': {
          display: value
        }
      };
    }
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: 'zIndex'
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: 'shadows'
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: 'typography'
  },
  fontSize: {
    themeKey: 'typography'
  },
  fontStyle: {
    themeKey: 'typography'
  },
  fontWeight: {
    themeKey: 'typography'
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: 'typography'
  }
};
var defaultSxConfig$1 = defaultSxConfig;

function objectsHaveSameKeys() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  var allKeys = objects.reduce(function (keys, object) {
    return keys.concat(Object.keys(object));
  }, []);
  var union = new Set(allKeys);
  return objects.every(function (object) {
    return union.size === Object.keys(object).length;
  });
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    var props = _defineProperty(_defineProperty({}, prop, val), "theme", theme);
    var options = config[prop];
    if (!options) {
      return _defineProperty({}, prop, val);
    }
    var _options$cssProperty = options.cssProperty,
      cssProperty = _options$cssProperty === void 0 ? prop : _options$cssProperty,
      themeKey = options.themeKey,
      transform = options.transform,
      style = options.style;
    if (val == null) {
      return null;
    }

    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && val === 'inherit') {
      return _defineProperty({}, prop, val);
    }
    var themeMapping = getPath(theme, themeKey) || {};
    if (style) {
      return style(props);
    }
    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
      var value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, "".concat(prop).concat(propValueFinal === 'default' ? '' : capitalize$1(propValueFinal)), propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return _defineProperty({}, cssProperty, value);
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx(props) {
    var _theme$unstable_sxCon;
    var _ref4 = props || {},
      sx = _ref4.sx,
      _ref4$theme = _ref4.theme,
      theme = _ref4$theme === void 0 ? {} : _ref4$theme;
    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }
    var config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : defaultSxConfig$1;

    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */
    function traverse(sxInput) {
      var sxObject = sxInput;
      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (_typeof(sxInput) !== 'object') {
        // value
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      var emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      var breakpointsKeys = Object.keys(emptyBreakpoints);
      var css = emptyBreakpoints;
      Object.keys(sxObject).forEach(function (styleKey) {
        var value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== undefined) {
          if (_typeof(value) === 'object') {
            if (config[styleKey]) {
              css = merge(css, getThemeValue(styleKey, value, theme, config));
            } else {
              var breakpointsValues = handleBreakpoints({
                theme: theme
              }, value, function (x) {
                return _defineProperty({}, styleKey, x);
              });
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme: theme
                });
              } else {
                css = merge(css, breakpointsValues);
              }
            }
          } else {
            css = merge(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx;
}
var styleFunctionSx$1 = unstable_createStyleFunctionSx();
styleFunctionSx$1.filterProps = ['sx'];
var styleFunctionSx$2 = styleFunctionSx$1;

/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */
function applyStyles(key, styles) {
  // @ts-expect-error this is 'any' type
  var theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
    // If CssVarsProvider is used as a provider,
    // returns '* :where([data-mui-color-scheme="light|dark"]) &'
    var selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
    return _defineProperty({}, selector, styles);
  }
  if (theme.palette.mode === key) {
    return styles;
  }
  return {};
}

var _excluded$z = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$2() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
    breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
    _options$palette = options.palette,
    paletteInput = _options$palette === void 0 ? {} : _options$palette,
    spacingInput = options.spacing,
    _options$shape = options.shape,
    shapeInput = _options$shape === void 0 ? {} : _options$shape,
    other = _objectWithoutPropertiesLoose(options, _excluded$z);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge$1({
    breakpoints: breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: _extends$1({
      mode: 'light'
    }, paletteInput),
    spacing: spacing,
    shape: _extends$1({}, shape$1, shapeInput)
  }, other);
  muiTheme.applyStyles = applyStyles;
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge$1(acc, argument);
  }, muiTheme);
  muiTheme.unstable_sxConfig = _extends$1({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$2({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}

var createTheme$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': createTheme$2,
  private_createBreakpoints: createBreakpoints,
  unstable_applyStyles: applyStyles
});

function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$2() {
  var defaultTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var contextTheme = React__namespace.useContext(ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}

var systemDefaultTheme$2 = createTheme$2();
function useTheme$1() {
  var defaultTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : systemDefaultTheme$2;
  return useTheme$2(defaultTheme);
}

var _excluded$y = ["sx"];
var splitProps = function splitProps(props) {
  var _props$theme$unstable, _props$theme;
  var result = {
    systemProps: {},
    otherProps: {}
  };
  var config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : defaultSxConfig$1;
  Object.keys(props).forEach(function (prop) {
    if (config[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  var inSx = props.sx,
    other = _objectWithoutPropertiesLoose(props, _excluded$y);
  var _splitProps = splitProps(other),
    systemProps = _splitProps.systemProps,
    otherProps = _splitProps.otherProps;
  var finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps].concat(_toConsumableArray(inSx));
  } else if (typeof inSx === 'function') {
    finalSx = function finalSx() {
      var result = inSx.apply(void 0, arguments);
      if (!isPlainObject(result)) {
        return systemProps;
      }
      return _extends$1({}, systemProps, result);
    };
  } else {
    finalSx = _extends$1({}, systemProps, inSx);
  }
  return _extends$1({}, otherProps, {
    sx: finalSx
  });
}

var styleFunctionSx = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': styleFunctionSx$2,
  unstable_createStyleFunctionSx: unstable_createStyleFunctionSx,
  extendSxProp: extendSxProp,
  unstable_defaultSxConfig: defaultSxConfig$1
});

var defaultGenerator = function defaultGenerator(componentName) {
  return componentName;
};
var createClassNameGenerator = function createClassNameGenerator() {
  var _generate = defaultGenerator;
  return {
    configure: function configure(generator) {
      _generate = generator;
    },
    generate: function generate(componentName) {
      return _generate(componentName);
    },
    reset: function reset() {
      _generate = defaultGenerator;
    }
  };
};
var ClassNameGenerator = createClassNameGenerator();
var ClassNameGenerator$1 = ClassNameGenerator;

function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == _typeof(e)) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}

var globalStateClasses = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  open: 'open',
  readOnly: 'readOnly',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot) {
  var globalStatePrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Mui';
  var globalStateClass = globalStateClasses[slot];
  return globalStateClass ? "".concat(globalStatePrefix, "-").concat(globalStateClass) : "".concat(ClassNameGenerator$1.generate(componentName), "-").concat(slot);
}

function generateUtilityClasses(componentName, slots) {
  var globalStatePrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Mui';
  var result = {};
  slots.forEach(function (slot) {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}

var reactIs = {exports: {}};

var reactIs_production_min = {};

var b = Symbol["for"]("react.element"),
  c = Symbol["for"]("react.portal"),
  d = Symbol["for"]("react.fragment"),
  e = Symbol["for"]("react.strict_mode"),
  f = Symbol["for"]("react.profiler"),
  g = Symbol["for"]("react.provider"),
  h = Symbol["for"]("react.context"),
  k = Symbol["for"]("react.server_context"),
  l = Symbol["for"]("react.forward_ref"),
  m = Symbol["for"]("react.suspense"),
  n = Symbol["for"]("react.suspense_list"),
  p = Symbol["for"]("react.memo"),
  q = Symbol["for"]("react.lazy"),
  t = Symbol["for"]("react.offscreen"),
  u;
u = Symbol["for"]("react.module.reference");
function v(a) {
  if ("object" === _typeof(a) && null !== a) {
    var r = a.$$typeof;
    switch (r) {
      case b:
        switch (a = a.type, a) {
          case d:
          case f:
          case e:
          case m:
          case n:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case h:
              case l:
              case q:
              case p:
              case g:
                return a;
              default:
                return r;
            }
        }
      case c:
        return r;
    }
  }
}
reactIs_production_min.ContextConsumer = h;
reactIs_production_min.ContextProvider = g;
reactIs_production_min.Element = b;
reactIs_production_min.ForwardRef = l;
reactIs_production_min.Fragment = d;
reactIs_production_min.Lazy = q;
reactIs_production_min.Memo = p;
reactIs_production_min.Portal = c;
reactIs_production_min.Profiler = f;
reactIs_production_min.StrictMode = e;
reactIs_production_min.Suspense = m;
reactIs_production_min.SuspenseList = n;
reactIs_production_min.isAsyncMode = function () {
  return !1;
};
reactIs_production_min.isConcurrentMode = function () {
  return !1;
};
reactIs_production_min.isContextConsumer = function (a) {
  return v(a) === h;
};
reactIs_production_min.isContextProvider = function (a) {
  return v(a) === g;
};
reactIs_production_min.isElement = function (a) {
  return "object" === _typeof(a) && null !== a && a.$$typeof === b;
};
reactIs_production_min.isForwardRef = function (a) {
  return v(a) === l;
};
reactIs_production_min.isFragment = function (a) {
  return v(a) === d;
};
reactIs_production_min.isLazy = function (a) {
  return v(a) === q;
};
reactIs_production_min.isMemo = function (a) {
  return v(a) === p;
};
reactIs_production_min.isPortal = function (a) {
  return v(a) === c;
};
reactIs_production_min.isProfiler = function (a) {
  return v(a) === f;
};
reactIs_production_min.isStrictMode = function (a) {
  return v(a) === e;
};
reactIs_production_min.isSuspense = function (a) {
  return v(a) === m;
};
reactIs_production_min.isSuspenseList = function (a) {
  return v(a) === n;
};
reactIs_production_min.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === _typeof(a) && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
reactIs_production_min.typeOf = v;

var reactIs_development = {};

if (process.env.NODE_ENV !== "production") {
  (function () {

    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol["for"]('react.element');
    var REACT_PORTAL_TYPE = Symbol["for"]('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol["for"]('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol["for"]('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol["for"]('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol["for"]('react.provider');
    var REACT_CONTEXT_TYPE = Symbol["for"]('react.context');
    var REACT_SERVER_CONTEXT_TYPE = Symbol["for"]('react.server_context');
    var REACT_FORWARD_REF_TYPE = Symbol["for"]('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol["for"]('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol["for"]('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol["for"]('react.memo');
    var REACT_LAZY_TYPE = Symbol["for"]('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol["for"]('react.offscreen');

    // -----------------------------------------------------------------------------

    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing

    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.

    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

    var REACT_MODULE_REFERENCE;
    {
      REACT_MODULE_REFERENCE = Symbol["for"]('react.module.reference');
    }
    function isValidElementType(type) {
      if (typeof type === 'string' || typeof type === 'function') {
        return true;
      } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

      if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
        return true;
      }
      if (_typeof(type) === 'object' && type !== null) {
        if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE ||
        // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
          return true;
        }
      }
      return false;
    }
    function typeOf(object) {
      if (_typeof(object) === 'object' && object !== null) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;
            switch (type) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
                return type;
              default:
                var $$typeofType = type && type.$$typeof;
                switch ($$typeofType) {
                  case REACT_SERVER_CONTEXT_TYPE:
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
      return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
        }
      }
      return false;
    }
    function isConcurrentMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
          hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
        }
      }
      return false;
    }
    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
      return _typeof(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    reactIs_development.ContextConsumer = ContextConsumer;
    reactIs_development.ContextProvider = ContextProvider;
    reactIs_development.Element = Element;
    reactIs_development.ForwardRef = ForwardRef;
    reactIs_development.Fragment = Fragment;
    reactIs_development.Lazy = Lazy;
    reactIs_development.Memo = Memo;
    reactIs_development.Portal = Portal;
    reactIs_development.Profiler = Profiler;
    reactIs_development.StrictMode = StrictMode;
    reactIs_development.Suspense = Suspense;
    reactIs_development.SuspenseList = SuspenseList;
    reactIs_development.isAsyncMode = isAsyncMode;
    reactIs_development.isConcurrentMode = isConcurrentMode;
    reactIs_development.isContextConsumer = isContextConsumer;
    reactIs_development.isContextProvider = isContextProvider;
    reactIs_development.isElement = isElement;
    reactIs_development.isForwardRef = isForwardRef;
    reactIs_development.isFragment = isFragment;
    reactIs_development.isLazy = isLazy;
    reactIs_development.isMemo = isMemo;
    reactIs_development.isPortal = isPortal;
    reactIs_development.isProfiler = isProfiler;
    reactIs_development.isStrictMode = isStrictMode;
    reactIs_development.isSuspense = isSuspense;
    reactIs_development.isSuspenseList = isSuspenseList;
    reactIs_development.isValidElementType = isValidElementType;
    reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}

/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE11 support
 */
function getDisplayName$1(Component) {
  if (Component == null) {
    return undefined;
  }
  if (typeof Component === 'string') {
    return Component;
  }
  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
  if (_typeof(Component) === 'object') {
    switch (Component.$$typeof) {
      case reactIs.exports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');
      case reactIs.exports.Memo:
        return getWrappedName(Component, Component.type, 'memo');
      default:
        return undefined;
    }
  }
  return undefined;
}

var getDisplayName = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': getDisplayName$1,
  getFunctionName: getFunctionName
});

var _excluded$x = ["ownerState"],
  _excluded2$6 = ["variants"],
  _excluded3$3 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function isEmpty$1(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag$1(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}

// Update /system/styled/#api in case if this changes
function shouldForwardProp$1(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var systemDefaultTheme$1 = createTheme$2();
var lowercaseFirstLetter$1 = function lowercaseFirstLetter(string) {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme$1(_ref2) {
  var defaultTheme = _ref2.defaultTheme,
    theme = _ref2.theme,
    themeId = _ref2.themeId;
  return isEmpty$1(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver$1(slot) {
  if (!slot) {
    return null;
  }
  return function (props, styles) {
    return styles[slot];
  };
}
function processStyleArg$1(callableStyle, _ref) {
  var ownerState = _ref.ownerState,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$x);
  var resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle(_extends$1({
    ownerState: ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap(function (resolvedStyle) {
      return processStyleArg$1(resolvedStyle, _extends$1({
        ownerState: ownerState
      }, props));
    });
  }
  if (!!resolvedStylesArg && _typeof(resolvedStylesArg) === 'object' && Array.isArray(resolvedStylesArg.variants)) {
    var _resolvedStylesArg$va = resolvedStylesArg.variants,
      variants = _resolvedStylesArg$va === void 0 ? [] : _resolvedStylesArg$va,
      otherStyles = _objectWithoutPropertiesLoose(resolvedStylesArg, _excluded2$6);
    var result = otherStyles;
    variants.forEach(function (variant) {
      var isMatch = true;
      if (typeof variant.props === 'function') {
        isMatch = variant.props(_extends$1({
          ownerState: ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach(function (key) {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [result];
        }
        result.push(typeof variant.style === 'function' ? variant.style(_extends$1({
          ownerState: ownerState
        }, props, ownerState)) : variant.style);
      }
    });
    return result;
  }
  return resolvedStylesArg;
}
function createStyled$2() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var themeId = input.themeId,
    _input$defaultTheme = input.defaultTheme,
    defaultTheme = _input$defaultTheme === void 0 ? systemDefaultTheme$1 : _input$defaultTheme,
    _input$rootShouldForw = input.rootShouldForwardProp,
    rootShouldForwardProp = _input$rootShouldForw === void 0 ? shouldForwardProp$1 : _input$rootShouldForw,
    _input$slotShouldForw = input.slotShouldForwardProp,
    slotShouldForwardProp = _input$slotShouldForw === void 0 ? shouldForwardProp$1 : _input$slotShouldForw;
  var systemSx = function systemSx(props) {
    return styleFunctionSx$2(_extends$1({}, props, {
      theme: resolveTheme$1(_extends$1({}, props, {
        defaultTheme: defaultTheme,
        themeId: themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return function (tag) {
    var inputOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    internal_processStyles(tag, function (styles) {
      return styles.filter(function (style) {
        return !(style != null && style.__mui_systemSx);
      });
    });
    var componentName = inputOptions.name,
      componentSlot = inputOptions.slot,
      inputSkipVariantsResolver = inputOptions.skipVariantsResolver,
      inputSkipSx = inputOptions.skipSx,
      _inputOptions$overrid = inputOptions.overridesResolver,
      overridesResolver = _inputOptions$overrid === void 0 ? defaultOverridesResolver$1(lowercaseFirstLetter$1(componentSlot)) : _inputOptions$overrid,
      options = _objectWithoutPropertiesLoose(inputOptions, _excluded3$3);

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    var skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver :
    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
    var skipSx = inputSkipSx || false;
    var label;
    if (process.env.NODE_ENV !== 'production') {
      if (componentName) {
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = "".concat(componentName, "-").concat(lowercaseFirstLetter$1(componentSlot || 'Root'));
      }
    }
    var shouldForwardPropOption = shouldForwardProp$1;

    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    if (componentSlot === 'Root' || componentSlot === 'root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag$1(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    var defaultStyledResolver = styled$3(tag, _extends$1({
      shouldForwardProp: shouldForwardPropOption,
      label: label
    }, options));
    var transformStyleArg = function transformStyleArg(stylesArg) {
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || isPlainObject(stylesArg)) {
        return function (props) {
          return processStyleArg$1(stylesArg, _extends$1({}, props, {
            theme: resolveTheme$1({
              theme: props.theme,
              defaultTheme: defaultTheme,
              themeId: themeId
            })
          }));
        };
      }
      return stylesArg;
    };
    var muiStyledResolver = function muiStyledResolver(styleArg) {
      var transformedStyleArg = transformStyleArg(styleArg);
      for (var _len = arguments.length, expressions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        expressions[_key - 1] = arguments[_key];
      }
      var expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(function (props) {
          var theme = resolveTheme$1(_extends$1({}, props, {
            defaultTheme: defaultTheme,
            themeId: themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          var styleOverrides = theme.components[componentName].styleOverrides;
          var resolvedStyleOverrides = {};
          // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
          Object.entries(styleOverrides).forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              slotKey = _ref4[0],
              slotStyle = _ref4[1];
            resolvedStyleOverrides[slotKey] = processStyleArg$1(slotStyle, _extends$1({}, props, {
              theme: theme
            }));
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(function (props) {
          var _theme$components;
          var theme = resolveTheme$1(_extends$1({}, props, {
            defaultTheme: defaultTheme,
            themeId: themeId
          }));
          var themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg$1({
            variants: themeVariants
          }, _extends$1({}, props, {
            theme: theme
          }));
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      var numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        var placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [].concat(_toConsumableArray(styleArg), _toConsumableArray(placeholders));
        transformedStyleArg.raw = [].concat(_toConsumableArray(styleArg.raw), _toConsumableArray(placeholders));
      }
      var Component = defaultStyledResolver.apply(void 0, [transformedStyleArg].concat(_toConsumableArray(expressionsWithDefaultTheme)));
      if (process.env.NODE_ENV !== 'production') {
        var displayName;
        if (componentName) {
          displayName = "".concat(componentName).concat(capitalize$1(componentSlot || ''));
        }
        if (displayName === undefined) {
          displayName = "Styled(".concat(getDisplayName$1(tag), ")");
        }
        Component.displayName = displayName;
      }
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}

var styled$2 = createStyled$2();
var systemStyled = styled$2;

/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */
function resolveProps(defaultProps, props) {
  var output = _extends$1({}, props);
  Object.keys(defaultProps).forEach(function (propName) {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = _extends$1({}, defaultProps[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      var defaultSlotProps = defaultProps[propName] || {};
      var slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        // Reduce the iteration if the slot props is empty
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        // Reduce the iteration if the default slot props is empty
        output[propName] = slotProps;
      } else {
        output[propName] = _extends$1({}, slotProps);
        Object.keys(defaultSlotProps).forEach(function (slotPropName) {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}

function getThemeProps$1(params) {
  var theme = params.theme,
    name = params.name,
    props = params.props;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return resolveProps(theme.components[name].defaultProps, props);
}

function useThemeProps(_ref) {
  var props = _ref.props,
    name = _ref.name,
    defaultTheme = _ref.defaultTheme,
    themeId = _ref.themeId;
  var theme = useTheme$1(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  var mergedProps = getThemeProps$1({
    theme: theme,
    name: name,
    props: props
  });
  return mergedProps;
}

/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */
var useEnhancedEffect = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
var useEnhancedEffect$1 = useEnhancedEffect;

/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  var _React$useState = React__namespace.useState(function () {
      if (noSsr && matchMedia) {
        return matchMedia(query).matches;
      }
      if (ssrMatchMedia) {
        return ssrMatchMedia(query).matches;
      }

      // Once the component is mounted, we rely on the
      // event listeners to return the correct matches value.
      return defaultMatches;
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    match = _React$useState2[0],
    setMatch = _React$useState2[1];
  useEnhancedEffect$1(function () {
    var active = true;
    if (!matchMedia) {
      return undefined;
    }
    var queryList = matchMedia(query);
    var updateMatch = function updateMatch() {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    // TODO: Use `addEventListener` once support for Safari < 14 is dropped
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia]);
  return match;
}

// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
var maybeReactUseSyncExternalStore = React__namespace['useSyncExternalStore' + ''];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  var getDefaultSnapshot = React__namespace.useCallback(function () {
    return defaultMatches;
  }, [defaultMatches]);
  var getServerSnapshot = React__namespace.useMemo(function () {
    if (noSsr && matchMedia) {
      return function () {
        return matchMedia(query).matches;
      };
    }
    if (ssrMatchMedia !== null) {
      var _ssrMatchMedia = ssrMatchMedia(query),
        matches = _ssrMatchMedia.matches;
      return function () {
        return matches;
      };
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia, noSsr, matchMedia]);
  var _React$useMemo = React__namespace.useMemo(function () {
      if (matchMedia === null) {
        return [getDefaultSnapshot, function () {
          return function () {};
        }];
      }
      var mediaQueryList = matchMedia(query);
      return [function () {
        return mediaQueryList.matches;
      }, function (notify) {
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        mediaQueryList.addListener(notify);
        return function () {
          mediaQueryList.removeListener(notify);
        };
      }];
    }, [getDefaultSnapshot, matchMedia, query]),
    _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
    getSnapshot = _React$useMemo2[0],
    subscribe = _React$useMemo2[1];
  var match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}
function useMediaQuery(queryInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme = useTheme$2();
  // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.
  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  var _getThemeProps = getThemeProps$1({
      name: 'MuiUseMediaQuery',
      props: options,
      theme: theme
    }),
    _getThemeProps$defaul = _getThemeProps.defaultMatches,
    defaultMatches = _getThemeProps$defaul === void 0 ? false : _getThemeProps$defaul,
    _getThemeProps$matchM = _getThemeProps.matchMedia,
    matchMedia = _getThemeProps$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _getThemeProps$matchM,
    _getThemeProps$ssrMat = _getThemeProps.ssrMatchMedia,
    ssrMatchMedia = _getThemeProps$ssrMat === void 0 ? null : _getThemeProps$ssrMat,
    _getThemeProps$noSsr = _getThemeProps.noSsr,
    noSsr = _getThemeProps$noSsr === void 0 ? false : _getThemeProps$noSsr;
  if (process.env.NODE_ENV !== 'production') {
    if (typeof queryInput === 'function' && theme === null) {
      console.error(['MUI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
    }
  }
  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, '');

  // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
  var useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  var match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__namespace.useDebugValue({
      query: query,
      match: match
    });
  }
  return match;
}

function clamp$1(val) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MIN_SAFE_INTEGER;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.MAX_SAFE_INTEGER;
  return Math.max(min, Math.min(val, max));
}

var clamp = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': clamp$1
});

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }
  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function isClassComponent$1(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
    prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;
  if (element == null ||
  // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === 'undefined') {
    return null;
  }
  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */
  if (typeof elementType === 'function' && !isClassComponent$1(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }
  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }
  return null;
}
var elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
var elementAcceptingRef$1 = elementAcceptingRef;

function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
    prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;
  if (propValue == null ||
  // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === 'undefined') {
    return null;
  }
  var warningHint;

  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */
  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }
  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }
  return null;
}
var elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef);

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.

var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }
  return _extends$1({}, propTypes, _defineProperty({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });
    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }
    return null;
  }));
}

function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  var propValue = props[propName];
  var safePropName = propFullName || propName;
  if (propValue == null) {
    return null;
  }
  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }
  return null;
}

var refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var refType$1 = refType;

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;
  function debounced() {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var later = function later() {
      // @ts-ignore
      func.apply(_this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = function () {
    clearTimeout(timeout);
  };
  return debounced;
}

function isMuiElement(element, muiNames) {
  var _muiName, _element$type;
  return /*#__PURE__*/ /*#__PURE__*/React__namespace.isValidElement(element) && muiNames.indexOf(
  // For server components `muiName` is avaialble in element.type._payload.value.muiName
  // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
  // eslint-disable-next-line no-underscore-dangle
  (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}

/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

function useControlled(_ref) {
  var controlled = _ref.controlled,
    defaultProp = _ref["default"],
    name = _ref.name,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'value' : _ref$state;
  // isControlled is ignored in the hook dependency lists as it should never change.
  var _React$useRef = React__namespace.useRef(controlled !== undefined),
    isControlled = _React$useRef.current;
  var _React$useState = React__namespace.useState(defaultProp),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    valueState = _React$useState2[0],
    setValue = _React$useState2[1];
  var value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== 'production') {
    React__namespace.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["MUI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [state, name, controlled]);
    var _React$useRef2 = React__namespace.useRef(defaultProp),
      defaultValue = _React$useRef2.current;
    React__namespace.useEffect(function () {
      if (!isControlled && !Object.is(defaultValue, defaultProp)) {
        console.error(["MUI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }
  var setValueIfUncontrolled = React__namespace.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */

function useEventCallback(fn) {
  var ref = React__namespace.useRef(fn);
  useEnhancedEffect$1(function () {
    ref.current = fn;
  });
  return React__namespace.useRef(function () {
    return (
      // @ts-expect-error hide `this`
      (ref.current).apply(void 0, arguments)
    );
  }).current;
}

function useForkRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return React__namespace.useMemo(function () {
    if (refs.every(function (ref) {
      return ref == null;
    })) {
      return null;
    }
    return function (instance) {
      refs.forEach(function (ref) {
        setRef(ref, instance);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

var UNINITIALIZED = {};

/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */
function useLazyRef(init, initArg) {
  var ref = React__namespace.useRef(UNINITIALIZED);
  if (ref.current === UNINITIALIZED) {
    ref.current = init(initArg);
  }
  return ref;
}

var EMPTY = [];

/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */
function useOnMount(fn) {
  /* eslint-disable react-hooks/exhaustive-deps */
  React__namespace.useEffect(fn, EMPTY);
  /* eslint-enable react-hooks/exhaustive-deps */
}

var Timeout = /*#__PURE__*/function () {
  function Timeout() {
    var _this = this;
    _classCallCheck(this, Timeout);
    this.currentId = null;
    this.clear = function () {
      if (_this.currentId !== null) {
        clearTimeout(_this.currentId);
        _this.currentId = null;
      }
    };
    this.disposeEffect = function () {
      return _this.clear;
    };
  }
  return _createClass(Timeout, [{
    key: "start",
    value:
    /**
     * Executes `fn` after `delay`, clearing any previously scheduled call.
     */
    function start(delay, fn) {
      var _this2 = this;
      this.clear();
      this.currentId = setTimeout(function () {
        _this2.currentId = null;
        fn();
      }, delay);
    }
  }], [{
    key: "create",
    value: function create() {
      return new Timeout();
    }
  }]);
}();
function useTimeout() {
  var timeout = useLazyRef(Timeout.create).current;
  useOnMount(timeout.disposeEffect);
  return timeout;
}

var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = new Timeout();
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};

/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */
function focusTriggersKeyboardModality(node) {
  var type = node.type,
    tagName = node.tagName;
  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }
  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }
  if (node.isContentEditable) {
    return true;
  }
  return false;
}

/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}

/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function isFocusVisible(event) {
  var target = event.target;
  try {
    return target.matches(':focus-visible');
  } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  }

  // No need for validFocusTarget check. The user does that by attaching it to
  // focusable events only.
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
  var ref = React__namespace.useCallback(function (node) {
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  var isFocusVisibleRef = React__namespace.useRef(false);

  /**
   * Should be called if a blur event is fired
   */
  function handleBlurVisible() {
    // checking against potential state variable does not suffice if we focus and blur synchronously.
    // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
    // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
    // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
    // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
    if (isFocusVisibleRef.current) {
      // To detect a tab/window switch, we look for a blur event followed
      // rapidly by a visibility change.
      // If we don't see a visibility change within 100ms, it's probably a
      // regular focus change.
      hadFocusVisibleRecently = true;
      hadFocusVisibleRecentlyTimeout.start(100, function () {
        hadFocusVisibleRecently = false;
      });
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }

  /**
   * Should be called if a blur event is fired
   */
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef: isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: ref
  };
}

// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize(doc) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
  var documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}

function getTypeByValue(value) {
  var valueType = _typeof(value);
  switch (valueType) {
    case 'number':
      if (Number.isNaN(value)) {
        return 'NaN';
      }
      if (!Number.isFinite(value)) {
        return 'Infinity';
      }
      if (value !== Math.floor(value)) {
        return 'float';
      }
      return 'number';
    case 'object':
      if (value === null) {
        return 'null';
      }
      return value.constructor.name;
    default:
      return valueType;
  }
}

// IE 11 support
function ponyfillIsInteger(x) {
  // eslint-disable-next-line no-restricted-globals
  return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
}
var isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(props, propName, componentName, location) {
  var propValue = props[propName];
  if (propValue == null || !isInteger(propValue)) {
    var propType = getTypeByValue(propValue);
    return new RangeError("Invalid ".concat(location, " `").concat(propName, "` of type `").concat(propType, "` supplied to `").concat(componentName, "`, expected `integer`."));
  }
  return null;
}
function validator(props, propName) {
  var propValue = props[propName];
  if (propValue === undefined) {
    return null;
  }
  for (var _len = arguments.length, other = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    other[_key - 2] = arguments[_key];
  }
  return requiredInteger.apply(void 0, [props, propName].concat(other));
}
function validatorNoop() {
  return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
var integerPropType = process.env.NODE_ENV === 'production' ? validatorNoop : validator;

function composeClasses(slots, getUtilityClass) {
  var classes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var output = {};
  Object.keys(slots).forEach(
  // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  function (slot) {
    output[slot] = slots[slot].reduce(function (acc, key) {
      if (key) {
        var utilityClass = getUtilityClass(key);
        if (utilityClass !== '') {
          acc.push(utilityClass);
        }
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
  return typeof element === 'string';
}

/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */

/**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === undefined || isHostComponent(elementType)) {
    return otherProps;
  }
  return _extends$1({}, otherProps, {
    ownerState: _extends$1({}, otherProps.ownerState, ownerState)
  });
}

/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */
function extractEventHandlers(object) {
  var excludeKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (object === undefined) {
    return {};
  }
  var result = {};
  Object.keys(object).filter(function (prop) {
    return prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop);
  }).forEach(function (prop) {
    result[prop] = object[prop];
  });
  return result;
}

/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */
function omitEventHandlers(object) {
  if (object === undefined) {
    return {};
  }
  var result = {};
  Object.keys(object).filter(function (prop) {
    return !(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function');
  }).forEach(function (prop) {
    result[prop] = object[prop];
  });
  return result;
}

/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */
function mergeSlotProps(parameters) {
  var getSlotProps = parameters.getSlotProps,
    additionalProps = parameters.additionalProps,
    externalSlotProps = parameters.externalSlotProps,
    externalForwardedProps = parameters.externalForwardedProps,
    className = parameters.className;
  if (!getSlotProps) {
    // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
    // so we can simply merge all the props without having to worry about extracting event handlers.
    var _joinedClasses = clsx(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    var _mergedStyle = _extends$1({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    var _props = _extends$1({}, additionalProps, externalForwardedProps, externalSlotProps);
    if (_joinedClasses.length > 0) {
      _props.className = _joinedClasses;
    }
    if (Object.keys(_mergedStyle).length > 0) {
      _props.style = _mergedStyle;
    }
    return {
      props: _props,
      internalRef: undefined
    };
  }

  // In this case, getSlotProps is responsible for calling the external event handlers.
  // We don't need to include them in the merged props because of this.

  var eventHandlers = extractEventHandlers(_extends$1({}, externalForwardedProps, externalSlotProps));
  var componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  var otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  var internalSlotProps = getSlotProps(eventHandlers);

  // The order of classes is important here.
  // Emotion (that we use in libraries consuming Base UI) depends on this order
  // to properly override style. It requires the most important classes to be last
  // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
  var joinedClasses = clsx(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
  var mergedStyle = _extends$1({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
  var props = _extends$1({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props: props,
    internalRef: internalSlotProps.ref
  };
}

/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === 'function') {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}

var _excluded$w = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */
function useSlotProps(parameters) {
  var _parameters$additiona;
  var elementType = parameters.elementType,
    externalSlotProps = parameters.externalSlotProps,
    ownerState = parameters.ownerState,
    _parameters$skipResol = parameters.skipResolvingSlotProps,
    skipResolvingSlotProps = _parameters$skipResol === void 0 ? false : _parameters$skipResol,
    rest = _objectWithoutPropertiesLoose(parameters, _excluded$w);
  var resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
  var _mergeSlotProps = mergeSlotProps(_extends$1({}, rest, {
      externalSlotProps: resolvedComponentsProps
    })),
    mergedProps = _mergeSlotProps.props,
    internalRef = _mergeSlotProps.internalRef;
  var ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
  var props = appendOwnerState(elementType, _extends$1({}, mergedProps, {
    ref: ref
  }), ownerState);
  return props;
}

var RtlContext = /*#__PURE__*/React__namespace.createContext();
process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  value: PropTypes.bool
} : void 0;
var useRtl = function useRtl() {
  var value = React__namespace.useContext(RtlContext);
  return value != null ? value : false;
};

var PropsContext = /*#__PURE__*/React__namespace.createContext(undefined);
process.env.NODE_ENV !== "production" ? {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object
} : void 0;
function getThemeProps(params) {
  var theme = params.theme,
    name = params.name,
    props = params.props;
  if (!theme || !theme.components || !theme.components[name]) {
    return props;
  }
  var config = theme.components[name];
  if (config.defaultProps) {
    // compatible with v5 signature
    return resolveProps(config.defaultProps, props);
  }
  if (!config.styleOverrides && !config.variants) {
    // v6 signature, no property 'defaultProps'
    return resolveProps(config, props);
  }
  return props;
}
function useDefaultProps$1(_ref2) {
  var props = _ref2.props,
    name = _ref2.name;
  var ctx = React__namespace.useContext(PropsContext);
  return getThemeProps({
    props: props,
    name: name,
    theme: {
      components: ctx
    }
  });
}

var _excluded$v = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"];
var defaultTheme$2 = createTheme$2();
// widening Theme to any so that the consumer can own the theme structure.
var defaultCreateStyledComponent = systemStyled('div', {
  name: 'MuiStack',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
});
function useThemePropsDefault(props) {
  return useThemeProps({
    props: props,
    name: 'MuiStack',
    defaultTheme: defaultTheme$2
  });
}

/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */
function joinChildren(children, separator) {
  var childrenArray = React__namespace.Children.toArray(children).filter(Boolean);
  return childrenArray.reduce(function (output, child, index) {
    output.push(child);
    if (index < childrenArray.length - 1) {
      output.push(/*#__PURE__*/React__namespace.cloneElement(separator, {
        key: "separator-".concat(index)
      }));
    }
    return output;
  }, []);
}
var getSideFromDirection = function getSideFromDirection(direction) {
  return {
    row: 'Left',
    'row-reverse': 'Right',
    column: 'Top',
    'column-reverse': 'Bottom'
  }[direction];
};
var style = function style(_ref) {
  var ownerState = _ref.ownerState,
    theme = _ref.theme;
  var styles = _extends$1({
    display: 'flex',
    flexDirection: 'column'
  }, handleBreakpoints({
    theme: theme
  }, resolveBreakpointValues({
    values: ownerState.direction,
    breakpoints: theme.breakpoints.values
  }), function (propValue) {
    return {
      flexDirection: propValue
    };
  }));
  if (ownerState.spacing) {
    var transformer = createUnarySpacing(theme);
    var base = Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      if (_typeof(ownerState.spacing) === 'object' && ownerState.spacing[breakpoint] != null || _typeof(ownerState.direction) === 'object' && ownerState.direction[breakpoint] != null) {
        acc[breakpoint] = true;
      }
      return acc;
    }, {});
    var directionValues = resolveBreakpointValues({
      values: ownerState.direction,
      base: base
    });
    var spacingValues = resolveBreakpointValues({
      values: ownerState.spacing,
      base: base
    });
    if (_typeof(directionValues) === 'object') {
      Object.keys(directionValues).forEach(function (breakpoint, index, breakpoints) {
        var directionValue = directionValues[breakpoint];
        if (!directionValue) {
          var previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
          directionValues[breakpoint] = previousDirectionValue;
        }
      });
    }
    var styleFromPropValue = function styleFromPropValue(propValue, breakpoint) {
      if (ownerState.useFlexGap) {
        return {
          gap: getValue(transformer, propValue)
        };
      }
      return {
        // The useFlexGap={false} implement relies on each child to give up control of the margin.
        // We need to reset the margin to avoid double spacing.
        '& > :not(style):not(style)': {
          margin: 0
        },
        '& > :not(style) ~ :not(style)': _defineProperty({}, "margin".concat(getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)), getValue(transformer, propValue))
      };
    };
    styles = deepmerge$1(styles, handleBreakpoints({
      theme: theme
    }, spacingValues, styleFromPropValue));
  }
  styles = mergeBreakpointsInOrder(theme.breakpoints, styles);
  return styles;
};
function createStack() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$createStyled = options.createStyledComponent,
    createStyledComponent = _options$createStyled === void 0 ? defaultCreateStyledComponent : _options$createStyled,
    _options$useThemeProp = options.useThemeProps,
    useThemeProps = _options$useThemeProp === void 0 ? useThemePropsDefault : _options$useThemeProp,
    _options$componentNam = options.componentName,
    componentName = _options$componentNam === void 0 ? 'MuiStack' : _options$componentNam;
  var useUtilityClasses = function useUtilityClasses() {
    var slots = {
      root: ['root']
    };
    return composeClasses(slots, function (slot) {
      return generateUtilityClass(componentName, slot);
    }, {});
  };
  var StackRoot = createStyledComponent(style);
  var Stack = /*#__PURE__*/React__namespace.forwardRef(function Grid(inProps, ref) {
    var themeProps = useThemeProps(inProps);
    var props = extendSxProp(themeProps); // `color` type conflicts with html color attribute.
    var _props$component = props.component,
      component = _props$component === void 0 ? 'div' : _props$component,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'column' : _props$direction,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
      divider = props.divider,
      children = props.children,
      className = props.className,
      _props$useFlexGap = props.useFlexGap,
      useFlexGap = _props$useFlexGap === void 0 ? false : _props$useFlexGap,
      other = _objectWithoutPropertiesLoose(props, _excluded$v);
    var ownerState = {
      direction: direction,
      spacing: spacing,
      useFlexGap: useFlexGap
    };
    var classes = useUtilityClasses();
    return /*#__PURE__*/jsxRuntime.exports.jsx(StackRoot, _extends$1({
      as: component,
      ownerState: ownerState,
      ref: ref,
      className: clsx(classes.root, className)
    }, other, {
      children: divider ? joinChildren(children, divider) : children
    }));
  });
  process.env.NODE_ENV !== "production" ? Stack.propTypes /* remove-proptypes */ = {
    children: PropTypes.node,
    direction: PropTypes.oneOfType([PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), PropTypes.arrayOf(PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), PropTypes.object]),
    divider: PropTypes.node,
    spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
    sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
  } : void 0;
  return Stack;
}

function createMixins(breakpoints, mixins) {
  return _extends$1({
    toolbar: _defineProperty(_defineProperty({
      minHeight: 56
    }, breakpoints.up('xs'), {
      '@media (orientation: landscape)': {
        minHeight: 48
      }
    }), breakpoints.up('sm'), {
      minHeight: 64
    })
  }, mixins);
}

var colorManipulator = {};

var interopRequireDefault = {exports: {}};

(function (module) {
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }
  module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(interopRequireDefault);

var require$$1$1 = /*@__PURE__*/getAugmentedNamespace(formatMuiErrorMessage);

var require$$2 = /*@__PURE__*/getAugmentedNamespace(clamp);

var _interopRequireDefault$1 = interopRequireDefault.exports;
Object.defineProperty(colorManipulator, "__esModule", {
  value: true
});
var alpha_1 = colorManipulator.alpha = alpha;
colorManipulator.blend = blend;
colorManipulator.colorChannel = void 0;
var darken_1 = colorManipulator.darken = darken;
colorManipulator.decomposeColor = decomposeColor;
colorManipulator.emphasize = emphasize;
var getContrastRatio_1 = colorManipulator.getContrastRatio = getContrastRatio;
colorManipulator.getLuminance = getLuminance;
colorManipulator.hexToRgb = hexToRgb;
colorManipulator.hslToRgb = hslToRgb;
var lighten_1 = colorManipulator.lighten = lighten;
colorManipulator.private_safeAlpha = private_safeAlpha;
colorManipulator.private_safeColorChannel = void 0;
colorManipulator.private_safeDarken = private_safeDarken;
colorManipulator.private_safeEmphasize = private_safeEmphasize;
colorManipulator.private_safeLighten = private_safeLighten;
colorManipulator.recomposeColor = recomposeColor;
colorManipulator.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault$1(require$$1$1);
var _clamp = _interopRequireDefault$1(require$$2);
/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clampWrapper(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error("MUI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }
  return (0, _clamp["default"])(value, min, max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
  color = color.slice(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }
  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
function intToHex(_int) {
  var hex = _int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Unsupported `".concat(color, "` color.\nThe following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().") : (0, _formatMuiErrorMessage2["default"])(9, color));
  }
  var values = color.substring(marker + 1, color.length - 1);
  var colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error(process.env.NODE_ENV !== "production" ? "MUI: unsupported `".concat(colorSpace, "` color space.\nThe following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.") : (0, _formatMuiErrorMessage2["default"])(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values,
    colorSpace: colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
var colorChannel = function colorChannel(color) {
  var decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map(function (val, idx) {
    return decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? "".concat(val, "%") : val;
  }).join(' ');
};
colorManipulator.colorChannel = colorChannel;
var private_safeColorChannel = function private_safeColorChannel(color, warning) {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
colorManipulator.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(color) {
  var type = color.type,
    colorSpace = color.colorSpace;
  var values = color.values;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }
  if (type.indexOf('color') !== -1) {
    values = "".concat(colorSpace, " ").concat(values.join(' '));
  } else {
    values = "".concat(values.join(', '));
  }
  return "".concat(type, "(").concat(values, ")");
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  var _decomposeColor = decomposeColor(color),
    values = _decomposeColor.values;
  return "#".concat(values.map(function (n, i) {
    return intToHex(i === 3 ? Math.round(255 * n) : n);
  }).join(''));
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
    values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);
  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };
  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }
    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha(color, value) {
  color = decomposeColor(color);
  value = clampWrapper(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = "/".concat(value);
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha(color, value);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (var _i = 0; _i < 3; _i += 1) {
      color.values[_i] += (1 - color.values[_i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return emphasize(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */
function blend(background, overlay, opacity) {
  var gamma = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1.0;
  var blendChannel = function blendChannel(b, o) {
    return Math.round(Math.pow(Math.pow(b, 1 / gamma) * (1 - opacity) + Math.pow(o, 1 / gamma) * opacity, gamma));
  };
  var backgroundColor = decomposeColor(background);
  var overlayColor = decomposeColor(overlay);
  var rgb = [blendChannel(backgroundColor.values[0], overlayColor.values[0]), blendChannel(backgroundColor.values[1], overlayColor.values[1]), blendChannel(backgroundColor.values[2], overlayColor.values[2])];
  return recomposeColor({
    type: 'rgb',
    values: rgb
  });
}

var _excluded$u = ["mode", "contrastThreshold", "tonalOffset"];
var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    "default": common$1.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common$1.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    "default": '#121212'
  },
  action: {
    active: common$1.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten_1(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken_1(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  if (mode === 'dark') {
    return {
      main: blue$1[200],
      light: blue$1[50],
      dark: blue$1[400]
    };
  }
  return {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}
function getDefaultSecondary() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  if (mode === 'dark') {
    return {
      main: purple$1[200],
      light: purple$1[50],
      dark: purple$1[400]
    };
  }
  return {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}
function getDefaultError() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  if (mode === 'dark') {
    return {
      main: red$1[500],
      light: red$1[300],
      dark: red$1[700]
    };
  }
  return {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}
function getDefaultInfo() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  if (mode === 'dark') {
    return {
      main: lightBlue$1[400],
      light: lightBlue$1[300],
      dark: lightBlue$1[700]
    };
  }
  return {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}
function getDefaultSuccess() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  if (mode === 'dark') {
    return {
      main: green$1[400],
      light: green$1[300],
      dark: green$1[700]
    };
  }
  return {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}
function getDefaultWarning() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  if (mode === 'dark') {
    return {
      main: orange$1[400],
      light: orange$1[300],
      dark: orange$1[700]
    };
  }
  return {
    main: '#ed6c02',
    // closest to orange[800] that pass 3:1.
    light: orange$1[500],
    dark: orange$1[900]
  };
}
function createPalette(palette) {
  var _palette$mode = palette.mode,
    mode = _palette$mode === void 0 ? 'light' : _palette$mode,
    _palette$contrastThre = palette.contrastThreshold,
    contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
    _palette$tonalOffset = palette.tonalOffset,
    tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
    other = _objectWithoutPropertiesLoose(palette, _excluded$u);
  var primary = palette.primary || getDefaultPrimary(mode);
  var secondary = palette.secondary || getDefaultSecondary(mode);
  var error = palette.error || getDefaultError(mode);
  var info = palette.info || getDefaultInfo(mode);
  var success = palette.success || getDefaultSuccess(mode);
  var warning = palette.warning || getDefaultWarning(mode);

  // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
  function getContrastText(background) {
    var contrastText = getContrastRatio_1(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== 'production') {
      var contrast = getContrastRatio_1(background, contrastText);
      if (contrast < 3) {
        console.error(["MUI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }
    return contrastText;
  }
  var augmentColor = function augmentColor(_ref) {
    var color = _ref.color,
      name = _ref.name,
      _ref$mainShade = _ref.mainShade,
      mainShade = _ref$mainShade === void 0 ? 500 : _ref$mainShade,
      _ref$lightShade = _ref.lightShade,
      lightShade = _ref$lightShade === void 0 ? 300 : _ref$lightShade,
      _ref$darkShade = _ref.darkShade,
      darkShade = _ref$darkShade === void 0 ? 700 : _ref$darkShade;
    color = _extends$1({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.hasOwnProperty('main')) {
      throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The color".concat(name ? " (".concat(name, ")") : '', " provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `").concat(mainShade, "` property.") : formatMuiErrorMessage$1(11, name ? " (".concat(name, ")") : '', mainShade));
    }
    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The color".concat(name ? " (".concat(name, ")") : '', " provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `").concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport { green } from \"@mui/material/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage$1(12, name ? " (".concat(name, ")") : '', JSON.stringify(color.main)));
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  var modes = {
    dark: dark,
    light: light
  };
  if (process.env.NODE_ENV !== 'production') {
    if (!modes[mode]) {
      console.error("MUI: The palette mode `".concat(mode, "` is not supported."));
    }
  }
  var paletteOutput = deepmerge$1(_extends$1({
    // A collection of common colors.
    common: _extends$1({}, common$1),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}

var _excluded$t = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */
function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
    _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
    _ref$fontWeightLight = _ref.fontWeightLight,
    fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
    _ref$fontWeightRegula = _ref.fontWeightRegular,
    fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
    _ref$fontWeightMedium = _ref.fontWeightMedium,
    fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
    _ref$fontWeightBold = _ref.fontWeightBold,
    fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
    _ref$htmlFontSize = _ref.htmlFontSize,
    htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
    allVariants = _ref.allVariants,
    pxToRem2 = _ref.pxToRem,
    other = _objectWithoutPropertiesLoose(_ref, _excluded$t);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('MUI: `fontSize` is required to be a number.');
    }
    if (typeof htmlFontSize !== 'number') {
      console.error('MUI: `htmlFontSize` is required to be a number.');
    }
  }
  var coef = fontSize / 14;
  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };
  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends$1({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };
  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: 'inherit',
      fontWeight: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      letterSpacing: 'inherit'
    }
  };
  return deepmerge$1(_extends$1({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep
  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;
function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
}

// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;

var _excluded$s = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
var duration = {
  shortest: 150,
  shorter: 200,
  "short": 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }
  var constant = height / 36;

  // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
  return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  var mergedEasing = _extends$1({}, easing, inputTransitions.easing);
  var mergedDuration = _extends$1({}, duration, inputTransitions.duration);
  var create = function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
      durationOption = _options$duration === void 0 ? mergedDuration.standard : _options$duration,
      _options$easing = options.easing,
      easingOption = _options$easing === void 0 ? mergedEasing.easeInOut : _options$easing,
      _options$delay = options.delay,
      delay = _options$delay === void 0 ? 0 : _options$delay,
      other = _objectWithoutPropertiesLoose(options, _excluded$s);
    if (process.env.NODE_ENV !== 'production') {
      var isString = function isString(value) {
        return typeof value === 'string';
      };
      // IE11 support, replace with Number.isNaN
      // eslint-disable-next-line no-restricted-globals
      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };
      if (!isString(props) && !Array.isArray(props)) {
        console.error('MUI: Argument "props" must be a string or Array.');
      }
      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("MUI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }
      if (!isString(easingOption)) {
        console.error('MUI: Argument "easing" must be a string.');
      }
      if (!isNumber(delay) && !isString(delay)) {
        console.error('MUI: Argument "delay" must be a number or a string.');
      }
      if (_typeof(options) !== 'object') {
        console.error(['MUI: Secong argument of transition.create must be an object.', "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join('\n'));
      }
      if (Object.keys(other).length !== 0) {
        console.error("MUI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }
    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  };
  return _extends$1({
    getAutoHeightDuration: getAutoHeightDuration,
    create: create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;

var _excluded$r = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$mixins = options.mixins,
    mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
    _options$palette = options.palette,
    paletteInput = _options$palette === void 0 ? {} : _options$palette,
    _options$transitions = options.transitions,
    transitionsInput = _options$transitions === void 0 ? {} : _options$transitions,
    _options$typography = options.typography,
    typographyInput = _options$typography === void 0 ? {} : _options$typography,
    other = _objectWithoutPropertiesLoose(options, _excluded$r);
  if (options.vars) {
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : formatMuiErrorMessage$1(18));
  }
  var palette = createPalette(paletteInput);
  var systemTheme = createTheme$2(options);
  var muiTheme = deepmerge$1(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette: palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: _extends$1({}, zIndex$1)
  });
  muiTheme = deepmerge$1(muiTheme, other);
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge$1(acc, argument);
  }, muiTheme);
  if (process.env.NODE_ENV !== 'production') {
    // TODO v6: Refactor to use globalStateClassesMapping from @mui/utils once `readOnly` state class is used in Rating component.
    var stateClasses = ['active', 'checked', 'completed', 'disabled', 'error', 'expanded', 'focused', 'focusVisible', 'required', 'selected'];
    var traverse = function traverse(node, component) {
      var key;

      // eslint-disable-next-line guard-for-in, no-restricted-syntax
      for (key in node) {
        var child = node[key];
        if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            var stateClass = generateUtilityClass('', key);
            console.error(["MUI: The `".concat(component, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', "Instead, you need to use the '&.".concat(stateClass, "' syntax:"), JSON.stringify({
              root: _defineProperty({}, "&.".concat(stateClass), child)
            }, null, 2), '', 'https://mui.com/r/state-classes-guide'].join('\n'));
          }
          // Remove the style to prevent global conflicts.
          node[key] = {};
        }
      }
    };
    Object.keys(muiTheme.components).forEach(function (component) {
      var styleOverrides = muiTheme.components[component].styleOverrides;
      if (styleOverrides && component.indexOf('Mui') === 0) {
        traverse(styleOverrides, component);
      }
    });
  }
  muiTheme.unstable_sxConfig = _extends$1({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$2({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}

var defaultTheme = createTheme();
var defaultTheme$1 = defaultTheme;

function useTheme() {
  var theme = useTheme$1(defaultTheme$1);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__namespace.useDebugValue(theme);
  }
  return theme[THEME_ID] || theme;
}

var createStyled$1 = {};

var _extends = {exports: {}};

(function (module) {
  function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
  }
  module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_extends);

var objectWithoutPropertiesLoose = {exports: {}};

(function (module) {
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n)) continue;
      t[n] = r[n];
    }
    return t;
  }
  module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(objectWithoutPropertiesLoose);

var require$$1 = /*@__PURE__*/getAugmentedNamespace(styledEngine);

var require$$4 = /*@__PURE__*/getAugmentedNamespace(deepmerge);

var require$$5 = /*@__PURE__*/getAugmentedNamespace(capitalize);

var require$$6 = /*@__PURE__*/getAugmentedNamespace(getDisplayName);

var require$$7 = /*@__PURE__*/getAugmentedNamespace(createTheme$1);

var require$$8 = /*@__PURE__*/getAugmentedNamespace(styleFunctionSx);

var _interopRequireDefault = interopRequireDefault.exports;
Object.defineProperty(createStyled$1, "__esModule", {
  value: true
});
var _default = createStyled$1["default"] = createStyled;
createStyled$1.shouldForwardProp = shouldForwardProp;
createStyled$1.systemDefaultTheme = void 0;
var _extends2 = _interopRequireDefault(_extends.exports);
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(objectWithoutPropertiesLoose.exports);
var _styledEngine = _interopRequireWildcard(require$$1);
var _deepmerge = require$$4;
var _capitalize = _interopRequireDefault(require$$5);
var _getDisplayName = _interopRequireDefault(require$$6);
var _createTheme = _interopRequireDefault(require$$7);
var _styleFunctionSx = _interopRequireDefault(require$$8);
var _excluded$q = ["ownerState"],
  _excluded2$5 = ["variants"],
  _excluded3$2 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
/* eslint-disable no-underscore-dangle */
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}

// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var systemDefaultTheme = createStyled$1.systemDefaultTheme = (0, _createTheme["default"])();
var lowercaseFirstLetter = function lowercaseFirstLetter(string) {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme(_ref2) {
  var defaultTheme = _ref2.defaultTheme,
    theme = _ref2.theme,
    themeId = _ref2.themeId;
  return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return function (props, styles) {
    return styles[slot];
  };
}
function processStyleArg(callableStyle, _ref) {
  var ownerState = _ref.ownerState,
    props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded$q);
  var resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, _extends2["default"])({
    ownerState: ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap(function (resolvedStyle) {
      return processStyleArg(resolvedStyle, (0, _extends2["default"])({
        ownerState: ownerState
      }, props));
    });
  }
  if (!!resolvedStylesArg && _typeof(resolvedStylesArg) === 'object' && Array.isArray(resolvedStylesArg.variants)) {
    var _resolvedStylesArg$va = resolvedStylesArg.variants,
      variants = _resolvedStylesArg$va === void 0 ? [] : _resolvedStylesArg$va,
      otherStyles = (0, _objectWithoutPropertiesLoose2["default"])(resolvedStylesArg, _excluded2$5);
    var result = otherStyles;
    variants.forEach(function (variant) {
      var isMatch = true;
      if (typeof variant.props === 'function') {
        isMatch = variant.props((0, _extends2["default"])({
          ownerState: ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach(function (key) {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [result];
        }
        result.push(typeof variant.style === 'function' ? variant.style((0, _extends2["default"])({
          ownerState: ownerState
        }, props, ownerState)) : variant.style);
      }
    });
    return result;
  }
  return resolvedStylesArg;
}
function createStyled() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var themeId = input.themeId,
    _input$defaultTheme = input.defaultTheme,
    defaultTheme = _input$defaultTheme === void 0 ? systemDefaultTheme : _input$defaultTheme,
    _input$rootShouldForw = input.rootShouldForwardProp,
    rootShouldForwardProp = _input$rootShouldForw === void 0 ? shouldForwardProp : _input$rootShouldForw,
    _input$slotShouldForw = input.slotShouldForwardProp,
    slotShouldForwardProp = _input$slotShouldForw === void 0 ? shouldForwardProp : _input$slotShouldForw;
  var systemSx = function systemSx(props) {
    return (0, _styleFunctionSx["default"])((0, _extends2["default"])({}, props, {
      theme: resolveTheme((0, _extends2["default"])({}, props, {
        defaultTheme: defaultTheme,
        themeId: themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return function (tag) {
    var inputOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    (0, _styledEngine.internal_processStyles)(tag, function (styles) {
      return styles.filter(function (style) {
        return !(style != null && style.__mui_systemSx);
      });
    });
    var componentName = inputOptions.name,
      componentSlot = inputOptions.slot,
      inputSkipVariantsResolver = inputOptions.skipVariantsResolver,
      inputSkipSx = inputOptions.skipSx,
      _inputOptions$overrid = inputOptions.overridesResolver,
      overridesResolver = _inputOptions$overrid === void 0 ? defaultOverridesResolver(lowercaseFirstLetter(componentSlot)) : _inputOptions$overrid,
      options = (0, _objectWithoutPropertiesLoose2["default"])(inputOptions, _excluded3$2);

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    var skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver :
    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
    var skipSx = inputSkipSx || false;
    var label;
    if (process.env.NODE_ENV !== 'production') {
      if (componentName) {
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = "".concat(componentName, "-").concat(lowercaseFirstLetter(componentSlot || 'Root'));
      }
    }
    var shouldForwardPropOption = shouldForwardProp;

    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    if (componentSlot === 'Root' || componentSlot === 'root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    var defaultStyledResolver = (0, _styledEngine["default"])(tag, (0, _extends2["default"])({
      shouldForwardProp: shouldForwardPropOption,
      label: label
    }, options));
    var transformStyleArg = function transformStyleArg(stylesArg) {
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge.isPlainObject)(stylesArg)) {
        return function (props) {
          return processStyleArg(stylesArg, (0, _extends2["default"])({}, props, {
            theme: resolveTheme({
              theme: props.theme,
              defaultTheme: defaultTheme,
              themeId: themeId
            })
          }));
        };
      }
      return stylesArg;
    };
    var muiStyledResolver = function muiStyledResolver(styleArg) {
      var transformedStyleArg = transformStyleArg(styleArg);
      for (var _len = arguments.length, expressions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        expressions[_key - 1] = arguments[_key];
      }
      var expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(function (props) {
          var theme = resolveTheme((0, _extends2["default"])({}, props, {
            defaultTheme: defaultTheme,
            themeId: themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          var styleOverrides = theme.components[componentName].styleOverrides;
          var resolvedStyleOverrides = {};
          // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
          Object.entries(styleOverrides).forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              slotKey = _ref4[0],
              slotStyle = _ref4[1];
            resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extends2["default"])({}, props, {
              theme: theme
            }));
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(function (props) {
          var _theme$components;
          var theme = resolveTheme((0, _extends2["default"])({}, props, {
            defaultTheme: defaultTheme,
            themeId: themeId
          }));
          var themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg({
            variants: themeVariants
          }, (0, _extends2["default"])({}, props, {
            theme: theme
          }));
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      var numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        var placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [].concat(_toConsumableArray(styleArg), _toConsumableArray(placeholders));
        transformedStyleArg.raw = [].concat(_toConsumableArray(styleArg.raw), _toConsumableArray(placeholders));
      }
      var Component = defaultStyledResolver.apply(void 0, [transformedStyleArg].concat(_toConsumableArray(expressionsWithDefaultTheme)));
      if (process.env.NODE_ENV !== 'production') {
        var displayName;
        if (componentName) {
          displayName = "".concat(componentName).concat((0, _capitalize["default"])(componentSlot || ''));
        }
        if (displayName === undefined) {
          displayName = "Styled(".concat((0, _getDisplayName["default"])(tag), ")");
        }
        Component.displayName = displayName;
      }
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}

// copied from @mui/system/createStyled
function slotShouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}

var rootShouldForwardProp = function rootShouldForwardProp(prop) {
  return slotShouldForwardProp(prop) && prop !== 'classes';
};
var rootShouldForwardProp$1 = rootShouldForwardProp;

var styled = _default({
  themeId: THEME_ID,
  defaultTheme: defaultTheme$1,
  rootShouldForwardProp: rootShouldForwardProp$1
});
var styled$1 = styled;

// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
var getOverlayAlpha = function getOverlayAlpha(elevation) {
  var alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * Math.pow(elevation, 2);
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return (alphaValue / 100).toFixed(2);
};
var getOverlayAlpha$1 = getOverlayAlpha;

process.env.NODE_ENV !== "production" ? {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object.isRequired
} : void 0;
function useDefaultProps(params) {
  return useDefaultProps$1(params);
}

function getSvgIconUtilityClass(slot) {
  return generateUtilityClass('MuiSvgIcon', slot);
}
generateUtilityClasses('MuiSvgIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);

var _excluded$p = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"];
var useUtilityClasses$j = function useUtilityClasses(ownerState) {
  var color = ownerState.color,
    fontSize = ownerState.fontSize,
    classes = ownerState.classes;
  var slots = {
    root: ['root', color !== 'inherit' && "color".concat(capitalize$1(color)), "fontSize".concat(capitalize$1(fontSize))]
  };
  return composeClasses(slots, getSvgIconUtilityClass, classes);
};
var SvgIconRoot = styled$1('svg', {
  name: 'MuiSvgIcon',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.color !== 'inherit' && styles["color".concat(capitalize$1(ownerState.color))], styles["fontSize".concat(capitalize$1(ownerState.fontSize))]];
  }
})(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
  return {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
    flexShrink: 0,
    transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
      duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
    }),
    fontSize: {
      inherit: 'inherit',
      small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
      medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
      large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
    }[ownerState.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : {
      action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
      disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
      inherit: undefined
    }[ownerState.color]
  };
});
var SvgIcon = /*#__PURE__*/React__namespace.forwardRef(function SvgIcon(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiSvgIcon'
  });
  var children = props.children,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'inherit' : _props$color,
    _props$component = props.component,
    component = _props$component === void 0 ? 'svg' : _props$component,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
    htmlColor = props.htmlColor,
    _props$inheritViewBox = props.inheritViewBox,
    inheritViewBox = _props$inheritViewBox === void 0 ? false : _props$inheritViewBox,
    titleAccess = props.titleAccess,
    _props$viewBox = props.viewBox,
    viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
    other = _objectWithoutPropertiesLoose(props, _excluded$p);
  var hasSvgAsChild = /*#__PURE__*/ /*#__PURE__*/React__namespace.isValidElement(children) && children.type === 'svg';
  var ownerState = _extends$1({}, props, {
    color: color,
    component: component,
    fontSize: fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox: inheritViewBox,
    viewBox: viewBox,
    hasSvgAsChild: hasSvgAsChild
  });
  var more = {};
  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }
  var classes = useUtilityClasses$j(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(SvgIconRoot, _extends$1({
    as: component,
    className: clsx(classes.root, className),
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, more, other, hasSvgAsChild && children.props, {
    ownerState: ownerState,
    children: [hasSvgAsChild ? children.props.children : children, titleAccess ? /*#__PURE__*/jsxRuntime.exports.jsx("title", {
      children: titleAccess
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'action', 'disabled', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'large', 'medium', 'small']), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = SvgIcon;

function createSvgIcon(path, displayName) {
  function Component(props, ref) {
    return /*#__PURE__*/jsxRuntime.exports.jsx(SvgIcon$1, _extends$1({
      "data-testid": "".concat(displayName, "Icon"),
      ref: ref
    }, props, {
      children: path
    }));
  }
  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }
  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React__namespace.memo(/*#__PURE__*/React__namespace.forwardRef(Component));
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = /*#__PURE__*/React__default["default"].createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);
  function Transition(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props["in"]) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref["in"];
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;
  var _proto = Transition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props["in"]) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;
    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }
    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default["default"].findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default["default"].findDOMNode(this), appearing],
      maybeNode = _ref2[0],
      maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default["default"].findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function () {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default["default"].findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
        maybeNode = _ref3[0],
        maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props,
      children = _this$props.children;
      _this$props["in"];
      _this$props.mountOnEnter;
      _this$props.unmountOnExit;
      _this$props.appear;
      _this$props.enter;
      _this$props.exit;
      _this$props.timeout;
      _this$props.addEndListener;
      _this$props.onEnter;
      _this$props.onEntering;
      _this$props.onEntered;
      _this$props.onExit;
      _this$props.onExiting;
      _this$props.onExited;
      _this$props.nodeRef;
      var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (/*#__PURE__*/
      // allows for nested Transitions
      React__default["default"].createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : /*#__PURE__*/React__default["default"].cloneElement(React__default["default"].Children.only(children), childProps))
    );
  };
  return Transition;
}(React__default["default"].Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  "in": PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}
Transition.defaultProps = {
  "in": false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && /*#__PURE__*/React.isValidElement(child) ? mapFn(child) : child;
  };
  var result = Object.create(null);
  if (children) React.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list

  var nextKeysPending = Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`

  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      onExited: onExited.bind(null, child),
      "in": true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (! /*#__PURE__*/React.isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = /*#__PURE__*/React.isValidElement(prevChild) && !prevChild.props["in"]; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = /*#__PURE__*/React.cloneElement(child, {
        onExited: onExited.bind(null, child),
        "in": true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = /*#__PURE__*/React.cloneElement(child, {
        "in": false
      });
    } else if (hasNext && hasPrev && /*#__PURE__*/React.isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = /*#__PURE__*/React.cloneElement(child, {
        onExited: onExited.bind(null, child),
        "in": prevChild.props["in"],
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);
  function TransitionGroup(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear

    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
      handleExited = _ref.handleExited,
      firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;
  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$1({}, state.children);
        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      Component = _this$props.component,
      childFactory = _this$props.childFactory,
      props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /*#__PURE__*/React__default["default"].createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /*#__PURE__*/React__default["default"].createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default["default"].createElement(Component, props, children));
  };
  return TransitionGroup;
}(React__default["default"].Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
var TransitionGroup$1 = TransitionGroup;

var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;
  var timeout = props.timeout,
    easing = props.easing,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : _typeof(easing) === 'object' ? easing[options.mode] : easing,
    delay: style.transitionDelay
  };
}

function getCollapseUtilityClass(slot) {
  return generateUtilityClass('MuiCollapse', slot);
}
generateUtilityClasses('MuiCollapse', ['root', 'horizontal', 'vertical', 'entered', 'hidden', 'wrapper', 'wrapperInner']);

var _excluded$o = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"];
var useUtilityClasses$i = function useUtilityClasses(ownerState) {
  var orientation = ownerState.orientation,
    classes = ownerState.classes;
  var slots = {
    root: ['root', "".concat(orientation)],
    entered: ['entered'],
    hidden: ['hidden'],
    wrapper: ['wrapper', "".concat(orientation)],
    wrapperInner: ['wrapperInner', "".concat(orientation)]
  };
  return composeClasses(slots, getCollapseUtilityClass, classes);
};
var CollapseRoot = styled$1('div', {
  name: 'MuiCollapse',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, styles[ownerState.orientation], ownerState.state === 'entered' && styles.entered, ownerState.state === 'exited' && !ownerState["in"] && ownerState.collapsedSize === '0px' && styles.hidden];
  }
})(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$1({
    height: 0,
    overflow: 'hidden',
    transition: theme.transitions.create('height')
  }, ownerState.orientation === 'horizontal' && {
    height: 'auto',
    width: 0,
    transition: theme.transitions.create('width')
  }, ownerState.state === 'entered' && _extends$1({
    height: 'auto',
    overflow: 'visible'
  }, ownerState.orientation === 'horizontal' && {
    width: 'auto'
  }), ownerState.state === 'exited' && !ownerState["in"] && ownerState.collapsedSize === '0px' && {
    visibility: 'hidden'
  });
});
var CollapseWrapper = styled$1('div', {
  name: 'MuiCollapse',
  slot: 'Wrapper',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.wrapper;
  }
})(function (_ref2) {
  var ownerState = _ref2.ownerState;
  return _extends$1({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%'
  }, ownerState.orientation === 'horizontal' && {
    width: 'auto',
    height: '100%'
  });
});
var CollapseWrapperInner = styled$1('div', {
  name: 'MuiCollapse',
  slot: 'WrapperInner',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.wrapperInner;
  }
})(function (_ref3) {
  var ownerState = _ref3.ownerState;
  return _extends$1({
    width: '100%'
  }, ownerState.orientation === 'horizontal' && {
    width: 'auto',
    height: '100%'
  });
});

/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Collapse = /*#__PURE__*/React__namespace.forwardRef(function Collapse(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiCollapse'
  });
  var addEndListener = props.addEndListener,
    _children = props.children,
    className = props.className,
    _props$collapsedSize = props.collapsedSize,
    collapsedSizeProp = _props$collapsedSize === void 0 ? '0px' : _props$collapsedSize,
    component = props.component,
    easing = props.easing,
    inProp = props["in"],
    onEnter = props.onEnter,
    onEntered = props.onEntered,
    onEntering = props.onEntering,
    onExit = props.onExit,
    onExited = props.onExited,
    onExiting = props.onExiting,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'vertical' : _props$orientation,
    style = props.style,
    _props$timeout = props.timeout,
    timeout = _props$timeout === void 0 ? duration.standard : _props$timeout,
    _props$TransitionComp = props.TransitionComponent,
    TransitionComponent = _props$TransitionComp === void 0 ? Transition$1 : _props$TransitionComp,
    other = _objectWithoutPropertiesLoose(props, _excluded$o);
  var ownerState = _extends$1({}, props, {
    orientation: orientation,
    collapsedSize: collapsedSizeProp
  });
  var classes = useUtilityClasses$i(ownerState);
  var theme = useTheme();
  var timer = useTimeout();
  var wrapperRef = React__namespace.useRef(null);
  var autoTransitionDuration = React__namespace.useRef();
  var collapsedSize = typeof collapsedSizeProp === 'number' ? "".concat(collapsedSizeProp, "px") : collapsedSizeProp;
  var isHorizontal = orientation === 'horizontal';
  var size = isHorizontal ? 'width' : 'height';
  var nodeRef = React__namespace.useRef(null);
  var handleRef = useForkRef(ref, nodeRef);
  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (maybeIsAppearing) {
      if (callback) {
        var node = nodeRef.current;

        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
        if (maybeIsAppearing === undefined) {
          callback(node);
        } else {
          callback(node, maybeIsAppearing);
        }
      }
    };
  };
  var getWrapperSize = function getWrapperSize() {
    return wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
  };
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    if (wrapperRef.current && isHorizontal) {
      // Set absolute position to get the size of collapsed content
      wrapperRef.current.style.position = 'absolute';
    }
    node.style[size] = collapsedSize;
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var wrapperSize = getWrapperSize();
    if (wrapperRef.current && isHorizontal) {
      // After the size is read reset the position back to default
      wrapperRef.current.style.position = '';
    }
    var _getTransitionProps = getTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }, {
        mode: 'enter'
      }),
      transitionDuration = _getTransitionProps.duration,
      transitionTimingFunction = _getTransitionProps.easing;
    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }
    node.style[size] = "".concat(wrapperSize, "px");
    node.style.transitionTimingFunction = transitionTimingFunction;
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
    node.style[size] = 'auto';
    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  var handleExit = normalizedTransitionCallback(function (node) {
    node.style[size] = "".concat(getWrapperSize(), "px");
    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleExiting = normalizedTransitionCallback(function (node) {
    var wrapperSize = getWrapperSize();
    var _getTransitionProps2 = getTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }, {
        mode: 'exit'
      }),
      transitionDuration = _getTransitionProps2.duration,
      transitionTimingFunction = _getTransitionProps2.easing;
    if (timeout === 'auto') {
      // TODO: rename getAutoHeightDuration to something more generic (width support)
      // Actually it just calculates animation duration based on size
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }
    node.style[size] = collapsedSize;
    node.style.transitionTimingFunction = transitionTimingFunction;
    if (onExiting) {
      onExiting(node);
    }
  });
  var handleAddEndListener = function handleAddEndListener(next) {
    if (timeout === 'auto') {
      timer.start(autoTransitionDuration.current || 0, next);
    }
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$1({
    "in": inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: function children(state, childProps) {
      return /*#__PURE__*/jsxRuntime.exports.jsx(CollapseRoot, _extends$1({
        as: component,
        className: clsx(classes.root, className, {
          'entered': classes.entered,
          'exited': !inProp && collapsedSize === '0px' && classes.hidden
        }[state]),
        style: _extends$1(_defineProperty({}, isHorizontal ? 'minWidth' : 'minHeight', collapsedSize), style),
        ref: handleRef
      }, childProps, {
        // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
        // that might have been forwarded from the Transition component.
        ownerState: _extends$1({}, ownerState, {
          state: state
        }),
        children: /*#__PURE__*/jsxRuntime.exports.jsx(CollapseWrapper, {
          ownerState: _extends$1({}, ownerState, {
            state: state
          }),
          className: classes.wrapper,
          ref: wrapperRef,
          children: /*#__PURE__*/jsxRuntime.exports.jsx(CollapseWrapperInner, {
            ownerState: _extends$1({}, ownerState, {
              state: state
            }),
            className: classes.wrapperInner,
            children: _children
          })
        })
      }));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Collapse.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  "in": PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
var Collapse$1 = Collapse;

function getPaperUtilityClass(slot) {
  return generateUtilityClass('MuiPaper', slot);
}
generateUtilityClasses('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);

var _excluded$n = ["className", "component", "elevation", "square", "variant"];
var useUtilityClasses$h = function useUtilityClasses(ownerState) {
  var square = ownerState.square,
    elevation = ownerState.elevation,
    variant = ownerState.variant,
    classes = ownerState.classes;
  var slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && "elevation".concat(elevation)]
  };
  return composeClasses(slots, getPaperUtilityClass, classes);
};
var PaperRoot = styled$1('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles["elevation".concat(ownerState.elevation)]];
  }
})(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  var _theme$vars$overlays;
  return _extends$1({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow')
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === 'outlined' && {
    border: "1px solid ".concat((theme.vars || theme).palette.divider)
  }, ownerState.variant === 'elevation' && _extends$1({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === 'dark' && {
    backgroundImage: "linear-gradient(".concat(alpha_1('#fff', getOverlayAlpha$1(ownerState.elevation)), ", ").concat(alpha_1('#fff', getOverlayAlpha$1(ownerState.elevation)), ")")
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
var Paper = /*#__PURE__*/React__namespace.forwardRef(function Paper(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiPaper'
  });
  var className = props.className,
    _props$component = props.component,
    component = _props$component === void 0 ? 'div' : _props$component,
    _props$elevation = props.elevation,
    elevation = _props$elevation === void 0 ? 1 : _props$elevation,
    _props$square = props.square,
    square = _props$square === void 0 ? false : _props$square,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'elevation' : _props$variant,
    other = _objectWithoutPropertiesLoose(props, _excluded$n);
  var ownerState = _extends$1({}, props, {
    component: component,
    elevation: elevation,
    square: square,
    variant: variant
  });
  var classes = useUtilityClasses$h(ownerState);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var theme = useTheme();
    if (theme.shadows[elevation] === undefined) {
      console.error(["MUI: The elevation provided <Paper elevation={".concat(elevation, "}> is not available in the theme."), "Please make sure that `theme.shadows[".concat(elevation, "]` is defined.")].join('\n'));
    }
  }
  return /*#__PURE__*/jsxRuntime.exports.jsx(PaperRoot, _extends$1({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Paper.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, function (props) {
    var elevation = props.elevation,
      variant = props.variant;
    if (elevation > 0 && variant === 'outlined') {
      return new Error("MUI: Combining `elevation={".concat(elevation, "}` with `variant=\"").concat(variant, "\"` has no effect. Either use `elevation={0}` or use a different `variant`."));
    }
    return null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['elevation', 'outlined']), PropTypes.string])
} : void 0;
var Paper$1 = Paper;

var _excluded$m = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"],
  _excluded2$4 = ["component", "slots", "slotProps"],
  _excluded3$1 = ["component"];
/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */
function useSlot(
/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */
name, parameters) {
  var className = parameters.className,
    initialElementType = parameters.elementType,
    ownerState = parameters.ownerState,
    externalForwardedProps = parameters.externalForwardedProps,
    getSlotOwnerState = parameters.getSlotOwnerState,
    internalForwardedProps = parameters.internalForwardedProps,
    useSlotPropsParams = _objectWithoutPropertiesLoose(parameters, _excluded$m);
  var rootComponent = externalForwardedProps.component,
    _externalForwardedPro = externalForwardedProps.slots,
    slots = _externalForwardedPro === void 0 ? _defineProperty({}, name, undefined) : _externalForwardedPro,
    _externalForwardedPro2 = externalForwardedProps.slotProps,
    slotProps = _externalForwardedPro2 === void 0 ? _defineProperty({}, name, undefined) : _externalForwardedPro2,
    other = _objectWithoutPropertiesLoose(externalForwardedProps, _excluded2$4);
  var elementType = slots[name] || initialElementType;

  // `slotProps[name]` can be a callback that receives the component's ownerState.
  // `resolvedComponentsProps` is always a plain object.
  var resolvedComponentsProps = resolveComponentProps(slotProps[name], ownerState);
  var _mergeSlotProps = mergeSlotProps(_extends$1({
      className: className
    }, useSlotPropsParams, {
      externalForwardedProps: name === 'root' ? other : undefined,
      externalSlotProps: resolvedComponentsProps
    })),
    slotComponent = _mergeSlotProps.props.component,
    internalRef = _mergeSlotProps.internalRef,
    mergedProps = _objectWithoutPropertiesLoose(_mergeSlotProps.props, _excluded3$1);
  var ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
  var slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
  var finalOwnerState = _extends$1({}, ownerState, slotOwnerState);
  var LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
  var props = appendOwnerState(elementType, _extends$1({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
    as: LeafComponent
  }, {
    ref: ref
  }), finalOwnerState);
  Object.keys(slotOwnerState).forEach(function (propName) {
    delete props[propName];
  });
  return [elementType, props];
}

function Ripple(props) {
  var className = props.className,
    classes = props.classes,
    _props$pulsate = props.pulsate,
    pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
    rippleX = props.rippleX,
    rippleY = props.rippleY,
    rippleSize = props.rippleSize,
    inProp = props["in"],
    onExited = props.onExited,
    timeout = props.timeout;
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    leaving = _React$useState2[0],
    setLeaving = _React$useState2[1];
  var rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  if (!inProp && !leaving) {
    setLeaving(true);
  }
  React__namespace.useEffect(function () {
    if (!inProp && onExited != null) {
      // react-transition-group#onExited
      var timeoutId = setTimeout(onExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }
    return undefined;
  }, [onExited, inProp, timeout]);
  return /*#__PURE__*/jsxRuntime.exports.jsx("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /*#__PURE__*/jsxRuntime.exports.jsx("span", {
      className: childClassName
    })
  });
}
process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  "in": PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;

var touchRippleClasses = generateUtilityClasses('MuiTouchRipple', ['root', 'ripple', 'rippleVisible', 'ripplePulsate', 'child', 'childLeaving', 'childPulsate']);
var touchRippleClasses$1 = touchRippleClasses;

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _excluded$l = ["center", "classes", "className"];
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4;
var DURATION = 550;
var DELAY_RIPPLE = 80;
var enterKeyframe = keyframes(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(0);\n    opacity: 0.1;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 0.3;\n  }\n"])))));
var exitKeyframe = keyframes(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"])))));
var pulsateKeyframe = keyframes(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(0.92);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n"])))));
var TouchRippleRoot = styled$1('span', {
  name: 'MuiTouchRipple',
  slot: 'Root'
})({
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: 'inherit'
});

// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
var TouchRippleRipple = styled$1(Ripple, {
  name: 'MuiTouchRipple',
  slot: 'Ripple'
})(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  opacity: 0;\n  position: absolute;\n\n  &.", " {\n    opacity: 0.3;\n    transform: scale(1);\n    animation-name: ", ";\n    animation-duration: ", "ms;\n    animation-timing-function: ", ";\n  }\n\n  &.", " {\n    animation-duration: ", "ms;\n  }\n\n  & .", " {\n    opacity: 1;\n    display: block;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-color: currentColor;\n  }\n\n  & .", " {\n    opacity: 0;\n    animation-name: ", ";\n    animation-duration: ", "ms;\n    animation-timing-function: ", ";\n  }\n\n  & .", " {\n    position: absolute;\n    /* @noflip */\n    left: 0px;\n    top: 0;\n    animation-name: ", ";\n    animation-duration: 2500ms;\n    animation-timing-function: ", ";\n    animation-iteration-count: infinite;\n    animation-delay: 200ms;\n  }\n"])))), touchRippleClasses$1.rippleVisible, enterKeyframe, DURATION, function (_ref) {
  var theme = _ref.theme;
  return theme.transitions.easing.easeInOut;
}, touchRippleClasses$1.ripplePulsate, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transitions.duration.shorter;
}, touchRippleClasses$1.child, touchRippleClasses$1.childLeaving, exitKeyframe, DURATION, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transitions.easing.easeInOut;
}, touchRippleClasses$1.childPulsate, pulsateKeyframe, function (_ref4) {
  var theme = _ref4.theme;
  return theme.transitions.easing.easeInOut;
});

/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */
var TouchRipple = /*#__PURE__*/React__namespace.forwardRef(function TouchRipple(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiTouchRipple'
  });
  var _props$center = props.center,
    centerProp = _props$center === void 0 ? false : _props$center,
    _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    className = props.className,
    other = _objectWithoutPropertiesLoose(props, _excluded$l);
  var _React$useState = React__namespace.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    ripples = _React$useState2[0],
    setRipples = _React$useState2[1];
  var nextKey = React__namespace.useRef(0);
  var rippleCallback = React__namespace.useRef(null);
  React__namespace.useEffect(function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]);

  // Used to filter out mouse emulated events on mobile.
  var ignoringMouseDown = React__namespace.useRef(false);
  // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.
  var startTimer = useTimeout();

  // This is the hook called once the previous timeout is ready.
  var startTimerCommit = React__namespace.useRef(null);
  var container = React__namespace.useRef(null);
  var startCommit = React__namespace.useCallback(function (params) {
    var pulsate = params.pulsate,
      rippleX = params.rippleX,
      rippleY = params.rippleY,
      rippleSize = params.rippleSize,
      cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(_toConsumableArray(oldRipples), [/*#__PURE__*/jsxRuntime.exports.jsx(TouchRippleRipple, {
        classes: {
          ripple: clsx(classes.ripple, touchRippleClasses$1.ripple),
          rippleVisible: clsx(classes.rippleVisible, touchRippleClasses$1.rippleVisible),
          ripplePulsate: clsx(classes.ripplePulsate, touchRippleClasses$1.ripplePulsate),
          child: clsx(classes.child, touchRippleClasses$1.child),
          childLeaving: clsx(classes.childLeaving, touchRippleClasses$1.childLeaving),
          childPulsate: clsx(classes.childPulsate, touchRippleClasses$1.childPulsate)
        },
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      }, nextKey.current)]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = React__namespace.useCallback(function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    var _options$pulsate = options.pulsate,
      pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
      _options$center = options.center,
      center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
      _options$fakeElement = options.fakeElement,
      fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
    if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }
    if ((event == null ? void 0 : event.type) === 'touchstart') {
      ignoringMouseDown.current = true;
    }
    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };

    // Get the size of the ripple
    var rippleX;
    var rippleY;
    var rippleSize;
    if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref5 = event.touches && event.touches.length > 0 ? event.touches[0] : event,
        clientX = _ref5.clientX,
        clientY = _ref5.clientY;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }
    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);

      // For some reason the animation is broken on Mobile Chrome if the size is even.
      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    }

    // Touche devices
    if (event != null && event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        };
        // Delay the execution of the ripple effect.
        // We have to make a tradeoff with this delay value.
        startTimer.start(DELAY_RIPPLE, function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        });
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit, startTimer]);
  var pulsate = React__namespace.useCallback(function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = React__namespace.useCallback(function (event, cb) {
    startTimer.clear();

    // The touch interaction occurs too quickly.
    // We still want to show ripple effect.
    if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.start(0, function () {
        stop(event, cb);
      });
      return;
    }
    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }
      return oldRipples;
    });
    rippleCallback.current = cb;
  }, [startTimer]);
  React__namespace.useImperativeHandle(ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/jsxRuntime.exports.jsx(TouchRippleRoot, _extends$1({
    className: clsx(touchRippleClasses$1.root, classes.root, className),
    ref: container
  }, other, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(TransitionGroup$1, {
      component: null,
      exit: true,
      children: ripples
    })
  }));
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
var TouchRipple$1 = TouchRipple;

function getButtonBaseUtilityClass(slot) {
  return generateUtilityClass('MuiButtonBase', slot);
}
var buttonBaseClasses = generateUtilityClasses('MuiButtonBase', ['root', 'disabled', 'focusVisible']);
var buttonBaseClasses$1 = buttonBaseClasses;

var _excluded$k = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"];
var useUtilityClasses$g = function useUtilityClasses(ownerState) {
  var disabled = ownerState.disabled,
    focusVisible = ownerState.focusVisible,
    focusVisibleClassName = ownerState.focusVisibleClassName,
    classes = ownerState.classes;
  var slots = {
    root: ['root', disabled && 'disabled', focusVisible && 'focusVisible']
  };
  var composedClasses = composeClasses(slots, getButtonBaseUtilityClass, classes);
  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += " ".concat(focusVisibleClassName);
  }
  return composedClasses;
};
var ButtonBaseRoot = styled$1('button', {
  name: 'MuiButtonBase',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})(_defineProperty(_defineProperty({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  boxSizing: 'border-box',
  WebkitTapHighlightColor: 'transparent',
  backgroundColor: 'transparent',
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: 'pointer',
  userSelect: 'none',
  verticalAlign: 'middle',
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  textDecoration: 'none',
  // So we take precedent over the style of a native <a /> element.
  color: 'inherit',
  '&::-moz-focus-inner': {
    borderStyle: 'none' // Remove Firefox dotted outline.
  }
}, "&.".concat(buttonBaseClasses$1.disabled), {
  pointerEvents: 'none',
  // Disable link interactions
  cursor: 'default'
}), '@media print', {
  colorAdjust: 'exact'
}));

/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */
var ButtonBase = /*#__PURE__*/React__namespace.forwardRef(function ButtonBase(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiButtonBase'
  });
  var action = props.action,
    _props$centerRipple = props.centerRipple,
    centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
    children = props.children,
    className = props.className,
    _props$component = props.component,
    component = _props$component === void 0 ? 'button' : _props$component,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$disableRipple = props.disableRipple,
    disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
    _props$disableTouchRi = props.disableTouchRipple,
    disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
    _props$focusRipple = props.focusRipple,
    focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
    _props$LinkComponent = props.LinkComponent,
    LinkComponent = _props$LinkComponent === void 0 ? 'a' : _props$LinkComponent,
    onBlur = props.onBlur,
    onClick = props.onClick,
    onContextMenu = props.onContextMenu,
    onDragLeave = props.onDragLeave,
    onFocus = props.onFocus,
    onFocusVisible = props.onFocusVisible,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    onMouseDown = props.onMouseDown,
    onMouseLeave = props.onMouseLeave,
    onMouseUp = props.onMouseUp,
    onTouchEnd = props.onTouchEnd,
    onTouchMove = props.onTouchMove,
    onTouchStart = props.onTouchStart,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    TouchRippleProps = props.TouchRippleProps,
    touchRippleRef = props.touchRippleRef,
    type = props.type,
    other = _objectWithoutPropertiesLoose(props, _excluded$k);
  var buttonRef = React__namespace.useRef(null);
  var rippleRef = React__namespace.useRef(null);
  var handleRippleRef = useForkRef(rippleRef, touchRippleRef);
  var _useIsFocusVisible = useIsFocusVisible(),
    isFocusVisibleRef = _useIsFocusVisible.isFocusVisibleRef,
    handleFocusVisible = _useIsFocusVisible.onFocus,
    handleBlurVisible = _useIsFocusVisible.onBlur,
    focusVisibleRef = _useIsFocusVisible.ref;
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focusVisible = _React$useState2[0],
    setFocusVisible = _React$useState2[1];
  if (disabled && focusVisible) {
    setFocusVisible(false);
  }
  React__namespace.useImperativeHandle(action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  var _React$useState3 = React__namespace.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    mountedState = _React$useState4[0],
    setMountedState = _React$useState4[1];
  React__namespace.useEffect(function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;
  React__namespace.useEffect(function () {
    if (focusVisible && focusRipple && !disableRipple && mountedState) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible, mountedState]);
  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return useEventCallback(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }
      var ignore = skipRippleAction;
      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }
      return true;
    });
  }
  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleContextMenu = useRippleHandler('stop', onContextMenu);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = useEventCallback(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }
    if (onFocus) {
      onFocus(event);
    }
  });
  var isNonNativeButton = function isNonNativeButton() {
    var button = buttonRef.current;
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };

  /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */
  var keydownRef = React__namespace.useRef(false);
  var handleKeyDown = useEventCallback(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }

    // Keyboard accessibility for non interactive elements
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();
      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = useEventCallback(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }
    if (onKeyUp) {
      onKeyUp(event);
    }

    // Keyboard accessibility for non interactive elements
    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;
  if (ComponentProp === 'button' && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }
  var buttonProps = {};
  if (ComponentProp === 'button') {
    buttonProps.type = type === undefined ? 'button' : type;
    buttonProps.disabled = disabled;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = 'button';
    }
    if (disabled) {
      buttonProps['aria-disabled'] = disabled;
    }
  }
  var handleRef = useForkRef(ref, focusVisibleRef, buttonRef);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__namespace.useEffect(function () {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['MUI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }
  var ownerState = _extends$1({}, props, {
    centerRipple: centerRipple,
    component: component,
    disabled: disabled,
    disableRipple: disableRipple,
    disableTouchRipple: disableTouchRipple,
    focusRipple: focusRipple,
    tabIndex: tabIndex,
    focusVisible: focusVisible
  });
  var classes = useUtilityClasses$g(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(ButtonBaseRoot, _extends$1({
    as: ComponentProp,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    onBlur: handleBlur,
    onClick: onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex,
    type: type
  }, buttonProps, other, {
    children: [children, enableTouchRipple ? /*#__PURE__*/
    /* TouchRipple is only needed client-side, x2 boost on the server. */
    jsxRuntime.exports.jsx(TouchRipple$1, _extends$1({
      ref: handleRippleRef,
      center: centerRipple
    }, TouchRippleProps)) : null]
  }));
});
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType$1,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes /* @typescript-to-proptypes-ignore */.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string])
} : void 0;
var ButtonBase$1 = ButtonBase;

function getAlertUtilityClass(slot) {
  return generateUtilityClass('MuiAlert', slot);
}
var alertClasses = generateUtilityClasses('MuiAlert', ['root', 'action', 'icon', 'message', 'filled', 'colorSuccess', 'colorInfo', 'colorWarning', 'colorError', 'filledSuccess', 'filledInfo', 'filledWarning', 'filledError', 'outlined', 'outlinedSuccess', 'outlinedInfo', 'outlinedWarning', 'outlinedError', 'standard', 'standardSuccess', 'standardInfo', 'standardWarning', 'standardError']);
var alertClasses$1 = alertClasses;

function getIconButtonUtilityClass(slot) {
  return generateUtilityClass('MuiIconButton', slot);
}
var iconButtonClasses = generateUtilityClasses('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'colorError', 'colorInfo', 'colorSuccess', 'colorWarning', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
var iconButtonClasses$1 = iconButtonClasses;

var _excluded$j = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];
var useUtilityClasses$f = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    disabled = ownerState.disabled,
    color = ownerState.color,
    edge = ownerState.edge,
    size = ownerState.size;
  var slots = {
    root: ['root', disabled && 'disabled', color !== 'default' && "color".concat(capitalize$1(color)), edge && "edge".concat(capitalize$1(edge)), "size".concat(capitalize$1(size))]
  };
  return composeClasses(slots, getIconButtonUtilityClass, classes);
};
var IconButtonRoot = styled$1(ButtonBase$1, {
  name: 'MuiIconButton',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.color !== 'default' && styles["color".concat(capitalize$1(ownerState.color))], ownerState.edge && styles["edge".concat(capitalize$1(ownerState.edge))], styles["size".concat(capitalize$1(ownerState.size))]];
  }
})(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$1({
    textAlign: 'center',
    flex: '0 0 auto',
    fontSize: theme.typography.pxToRem(24),
    padding: 8,
    borderRadius: '50%',
    overflow: 'visible',
    // Explicitly set the default value to solve a bug on IE11.
    color: (theme.vars || theme).palette.action.active,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shortest
    })
  }, !ownerState.disableRipple && {
    '&:hover': {
      backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.action.activeChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha_1(theme.palette.action.active, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }, ownerState.edge === 'start' && {
    marginLeft: ownerState.size === 'small' ? -3 : -12
  }, ownerState.edge === 'end' && {
    marginRight: ownerState.size === 'small' ? -3 : -12
  });
}, function (_ref2) {
  var theme = _ref2.theme,
    ownerState = _ref2.ownerState;
  var _palette;
  var palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
  return _extends$1({}, ownerState.color === 'inherit' && {
    color: 'inherit'
  }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && _extends$1({
    color: palette == null ? void 0 : palette.main
  }, !ownerState.disableRipple && {
    '&:hover': _extends$1({}, palette && {
      backgroundColor: theme.vars ? "rgba(".concat(palette.mainChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha_1(palette.main, theme.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    })
  }), ownerState.size === 'small' && {
    padding: 5,
    fontSize: theme.typography.pxToRem(18)
  }, ownerState.size === 'large' && {
    padding: 12,
    fontSize: theme.typography.pxToRem(28)
  }, _defineProperty({}, "&.".concat(iconButtonClasses$1.disabled), {
    backgroundColor: 'transparent',
    color: (theme.vars || theme).palette.action.disabled
  }));
});

/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */
var IconButton = /*#__PURE__*/React__namespace.forwardRef(function IconButton(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiIconButton'
  });
  var _props$edge = props.edge,
    edge = _props$edge === void 0 ? false : _props$edge,
    children = props.children,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'default' : _props$color,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$disableFocusRi = props.disableFocusRipple,
    disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    other = _objectWithoutPropertiesLoose(props, _excluded$j);
  var ownerState = _extends$1({}, props, {
    edge: edge,
    color: color,
    disabled: disabled,
    disableFocusRipple: disableFocusRipple,
    size: size
  });
  var classes = useUtilityClasses$f(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(IconButtonRoot, _extends$1({
    className: clsx(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other, {
    ownerState: ownerState,
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? IconButton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var found = React__namespace.Children.toArray(props.children).some(function (child) {
      return /*#__PURE__*/ /*#__PURE__*/React__namespace.isValidElement(child) && child.props.onClick;
    });
    if (found) {
      return new Error(['MUI: You are providing an onClick event listener to a child of a button element.', 'Prefer applying it to the IconButton directly.', 'This guarantees that the whole <button> will be responsive to click events.'].join('\n'));
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(['end', 'start', false]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['small', 'medium', 'large']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var IconButton$1 = IconButton;

var SuccessOutlinedIcon = createSvgIcon(/*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

var ReportProblemOutlinedIcon = createSvgIcon(/*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

var ErrorOutlineIcon = createSvgIcon(/*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

var InfoOutlinedIcon = createSvgIcon(/*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

var ClearIcon = createSvgIcon(/*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

var _excluded$i = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"];
var useUtilityClasses$e = function useUtilityClasses(ownerState) {
  var variant = ownerState.variant,
    color = ownerState.color,
    severity = ownerState.severity,
    classes = ownerState.classes;
  var slots = {
    root: ['root', "color".concat(capitalize$1(color || severity)), "".concat(variant).concat(capitalize$1(color || severity)), "".concat(variant)],
    icon: ['icon'],
    message: ['message'],
    action: ['action']
  };
  return composeClasses(slots, getAlertUtilityClass, classes);
};
var AlertRoot = styled$1(Paper$1, {
  name: 'MuiAlert',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, styles[ownerState.variant], styles["".concat(ownerState.variant).concat(capitalize$1(ownerState.color || ownerState.severity))]];
  }
})(function (_ref) {
  var theme = _ref.theme;
  var getColor = theme.palette.mode === 'light' ? darken_1 : lighten_1;
  var getBackgroundColor = theme.palette.mode === 'light' ? lighten_1 : darken_1;
  return _extends$1({}, theme.typography.body2, {
    backgroundColor: 'transparent',
    display: 'flex',
    padding: '6px 16px',
    variants: [].concat(_toConsumableArray(Object.entries(theme.palette).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        value = _ref3[1];
      return value.main && value.light;
    }).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        color = _ref5[0];
      return {
        props: {
          colorSeverity: color,
          variant: 'standard'
        },
        style: _defineProperty({
          color: theme.vars ? theme.vars.palette.Alert["".concat(color, "Color")] : getColor(theme.palette[color].light, 0.6),
          backgroundColor: theme.vars ? theme.vars.palette.Alert["".concat(color, "StandardBg")] : getBackgroundColor(theme.palette[color].light, 0.9)
        }, "& .".concat(alertClasses$1.icon), theme.vars ? {
          color: theme.vars.palette.Alert["".concat(color, "IconColor")]
        } : {
          color: theme.palette[color].main
        })
      };
    })), _toConsumableArray(Object.entries(theme.palette).filter(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        value = _ref7[1];
      return value.main && value.light;
    }).map(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 1),
        color = _ref9[0];
      return {
        props: {
          colorSeverity: color,
          variant: 'outlined'
        },
        style: _defineProperty({
          color: theme.vars ? theme.vars.palette.Alert["".concat(color, "Color")] : getColor(theme.palette[color].light, 0.6),
          border: "1px solid ".concat((theme.vars || theme).palette[color].light)
        }, "& .".concat(alertClasses$1.icon), theme.vars ? {
          color: theme.vars.palette.Alert["".concat(color, "IconColor")]
        } : {
          color: theme.palette[color].main
        })
      };
    })), _toConsumableArray(Object.entries(theme.palette).filter(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 2),
        value = _ref11[1];
      return value.main && value.dark;
    }).map(function (_ref12) {
      var _ref13 = _slicedToArray(_ref12, 1),
        color = _ref13[0];
      return {
        props: {
          colorSeverity: color,
          variant: 'filled'
        },
        style: _extends$1({
          fontWeight: theme.typography.fontWeightMedium
        }, theme.vars ? {
          color: theme.vars.palette.Alert["".concat(color, "FilledColor")],
          backgroundColor: theme.vars.palette.Alert["".concat(color, "FilledBg")]
        } : {
          backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
          color: theme.palette.getContrastText(theme.palette[color].main)
        })
      };
    })))
  });
});
var AlertIcon = styled$1('div', {
  name: 'MuiAlert',
  slot: 'Icon',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.icon;
  }
})({
  marginRight: 12,
  padding: '7px 0',
  display: 'flex',
  fontSize: 22,
  opacity: 0.9
});
var AlertMessage = styled$1('div', {
  name: 'MuiAlert',
  slot: 'Message',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.message;
  }
})({
  padding: '8px 0',
  minWidth: 0,
  overflow: 'auto'
});
var AlertAction = styled$1('div', {
  name: 'MuiAlert',
  slot: 'Action',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.action;
  }
})({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '4px 0 0 16px',
  marginLeft: 'auto',
  marginRight: -8
});
var defaultIconMapping = {
  success: /*#__PURE__*/jsxRuntime.exports.jsx(SuccessOutlinedIcon, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/jsxRuntime.exports.jsx(ReportProblemOutlinedIcon, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/jsxRuntime.exports.jsx(ErrorOutlineIcon, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/jsxRuntime.exports.jsx(InfoOutlinedIcon, {
    fontSize: "inherit"
  })
};
var Alert = /*#__PURE__*/React__namespace.forwardRef(function Alert(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiAlert'
  });
  var action = props.action,
    children = props.children,
    className = props.className,
    _props$closeText = props.closeText,
    closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
    color = props.color,
    _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    _props$componentsProp = props.componentsProps,
    componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp,
    icon = props.icon,
    _props$iconMapping = props.iconMapping,
    iconMapping = _props$iconMapping === void 0 ? defaultIconMapping : _props$iconMapping,
    onClose = props.onClose,
    _props$role = props.role,
    role = _props$role === void 0 ? 'alert' : _props$role,
    _props$severity = props.severity,
    severity = _props$severity === void 0 ? 'success' : _props$severity,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'standard' : _props$variant,
    other = _objectWithoutPropertiesLoose(props, _excluded$i);
  var ownerState = _extends$1({}, props, {
    color: color,
    severity: severity,
    variant: variant,
    colorSeverity: color || severity
  });
  var classes = useUtilityClasses$e(ownerState);
  var externalForwardedProps = {
    slots: _extends$1({
      closeButton: components.CloseButton,
      closeIcon: components.CloseIcon
    }, slots),
    slotProps: _extends$1({}, componentsProps, slotProps)
  };
  var _useSlot = useSlot('closeButton', {
      elementType: IconButton$1,
      externalForwardedProps: externalForwardedProps,
      ownerState: ownerState
    }),
    _useSlot2 = _slicedToArray(_useSlot, 2),
    CloseButtonSlot = _useSlot2[0],
    closeButtonProps = _useSlot2[1];
  var _useSlot3 = useSlot('closeIcon', {
      elementType: ClearIcon,
      externalForwardedProps: externalForwardedProps,
      ownerState: ownerState
    }),
    _useSlot4 = _slicedToArray(_useSlot3, 2),
    CloseIconSlot = _useSlot4[0],
    closeIconProps = _useSlot4[1];
  return /*#__PURE__*/jsxRuntime.exports.jsxs(AlertRoot, _extends$1({
    role: role,
    elevation: 0,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other, {
    children: [icon !== false ? /*#__PURE__*/jsxRuntime.exports.jsx(AlertIcon, {
      ownerState: ownerState,
      className: classes.icon,
      children: icon || iconMapping[severity] || defaultIconMapping[severity]
    }) : null, /*#__PURE__*/jsxRuntime.exports.jsx(AlertMessage, {
      ownerState: ownerState,
      className: classes.message,
      children: children
    }), action != null ? /*#__PURE__*/jsxRuntime.exports.jsx(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: action
    }) : null, action == null && onClose ? /*#__PURE__*/jsxRuntime.exports.jsx(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: /*#__PURE__*/jsxRuntime.exports.jsx(CloseButtonSlot, _extends$1({
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
      }, closeButtonProps, {
        children: /*#__PURE__*/jsxRuntime.exports.jsx(CloseIconSlot, _extends$1({
          fontSize: "small"
        }, closeIconProps))
      }))
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? Alert.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: PropTypes.node,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: PropTypes.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  components: PropTypes.shape({
    CloseButton: PropTypes.elementType,
    CloseIcon: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    closeButton: PropTypes.object,
    closeIcon: PropTypes.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: PropTypes.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: PropTypes.shape({
    error: PropTypes.node,
    info: PropTypes.node,
    success: PropTypes.node,
    warning: PropTypes.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: PropTypes.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    closeButton: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    closeIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    closeButton: PropTypes.elementType,
    closeIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['filled', 'outlined', 'standard']), PropTypes.string])
} : void 0;
var Alert$1 = Alert;

function getTypographyUtilityClass(slot) {
  return generateUtilityClass('MuiTypography', slot);
}
generateUtilityClasses('MuiTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'inherit', 'button', 'caption', 'overline', 'alignLeft', 'alignRight', 'alignCenter', 'alignJustify', 'noWrap', 'gutterBottom', 'paragraph']);

var _excluded$h = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];
var useUtilityClasses$d = function useUtilityClasses(ownerState) {
  var align = ownerState.align,
    gutterBottom = ownerState.gutterBottom,
    noWrap = ownerState.noWrap,
    paragraph = ownerState.paragraph,
    variant = ownerState.variant,
    classes = ownerState.classes;
  var slots = {
    root: ['root', variant, ownerState.align !== 'inherit' && "align".concat(capitalize$1(align)), gutterBottom && 'gutterBottom', noWrap && 'noWrap', paragraph && 'paragraph']
  };
  return composeClasses(slots, getTypographyUtilityClass, classes);
};
var TypographyRoot = styled$1('span', {
  name: 'MuiTypography',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.variant && styles[ownerState.variant], ownerState.align !== 'inherit' && styles["align".concat(capitalize$1(ownerState.align))], ownerState.noWrap && styles.noWrap, ownerState.gutterBottom && styles.gutterBottom, ownerState.paragraph && styles.paragraph];
  }
})(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$1({
    margin: 0
  }, ownerState.variant === 'inherit' && {
    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
    font: 'inherit'
  }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
    textAlign: ownerState.align
  }, ownerState.noWrap && {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, ownerState.gutterBottom && {
    marginBottom: '0.35em'
  }, ownerState.paragraph && {
    marginBottom: 16
  });
});
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  inherit: 'p'
};

// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
var colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};
var transformDeprecatedColors = function transformDeprecatedColors(color) {
  return colorTransformations[color] || color;
};
var Typography = /*#__PURE__*/React__namespace.forwardRef(function Typography(inProps, ref) {
  var themeProps = useDefaultProps({
    props: inProps,
    name: 'MuiTypography'
  });
  var color = transformDeprecatedColors(themeProps.color);
  var props = extendSxProp(_extends$1({}, themeProps, {
    color: color
  }));
  var _props$align = props.align,
    align = _props$align === void 0 ? 'inherit' : _props$align,
    className = props.className,
    component = props.component,
    _props$gutterBottom = props.gutterBottom,
    gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
    _props$noWrap = props.noWrap,
    noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
    _props$paragraph = props.paragraph,
    paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'body1' : _props$variant,
    _props$variantMapping = props.variantMapping,
    variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
    other = _objectWithoutPropertiesLoose(props, _excluded$h);
  var ownerState = _extends$1({}, props, {
    align: align,
    color: color,
    className: className,
    component: component,
    gutterBottom: gutterBottom,
    noWrap: noWrap,
    paragraph: paragraph,
    variant: variant,
    variantMapping: variantMapping
  });
  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  var classes = useUtilityClasses$d(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(TypographyRoot, _extends$1({
    as: Component,
    ref: ref,
    ownerState: ownerState,
    className: clsx(classes.root, className)
  }, other));
});
process.env.NODE_ENV !== "production" ? Typography.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['body1', 'body2', 'button', 'caption', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'inherit', 'overline', 'subtitle1', 'subtitle2']), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes /* @typescript-to-proptypes-ignore */.object
} : void 0;
var Typography$1 = Typography;

function getContainer$1(container) {
  return typeof container === 'function' ? container() : container;
}

/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */
var Portal = /*#__PURE__*/React__namespace.forwardRef(function Portal(props, forwardedRef) {
  var children = props.children,
    container = props.container,
    _props$disablePortal = props.disablePortal,
    disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal;
  var _React$useState = React__namespace.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mountNode = _React$useState2[0],
    setMountNode = _React$useState2[1];
  // @ts-expect-error TODO upstream fix
  var handleRef = useForkRef(/*#__PURE__*/ /*#__PURE__*/React__namespace.isValidElement(children) ? children.ref : null, forwardedRef);
  useEnhancedEffect$1(function () {
    if (!disablePortal) {
      setMountNode(getContainer$1(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect$1(function () {
    if (mountNode && !disablePortal) {
      setRef(forwardedRef, mountNode);
      return function () {
        setRef(forwardedRef, null);
      };
    }
    return undefined;
  }, [forwardedRef, mountNode, disablePortal]);
  if (disablePortal) {
    if (/*#__PURE__*/React__namespace.isValidElement(children)) {
      var newProps = {
        ref: handleRef
      };
      return /*#__PURE__*/React__namespace.cloneElement(children, newProps);
    }
    return /*#__PURE__*/jsxRuntime.exports.jsx(React__namespace.Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/jsxRuntime.exports.jsx(React__namespace.Fragment, {
    children: mountNode ? /*#__PURE__*/ReactDOM__namespace.createPortal(children, mountNode) : mountNode
  });
});
process.env.NODE_ENV !== "production" ? Portal.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = exactProp(Portal.propTypes);
}
var Portal$1 = Portal;

function formControlState(_ref) {
  var props = _ref.props,
    states = _ref.states,
    muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];
    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }
    return acc;
  }, {});
}

/**
 * @ignore - internal component.
 */
var FormControlContext = /*#__PURE__*/React__namespace.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}
var FormControlContext$1 = FormControlContext;

function useFormControl() {
  return React__namespace.useContext(FormControlContext$1);
}

var _excluded$g = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
var styles$1 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};

/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Fade = /*#__PURE__*/React__namespace.forwardRef(function Fade(props, ref) {
  var theme = useTheme();
  var defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  var addEndListener = props.addEndListener,
    _props$appear = props.appear,
    appear = _props$appear === void 0 ? true : _props$appear,
    _children = props.children,
    easing = props.easing,
    inProp = props["in"],
    onEnter = props.onEnter,
    onEntered = props.onEntered,
    onEntering = props.onEntering,
    onExit = props.onExit,
    onExited = props.onExited,
    onExiting = props.onExiting,
    style = props.style,
    _props$timeout = props.timeout,
    timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
    _props$TransitionComp = props.TransitionComponent,
    TransitionComponent = _props$TransitionComp === void 0 ? Transition$1 : _props$TransitionComp,
    other = _objectWithoutPropertiesLoose(props, _excluded$g);
  var nodeRef = React__namespace.useRef(null);
  var handleRef = useForkRef(nodeRef, _children.ref, ref);
  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (maybeIsAppearing) {
      if (callback) {
        var node = nodeRef.current;

        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
        if (maybeIsAppearing === undefined) {
          callback(node);
        } else {
          callback(node, maybeIsAppearing);
        }
      }
    };
  };
  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    reflow(node); // So the animation always start from the start.

    var transitionProps = getTransitionProps({
      style: style,
      timeout: timeout,
      easing: easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = getTransitionProps({
      style: style,
      timeout: timeout,
      easing: easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleAddEndListener = function handleAddEndListener(next) {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$1({
    appear: appear,
    "in": inProp,
    nodeRef: nodeRef ,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: function children(state, childProps) {
      return /*#__PURE__*/React__namespace.cloneElement(_children, _extends$1({
        style: _extends$1({
          opacity: 0,
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles$1[state], style, _children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Fade.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  "in": PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
var Fade$1 = Fade;

function getBackdropUtilityClass(slot) {
  return generateUtilityClass('MuiBackdrop', slot);
}
generateUtilityClasses('MuiBackdrop', ['root', 'invisible']);

var _excluded$f = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"];
var useUtilityClasses$c = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    invisible = ownerState.invisible;
  var slots = {
    root: ['root', invisible && 'invisible']
  };
  return composeClasses(slots, getBackdropUtilityClass, classes);
};
var BackdropRoot = styled$1('div', {
  name: 'MuiBackdrop',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.invisible && styles.invisible];
  }
})(function (_ref2) {
  var ownerState = _ref2.ownerState;
  return _extends$1({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  }, ownerState.invisible && {
    backgroundColor: 'transparent'
  });
});
var Backdrop = /*#__PURE__*/React__namespace.forwardRef(function Backdrop(inProps, ref) {
  var _slotProps$root, _ref, _slots$root;
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiBackdrop'
  });
  var children = props.children,
    className = props.className,
    _props$component = props.component,
    component = _props$component === void 0 ? 'div' : _props$component,
    _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    _props$componentsProp = props.componentsProps,
    componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp,
    _props$invisible = props.invisible,
    invisible = _props$invisible === void 0 ? false : _props$invisible,
    open = props.open,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    _props$TransitionComp = props.TransitionComponent,
    TransitionComponent = _props$TransitionComp === void 0 ? Fade$1 : _props$TransitionComp,
    transitionDuration = props.transitionDuration,
    other = _objectWithoutPropertiesLoose(props, _excluded$f);
  var ownerState = _extends$1({}, props, {
    component: component,
    invisible: invisible
  });
  var classes = useUtilityClasses$c(ownerState);
  var rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
  return /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$1({
    "in": open,
    timeout: transitionDuration
  }, other, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(BackdropRoot, _extends$1({
      "aria-hidden": true
    }, rootSlotProps, {
      as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
      className: clsx(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
      ownerState: _extends$1({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
      classes: classes,
      ref: ref,
      children: children
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Backdrop.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
var Backdrop$1 = Backdrop;

function getSwitchBaseUtilityClass(slot) {
  return generateUtilityClass('PrivateSwitchBase', slot);
}
generateUtilityClasses('PrivateSwitchBase', ['root', 'checked', 'disabled', 'input', 'edgeStart', 'edgeEnd']);

var _excluded$e = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"];
var useUtilityClasses$b = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    checked = ownerState.checked,
    disabled = ownerState.disabled,
    edge = ownerState.edge;
  var slots = {
    root: ['root', checked && 'checked', disabled && 'disabled', edge && "edge".concat(capitalize$1(edge))],
    input: ['input']
  };
  return composeClasses(slots, getSwitchBaseUtilityClass, classes);
};
var SwitchBaseRoot = styled$1(ButtonBase$1)(function (_ref) {
  var ownerState = _ref.ownerState;
  return _extends$1({
    padding: 9,
    borderRadius: '50%'
  }, ownerState.edge === 'start' && {
    marginLeft: ownerState.size === 'small' ? -3 : -12
  }, ownerState.edge === 'end' && {
    marginRight: ownerState.size === 'small' ? -3 : -12
  });
});
var SwitchBaseInput = styled$1('input', {
  shouldForwardProp: rootShouldForwardProp$1
})({
  cursor: 'inherit',
  position: 'absolute',
  opacity: 0,
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
});

/**
 * @ignore - internal component.
 */
var SwitchBase = /*#__PURE__*/React__namespace.forwardRef(function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
    checkedProp = props.checked,
    checkedIcon = props.checkedIcon,
    className = props.className,
    defaultChecked = props.defaultChecked,
    disabledProp = props.disabled,
    _props$disableFocusRi = props.disableFocusRipple,
    disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
    _props$edge = props.edge,
    edge = _props$edge === void 0 ? false : _props$edge,
    icon = props.icon,
    id = props.id,
    inputProps = props.inputProps,
    inputRef = props.inputRef,
    name = props.name,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    readOnly = props.readOnly,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    tabIndex = props.tabIndex,
    type = props.type,
    value = props.value,
    other = _objectWithoutPropertiesLoose(props, _excluded$e);
  var _useControlled = useControlled({
      controlled: checkedProp,
      "default": Boolean(defaultChecked),
      name: 'SwitchBase',
      state: 'checked'
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    checked = _useControlled2[0],
    setCheckedState = _useControlled2[1];
  var muiFormControl = useFormControl();
  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };
  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };
  var handleInputChange = function handleInputChange(event) {
    // Workaround for https://github.com/facebook/react/issues/9023
    if (event.nativeEvent.defaultPrevented) {
      return;
    }
    var newChecked = event.target.checked;
    setCheckedState(newChecked);
    if (onChange) {
      // TODO v6: remove the second argument.
      onChange(event, newChecked);
    }
  };
  var disabled = disabledProp;
  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }
  var hasLabelFor = type === 'checkbox' || type === 'radio';
  var ownerState = _extends$1({}, props, {
    checked: checked,
    disabled: disabled,
    disableFocusRipple: disableFocusRipple,
    edge: edge
  });
  var classes = useUtilityClasses$b(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(SwitchBaseRoot, _extends$1({
    component: "span",
    className: clsx(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/jsxRuntime.exports.jsx(SwitchBaseInput, _extends$1({
      autoFocus: autoFocus,
      checked: checkedProp,
      defaultChecked: defaultChecked,
      className: classes.input,
      disabled: disabled,
      id: hasLabelFor ? id : undefined,
      name: name,
      onChange: handleInputChange,
      readOnly: readOnly,
      ref: inputRef,
      required: required,
      ownerState: ownerState,
      tabIndex: tabIndex,
      type: type
    }, type === 'checkbox' && value === undefined ? {} : {
      value: value
    }, inputProps)), checked ? checkedIcon : icon]
  }));
});

// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
process.env.NODE_ENV !== "production" ? SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(['end', 'start', false]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /*
   * @ignore
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,
  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
var SwitchBase$1 = SwitchBase;

// Is a vertical scrollbar displayed?
function isOverflowing(container) {
  var doc = ownerDocument(container);
  if (doc.body === container) {
    return ownerWindow(container).innerWidth > doc.documentElement.clientWidth;
  }
  return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
  if (show) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('aria-hidden');
  }
}
function getPaddingRight(element) {
  return parseInt(ownerWindow(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
  // The forbidden HTML tags are the ones from ARIA specification that
  // can be children of body and can't have aria-hidden attribute.
  // cf. https://www.w3.org/TR/html-aria/#docconformance
  var forbiddenTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE', 'LINK', 'MAP', 'META', 'NOSCRIPT', 'PICTURE', 'COL', 'COLGROUP', 'PARAM', 'SLOT', 'SOURCE', 'TRACK'];
  var isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
  var isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
  return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
  var blacklist = [mountElement, currentElement].concat(_toConsumableArray(elementsToExclude));
  [].forEach.call(container.children, function (element) {
    var isNotExcludedElement = blacklist.indexOf(element) === -1;
    var isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
    if (isNotExcludedElement && isNotForbiddenElement) {
      ariaHidden(element, show);
    }
  });
}
function findIndexOf(items, callback) {
  var idx = -1;
  items.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }
    return false;
  });
  return idx;
}
function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var container = containerInfo.container;
  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      var scrollbarSize = getScrollbarSize(ownerDocument(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: 'padding-right',
        el: container
      });
      // Use computed style, here to get the real padding to add our scrollbar width.
      container.style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px");

      // .mui-fixed is a global helper.
      var fixedElements = ownerDocument(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedElements, function (element) {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: 'padding-right',
          el: element
        });
        element.style.paddingRight = "".concat(getPaddingRight(element) + scrollbarSize, "px");
      });
    }
    var scrollContainer;
    if (container.parentNode instanceof DocumentFragment) {
      scrollContainer = ownerDocument(container).body;
    } else {
      // Support html overflow-y: auto for scroll stability between pages
      // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
      var parent = container.parentElement;
      var containerWindow = ownerWindow(container);
      scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
    }

    // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.
    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: 'overflow',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: 'overflow-x',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: 'overflow-y',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }
  var restore = function restore() {
    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
        el = _ref.el,
        property = _ref.property;
      if (value) {
        el.style.setProperty(property, value);
      } else {
        el.style.removeProperty(property);
      }
    });
  };
  return restore;
}
function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (element) {
    if (element.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    _classCallCheck(this, ModalManager);
    this.containers = void 0;
    this.modals = void 0;
    this.modals = [];
    this.containers = [];
  }
  return _createClass(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);
      if (modalIndex !== -1) {
        return modalIndex;
      }
      modalIndex = this.modals.length;
      this.modals.push(modal);

      // If the modal we are adding is already in the DOM.
      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }
      var hiddenSiblings = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });
      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }
      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblings: hiddenSiblings
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var ariaHiddenState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var modalIndex = this.modals.indexOf(modal);
      if (modalIndex === -1) {
        return modalIndex;
      }
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1);

      // If that was the last modal in a container, clean up the container.
      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }
        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, ariaHiddenState);
        }
        ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1];
        // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null
        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }
      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);
}();

// Inspired by https://github.com/focus-trap/tabbable
var candidatesSelector = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'].join(',');
function getTabIndex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  }

  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.
  if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }
  return node.tabIndex;
}
function isNonTabbableRadio(node) {
  if (node.tagName !== 'INPUT' || node.type !== 'radio') {
    return false;
  }
  if (!node.name) {
    return false;
  }
  var getRadio = function getRadio(selector) {
    return node.ownerDocument.querySelector("input[type=\"radio\"]".concat(selector));
  };
  var roving = getRadio("[name=\"".concat(node.name, "\"]:checked"));
  if (!roving) {
    roving = getRadio("[name=\"".concat(node.name, "\"]"));
  }
  return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) {
    return false;
  }
  return true;
}
function defaultGetTabbable(root) {
  var regularTabNodes = [];
  var orderedTabNodes = [];
  Array.from(root.querySelectorAll(candidatesSelector)).forEach(function (node, i) {
    var nodeTabIndex = getTabIndex(node);
    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
      return;
    }
    if (nodeTabIndex === 0) {
      regularTabNodes.push(node);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node: node
      });
    }
  });
  return orderedTabNodes.sort(function (a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  }).map(function (a) {
    return a.node;
  }).concat(regularTabNodes);
}
function defaultIsEnabled() {
  return true;
}

/**
 * @ignore - internal component.
 */
function FocusTrap(props) {
  var children = props.children,
    _props$disableAutoFoc = props.disableAutoFocus,
    disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
    _props$disableEnforce = props.disableEnforceFocus,
    disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
    _props$disableRestore = props.disableRestoreFocus,
    disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
    _props$getTabbable = props.getTabbable,
    getTabbable = _props$getTabbable === void 0 ? defaultGetTabbable : _props$getTabbable,
    _props$isEnabled = props.isEnabled,
    isEnabled = _props$isEnabled === void 0 ? defaultIsEnabled : _props$isEnabled,
    open = props.open;
  var ignoreNextEnforceFocus = React__namespace.useRef(false);
  var sentinelStart = React__namespace.useRef(null);
  var sentinelEnd = React__namespace.useRef(null);
  var nodeToRestore = React__namespace.useRef(null);
  var reactFocusEventTarget = React__namespace.useRef(null);
  // This variable is useful when disableAutoFocus is true.
  // It waits for the active element to move into the component to activate.
  var activated = React__namespace.useRef(false);
  var rootRef = React__namespace.useRef(null);
  // @ts-expect-error TODO upstream fix
  var handleRef = useForkRef(children.ref, rootRef);
  var lastKeydown = React__namespace.useRef(null);
  React__namespace.useEffect(function () {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open]);
  React__namespace.useEffect(function () {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    var doc = ownerDocument(rootRef.current);
    if (!rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(['MUI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }
        rootRef.current.setAttribute('tabIndex', '-1');
      }
      if (activated.current) {
        rootRef.current.focus();
      }
    }
    return function () {
      // restoreLastFocus()
      if (!disableRestoreFocus) {
        // In IE11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE11 have a focus method.
        // Once IE11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }
        nodeToRestore.current = null;
      }
    };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  React__namespace.useEffect(function () {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    var doc = ownerDocument(rootRef.current);
    var loopFocus = function loopFocus(nativeEvent) {
      lastKeydown.current = nativeEvent;
      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
        return;
      }

      // Make sure the next tab starts from the right place.
      // doc.activeElement refers to the origin.
      if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;
        if (sentinelEnd.current) {
          sentinelEnd.current.focus();
        }
      }
    };
    var contain = function contain() {
      var rootElement = rootRef.current;

      // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.
      if (rootElement === null) {
        return;
      }
      if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      // The focus is already inside
      if (rootElement.contains(doc.activeElement)) {
        return;
      }

      // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
      if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) {
        return;
      }

      // if the focus event is not coming from inside the children's react tree, reset the refs
      if (doc.activeElement !== reactFocusEventTarget.current) {
        reactFocusEventTarget.current = null;
      } else if (reactFocusEventTarget.current !== null) {
        return;
      }
      if (!activated.current) {
        return;
      }
      var tabbable = [];
      if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
        tabbable = getTabbable(rootRef.current);
      }

      // one of the sentinel nodes was focused, so move the focus
      // to the first/last tabbable element inside the focus trap
      if (tabbable.length > 0) {
        var _lastKeydown$current, _lastKeydown$current2;
        var isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
        var focusNext = tabbable[0];
        var focusPrevious = tabbable[tabbable.length - 1];
        if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
          if (isShiftTab) {
            focusPrevious.focus();
          } else {
            focusNext.focus();
          }
        }
        // no tabbable elements in the trap focus or the focus was outside of the focus trap
      } else {
        rootElement.focus();
      }
    };
    doc.addEventListener('focusin', contain);
    doc.addEventListener('keydown', loopFocus, true);

    // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
    // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    // Instead, we can look if the active element was restored on the BODY element.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
    var interval = setInterval(function () {
      if (doc.activeElement && doc.activeElement.tagName === 'BODY') {
        contain();
      }
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focusin', contain);
      doc.removeEventListener('keydown', loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);
  var onFocus = function onFocus(event) {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
    reactFocusEventTarget.current = event.target;
    var childrenPropsHandler = children.props.onFocus;
    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };
  var handleFocusSentinel = function handleFocusSentinel(event) {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
  };
  return /*#__PURE__*/jsxRuntime.exports.jsxs(React__namespace.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.exports.jsx("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-testid": "sentinelStart"
    }), /*#__PURE__*/React__namespace.cloneElement(children, {
      ref: handleRef,
      onFocus: onFocus
    }), /*#__PURE__*/jsxRuntime.exports.jsx("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" ? FocusTrap.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  FocusTrap['propTypes' + ''] = exactProp(FocusTrap.propTypes);
}

function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}
function getHasTransition(children) {
  return children ? children.props.hasOwnProperty('in') : false;
}

// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var defaultManager = new ModalManager();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */
function useModal(parameters) {
  var container = parameters.container,
    _parameters$disableEs = parameters.disableEscapeKeyDown,
    disableEscapeKeyDown = _parameters$disableEs === void 0 ? false : _parameters$disableEs,
    _parameters$disableSc = parameters.disableScrollLock,
    disableScrollLock = _parameters$disableSc === void 0 ? false : _parameters$disableSc,
    _parameters$manager = parameters.manager,
    manager = _parameters$manager === void 0 ? defaultManager : _parameters$manager,
    _parameters$closeAfte = parameters.closeAfterTransition,
    closeAfterTransition = _parameters$closeAfte === void 0 ? false : _parameters$closeAfte,
    onTransitionEnter = parameters.onTransitionEnter,
    onTransitionExited = parameters.onTransitionExited,
    children = parameters.children,
    onClose = parameters.onClose,
    open = parameters.open,
    rootRef = parameters.rootRef;

  // @ts-ignore internal logic
  var modal = React__namespace.useRef({});
  var mountNodeRef = React__namespace.useRef(null);
  var modalRef = React__namespace.useRef(null);
  var handleRef = useForkRef(modalRef, rootRef);
  var _React$useState = React__namespace.useState(!open),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    exited = _React$useState2[0],
    setExited = _React$useState2[1];
  var hasTransition = getHasTransition(children);
  var ariaHiddenProp = true;
  if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) {
    ariaHiddenProp = false;
  }
  var getDoc = function getDoc() {
    return ownerDocument(mountNodeRef.current);
  };
  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mount = mountNodeRef.current;
    return modal.current;
  };
  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    });

    // Fix a bug on Chrome where the scroll isn't initially 0.
    if (modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  };
  var handleOpen = useEventCallback(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer);

    // The element was already mounted.
    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = React__namespace.useCallback(function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = useEventCallback(function (node) {
    mountNodeRef.current = node;
    if (!node) {
      return;
    }
    if (open && isTopModal()) {
      handleMounted();
    } else if (modalRef.current) {
      ariaHidden(modalRef.current, ariaHiddenProp);
    }
  });
  var handleClose = React__namespace.useCallback(function () {
    manager.remove(getModal(), ariaHiddenProp);
  }, [ariaHiddenProp, manager]);
  React__namespace.useEffect(function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  React__namespace.useEffect(function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
  var createHandleKeyDown = function createHandleKeyDown(otherHandlers) {
    return function (event) {
      var _otherHandlers$onKeyD;
      (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);

      // The handler doesn't take event.defaultPrevented into account:
      //
      // event.preventDefault() is meant to stop default behaviors like
      // clicking a checkbox to check it, hitting a button to submit a form,
      // and hitting left arrow to move the cursor in a text input etc.
      // Only special HTML elements have these default behaviors.
      if (event.key !== 'Escape' || event.which === 229 ||
      // Wait until IME is settled.
      !isTopModal()) {
        return;
      }
      if (!disableEscapeKeyDown) {
        // Swallow the event, in case someone is listening for the escape key on the body.
        event.stopPropagation();
        if (onClose) {
          onClose(event, 'escapeKeyDown');
        }
      }
    };
  };
  var createHandleBackdropClick = function createHandleBackdropClick(otherHandlers) {
    return function (event) {
      var _otherHandlers$onClic;
      (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
      if (event.target !== event.currentTarget) {
        return;
      }
      if (onClose) {
        onClose(event, 'backdropClick');
      }
    };
  };
  var getRootProps = function getRootProps() {
    var otherHandlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var propsEventHandlers = extractEventHandlers(parameters);

    // The custom event handlers shouldn't be spread on the root element
    delete propsEventHandlers.onTransitionEnter;
    delete propsEventHandlers.onTransitionExited;
    var externalEventHandlers = _extends$1({}, propsEventHandlers, otherHandlers);
    return _extends$1({
      role: 'presentation'
    }, externalEventHandlers, {
      onKeyDown: createHandleKeyDown(externalEventHandlers),
      ref: handleRef
    });
  };
  var getBackdropProps = function getBackdropProps() {
    var otherHandlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var externalEventHandlers = otherHandlers;
    return _extends$1({
      'aria-hidden': true
    }, externalEventHandlers, {
      onClick: createHandleBackdropClick(externalEventHandlers),
      open: open
    });
  };
  var getTransitionProps = function getTransitionProps() {
    var handleEnter = function handleEnter() {
      setExited(false);
      if (onTransitionEnter) {
        onTransitionEnter();
      }
    };
    var handleExited = function handleExited() {
      setExited(true);
      if (onTransitionExited) {
        onTransitionExited();
      }
      if (closeAfterTransition) {
        handleClose();
      }
    };
    return {
      onEnter: createChainedFunction(handleEnter, children == null ? void 0 : children.props.onEnter),
      onExited: createChainedFunction(handleExited, children == null ? void 0 : children.props.onExited)
    };
  };
  return {
    getRootProps: getRootProps,
    getBackdropProps: getBackdropProps,
    getTransitionProps: getTransitionProps,
    rootRef: handleRef,
    portalRef: handlePortalRef,
    isTopModal: isTopModal,
    exited: exited,
    hasTransition: hasTransition
  };
}

function getModalUtilityClass(slot) {
  return generateUtilityClass('MuiModal', slot);
}
generateUtilityClasses('MuiModal', ['root', 'hidden', 'backdrop']);

var _excluded$d = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"];
var useUtilityClasses$a = function useUtilityClasses(ownerState) {
  var open = ownerState.open,
    exited = ownerState.exited,
    classes = ownerState.classes;
  var slots = {
    root: ['root', !open && exited && 'hidden'],
    backdrop: ['backdrop']
  };
  return composeClasses(slots, getModalUtilityClass, classes);
};
var ModalRoot = styled$1('div', {
  name: 'MuiModal',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
  }
})(function (_ref3) {
  var theme = _ref3.theme,
    ownerState = _ref3.ownerState;
  return _extends$1({
    position: 'fixed',
    zIndex: (theme.vars || theme).zIndex.modal,
    right: 0,
    bottom: 0,
    top: 0,
    left: 0
  }, !ownerState.open && ownerState.exited && {
    visibility: 'hidden'
  });
});
var ModalBackdrop = styled$1(Backdrop$1, {
  name: 'MuiModal',
  slot: 'Backdrop',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.backdrop;
  }
})({
  zIndex: -1
});

/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */
var Modal = /*#__PURE__*/React__namespace.forwardRef(function Modal(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
  var props = useDefaultProps({
    name: 'MuiModal',
    props: inProps
  });
  var _props$BackdropCompon = props.BackdropComponent,
    BackdropComponent = _props$BackdropCompon === void 0 ? ModalBackdrop : _props$BackdropCompon,
    BackdropProps = props.BackdropProps,
    className = props.className,
    _props$closeAfterTran = props.closeAfterTransition,
    closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
    children = props.children,
    container = props.container,
    component = props.component,
    _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    _props$componentsProp = props.componentsProps,
    componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp,
    _props$disableAutoFoc = props.disableAutoFocus,
    disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
    _props$disableEnforce = props.disableEnforceFocus,
    disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
    _props$disableEscapeK = props.disableEscapeKeyDown,
    disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
    _props$disablePortal = props.disablePortal,
    disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
    _props$disableRestore = props.disableRestoreFocus,
    disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
    _props$disableScrollL = props.disableScrollLock,
    disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
    _props$hideBackdrop = props.hideBackdrop,
    hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
    _props$keepMounted = props.keepMounted,
    keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
    onBackdropClick = props.onBackdropClick,
    open = props.open,
    slotProps = props.slotProps,
    slots = props.slots,
    other = _objectWithoutPropertiesLoose(props, _excluded$d);
  var propsWithDefaults = _extends$1({}, props, {
    closeAfterTransition: closeAfterTransition,
    disableAutoFocus: disableAutoFocus,
    disableEnforceFocus: disableEnforceFocus,
    disableEscapeKeyDown: disableEscapeKeyDown,
    disablePortal: disablePortal,
    disableRestoreFocus: disableRestoreFocus,
    disableScrollLock: disableScrollLock,
    hideBackdrop: hideBackdrop,
    keepMounted: keepMounted
  });
  var _useModal = useModal(_extends$1({}, propsWithDefaults, {
      rootRef: ref
    })),
    getRootProps = _useModal.getRootProps,
    getBackdropProps = _useModal.getBackdropProps,
    getTransitionProps = _useModal.getTransitionProps,
    portalRef = _useModal.portalRef,
    isTopModal = _useModal.isTopModal,
    exited = _useModal.exited,
    hasTransition = _useModal.hasTransition;
  var ownerState = _extends$1({}, propsWithDefaults, {
    exited: exited
  });
  var classes = useUtilityClasses$a(ownerState);
  var childProps = {};
  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = '-1';
  }

  // It's a Transition like component
  if (hasTransition) {
    var _getTransitionProps = getTransitionProps(),
      onEnter = _getTransitionProps.onEnter,
      onExited = _getTransitionProps.onExited;
    childProps.onEnter = onEnter;
    childProps.onExited = onExited;
  }
  var RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : ModalRoot;
  var BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
  var rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  var backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
  var rootProps = useSlotProps({
    elementType: RootSlot,
    externalSlotProps: rootSlotProps,
    externalForwardedProps: other,
    getSlotProps: getRootProps,
    additionalProps: {
      ref: ref,
      as: component
    },
    ownerState: ownerState,
    className: clsx(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
  });
  var backdropProps = useSlotProps({
    elementType: BackdropSlot,
    externalSlotProps: backdropSlotProps,
    additionalProps: BackdropProps,
    getSlotProps: function getSlotProps(otherHandlers) {
      return getBackdropProps(_extends$1({}, otherHandlers, {
        onClick: function onClick(e) {
          if (onBackdropClick) {
            onBackdropClick(e);
          }
          if (otherHandlers != null && otherHandlers.onClick) {
            otherHandlers.onClick(e);
          }
        }
      }));
    },
    className: clsx(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
    ownerState: ownerState
  });
  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }
  return /*#__PURE__*/jsxRuntime.exports.jsx(Portal$1, {
    ref: portalRef,
    container: container,
    disablePortal: disablePortal,
    children: /*#__PURE__*/jsxRuntime.exports.jsxs(RootSlot, _extends$1({}, rootProps, {
      children: [!hideBackdrop && BackdropComponent ? /*#__PURE__*/jsxRuntime.exports.jsx(BackdropSlot, _extends$1({}, backdropProps)) : null, /*#__PURE__*/jsxRuntime.exports.jsx(FocusTrap, {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        isEnabled: isTopModal,
        open: open,
        children: /*#__PURE__*/React__namespace.cloneElement(children, childProps)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" ? Modal.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Backdrop: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var Modal$1 = Modal;

function getDividerUtilityClass(slot) {
  return generateUtilityClass('MuiDivider', slot);
}
var dividerClasses = generateUtilityClasses('MuiDivider', ['root', 'absolute', 'fullWidth', 'inset', 'middle', 'flexItem', 'light', 'vertical', 'withChildren', 'withChildrenVertical', 'textAlignRight', 'textAlignLeft', 'wrapper', 'wrapperVertical']);
var dividerClasses$1 = dividerClasses;

var _excluded$c = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"];
var useUtilityClasses$9 = function useUtilityClasses(ownerState) {
  var absolute = ownerState.absolute,
    children = ownerState.children,
    classes = ownerState.classes,
    flexItem = ownerState.flexItem,
    light = ownerState.light,
    orientation = ownerState.orientation,
    textAlign = ownerState.textAlign,
    variant = ownerState.variant;
  var slots = {
    root: ['root', absolute && 'absolute', variant, light && 'light', orientation === 'vertical' && 'vertical', flexItem && 'flexItem', children && 'withChildren', children && orientation === 'vertical' && 'withChildrenVertical', textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight', textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'],
    wrapper: ['wrapper', orientation === 'vertical' && 'wrapperVertical']
  };
  return composeClasses(slots, getDividerUtilityClass, classes);
};
var DividerRoot = styled$1('div', {
  name: 'MuiDivider',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.absolute && styles.absolute, styles[ownerState.variant], ownerState.light && styles.light, ownerState.orientation === 'vertical' && styles.vertical, ownerState.flexItem && styles.flexItem, ownerState.children && styles.withChildren, ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft];
  }
})(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$1({
    margin: 0,
    // Reset browser default style.
    flexShrink: 0,
    borderWidth: 0,
    borderStyle: 'solid',
    borderColor: (theme.vars || theme).palette.divider,
    borderBottomWidth: 'thin'
  }, ownerState.absolute && {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%'
  }, ownerState.light && {
    borderColor: theme.vars ? "rgba(".concat(theme.vars.palette.dividerChannel, " / 0.08)") : alpha_1(theme.palette.divider, 0.08)
  }, ownerState.variant === 'inset' && {
    marginLeft: 72
  }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }, ownerState.orientation === 'vertical' && {
    height: '100%',
    borderBottomWidth: 0,
    borderRightWidth: 'thin'
  }, ownerState.flexItem && {
    alignSelf: 'stretch',
    height: 'auto'
  });
}, function (_ref2) {
  var ownerState = _ref2.ownerState;
  return _extends$1({}, ownerState.children && {
    display: 'flex',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    border: 0,
    borderTopStyle: 'solid',
    borderLeftStyle: 'solid',
    '&::before, &::after': {
      content: '""',
      alignSelf: 'center'
    }
  });
}, function (_ref3) {
  var theme = _ref3.theme,
    ownerState = _ref3.ownerState;
  return _extends$1({}, ownerState.children && ownerState.orientation !== 'vertical' && {
    '&::before, &::after': {
      width: '100%',
      borderTop: "thin solid ".concat((theme.vars || theme).palette.divider),
      borderTopStyle: 'inherit'
    }
  });
}, function (_ref4) {
  var theme = _ref4.theme,
    ownerState = _ref4.ownerState;
  return _extends$1({}, ownerState.children && ownerState.orientation === 'vertical' && {
    flexDirection: 'column',
    '&::before, &::after': {
      height: '100%',
      borderLeft: "thin solid ".concat((theme.vars || theme).palette.divider),
      borderLeftStyle: 'inherit'
    }
  });
}, function (_ref5) {
  var ownerState = _ref5.ownerState;
  return _extends$1({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
    '&::before': {
      width: '90%'
    },
    '&::after': {
      width: '10%'
    }
  }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
    '&::before': {
      width: '10%'
    },
    '&::after': {
      width: '90%'
    }
  });
});
var DividerWrapper = styled$1('span', {
  name: 'MuiDivider',
  slot: 'Wrapper',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.wrapper, ownerState.orientation === 'vertical' && styles.wrapperVertical];
  }
})(function (_ref6) {
  var theme = _ref6.theme,
    ownerState = _ref6.ownerState;
  return _extends$1({
    display: 'inline-block',
    paddingLeft: "calc(".concat(theme.spacing(1), " * 1.2)"),
    paddingRight: "calc(".concat(theme.spacing(1), " * 1.2)")
  }, ownerState.orientation === 'vertical' && {
    paddingTop: "calc(".concat(theme.spacing(1), " * 1.2)"),
    paddingBottom: "calc(".concat(theme.spacing(1), " * 1.2)")
  });
});
var Divider = /*#__PURE__*/React__namespace.forwardRef(function Divider(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiDivider'
  });
  var _props$absolute = props.absolute,
    absolute = _props$absolute === void 0 ? false : _props$absolute,
    children = props.children,
    className = props.className,
    _props$component = props.component,
    component = _props$component === void 0 ? children ? 'div' : 'hr' : _props$component,
    _props$flexItem = props.flexItem,
    flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
    _props$light = props.light,
    light = _props$light === void 0 ? false : _props$light,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
    _props$role = props.role,
    role = _props$role === void 0 ? component !== 'hr' ? 'separator' : undefined : _props$role,
    _props$textAlign = props.textAlign,
    textAlign = _props$textAlign === void 0 ? 'center' : _props$textAlign,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
    other = _objectWithoutPropertiesLoose(props, _excluded$c);
  var ownerState = _extends$1({}, props, {
    absolute: absolute,
    component: component,
    flexItem: flexItem,
    light: light,
    orientation: orientation,
    role: role,
    textAlign: textAlign,
    variant: variant
  });
  var classes = useUtilityClasses$9(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(DividerRoot, _extends$1({
    as: component,
    className: clsx(classes.root, className),
    role: role,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children ? /*#__PURE__*/jsxRuntime.exports.jsx(DividerWrapper, {
      className: classes.wrapper,
      ownerState: ownerState,
      children: children
    }) : null
  }));
});

/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */
Divider.muiSkipListHighlight = true;
process.env.NODE_ENV !== "production" ? Divider.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: PropTypes.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  light: PropTypes.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * @ignore
   */
  role: PropTypes /* @typescript-to-proptypes-ignore */.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: PropTypes.oneOf(['center', 'left', 'right']),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['fullWidth', 'inset', 'middle']), PropTypes.string])
} : void 0;
var Divider$1 = Divider;

var _excluded$b = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function getTranslateValue(direction, node, resolvedContainer) {
  var rect = node.getBoundingClientRect();
  var containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  var containerWindow = ownerWindow(node);
  var transform;
  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }
  var offsetX = 0;
  var offsetY = 0;
  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }
  if (direction === 'left') {
    if (containerRect) {
      return "translateX(".concat(containerRect.right + offsetX - rect.left, "px)");
    }
    return "translateX(".concat(containerWindow.innerWidth + offsetX - rect.left, "px)");
  }
  if (direction === 'right') {
    if (containerRect) {
      return "translateX(-".concat(rect.right - containerRect.left - offsetX, "px)");
    }
    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
  }
  if (direction === 'up') {
    if (containerRect) {
      return "translateY(".concat(containerRect.bottom + offsetY - rect.top, "px)");
    }
    return "translateY(".concat(containerWindow.innerHeight + offsetY - rect.top, "px)");
  }

  // direction === 'down'
  if (containerRect) {
    return "translateY(-".concat(rect.top - containerRect.top + rect.height - offsetY, "px)");
  }
  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}
function resolveContainer(containerPropProp) {
  return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function setTranslateValue(direction, node, containerProp) {
  var resolvedContainer = resolveContainer(containerProp);
  var transform = getTranslateValue(direction, node, resolvedContainer);
  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}

/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Slide = /*#__PURE__*/React__namespace.forwardRef(function Slide(props, ref) {
  var theme = useTheme();
  var defaultEasing = {
    enter: theme.transitions.easing.easeOut,
    exit: theme.transitions.easing.sharp
  };
  var defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  var addEndListener = props.addEndListener,
    _props$appear = props.appear,
    appear = _props$appear === void 0 ? true : _props$appear,
    _children = props.children,
    containerProp = props.container,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'down' : _props$direction,
    _props$easing = props.easing,
    easingProp = _props$easing === void 0 ? defaultEasing : _props$easing,
    inProp = props["in"],
    onEnter = props.onEnter,
    onEntered = props.onEntered,
    onEntering = props.onEntering,
    onExit = props.onExit,
    onExited = props.onExited,
    onExiting = props.onExiting,
    style = props.style,
    _props$timeout = props.timeout,
    timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
    _props$TransitionComp = props.TransitionComponent,
    TransitionComponent = _props$TransitionComp === void 0 ? Transition$1 : _props$TransitionComp,
    other = _objectWithoutPropertiesLoose(props, _excluded$b);
  var childrenRef = React__namespace.useRef(null);
  var handleRef = useForkRef(_children.ref, childrenRef, ref);
  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (isAppearing) {
      if (callback) {
        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
        if (isAppearing === undefined) {
          callback(childrenRef.current);
        } else {
          callback(childrenRef.current, isAppearing);
        }
      }
    };
  };
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    setTranslateValue(direction, node, containerProp);
    reflow(node);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var transitionProps = getTransitionProps({
      timeout: timeout,
      style: style,
      easing: easingProp
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', _extends$1({}, transitionProps));
    node.style.transition = theme.transitions.create('transform', _extends$1({}, transitionProps));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = getTransitionProps({
      timeout: timeout,
      style: style,
      easing: easingProp
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    setTranslateValue(direction, node, containerProp);
    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(function (node) {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';
    if (onExited) {
      onExited(node);
    }
  });
  var handleAddEndListener = function handleAddEndListener(next) {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(childrenRef.current, next);
    }
  };
  var updatePosition = React__namespace.useCallback(function () {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  React__namespace.useEffect(function () {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }
    var handleResize = debounce(function () {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    var containerWindow = ownerWindow(childrenRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp, containerProp]);
  React__namespace.useEffect(function () {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$1({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear: appear,
    "in": inProp,
    timeout: timeout
  }, other, {
    children: function children(state, childProps) {
      return /*#__PURE__*/React__namespace.cloneElement(_children, _extends$1({
        ref: handleRef,
        style: _extends$1({
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, style, _children.props.style)
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Slide.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), function (props) {
    if (props.open) {
      var resolvedContainer = resolveContainer(props.container);
      if (resolvedContainer && resolvedContainer.nodeType === 1) {
        var box = resolvedContainer.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `container` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedContainer || typeof resolvedContainer.getBoundingClientRect !== 'function' || resolvedContainer.contextElement != null && resolvedContainer.contextElement.nodeType !== 1) {
        return new Error(['MUI: The `container` prop provided to the component is invalid.', 'It should be an HTML element instance.'].join('\n'));
      }
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: PropTypes.oneOf(['down', 'left', 'right', 'up']),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  "in": PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
var Slide$1 = Slide;

function getDrawerUtilityClass(slot) {
  return generateUtilityClass('MuiDrawer', slot);
}
generateUtilityClasses('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);

var _excluded$a = ["BackdropProps"],
  _excluded2$3 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];
var overridesResolver$2 = function overridesResolver(props, styles) {
  var ownerState = props.ownerState;
  return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
};
var useUtilityClasses$8 = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    anchor = ownerState.anchor,
    variant = ownerState.variant;
  var slots = {
    root: ['root'],
    docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
    modal: ['modal'],
    paper: ['paper', "paperAnchor".concat(capitalize$1(anchor)), variant !== 'temporary' && "paperAnchorDocked".concat(capitalize$1(anchor))]
  };
  return composeClasses(slots, getDrawerUtilityClass, classes);
};
var DrawerRoot = styled$1(Modal$1, {
  name: 'MuiDrawer',
  slot: 'Root',
  overridesResolver: overridesResolver$2
})(function (_ref) {
  var theme = _ref.theme;
  return {
    zIndex: (theme.vars || theme).zIndex.drawer
  };
});
var DrawerDockedRoot = styled$1('div', {
  shouldForwardProp: rootShouldForwardProp$1,
  name: 'MuiDrawer',
  slot: 'Docked',
  skipVariantsResolver: false,
  overridesResolver: overridesResolver$2
})({
  flex: '0 0 auto'
});
var DrawerPaper = styled$1(Paper$1, {
  name: 'MuiDrawer',
  slot: 'Paper',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.paper, styles["paperAnchor".concat(capitalize$1(ownerState.anchor))], ownerState.variant !== 'temporary' && styles["paperAnchorDocked".concat(capitalize$1(ownerState.anchor))]];
  }
})(function (_ref2) {
  var theme = _ref2.theme,
    ownerState = _ref2.ownerState;
  return _extends$1({
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flex: '1 0 auto',
    zIndex: (theme.vars || theme).zIndex.drawer,
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch',
    // temporary style
    position: 'fixed',
    top: 0,
    // We disable the focus ring for mouse, touch and keyboard users.
    // At some point, it would be better to keep it for keyboard users.
    // :focus-ring CSS pseudo-class will help.
    outline: 0
  }, ownerState.anchor === 'left' && {
    left: 0
  }, ownerState.anchor === 'top' && {
    top: 0,
    left: 0,
    right: 0,
    height: 'auto',
    maxHeight: '100%'
  }, ownerState.anchor === 'right' && {
    right: 0
  }, ownerState.anchor === 'bottom' && {
    top: 'auto',
    left: 0,
    bottom: 0,
    right: 0,
    height: 'auto',
    maxHeight: '100%'
  }, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
    borderRight: "1px solid ".concat((theme.vars || theme).palette.divider)
  }, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
    borderBottom: "1px solid ".concat((theme.vars || theme).palette.divider)
  }, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
    borderLeft: "1px solid ".concat((theme.vars || theme).palette.divider)
  }, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
    borderTop: "1px solid ".concat((theme.vars || theme).palette.divider)
  });
});
var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(_ref3, anchor) {
  var direction = _ref3.direction;
  return direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}

/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */
var Drawer = /*#__PURE__*/React__namespace.forwardRef(function Drawer(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiDrawer'
  });
  var theme = useTheme();
  var isRtl = useRtl();
  var defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  var _props$anchor = props.anchor,
    anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
    BackdropProps = props.BackdropProps,
    children = props.children,
    className = props.className,
    _props$elevation = props.elevation,
    elevation = _props$elevation === void 0 ? 16 : _props$elevation,
    _props$hideBackdrop = props.hideBackdrop,
    hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
    _props$ModalProps = props.ModalProps,
    _props$ModalProps2 = _props$ModalProps === void 0 ? {} : _props$ModalProps,
    BackdropPropsProp = _props$ModalProps2.BackdropProps,
    onClose = props.onClose,
    _props$open = props.open,
    open = _props$open === void 0 ? false : _props$open,
    _props$PaperProps = props.PaperProps,
    PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
    SlideProps = props.SlideProps,
    _props$TransitionComp = props.TransitionComponent,
    TransitionComponent = _props$TransitionComp === void 0 ? Slide$1 : _props$TransitionComp,
    _props$transitionDura = props.transitionDuration,
    transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'temporary' : _props$variant,
    ModalProps = _objectWithoutPropertiesLoose(props.ModalProps, _excluded$a),
    other = _objectWithoutPropertiesLoose(props, _excluded2$3);

  // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.
  var mounted = React__namespace.useRef(false);
  React__namespace.useEffect(function () {
    mounted.current = true;
  }, []);
  var anchorInvariant = getAnchor({
    direction: isRtl ? 'rtl' : 'ltr'
  }, anchorProp);
  var anchor = anchorProp;
  var ownerState = _extends$1({}, props, {
    anchor: anchor,
    elevation: elevation,
    open: open,
    variant: variant
  }, other);
  var classes = useUtilityClasses$8(ownerState);
  var drawer = /*#__PURE__*/jsxRuntime.exports.jsx(DrawerPaper, _extends$1({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: clsx(classes.paper, PaperProps.className),
    ownerState: ownerState,
    children: children
  }));
  if (variant === 'permanent') {
    return /*#__PURE__*/jsxRuntime.exports.jsx(DrawerDockedRoot, _extends$1({
      className: clsx(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: drawer
    }));
  }
  var slidingDrawer = /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$1({
    "in": open,
    direction: oppositeDirection[anchorInvariant],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps, {
    children: drawer
  }));
  if (variant === 'persistent') {
    return /*#__PURE__*/jsxRuntime.exports.jsx(DrawerDockedRoot, _extends$1({
      className: clsx(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: slidingDrawer
    }));
  }

  // variant === temporary
  return /*#__PURE__*/jsxRuntime.exports.jsx(DrawerRoot, _extends$1({
    BackdropProps: _extends$1({}, BackdropProps, BackdropPropsProp, {
      transitionDuration: transitionDuration
    }),
    className: clsx(classes.root, classes.modal, className),
    open: open,
    ownerState: ownerState,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    ref: ref
  }, other, ModalProps, {
    children: slidingDrawer
  }));
});
process.env.NODE_ENV !== "production" ? Drawer.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: integerPropType,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Props applied to the [`Modal`](/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: PropTypes.object,
  /**
   * Props applied to the [`Slide`](/material-ui/api/slide/) element.
   */
  SlideProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
var Drawer$1 = Drawer;

var Stack = createStack({
  createStyledComponent: styled$1('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  }),
  useThemeProps: function useThemeProps(inProps) {
    return useDefaultProps({
      props: inProps,
      name: 'MuiStack'
    });
  }
});
process.env.NODE_ENV !== "production" ? Stack.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: PropTypes.oneOfType([PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), PropTypes.arrayOf(PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), PropTypes.object]),
  /**
   * Add an element between each child.
   */
  divider: PropTypes.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: PropTypes.bool
} : void 0;
var Stack$1 = Stack;

function getFormControlLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiFormControlLabel', slot);
}
var formControlLabelClasses = generateUtilityClasses('MuiFormControlLabel', ['root', 'labelPlacementStart', 'labelPlacementTop', 'labelPlacementBottom', 'disabled', 'label', 'error', 'required', 'asterisk']);
var formControlLabelClasses$1 = formControlLabelClasses;

var _excluded$9 = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"];
var useUtilityClasses$7 = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    disabled = ownerState.disabled,
    labelPlacement = ownerState.labelPlacement,
    error = ownerState.error,
    required = ownerState.required;
  var slots = {
    root: ['root', disabled && 'disabled', "labelPlacement".concat(capitalize$1(labelPlacement)), error && 'error', required && 'required'],
    label: ['label', disabled && 'disabled'],
    asterisk: ['asterisk', error && 'error']
  };
  return composeClasses(slots, getFormControlLabelUtilityClasses, classes);
};
var FormControlLabelRoot = styled$1('label', {
  name: 'MuiFormControlLabel',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [_defineProperty({}, "& .".concat(formControlLabelClasses$1.label), styles.label), styles.root, styles["labelPlacement".concat(capitalize$1(ownerState.labelPlacement))]];
  }
})(function (_ref3) {
  var theme = _ref3.theme,
    ownerState = _ref3.ownerState;
  return _extends$1(_defineProperty({
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    WebkitTapHighlightColor: 'transparent',
    marginLeft: -11,
    marginRight: 16
  }, "&.".concat(formControlLabelClasses$1.disabled), {
    cursor: 'default'
  }), ownerState.labelPlacement === 'start' && {
    flexDirection: 'row-reverse',
    marginLeft: 16,
    // used for row presentation of radio/checkbox
    marginRight: -11
  }, ownerState.labelPlacement === 'top' && {
    flexDirection: 'column-reverse',
    marginLeft: 16
  }, ownerState.labelPlacement === 'bottom' && {
    flexDirection: 'column',
    marginLeft: 16
  }, _defineProperty({}, "& .".concat(formControlLabelClasses$1.label), _defineProperty({}, "&.".concat(formControlLabelClasses$1.disabled), {
    color: (theme.vars || theme).palette.text.disabled
  })));
});
var AsteriskComponent = styled$1('span', {
  name: 'MuiFormControlLabel',
  slot: 'Asterisk',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.asterisk;
  }
})(function (_ref4) {
  var theme = _ref4.theme;
  return _defineProperty({}, "&.".concat(formControlLabelClasses$1.error), {
    color: (theme.vars || theme).palette.error.main
  });
});

/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */
var FormControlLabel = /*#__PURE__*/React__namespace.forwardRef(function FormControlLabel(inProps, ref) {
  var _ref, _slotProps$typography;
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiFormControlLabel'
  });
  var className = props.className,
    _props$componentsProp = props.componentsProps,
    componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp,
    control = props.control,
    disabledProp = props.disabled,
    disableTypography = props.disableTypography,
    labelProp = props.label,
    _props$labelPlacement = props.labelPlacement,
    labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
    requiredProp = props.required,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    other = _objectWithoutPropertiesLoose(props, _excluded$9);
  var muiFormControl = useFormControl();
  var disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
  var required = requiredProp != null ? requiredProp : control.props.required;
  var controlProps = {
    disabled: disabled,
    required: required
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['error']
  });
  var ownerState = _extends$1({}, props, {
    disabled: disabled,
    labelPlacement: labelPlacement,
    required: required,
    error: fcs.error
  });
  var classes = useUtilityClasses$7(ownerState);
  var typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
  var label = labelProp;
  if (label != null && label.type !== Typography$1 && !disableTypography) {
    label = /*#__PURE__*/jsxRuntime.exports.jsx(Typography$1, _extends$1({
      component: "span"
    }, typographySlotProps, {
      className: clsx(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
      children: label
    }));
  }
  return /*#__PURE__*/jsxRuntime.exports.jsxs(FormControlLabelRoot, _extends$1({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/React__namespace.cloneElement(control, controlProps), required ? /*#__PURE__*/jsxRuntime.exports.jsxs(Stack$1, {
      display: "block",
      children: [label, /*#__PURE__*/jsxRuntime.exports.jsxs(AsteriskComponent, {
        ownerState: ownerState,
        "aria-hidden": true,
        className: classes.asterisk,
        children: ["\u2009", '*']
      })]
    }) : label]
  }));
});
process.env.NODE_ENV !== "production" ? FormControlLabel.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    typography: PropTypes.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: PropTypes.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: PropTypes.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: PropTypes.oneOf(['bottom', 'end', 'start', 'top']),
  /**
   * @ignore
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    typography: PropTypes.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
var FormControlLabel$1 = FormControlLabel;

var _excluded$8 = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};

/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */
var isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);

/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Grow = /*#__PURE__*/React__namespace.forwardRef(function Grow(props, ref) {
  var addEndListener = props.addEndListener,
    _props$appear = props.appear,
    appear = _props$appear === void 0 ? true : _props$appear,
    _children = props.children,
    easing = props.easing,
    inProp = props["in"],
    onEnter = props.onEnter,
    onEntered = props.onEntered,
    onEntering = props.onEntering,
    onExit = props.onExit,
    onExited = props.onExited,
    onExiting = props.onExiting,
    style = props.style,
    _props$timeout = props.timeout,
    timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
    _props$TransitionComp = props.TransitionComponent,
    TransitionComponent = _props$TransitionComp === void 0 ? Transition$1 : _props$TransitionComp,
    other = _objectWithoutPropertiesLoose(props, _excluded$8);
  var timer = useTimeout();
  var autoTimeout = React__namespace.useRef();
  var theme = useTheme();
  var nodeRef = React__namespace.useRef(null);
  var handleRef = useForkRef(nodeRef, _children.ref, ref);
  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (maybeIsAppearing) {
      if (callback) {
        var node = nodeRef.current;

        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
        if (maybeIsAppearing === undefined) {
          callback(node);
        } else {
          callback(node, maybeIsAppearing);
        }
      }
    };
  };
  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    reflow(node); // So the animation always start from the start.

    var _getTransitionProps = getTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }, {
        mode: 'enter'
      }),
      transitionDuration = _getTransitionProps.duration,
      delay = _getTransitionProps.delay,
      transitionTimingFunction = _getTransitionProps.easing;
    var duration;
    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }
    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: isWebKit154 ? duration : duration * 0.666,
      delay: delay,
      easing: transitionTimingFunction
    })].join(',');
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = getTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }, {
        mode: 'exit'
      }),
      transitionDuration = _getTransitionProps2.duration,
      delay = _getTransitionProps2.delay,
      transitionTimingFunction = _getTransitionProps2.easing;
    var duration;
    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }
    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: isWebKit154 ? duration : duration * 0.666,
      delay: isWebKit154 ? delay : delay || duration * 0.333,
      easing: transitionTimingFunction
    })].join(',');
    node.style.opacity = 0;
    node.style.transform = getScale(0.75);
    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleAddEndListener = function handleAddEndListener(next) {
    if (timeout === 'auto') {
      timer.start(autoTimeout.current || 0, next);
    }
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$1({
    appear: appear,
    "in": inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: function children(state, childProps) {
      return /*#__PURE__*/React__namespace.cloneElement(_children, _extends$1({
        style: _extends$1({
          opacity: 0,
          transform: getScale(0.75),
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, _children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Grow.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  "in": PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Grow.muiSupportAuto = true;
var Grow$1 = Grow;

/**
 * @ignore - internal component.
 */
var ListContext = /*#__PURE__*/React__namespace.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}
var ListContext$1 = ListContext;

function getListUtilityClass(slot) {
  return generateUtilityClass('MuiList', slot);
}
generateUtilityClasses('MuiList', ['root', 'padding', 'dense', 'subheader']);

var _excluded$7 = ["children", "className", "component", "dense", "disablePadding", "subheader"];
var useUtilityClasses$6 = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    disablePadding = ownerState.disablePadding,
    dense = ownerState.dense,
    subheader = ownerState.subheader;
  var slots = {
    root: ['root', !disablePadding && 'padding', dense && 'dense', subheader && 'subheader']
  };
  return composeClasses(slots, getListUtilityClass, classes);
};
var ListRoot = styled$1('ul', {
  name: 'MuiList',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, !ownerState.disablePadding && styles.padding, ownerState.dense && styles.dense, ownerState.subheader && styles.subheader];
  }
})(function (_ref) {
  var ownerState = _ref.ownerState;
  return _extends$1({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  }, !ownerState.disablePadding && {
    paddingTop: 8,
    paddingBottom: 8
  }, ownerState.subheader && {
    paddingTop: 0
  });
});
var List = /*#__PURE__*/React__namespace.forwardRef(function List(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiList'
  });
  var children = props.children,
    className = props.className,
    _props$component = props.component,
    component = _props$component === void 0 ? 'ul' : _props$component,
    _props$dense = props.dense,
    dense = _props$dense === void 0 ? false : _props$dense,
    _props$disablePadding = props.disablePadding,
    disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
    subheader = props.subheader,
    other = _objectWithoutPropertiesLoose(props, _excluded$7);
  var context = React__namespace.useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);
  var ownerState = _extends$1({}, props, {
    component: component,
    dense: dense,
    disablePadding: disablePadding
  });
  var classes = useUtilityClasses$6(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(ListContext$1.Provider, {
    value: context,
    children: /*#__PURE__*/jsxRuntime.exports.jsxs(ListRoot, _extends$1({
      as: component,
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [subheader, children]
    }))
  });
});
process.env.NODE_ENV !== "production" ? List.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var List$1 = List;

function getListItemUtilityClass(slot) {
  return generateUtilityClass('MuiListItem', slot);
}
var listItemClasses = generateUtilityClasses('MuiListItem', ['root', 'container', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'padding', 'button', 'secondaryAction', 'selected']);
var listItemClasses$1 = listItemClasses;

var listItemButtonClasses = generateUtilityClasses('MuiListItemButton', ['root', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'selected']);
var listItemButtonClasses$1 = listItemButtonClasses;

function getListItemSecondaryActionClassesUtilityClass(slot) {
  return generateUtilityClass('MuiListItemSecondaryAction', slot);
}
generateUtilityClasses('MuiListItemSecondaryAction', ['root', 'disableGutters']);

var _excluded$6 = ["className"];
var useUtilityClasses$5 = function useUtilityClasses(ownerState) {
  var disableGutters = ownerState.disableGutters,
    classes = ownerState.classes;
  var slots = {
    root: ['root', disableGutters && 'disableGutters']
  };
  return composeClasses(slots, getListItemSecondaryActionClassesUtilityClass, classes);
};
var ListItemSecondaryActionRoot = styled$1('div', {
  name: 'MuiListItemSecondaryAction',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.disableGutters && styles.disableGutters];
  }
})(function (_ref) {
  var ownerState = _ref.ownerState;
  return _extends$1({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)'
  }, ownerState.disableGutters && {
    right: 0
  });
});

/**
 * Must be used as the last child of ListItem to function properly.
 */
var ListItemSecondaryAction = /*#__PURE__*/React__namespace.forwardRef(function ListItemSecondaryAction(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiListItemSecondaryAction'
  });
  var className = props.className,
    other = _objectWithoutPropertiesLoose(props, _excluded$6);
  var context = React__namespace.useContext(ListContext$1);
  var ownerState = _extends$1({}, props, {
    disableGutters: context.disableGutters
  });
  var classes = useUtilityClasses$5(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(ListItemSecondaryActionRoot, _extends$1({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListItemSecondaryAction.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var ListItemSecondaryAction$1 = ListItemSecondaryAction;

var _excluded$5 = ["className"],
  _excluded2$2 = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"];
var overridesResolver$1 = function overridesResolver(props, styles) {
  var ownerState = props.ownerState;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters, !ownerState.disablePadding && styles.padding, ownerState.button && styles.button, ownerState.hasSecondaryAction && styles.secondaryAction];
};
var useUtilityClasses$4 = function useUtilityClasses(ownerState) {
  var alignItems = ownerState.alignItems,
    button = ownerState.button,
    classes = ownerState.classes,
    dense = ownerState.dense,
    disabled = ownerState.disabled,
    disableGutters = ownerState.disableGutters,
    disablePadding = ownerState.disablePadding,
    divider = ownerState.divider,
    hasSecondaryAction = ownerState.hasSecondaryAction,
    selected = ownerState.selected;
  var slots = {
    root: ['root', dense && 'dense', !disableGutters && 'gutters', !disablePadding && 'padding', divider && 'divider', disabled && 'disabled', button && 'button', alignItems === 'flex-start' && 'alignItemsFlexStart', hasSecondaryAction && 'secondaryAction', selected && 'selected'],
    container: ['container']
  };
  return composeClasses(slots, getListItemUtilityClass, classes);
};
var ListItemRoot = styled$1('div', {
  name: 'MuiListItem',
  slot: 'Root',
  overridesResolver: overridesResolver$1
})(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$1({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'left'
  }, !ownerState.disablePadding && _extends$1({
    paddingTop: 8,
    paddingBottom: 8
  }, ownerState.dense && {
    paddingTop: 4,
    paddingBottom: 4
  }, !ownerState.disableGutters && {
    paddingLeft: 16,
    paddingRight: 16
  }, !!ownerState.secondaryAction && {
    // Add some space to avoid collision as `ListItemSecondaryAction`
    // is absolutely positioned.
    paddingRight: 48
  }), !!ownerState.secondaryAction && _defineProperty({}, "& > .".concat(listItemButtonClasses$1.root), {
    paddingRight: 48
  }), _defineProperty(_defineProperty(_defineProperty({}, "&.".concat(listItemClasses$1.focusVisible), {
    backgroundColor: (theme.vars || theme).palette.action.focus
  }), "&.".concat(listItemClasses$1.selected), _defineProperty({
    backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.primary.mainChannel, " / ").concat(theme.vars.palette.action.selectedOpacity, ")") : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity)
  }, "&.".concat(listItemClasses$1.focusVisible), {
    backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.primary.mainChannel, " / calc(").concat(theme.vars.palette.action.selectedOpacity, " + ").concat(theme.vars.palette.action.focusOpacity, "))") : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
  })), "&.".concat(listItemClasses$1.disabled), {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }), ownerState.alignItems === 'flex-start' && {
    alignItems: 'flex-start'
  }, ownerState.divider && {
    borderBottom: "1px solid ".concat((theme.vars || theme).palette.divider),
    backgroundClip: 'padding-box'
  }, ownerState.button && _defineProperty({
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shortest
    }),
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: (theme.vars || theme).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }, "&.".concat(listItemClasses$1.selected, ":hover"), {
    backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.primary.mainChannel, " / calc(").concat(theme.vars.palette.action.selectedOpacity, " + ").concat(theme.vars.palette.action.hoverOpacity, "))") : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.primary.mainChannel, " / ").concat(theme.vars.palette.action.selectedOpacity, ")") : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  }), ownerState.hasSecondaryAction && {
    // Add some space to avoid collision as `ListItemSecondaryAction`
    // is absolutely positioned.
    paddingRight: 48
  });
});
var ListItemContainer = styled$1('li', {
  name: 'MuiListItem',
  slot: 'Container',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.container;
  }
})({
  position: 'relative'
});

/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */
var ListItem = /*#__PURE__*/React__namespace.forwardRef(function ListItem(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiListItem'
  });
  var _props$alignItems = props.alignItems,
    alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    _props$button = props.button,
    button = _props$button === void 0 ? false : _props$button,
    childrenProp = props.children,
    className = props.className,
    componentProp = props.component,
    _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    _props$componentsProp = props.componentsProps,
    componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp,
    _props$ContainerCompo = props.ContainerComponent,
    ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
    _props$ContainerProps = props.ContainerProps,
    _props$ContainerProps2 = _props$ContainerProps === void 0 ? {} : _props$ContainerProps,
    ContainerClassName = _props$ContainerProps2.className,
    _props$dense = props.dense,
    dense = _props$dense === void 0 ? false : _props$dense,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$disableGutters = props.disableGutters,
    disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
    _props$disablePadding = props.disablePadding,
    disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
    _props$divider = props.divider,
    divider = _props$divider === void 0 ? false : _props$divider,
    focusVisibleClassName = props.focusVisibleClassName,
    secondaryAction = props.secondaryAction,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    ContainerProps = _objectWithoutPropertiesLoose(props.ContainerProps, _excluded$5),
    other = _objectWithoutPropertiesLoose(props, _excluded2$2);
  var context = React__namespace.useContext(ListContext$1);
  var childContext = React__namespace.useMemo(function () {
    return {
      dense: dense || context.dense || false,
      alignItems: alignItems,
      disableGutters: disableGutters
    };
  }, [alignItems, context.dense, dense, disableGutters]);
  var listItemRef = React__namespace.useRef(null);
  useEnhancedEffect$1(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('MUI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var children = React__namespace.Children.toArray(childrenProp);

  // v4 implementation, deprecated in v5, will be removed in v6
  var hasSecondaryAction = children.length && isMuiElement(children[children.length - 1], ['ListItemSecondaryAction']);
  var ownerState = _extends$1({}, props, {
    alignItems: alignItems,
    autoFocus: autoFocus,
    button: button,
    dense: childContext.dense,
    disabled: disabled,
    disableGutters: disableGutters,
    disablePadding: disablePadding,
    divider: divider,
    hasSecondaryAction: hasSecondaryAction,
    selected: selected
  });
  var classes = useUtilityClasses$4(ownerState);
  var handleRef = useForkRef(listItemRef, ref);
  var Root = slots.root || components.Root || ListItemRoot;
  var rootProps = slotProps.root || componentsProps.root || {};
  var componentProps = _extends$1({
    className: clsx(classes.root, rootProps.className, className),
    disabled: disabled
  }, other);
  var Component = componentProp || 'li';
  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = clsx(listItemClasses$1.focusVisible, focusVisibleClassName);
    Component = ButtonBase$1;
  }

  // v4 implementation, deprecated in v5, will be removed in v6
  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component;

    // Avoid nesting of li > li.
    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }
    return /*#__PURE__*/jsxRuntime.exports.jsx(ListContext$1.Provider, {
      value: childContext,
      children: /*#__PURE__*/jsxRuntime.exports.jsxs(ListItemContainer, _extends$1({
        as: ContainerComponent,
        className: clsx(classes.container, ContainerClassName),
        ref: handleRef,
        ownerState: ownerState
      }, ContainerProps, {
        children: [/*#__PURE__*/jsxRuntime.exports.jsx(Root, _extends$1({}, rootProps, !isHostComponent(Root) && {
          as: Component,
          ownerState: _extends$1({}, ownerState, rootProps.ownerState)
        }, componentProps, {
          children: children
        })), children.pop()]
      }))
    });
  }
  return /*#__PURE__*/jsxRuntime.exports.jsx(ListContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsxRuntime.exports.jsxs(Root, _extends$1({}, rootProps, {
      as: Component,
      ref: handleRef
    }, !isHostComponent(Root) && {
      ownerState: _extends$1({}, ownerState, rootProps.ownerState)
    }, componentProps, {
      children: [children, secondaryAction && /*#__PURE__*/jsxRuntime.exports.jsx(ListItemSecondaryAction$1, {
        children: secondaryAction
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" ? ListItem.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: PropTypes.oneOf(['center', 'flex-start']),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: PropTypes.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var children = React__namespace.Children.toArray(props.children);

    // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
    var secondaryActionIndex = -1;
    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];
      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    }

    //  is ListItemSecondaryAction the last child of ListItem
    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('MUI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: elementTypeAcceptingRef$1,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: PropTypes.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: PropTypes.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: PropTypes.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var ListItem$1 = ListItem;

var listItemIconClasses = generateUtilityClasses('MuiListItemIcon', ['root', 'alignItemsFlexStart']);
var listItemIconClasses$1 = listItemIconClasses;

var listItemTextClasses = generateUtilityClasses('MuiListItemText', ['root', 'multiline', 'dense', 'inset', 'primary', 'secondary']);
var listItemTextClasses$1 = listItemTextClasses;

var _excluded$4 = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }
  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }
  return disableListWrap ? null : list.firstChild;
}
function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }
  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }
  return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }
  var text = nextFocus.innerText;
  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }
  text = text.trim().toLowerCase();
  if (text.length === 0) {
    return false;
  }
  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }
  return text.indexOf(textCriteria.keys.join('')) === 0;
}
function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return false;
      }
      wrappedOnce = true;
    }

    // Same logic as useAutocomplete.js
    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return true;
    }
  }
  return false;
}

/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */
var MenuList = /*#__PURE__*/React__namespace.forwardRef(function MenuList(props, ref) {
  var actions = props.actions,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    _props$autoFocusItem = props.autoFocusItem,
    autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
    children = props.children,
    className = props.className,
    _props$disabledItemsF = props.disabledItemsFocusable,
    disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
    _props$disableListWra = props.disableListWrap,
    disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
    onKeyDown = props.onKeyDown,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
    other = _objectWithoutPropertiesLoose(props, _excluded$4);
  var listRef = React__namespace.useRef(null);
  var textCriteriaRef = React__namespace.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect$1(function () {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  React__namespace.useImperativeHandle(actions, function () {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, _ref) {
        var direction = _ref.direction;
        // Let's ignore that piece of logic if users are already overriding the width
        // of the menu.
        var noExplicitWidth = !listRef.current.style.width;
        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat(getScrollbarSize(ownerDocument(containerElement)), "px");
          listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }
        return listRef.current;
      }
    };
  }, []);
  var handleKeyDown = function handleKeyDown(event) {
    var list = listRef.current;
    var key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */
    var currentFocus = ownerDocument(list).activeElement;
    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();
      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }
      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  var handleRef = useForkRef(listRef, ref);

  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */
  var activeItemIndex = -1;
  // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback
  React__namespace.Children.forEach(children, function (child, index) {
    if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
      if (activeItemIndex === index) {
        activeItemIndex += 1;
        if (activeItemIndex >= children.length) {
          // there are no focusable items within the list.
          activeItemIndex = -1;
        }
      }
      return;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (reactIs.exports.isFragment(child)) {
        console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
    if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
      activeItemIndex += 1;
      if (activeItemIndex >= children.length) {
        // there are no focusable items within the list.
        activeItemIndex = -1;
      }
    }
  });
  var items = React__namespace.Children.map(children, function (child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};
      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }
      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }
      return /*#__PURE__*/React__namespace.cloneElement(child, newChildProps);
    }
    return child;
  });
  return /*#__PURE__*/jsxRuntime.exports.jsx(List$1, _extends$1({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other, {
    children: items
  }));
});
process.env.NODE_ENV !== "production" ? MenuList.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
var MenuList$1 = MenuList;

function getPopoverUtilityClass(slot) {
  return generateUtilityClass('MuiPopover', slot);
}
generateUtilityClasses('MuiPopover', ['root', 'paper']);

var _excluded$3 = ["onEntering"],
  _excluded2$1 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"],
  _excluded3 = ["slotProps"];
function getOffsetTop(rect, vertical) {
  var offset = 0;
  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }
  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;
  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }
  return offset;
}
function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
}
function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var useUtilityClasses$3 = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes;
  var slots = {
    root: ['root'],
    paper: ['paper']
  };
  return composeClasses(slots, getPopoverUtilityClass, classes);
};
var PopoverRoot = styled$1(Modal$1, {
  name: 'MuiPopover',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})({});
var PopoverPaper = styled$1(Paper$1, {
  name: 'MuiPopover',
  slot: 'Paper',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.paper;
  }
})({
  position: 'absolute',
  overflowY: 'auto',
  overflowX: 'hidden',
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: 'calc(100% - 32px)',
  maxHeight: 'calc(100% - 32px)',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
var Popover = /*#__PURE__*/React__namespace.forwardRef(function Popover(inProps, ref) {
  var _slotProps$paper, _slots$root, _slots$paper;
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiPopover'
  });
  var action = props.action,
    anchorEl = props.anchorEl,
    _props$anchorOrigin = props.anchorOrigin,
    anchorOrigin = _props$anchorOrigin === void 0 ? {
      vertical: 'top',
      horizontal: 'left'
    } : _props$anchorOrigin,
    anchorPosition = props.anchorPosition,
    _props$anchorReferenc = props.anchorReference,
    anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
    children = props.children,
    className = props.className,
    containerProp = props.container,
    _props$elevation = props.elevation,
    elevation = _props$elevation === void 0 ? 8 : _props$elevation,
    _props$marginThreshol = props.marginThreshold,
    marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
    open = props.open,
    _props$PaperProps = props.PaperProps,
    PaperPropsProp = _props$PaperProps === void 0 ? {} : _props$PaperProps,
    slots = props.slots,
    slotProps = props.slotProps,
    _props$transformOrigi = props.transformOrigin,
    transformOrigin = _props$transformOrigi === void 0 ? {
      vertical: 'top',
      horizontal: 'left'
    } : _props$transformOrigi,
    _props$TransitionComp = props.TransitionComponent,
    TransitionComponent = _props$TransitionComp === void 0 ? Grow$1 : _props$TransitionComp,
    _props$transitionDura = props.transitionDuration,
    transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
    _props$TransitionProp = props.TransitionProps,
    _props$TransitionProp2 = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
    onEntering = _props$TransitionProp2.onEntering,
    _props$disableScrollL = props.disableScrollLock,
    disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
    TransitionProps = _objectWithoutPropertiesLoose(props.TransitionProps, _excluded$3),
    other = _objectWithoutPropertiesLoose(props, _excluded2$1);
  var externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
  var paperRef = React__namespace.useRef();
  var handlePaperRef = useForkRef(paperRef, externalPaperSlotProps.ref);
  var ownerState = _extends$1({}, props, {
    anchorOrigin: anchorOrigin,
    anchorReference: anchorReference,
    elevation: elevation,
    marginThreshold: marginThreshold,
    externalPaperSlotProps: externalPaperSlotProps,
    transformOrigin: transformOrigin,
    TransitionComponent: TransitionComponent,
    transitionDuration: transitionDurationProp,
    TransitionProps: TransitionProps
  });
  var classes = useUtilityClasses$3(ownerState);

  // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)
  var getAnchorOffset = React__namespace.useCallback(function () {
    if (anchorReference === 'anchorPosition') {
      if (process.env.NODE_ENV !== 'production') {
        if (!anchorPosition) {
          console.error('MUI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }
      return anchorPosition;
    }
    var resolvedAnchorEl = resolveAnchorEl(anchorEl);

    // If an anchor element wasn't provided, just use the parent body element of this Popover
    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : ownerDocument(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();
    if (process.env.NODE_ENV !== 'production') {
      var box = anchorElement.getBoundingClientRect();
      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]);

  // Returns the base transform origin using the element
  var getTransformOrigin = React__namespace.useCallback(function (elemRect) {
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical),
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = React__namespace.useCallback(function (element) {
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    };

    // Get the transform origin point on the element itself
    var elemTransformOrigin = getTransformOrigin(elemRect);
    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    }

    // Get the offset of the anchoring element
    var anchorOffset = getAnchorOffset();

    // Calculate element positioning
    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width;

    // Use the parent window of the anchorEl if provided
    var containerWindow = ownerWindow(resolveAnchorEl(anchorEl));

    // Window thresholds taking required margin into account
    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold;

    // Check if the vertical axis needs shifting
    if (marginThreshold !== null && top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (marginThreshold !== null && bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;
      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['MUI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    }

    // Check if the horizontal axis needs shifting
    if (marginThreshold !== null && left < marginThreshold) {
      var _diff2 = left - marginThreshold;
      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;
      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }
    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
  var _React$useState = React__namespace.useState(open),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isPositioned = _React$useState2[0],
    setIsPositioned = _React$useState2[1];
  var setPositioningStyles = React__namespace.useCallback(function () {
    var element = paperRef.current;
    if (!element) {
      return;
    }
    var positioning = getPositioningStyle(element);
    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }
    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }
    element.style.transformOrigin = positioning.transformOrigin;
    setIsPositioned(true);
  }, [getPositioningStyle]);
  React__namespace.useEffect(function () {
    if (disableScrollLock) {
      window.addEventListener('scroll', setPositioningStyles);
    }
    return function () {
      return window.removeEventListener('scroll', setPositioningStyles);
    };
  }, [anchorEl, disableScrollLock, setPositioningStyles]);
  var handleEntering = function handleEntering(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }
    setPositioningStyles();
  };
  var handleExited = function handleExited() {
    setIsPositioned(false);
  };
  React__namespace.useEffect(function () {
    if (open) {
      setPositioningStyles();
    }
  });
  React__namespace.useImperativeHandle(action, function () {
    return open ? {
      updatePosition: function updatePosition() {
        setPositioningStyles();
      }
    } : null;
  }, [open, setPositioningStyles]);
  React__namespace.useEffect(function () {
    if (!open) {
      return undefined;
    }
    var handleResize = debounce(function () {
      setPositioningStyles();
    });
    var containerWindow = ownerWindow(anchorEl);
    containerWindow.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [anchorEl, open, setPositioningStyles]);
  var transitionDuration = transitionDurationProp;
  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }

  // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container
  var container = containerProp || (anchorEl ? ownerDocument(resolveAnchorEl(anchorEl)).body : undefined);
  var RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : PopoverRoot;
  var PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : PopoverPaper;
  var paperProps = useSlotProps({
    elementType: PaperSlot,
    externalSlotProps: _extends$1({}, externalPaperSlotProps, {
      style: isPositioned ? externalPaperSlotProps.style : _extends$1({}, externalPaperSlotProps.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: elevation,
      ref: handlePaperRef
    },
    ownerState: ownerState,
    className: clsx(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
  });
  var _useSlotProps = useSlotProps({
      elementType: RootSlot,
      externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
      externalForwardedProps: other,
      additionalProps: {
        ref: ref,
        slotProps: {
          backdrop: {
            invisible: true
          }
        },
        container: container,
        open: open
      },
      ownerState: ownerState,
      className: clsx(classes.root, className)
    }),
    rootSlotPropsProp = _useSlotProps.slotProps,
    rootProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded3);
  return /*#__PURE__*/jsxRuntime.exports.jsx(RootSlot, _extends$1({}, rootProps, !isHostComponent(RootSlot) && {
    slotProps: rootSlotPropsProp,
    disableScrollLock: disableScrollLock
  }, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$1({
      appear: true,
      "in": open,
      onEntering: handleEntering,
      onExited: handleExited,
      timeout: transitionDuration
    }, TransitionProps, {
      children: /*#__PURE__*/jsxRuntime.exports.jsx(PaperSlot, _extends$1({}, paperProps, {
        children: children
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Popover.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType$1,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), function (props) {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      var resolvedAnchorEl = resolveAnchorEl(props.anchorEl);
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element or PopoverVirtualElement instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
      }
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes /* @typescript-to-proptypes-ignore */.shape({
    component: elementTypeAcceptingRef$1
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object
} : void 0;
var Popover$1 = Popover;

function getMenuUtilityClass(slot) {
  return generateUtilityClass('MuiMenu', slot);
}
generateUtilityClasses('MuiMenu', ['root', 'paper', 'list']);

var _excluded$2 = ["onEntering"],
  _excluded2 = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"];
var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var useUtilityClasses$2 = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes;
  var slots = {
    root: ['root'],
    paper: ['paper'],
    list: ['list']
  };
  return composeClasses(slots, getMenuUtilityClass, classes);
};
var MenuRoot = styled$1(Popover$1, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return rootShouldForwardProp$1(prop) || prop === 'classes';
  },
  name: 'MuiMenu',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})({});
var MenuPaper = styled$1(PopoverPaper, {
  name: 'MuiMenu',
  slot: 'Paper',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.paper;
  }
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: 'calc(100% - 96px)',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch'
});
var MenuMenuList = styled$1(MenuList$1, {
  name: 'MuiMenu',
  slot: 'List',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.list;
  }
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
var Menu = /*#__PURE__*/React__namespace.forwardRef(function Menu(inProps, ref) {
  var _slots$paper, _slotProps$paper;
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiMenu'
  });
  var _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    children = props.children,
    className = props.className,
    _props$disableAutoFoc = props.disableAutoFocusItem,
    disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
    _props$MenuListProps = props.MenuListProps,
    MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
    onClose = props.onClose,
    open = props.open,
    _props$PaperProps = props.PaperProps,
    PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
    PopoverClasses = props.PopoverClasses,
    _props$transitionDura = props.transitionDuration,
    transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
    _props$TransitionProp = props.TransitionProps,
    _props$TransitionProp2 = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
    onEntering = _props$TransitionProp2.onEntering,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    TransitionProps = _objectWithoutPropertiesLoose(props.TransitionProps, _excluded$2),
    other = _objectWithoutPropertiesLoose(props, _excluded2);
  var isRtl = useRtl();
  var ownerState = _extends$1({}, props, {
    autoFocus: autoFocus,
    disableAutoFocusItem: disableAutoFocusItem,
    MenuListProps: MenuListProps,
    onEntering: onEntering,
    PaperProps: PaperProps,
    transitionDuration: transitionDuration,
    TransitionProps: TransitionProps,
    variant: variant
  });
  var classes = useUtilityClasses$2(ownerState);
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = React__namespace.useRef(null);
  var handleEntering = function handleEntering(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, {
        direction: isRtl ? 'rtl' : 'ltr'
      });
    }
    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };
  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };

  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */
  var activeItemIndex = -1;
  // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback
  React__namespace.Children.map(children, function (child, index) {
    if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
      return;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (reactIs.exports.isFragment(child)) {
        console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : MenuPaper;
  var paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
  var rootSlotProps = useSlotProps({
    elementType: slots.root,
    externalSlotProps: slotProps.root,
    ownerState: ownerState,
    className: [classes.root, className]
  });
  var paperSlotProps = useSlotProps({
    elementType: PaperSlot,
    externalSlotProps: paperExternalSlotProps,
    ownerState: ownerState,
    className: classes.paper
  });
  return /*#__PURE__*/jsxRuntime.exports.jsx(MenuRoot, _extends$1({
    onClose: onClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: isRtl ? 'right' : 'left'
    },
    transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      paper: PaperSlot,
      root: slots.root
    },
    slotProps: {
      root: rootSlotProps,
      paper: paperSlotProps
    },
    open: open,
    ref: ref,
    transitionDuration: transitionDuration,
    TransitionProps: _extends$1({
      onEntering: handleEntering
    }, TransitionProps),
    ownerState: ownerState
  }, other, {
    classes: PopoverClasses,
    children: /*#__PURE__*/jsxRuntime.exports.jsx(MenuMenuList, _extends$1({
      onKeyDown: handleListKeyDown,
      actions: menuListActionsRef,
      autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
      autoFocusItem: autoFocusItem,
      variant: variant
    }, MenuListProps, {
      className: clsx(classes.list, MenuListProps.className),
      children: children
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Menu.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
var Menu$1 = Menu;

function getMenuItemUtilityClass(slot) {
  return generateUtilityClass('MuiMenuItem', slot);
}
var menuItemClasses = generateUtilityClasses('MuiMenuItem', ['root', 'focusVisible', 'dense', 'disabled', 'divider', 'gutters', 'selected']);
var menuItemClasses$1 = menuItemClasses;

var _excluded$1 = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"];
var overridesResolver = function overridesResolver(props, styles) {
  var ownerState = props.ownerState;
  return [styles.root, ownerState.dense && styles.dense, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};
var useUtilityClasses$1 = function useUtilityClasses(ownerState) {
  var disabled = ownerState.disabled,
    dense = ownerState.dense,
    divider = ownerState.divider,
    disableGutters = ownerState.disableGutters,
    selected = ownerState.selected,
    classes = ownerState.classes;
  var slots = {
    root: ['root', dense && 'dense', disabled && 'disabled', !disableGutters && 'gutters', divider && 'divider', selected && 'selected']
  };
  var composedClasses = composeClasses(slots, getMenuItemUtilityClass, classes);
  return _extends$1({}, classes, composedClasses);
};
var MenuItemRoot = styled$1(ButtonBase$1, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return rootShouldForwardProp$1(prop) || prop === 'classes';
  },
  name: 'MuiMenuItem',
  slot: 'Root',
  overridesResolver: overridesResolver
})(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$1({}, theme.typography.body1, {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    minHeight: 48,
    paddingTop: 6,
    paddingBottom: 6,
    boxSizing: 'border-box',
    whiteSpace: 'nowrap'
  }, !ownerState.disableGutters && {
    paddingLeft: 16,
    paddingRight: 16
  }, ownerState.divider && {
    borderBottom: "1px solid ".concat((theme.vars || theme).palette.divider),
    backgroundClip: 'padding-box'
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: (theme.vars || theme).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }, "&.".concat(menuItemClasses$1.selected), _defineProperty({
    backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.primary.mainChannel, " / ").concat(theme.vars.palette.action.selectedOpacity, ")") : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity)
  }, "&.".concat(menuItemClasses$1.focusVisible), {
    backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.primary.mainChannel, " / calc(").concat(theme.vars.palette.action.selectedOpacity, " + ").concat(theme.vars.palette.action.focusOpacity, "))") : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
  })), "&.".concat(menuItemClasses$1.selected, ":hover"), {
    backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.primary.mainChannel, " / calc(").concat(theme.vars.palette.action.selectedOpacity, " + ").concat(theme.vars.palette.action.hoverOpacity, "))") : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.primary.mainChannel, " / ").concat(theme.vars.palette.action.selectedOpacity, ")") : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  }), "&.".concat(menuItemClasses$1.focusVisible), {
    backgroundColor: (theme.vars || theme).palette.action.focus
  }), "&.".concat(menuItemClasses$1.disabled), {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }), "& + .".concat(dividerClasses$1.root), {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }), "& + .".concat(dividerClasses$1.inset), {
    marginLeft: 52
  }), "& .".concat(listItemTextClasses$1.root), {
    marginTop: 0,
    marginBottom: 0
  }), "& .".concat(listItemTextClasses$1.inset), {
    paddingLeft: 36
  }), "& .".concat(listItemIconClasses$1.root), {
    minWidth: 36
  }), !ownerState.dense && _defineProperty({}, theme.breakpoints.up('sm'), {
    minHeight: 'auto'
  }), ownerState.dense && _extends$1({
    minHeight: 32,
    // https://m2.material.io/components/menus#specs > Dense
    paddingTop: 4,
    paddingBottom: 4
  }, theme.typography.body2, _defineProperty({}, "& .".concat(listItemIconClasses$1.root, " svg"), {
    fontSize: '1.25rem'
  })));
});
var MenuItem = /*#__PURE__*/React__namespace.forwardRef(function MenuItem(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiMenuItem'
  });
  var _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    _props$component = props.component,
    component = _props$component === void 0 ? 'li' : _props$component,
    _props$dense = props.dense,
    dense = _props$dense === void 0 ? false : _props$dense,
    _props$divider = props.divider,
    divider = _props$divider === void 0 ? false : _props$divider,
    _props$disableGutters = props.disableGutters,
    disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
    focusVisibleClassName = props.focusVisibleClassName,
    _props$role = props.role,
    role = _props$role === void 0 ? 'menuitem' : _props$role,
    tabIndexProp = props.tabIndex,
    className = props.className,
    other = _objectWithoutPropertiesLoose(props, _excluded$1);
  var context = React__namespace.useContext(ListContext$1);
  var childContext = React__namespace.useMemo(function () {
    return {
      dense: dense || context.dense || false,
      disableGutters: disableGutters
    };
  }, [context.dense, dense, disableGutters]);
  var menuItemRef = React__namespace.useRef(null);
  useEnhancedEffect$1(function () {
    if (autoFocus) {
      if (menuItemRef.current) {
        menuItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('MUI: Unable to set focus to a MenuItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var ownerState = _extends$1({}, props, {
    dense: childContext.dense,
    divider: divider,
    disableGutters: disableGutters
  });
  var classes = useUtilityClasses$1(props);
  var handleRef = useForkRef(menuItemRef, ref);
  var tabIndex;
  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }
  return /*#__PURE__*/jsxRuntime.exports.jsx(ListContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsxRuntime.exports.jsx(MenuItemRoot, _extends$1({
      ref: handleRef,
      role: role,
      tabIndex: tabIndex,
      component: component,
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
      className: clsx(classes.root, className)
    }, other, {
      ownerState: ownerState,
      classes: classes
    }))
  });
});
process.env.NODE_ENV !== "production" ? MenuItem.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * @ignore
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  role: PropTypes /* @typescript-to-proptypes-ignore */.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number
} : void 0;
var MenuItem$1 = MenuItem;

function getSwitchUtilityClass(slot) {
  return generateUtilityClass('MuiSwitch', slot);
}
var switchClasses = generateUtilityClasses('MuiSwitch', ['root', 'edgeStart', 'edgeEnd', 'switchBase', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium', 'checked', 'disabled', 'input', 'thumb', 'track']);
var switchClasses$1 = switchClasses;

var _excluded = ["className", "color", "edge", "size", "sx"];
var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    edge = ownerState.edge,
    size = ownerState.size,
    color = ownerState.color,
    checked = ownerState.checked,
    disabled = ownerState.disabled;
  var slots = {
    root: ['root', edge && "edge".concat(capitalize$1(edge)), "size".concat(capitalize$1(size))],
    switchBase: ['switchBase', "color".concat(capitalize$1(color)), checked && 'checked', disabled && 'disabled'],
    thumb: ['thumb'],
    track: ['track'],
    input: ['input']
  };
  var composedClasses = composeClasses(slots, getSwitchUtilityClass, classes);
  return _extends$1({}, classes, composedClasses);
};
var SwitchRoot = styled$1('span', {
  name: 'MuiSwitch',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.edge && styles["edge".concat(capitalize$1(ownerState.edge))], styles["size".concat(capitalize$1(ownerState.size))]];
  }
})({
  display: 'inline-flex',
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: 'hidden',
  padding: 12,
  boxSizing: 'border-box',
  position: 'relative',
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: 'middle',
  // For correct alignment with the text.
  '@media print': {
    colorAdjust: 'exact'
  },
  variants: [{
    props: {
      edge: 'start'
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: 'end'
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: 'small'
    },
    style: _defineProperty(_defineProperty({
      width: 40,
      height: 24,
      padding: 7
    }, "& .".concat(switchClasses$1.thumb), {
      width: 16,
      height: 16
    }), "& .".concat(switchClasses$1.switchBase), _defineProperty({
      padding: 4
    }, "&.".concat(switchClasses$1.checked), {
      transform: 'translateX(16px)'
    }))
  }]
});
var SwitchSwitchBase = styled$1(SwitchBase$1, {
  name: 'MuiSwitch',
  slot: 'SwitchBase',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.switchBase, _defineProperty({}, "& .".concat(switchClasses$1.input), styles.input), ownerState.color !== 'default' && styles["color".concat(capitalize$1(ownerState.color))]];
  }
})(function (_ref2) {
  var theme = _ref2.theme;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    // Render above the focus ripple.
    color: theme.vars ? theme.vars.palette.Switch.defaultColor : "".concat(theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]),
    transition: theme.transitions.create(['left', 'transform'], {
      duration: theme.transitions.duration.shortest
    })
  }, "&.".concat(switchClasses$1.checked), {
    transform: 'translateX(20px)'
  }), "&.".concat(switchClasses$1.disabled), {
    color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : "".concat(theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600])
  }), "&.".concat(switchClasses$1.checked, " + .").concat(switchClasses$1.track), {
    opacity: 0.5
  }), "&.".concat(switchClasses$1.disabled, " + .").concat(switchClasses$1.track), {
    opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : "".concat(theme.palette.mode === 'light' ? 0.12 : 0.2)
  }), "& .".concat(switchClasses$1.input), {
    left: '-100%',
    width: '300%'
  });
}, function (_ref4) {
  var theme = _ref4.theme;
  return {
    '&:hover': {
      backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.action.activeChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha_1(theme.palette.action.active, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    variants: _toConsumableArray(Object.entries(theme.palette).filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        value = _ref6[1];
      return value.main && value.light;
    }) // check all the used fields in the style below
    .map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 1),
        color = _ref8[0];
      return {
        props: {
          color: color
        },
        style: _defineProperty(_defineProperty({}, "&.".concat(switchClasses$1.checked), _defineProperty({
          color: (theme.vars || theme).palette[color].main,
          '&:hover': {
            backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha_1(theme.palette[color].main, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
              backgroundColor: 'transparent'
            }
          }
        }, "&.".concat(switchClasses$1.disabled), {
          color: theme.vars ? theme.vars.palette.Switch["".concat(color, "DisabledColor")] : "".concat(theme.palette.mode === 'light' ? lighten_1(theme.palette[color].main, 0.62) : darken_1(theme.palette[color].main, 0.55))
        })), "&.".concat(switchClasses$1.checked, " + .").concat(switchClasses$1.track), {
          backgroundColor: (theme.vars || theme).palette[color].main
        })
      };
    }))
  };
});
var SwitchTrack = styled$1('span', {
  name: 'MuiSwitch',
  slot: 'Track',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.track;
  }
})(function (_ref9) {
  var theme = _ref9.theme;
  return {
    height: '100%',
    width: '100%',
    borderRadius: 14 / 2,
    zIndex: -1,
    transition: theme.transitions.create(['opacity', 'background-color'], {
      duration: theme.transitions.duration.shortest
    }),
    backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : "".concat(theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white),
    opacity: theme.vars ? theme.vars.opacity.switchTrack : "".concat(theme.palette.mode === 'light' ? 0.38 : 0.3)
  };
});
var SwitchThumb = styled$1('span', {
  name: 'MuiSwitch',
  slot: 'Thumb',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.thumb;
  }
})(function (_ref10) {
  var theme = _ref10.theme;
  return {
    boxShadow: (theme.vars || theme).shadows[1],
    backgroundColor: 'currentColor',
    width: 20,
    height: 20,
    borderRadius: '50%'
  };
});
var Switch = /*#__PURE__*/React__namespace.forwardRef(function Switch(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiSwitch'
  });
  var className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$edge = props.edge,
    edge = _props$edge === void 0 ? false : _props$edge,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    sx = props.sx,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var ownerState = _extends$1({}, props, {
    color: color,
    edge: edge,
    size: size
  });
  var classes = useUtilityClasses(ownerState);
  var icon = /*#__PURE__*/jsxRuntime.exports.jsx(SwitchThumb, {
    className: classes.thumb,
    ownerState: ownerState
  });
  return /*#__PURE__*/jsxRuntime.exports.jsxs(SwitchRoot, {
    className: clsx(classes.root, className),
    sx: sx,
    ownerState: ownerState,
    children: [/*#__PURE__*/jsxRuntime.exports.jsx(SwitchSwitchBase, _extends$1({
      type: "checkbox",
      icon: icon,
      checkedIcon: icon,
      ref: ref,
      ownerState: ownerState
    }, other, {
      classes: _extends$1({}, classes, {
        root: classes.switchBase
      })
    })), /*#__PURE__*/jsxRuntime.exports.jsx(SwitchTrack, {
      className: classes.track,
      ownerState: ownerState
    })]
  });
});
process.env.NODE_ENV !== "production" ? Switch.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(['end', 'start', false]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
var Switch$1 = Switch;

var classnames = {exports: {}};

(function (module) {
  /* global define */

  (function () {

    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = '';
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === 'string' || typeof arg === 'number') {
        return arg;
      }
      if (_typeof(arg) !== 'object') {
        return '';
      }
      if (Array.isArray(arg)) {
        return classNames.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
        return arg.toString();
      }
      var classes = '';
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + ' ' + newClass;
      }
      return value + newClass;
    }
    if (module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var classNames = classnames.exports;

const RktIcon = (_a) => {
    var { idString, additionalClasses, iconName = 'home-default', strokeWidth = 1.5, onClick } = _a, rest = __rest(_a, ["idString", "additionalClasses", "iconName", "strokeWidth", "onClick"]);
    return (jsxRuntime.exports.jsx(SvgIcon$1, Object.assign({ classes: { root: `rkt-Icon ${additionalClasses || ''}` }, "data-id": idString, onClick: onClick, inheritViewBox: true }, rest, { children: jsxRuntime.exports.jsx("use", { xlinkHref: `#${iconName}`, strokeWidth: `${strokeWidth}` }) })));
};

const RktToggle = (_a) => {
    var { toggleSummary, content, idString, contentId, triggerButtonAdditionalClasses, additionalClasses, iconAdditionalClasses, isOpen = false, onDark = false, variant = 'medium', iconPlacement = 'left', onToggle, iconContainerAdditionalClasses } = _a, rest = __rest(_a, ["toggleSummary", "content", "idString", "contentId", "triggerButtonAdditionalClasses", "additionalClasses", "iconAdditionalClasses", "isOpen", "onDark", "variant", "iconPlacement", "onToggle", "iconContainerAdditionalClasses"]);
    const [expanded, setExpanded] = React__namespace.useState(isOpen);
    const toggleExpanded = () => {
        setExpanded((prev) => !prev);
    };
    return (jsxRuntime.exports.jsxs("div", Object.assign({ className: classNames({
            'rkt-Toggle': true,
            'rkt-Toggle--small': variant === 'small',
            'rkt-Toggle--large': variant === 'large',
            'rkt-Toggle--on-dark': onDark,
        }, additionalClasses), "data-id": idString }, rest, { children: [jsxRuntime.exports.jsx("button", Object.assign({ onClick: () => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-unused-expressions
                    onToggle && onToggle();
                    toggleExpanded();
                }, className: classNames({
                    'rkt-Toggle__trigger': true,
                    'rkt-Toggle__trigger--on-dark': onDark,
                    'rkt-Toggle__trigger--icon-right': iconPlacement === 'right',
                }, triggerButtonAdditionalClasses), "aria-expanded": expanded, "aria-controls": contentId, type: "button" }, { children: jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [iconPlacement === 'left' && (jsxRuntime.exports.jsx("span", Object.assign({ className: classNames({
                                'rkt-Toggle__trigger-icon-container': true,
                            }, iconContainerAdditionalClasses) }, { children: jsxRuntime.exports.jsx(RktIcon, { iconName: "expand_more-default", additionalClasses: classNames({
                                    'rkt-Toggle__trigger-icon rkt-Icon--toggle': true,
                                    'rkt-Icon--is-open': expanded,
                                }, iconAdditionalClasses) }) }))), toggleSummary, iconPlacement === 'right' && (jsxRuntime.exports.jsx("span", Object.assign({ className: classNames({
                                'rkt-Toggle__trigger-icon-container': true,
                            }, iconContainerAdditionalClasses) }, { children: jsxRuntime.exports.jsx(RktIcon, { iconName: "expand_more-default", additionalClasses: classNames({
                                    'rkt-Toggle__trigger-icon rkt-Icon--toggle': true,
                                    'rkt-Icon--is-open': expanded,
                                }, iconAdditionalClasses) }) })))] }) })), jsxRuntime.exports.jsx(Collapse$1, Object.assign({ in: expanded }, { children: jsxRuntime.exports.jsx("div", Object.assign({ className: "rkt-Toggle__content", id: contentId }, { children: content })) }))] })));
};

const RktStack = (_a) => {
    var { splitAt, spacing, idString, additionalClasses, isStackItem, children, as: Component = 'div' } = _a, props = __rest(_a, ["splitAt", "spacing", "idString", "additionalClasses", "isStackItem", "children", "as"]);
    const stackClasses = classNames('rkt-Stack', additionalClasses, {
        [`rkt-Stack--spacing-${spacing}`]: !!spacing,
        [`rkt-Stack--split@${splitAt}`]: !!splitAt,
        'rkt-Stack__item': isStackItem === true,
    });
    return (jsxRuntime.exports.jsx(Component, Object.assign({ className: stackClasses, "data-id": idString }, props, { children: children })));
};

const RktStackItem = (_a) => {
    var { children, idString, additionalClasses, as: Component = 'div' } = _a, props = __rest(_a, ["children", "idString", "additionalClasses", "as"]);
    return (jsxRuntime.exports.jsx(Component, Object.assign({ className: classNames('rkt-Stack__item', additionalClasses), "data-id": idString }, props, { children: children })));
};

const RktSidenav = (_a) => {
    var { idString, children, branding, sidenavId = 'rkt-sidenav', toggleOpenedIcon = (jsxRuntime.exports.jsxs("svg", Object.assign({ className: "rkt-Sidenav__menu-icon", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M21 3V5L9 5V3H21Z", fill: "#1C1B1A" }), jsxRuntime.exports.jsx("path", { d: "M6.8 11L9.4 8.4L8 7L3 12L8 17L9.4 15.6L6.8 13H21V11H6.8Z", fill: "#1C1B1A" }), jsxRuntime.exports.jsx("path", { d: "M21 21L9 21V19L21 19V21Z", fill: "#1C1B1A" })] }))), toggleClosedIcon = (jsxRuntime.exports.jsxs("svg", Object.assign({ className: "rkt-Sidenav__menu-icon", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M3 3H21V5H3V3Z", fill: "#1C1B1A" }), jsxRuntime.exports.jsx("path", { d: "M3 11H21V13H3V11Z", fill: "#1C1B1A" }), jsxRuntime.exports.jsx("path", { d: "M3 19V21H14.4098V19H3Z", fill: "#1C1B1A" })] }))), additionalClasses, topBarAdditionalClasses, toggleButtonScreenReaderText = 'Toggle Sidenav', onToggleSidenavSmall, sidenavIsOpen = false } = _a, rest = __rest(_a, ["idString", "children", "branding", "sidenavId", "toggleOpenedIcon", "toggleClosedIcon", "additionalClasses", "topBarAdditionalClasses", "toggleButtonScreenReaderText", "onToggleSidenavSmall", "sidenavIsOpen"]);
    const [sidenavStateIsOpen, setSidenavIsOpen] = React__namespace.useState(sidenavIsOpen);
    const componentEl = React__namespace.useRef(null);
    const closeSidenavOnResize = () => {
        if (sidenavStateIsOpen) {
            setSidenavIsOpen(!sidenavStateIsOpen);
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-unused-expressions
            onToggleSidenavSmall && onToggleSidenavSmall();
        }
    };
    /**
     * When page is resized
     * we want to close the
     * sidenav if it was left open.
     */
    if (typeof window === 'object') {
        React__namespace.useEffect(() => {
            window.addEventListener('resize', closeSidenavOnResize);
            window.addEventListener('orientationchange', closeSidenavOnResize);
            return () => {
                window.removeEventListener('resize', closeSidenavOnResize);
                window.removeEventListener('orientationchange', closeSidenavOnResize);
            };
        }, [sidenavStateIsOpen]);
    }
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsxs("div", Object.assign({ className: classNames({
                    'rkt-Sidenav-bar rkt-Spacing--ph16': true,
                    'rkt-Visibility--hidden': sidenavStateIsOpen,
                }, topBarAdditionalClasses) }, { children: [jsxRuntime.exports.jsxs("button", Object.assign({ className: "rkt-ButtonReset rkt-Spacing--mr16 rkt-Stack__item--center-column", type: "button", onClick: () => {
                            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-unused-expressions
                            onToggleSidenavSmall && onToggleSidenavSmall();
                            setSidenavIsOpen(!sidenavStateIsOpen);
                        }, "aria-expanded": sidenavStateIsOpen, "aria-controls": sidenavId }, { children: [jsxRuntime.exports.jsx("span", Object.assign({ className: "rkt-ScreenReaderText" }, { children: toggleButtonScreenReaderText })), sidenavStateIsOpen ? toggleOpenedIcon : toggleClosedIcon] })), branding] })), jsxRuntime.exports.jsxs(Drawer$1, Object.assign({ ref: componentEl, "data-id": idString, id: sidenavId, className: classNames({
                    'rkt-Sidenav__drawer rkt-Sidenav__drawer--pop-over': true,
                }, additionalClasses) }, rest, { variant: "temporary", anchor: "left", onClose: () => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-unused-expressions
                    onToggleSidenavSmall && onToggleSidenavSmall();
                    setSidenavIsOpen(!sidenavStateIsOpen);
                }, open: sidenavStateIsOpen, ModalProps: {
                    keepMounted: true,
                } }, { children: [jsxRuntime.exports.jsxs(RktStack, Object.assign({ spacing: "16", splitAt: "0", additionalClasses: classNames({
                            'rkt-Spacing--pv16 rkt-Spacing--ph16': true,
                        }, additionalClasses) }, { children: [jsxRuntime.exports.jsx(RktStackItem, { children: jsxRuntime.exports.jsxs("button", Object.assign({ className: "rkt-ButtonReset", type: "button", onClick: () => {
                                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-unused-expressions
                                        onToggleSidenavSmall && onToggleSidenavSmall();
                                        setSidenavIsOpen(!sidenavStateIsOpen);
                                    }, "aria-expanded": sidenavStateIsOpen, "aria-controls": sidenavId }, { children: [jsxRuntime.exports.jsx("span", Object.assign({ className: "rkt-ScreenReaderText" }, { children: toggleButtonScreenReaderText })), toggleOpenedIcon] })) }), jsxRuntime.exports.jsx(RktStackItem, Object.assign({ additionalClasses: "rkt-Stack__item--flex" }, { children: branding }))] })), jsxRuntime.exports.jsx(Divider$1, { classes: { root: 'rkt-HorizontalDivider' } }), children] })), jsxRuntime.exports.jsxs(Drawer$1, Object.assign({ ref: componentEl, "data-id": idString, className: classNames({
                    'rkt-Sidenav__drawer rkt-Sidenav__drawer--fixed': true,
                }, additionalClasses) }, rest, { variant: "permanent", anchor: "left", open: true }, { children: [jsxRuntime.exports.jsx("div", Object.assign({ className: "rkt-Spacing--pv16 rkt-Spacing--ph16" }, { children: branding })), jsxRuntime.exports.jsx(Divider$1, { classes: { root: 'rkt-HorizontalDivider' } }), children] }))] }));
};

/**
 * Opens a Mat Menu when the button icon is
 * clicked on large views and a Mat Drawer (bottom sheet) on small views.
 * It detects the view size using the sidenavBreakpoint prop to determine which to open.
 * It passes the handleClose method from this component to the child item's onClick function so that
 * the item can optionally close the menu on click.
 */
const RktSidenavIconMenu = (_a) => {
    var { children, icon, idString, bottomSheetContent, bottomSheetAdditionalClasses, menuAdditionalClasses, buttonAdditionalClasses, menuId = 'rkt-sidenav-menu', buttonId = 'rkt-menu-button', iconAriaLabel = 'Toggle Menu', sidenavBreakpoint = '768px', onMenuClose } = _a, rest = __rest(_a, ["children", "icon", "idString", "bottomSheetContent", "bottomSheetAdditionalClasses", "menuAdditionalClasses", "buttonAdditionalClasses", "menuId", "buttonId", "iconAriaLabel", "sidenavBreakpoint", "onMenuClose"]);
    const isSmallView = useMediaQuery(`(max-width: ${sidenavBreakpoint})`);
    const [anchorEl, setAnchorEl] = React__namespace.useState(null);
    const menuIsOpen = Boolean(anchorEl);
    const [bottomSheetIsOpen, setBottomSheetIsOpen] = React__namespace.useState(false);
    const bottomSheetClasses = bottomSheetAdditionalClasses
        ? `rkt-BottomSheet ${bottomSheetAdditionalClasses}`
        : 'rkt-BottomSheet';
    const menuClasses = menuAdditionalClasses
        ? `rkt-Menu ${menuAdditionalClasses}`
        : 'rkt-Menu';
    const handleClose = (e) => {
        /* eslint-disable */
        onMenuClose && onMenuClose(e);
        // If it's a small screen then close the bottom sheet; else close the menu
        isSmallView ? toggleBottomSheet(false)(e) : setAnchorEl(null);
        /* eslint-enable */
    };
    const toggleBottomSheet = (open) => (e) => {
        if (!(e.key === 'Tab' ||
            e.key === 'Shift')) {
            setBottomSheetIsOpen(open);
        }
    };
    /**
     * When page is resized
     * we want to close the
     * menu/bottom sheet if it was left open.
     */
    if (typeof window === 'object') {
        React__namespace.useEffect(() => {
            window.addEventListener('resize', handleClose);
            window.addEventListener('orientationchange', handleClose);
            return () => {
                window.removeEventListener('resize', handleClose);
                window.removeEventListener('orientationchange', handleClose);
            };
        }, [menuIsOpen || bottomSheetIsOpen]);
    }
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx("button", Object.assign({ className: classNames(
                // eslint-disable-next-line @typescript-eslint/naming-convention
                { 'rkt-ButtonReset': true }, buttonAdditionalClasses), type: "button", "aria-haspopup": "true", "aria-label": iconAriaLabel, "aria-controls": bottomSheetIsOpen || menuIsOpen ? menuId : undefined, "aria-expanded": bottomSheetIsOpen || menuIsOpen ? 'true' : 'false', onClick: (e) => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-unused-expressions
                    isSmallView
                        ? toggleBottomSheet(true)(e)
                        : setAnchorEl(e.currentTarget);
                } }, { children: icon })), !isSmallView && (jsxRuntime.exports.jsx(Menu$1, Object.assign({ "data-id": idString, id: menuId, anchorEl: anchorEl, open: menuIsOpen, onClose: handleClose, MenuListProps: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    'aria-labelledby': buttonId,
                }, classes: { root: menuClasses } }, rest, { children: React__namespace.Children.toArray(children).map((child) => React__namespace.isValidElement(child)
                    ? React__namespace.cloneElement(child, { handleClose })
                    : child) }))), isSmallView && (jsxRuntime.exports.jsx(Drawer$1, Object.assign({ "data-id": idString, anchor: "bottom", open: bottomSheetIsOpen, onClose: handleClose, classes: { paper: bottomSheetClasses } }, rest, { children: jsxRuntime.exports.jsx("div", Object.assign({ role: "presentation", onClick: handleClose, onKeyDown: handleClose }, { children: jsxRuntime.exports.jsx(List$1, Object.assign({ classes: { root: `${bottomSheetClasses} rkt-Spacing--pa16` } }, { children: React__namespace.Children.toArray(bottomSheetContent).map((item) => React__namespace.isValidElement(item)
                            ? React__namespace.cloneElement(item, { handleClose })
                            : item) })) })) })))] }));
};

const RktSidenavIconMenuItem = (_a) => {
    var { children, additionalClasses, idString, closeOnClick = true, disabled, onClickCallback, handleClose, isBottomSheetItem = false } = _a, rest = __rest(_a, ["children", "additionalClasses", "idString", "closeOnClick", "disabled", "onClickCallback", "handleClose", "isBottomSheetItem"]);
    const menuClasses = additionalClasses ? `rkt-Menu__item ${additionalClasses}` : 'rkt-Menu__item';
    return (jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children: isBottomSheetItem ?
            (jsxRuntime.exports.jsx(ListItem$1, Object.assign({ "data-id": idString, disabled: disabled, classes: { root: additionalClasses }, disablePadding: true, onClick: (e) => {
                    /* eslint-disable */
                    onClickCallback && onClickCallback(e);
                    if (closeOnClick) {
                        handleClose && handleClose(e);
                    }
                    /* eslint-enable */
                } }, rest, { children: children }))) :
            (jsxRuntime.exports.jsx(MenuItem$1, Object.assign({ disabled: disabled, classes: { root: menuClasses }, "data-id": idString, onClick: (e) => {
                    /* eslint-disable */
                    onClickCallback && onClickCallback(e);
                    if (closeOnClick) {
                        handleClose && handleClose(e);
                    }
                    /* eslint-enable */
                } }, rest, { children: children }))) }));
};

// Get all focusable elements in a container
const rktGetFocusableEls = (container) => {
    const focusEls = container.querySelectorAll('a[href], area[href],' +
        'input:not([disabled]),' +
        'select:not([disabled]),' +
        'textarea:not([disabled]),' +
        'button:not([disabled]), [tabindex="0"]');
    return focusEls;
};
// Focus first element in a container
const rktFocusFirstEl = (container) => {
    const focusEls = rktGetFocusableEls(container);
    if (focusEls.length > 0) {
        focusEls[0].focus();
    }
};

/**
 * Gets the document's active element
 * and checks if it contains the supplied
 * CSS class. If it does not,
 * it will focus the first element in the supplied container.
 *
 * @param container
 * @param containerItemClassName
 */
const rktFocusTrap = (container, containerItemClassName) => {
    const activeElement = document.activeElement;
    const isFocusedOnEl = activeElement.classList.contains(containerItemClassName);
    if (!isFocusedOnEl) {
        rktFocusFirstEl(container);
    }
};

/**
 * Adds overflow and height style classes that lock a page
 * from scrolling behind an open nav or container.
 */
const rktAddPageLockClasses = () => {
    document.body.classList.add('rkt-Overflow--hidden');
    document.documentElement.classList.add('rkt-Overflow--hidden');
    document.body.classList.add('rkt-Height--100');
    document.documentElement.classList.add('rkt-Height--100');
};
/**
 * Removes overflow and height classes that lock a page
 * from scrolling behind an open nav or container.
 */
const rktRemovePageLockClasses = () => {
    document.body.classList.remove('rkt-Overflow--hidden');
    document.documentElement.classList.remove('rkt-Overflow--hidden');
    document.body.classList.remove('rkt-Height--100');
    document.documentElement.classList.remove('rkt-Height--100');
};

const rktDarkModeClassName = 'rkt-DarkMode';
const rktLightModeClassName = 'rkt-LightMode';
// Add light mode class to root element
// Remove dark mode class if it there
const rktAddLightModeClass = (rootElement = document.body) => {
    if (rootElement.classList.contains(rktLightModeClassName))
        return;
    rktRemoveDarkModeClass(rootElement);
    rootElement.classList.add(rktLightModeClassName);
};
// Remove light mode class from body element if present
const rktRemoveLightModeClass = (rootElement = document.body) => {
    if (rootElement.classList.contains(rktLightModeClassName)) {
        rootElement.classList.remove(rktLightModeClassName);
    }
};
// Add dark mode class to body element
// Remove light mode class if it there
const rktAddDarkModeClass = (rootElement = document.body) => {
    if (rootElement.classList.contains(rktDarkModeClassName))
        return;
    rktRemoveLightModeClass(rootElement);
    rootElement.classList.add(rktDarkModeClassName);
};
// Remove dark mode class from body element if present
const rktRemoveDarkModeClass = (rootElement = document.body) => {
    if (rootElement.classList.contains(rktDarkModeClassName)) {
        rootElement.classList.remove(rktDarkModeClassName);
    }
};
// If isDarkMode is true add dark mode class. Otherwise add Light mode class.
// Useful for a button toggle or cases where dark mode needs to be "hard-coded" to yes or no.
const rktToggleDarkModeClass = (isDarkMode, rootElement = document.body) => {
    return isDarkMode ? rktAddDarkModeClass(rootElement) : rktAddLightModeClass(rootElement);
};

const rktIsScrolled = () => {
    if (typeof window === 'object') {
        const [isScrolled, setIsScrolled] = React__namespace.useState(false);
        React__namespace.useEffect(() => {
            const checkScrollPosition = () => {
                if (window.scrollY >= 10) {
                    if (!isScrolled)
                        setIsScrolled(true);
                }
                else {
                    if (isScrolled)
                        setIsScrolled(false);
                }
            };
            window.addEventListener('scroll', checkScrollPosition);
            return () => {
                window.removeEventListener('scroll', checkScrollPosition);
            };
        });
        return isScrolled;
    }
};

const RktMasthead = (_a) => {
    var { Branding, NavItems, NavItem, CollapsibleNav, mastheadBreakpoint = '1006px', idString, additionalClasses, collapsibleNavButtonScreenReaderText = 'Toggle Navigation', collapsibleNavId, onCollapsibleNavToggle, menuOpenIcon = (jsxRuntime.exports.jsx("svg", Object.assign({ className: "rkt-Masthead__menu-icon", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, { children: jsxRuntime.exports.jsx("path", { d: "M7 7L17 17M17 7L7 17", stroke: "#111111", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }))), menuClosedIcon = (jsxRuntime.exports.jsxs("svg", Object.assign({ className: "rkt-Masthead__menu-icon", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, { children: [jsxRuntime.exports.jsx("path", { d: "M4 17.5H20", stroke: "#111111", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M4 12H20", stroke: "#111111", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M4 6.49998H20", stroke: "#111111", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }))) } = _a, rest = __rest(_a, ["Branding", "NavItems", "NavItem", "CollapsibleNav", "mastheadBreakpoint", "idString", "additionalClasses", "collapsibleNavButtonScreenReaderText", "collapsibleNavId", "onCollapsibleNavToggle", "menuOpenIcon", "menuClosedIcon"]);
    /**
     * Handle menu state
     */
    const [menuOpen, setMenuOpen] = React__namespace.useState(false);
    const changeMenuState = (newValue) => {
        setMenuOpen(newValue);
    };
    const handleToggleMenu = () => {
        const htmlElement = document.documentElement;
        onCollapsibleNavToggle && onCollapsibleNavToggle();
        setMenuOpen(!menuOpen);
        /**
         * If html element exists and menu is open then add overflow class, remove if closed
         * NOTE: this only works if the app doesn't have any more specific classes on the root HTML element that modify overflow behavior
         */
        if (htmlElement) {
            menuOpen
                ? htmlElement.classList.remove('rkt-Overflow--hidden')
                : htmlElement.classList.add('rkt-Overflow--hidden');
        }
    };
    /**
     * Handle resizing and orientation change. We don't want to run this effect in SSR settings
     */
    if (typeof window === 'object') {
        React__namespace.useEffect(() => {
            const handleOrientationChange = () => {
                const htmlElement = document.documentElement;
                // we want to close the collapsible nav when the orientation changes
                if (menuOpen) {
                    setMenuOpen(false);
                    htmlElement.classList.remove('rkt-Overflow--hidden');
                }
            };
            const handleWindowResize = () => {
                const htmlElement = document.documentElement;
                // we want to close the collapsible nav when the viewport is large and the menu is still open
                // we use regex to remove the px unit to be able to compare it with the absolute value from innerWidth
                if (window.innerWidth >= Number(`${mastheadBreakpoint}`.match(/\d+/g)) && menuOpen) {
                    setMenuOpen(false);
                    htmlElement.classList.remove('rkt-Overflow--hidden');
                }
            };
            window.addEventListener('resize', handleWindowResize);
            window.addEventListener('orientationchange', handleOrientationChange);
            return () => {
                window.removeEventListener('resize', handleWindowResize);
                window.removeEventListener('orientationchange', handleOrientationChange);
            };
        }, [menuOpen]);
    }
    return (jsxRuntime.exports.jsxs(RktStack, Object.assign({ as: "header", additionalClasses: classNames({
            'rkt-Masthead--is-open': menuOpen,
            'rkt-Masthead--is-scrolled': rktIsScrolled(),
            'rkt-Masthead': true,
            'rkt-Masthead--react': true,
        }, additionalClasses), "data-id": idString }, rest, { children: [jsxRuntime.exports.jsxs(RktStack, Object.assign({ isStackItem: true, additionalClasses: "rkt-Masthead__content", splitAt: "0" }, { children: [jsxRuntime.exports.jsx(RktStackItem, Object.assign({ additionalClasses: "rkt-Masthead__menu rkt-Stack__item--center-column@1 rkt-Stack__item" }, { children: CollapsibleNav && (jsxRuntime.exports.jsx("button", Object.assign({ "aria-controls": menuOpen ? collapsibleNavId : undefined, "aria-expanded": menuOpen ? true : false, "aria-haspopup": "true", onClick: handleToggleMenu, "aria-label": collapsibleNavButtonScreenReaderText, className: "rkt-Masthead__collapsible-nav-button", type: "button" }, { children: jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx("span", Object.assign({ className: "rkt-ScreenReaderText" }, { children: collapsibleNavButtonScreenReaderText })), menuOpen ? menuOpenIcon : menuClosedIcon] }) }))) })), Branding, jsxRuntime.exports.jsx(NavItems, {}), NavItem && jsxRuntime.exports.jsx(NavItem, {})] })), CollapsibleNav && jsxRuntime.exports.jsx(CollapsibleNav, { menuOpen: menuOpen, changeMenuOpen: changeMenuState })] })));
};

const RktTag = (_a) => {
    var { children, variant, onDark, idString, additionalClasses, contentAdditionalClasses, iconPosition, icon } = _a, rest = __rest(_a, ["children", "variant", "onDark", "idString", "additionalClasses", "contentAdditionalClasses", "iconPosition", "icon"]);
    return (jsxRuntime.exports.jsxs("div", Object.assign({ className: classNames({
            'rkt-Tag': true,
            'rkt-Tag--secondary': variant === 'secondary',
            'rkt-Tag--info': variant === 'info',
            'rkt-Tag--success': variant === 'success',
            'rkt-Tag--primary': variant === 'primary',
            'rkt-Tag--warn': variant === 'warn',
            'rkt-Tag--on-dark': onDark,
            'rkt-Tag--has-icon-left': iconPosition === 'left',
            'rkt-Tag--has-icon-right': iconPosition === 'right',
        }, additionalClasses), "data-id": idString }, rest, { children: [iconPosition === 'left' && icon, jsxRuntime.exports.jsx("span", Object.assign({ className: classNames({
                    'rkt-Tag__text': true,
                    'rkt-Tag__text--on-dark': onDark,
                }, contentAdditionalClasses) }, { children: children })), iconPosition === 'right' && icon] })));
};

var RktRed700 = "#a3202b";
var RktYellow600 = "#a56a06";
var RktGray200 = "#e9e9e9";
var RktGray400 = "#949494";
var RktGray800 = "#111111";
var RktGray900 = "#050505";

var RktTypographyColorBody16 = "#111111";
var RktTypographyFontFamilyButton = "'Wintle Text', Helvetica, 'Helvetica Neue', Arial, sans-serif";
var RktTypographyFontFamilyCaption = "'Wintle Text', Helvetica, 'Helvetica Neue', Arial, sans-serif";
var RktTypographyFontFamilySubheadingOne = "'Wintle Text', Helvetica, 'Helvetica Neue', Arial, sans-serif";
var RktTypographyFontFamilySubheadingTwo = "'Wintle Text', Helvetica, 'Helvetica Neue', Arial, sans-serif";
var RktTypographyFontFamilyRocket = "'Wintle Text', Helvetica, 'Helvetica Neue', Arial, sans-serif";
var RktTypographyFontFamilyBody16 = "'Wintle Text', Helvetica, 'Helvetica Neue', Arial, sans-serif";
var RktTypographyFontSizeCaption = "12px";
var RktTypographyFontSizeSubheadingOne = "18px";
var RktTypographyFontSizeSubheadingTwo = "18px";
var RktTypographyFontSizeButton = "14px";
var RktTypographyFontSizeBody16 = "1rem";
var RktTypographyFontWeight500 = "500";
var RktTypographyFontWeightSubheadingOne = "300";
var RktTypographyFontWeightSubheadingTwo = "500";
var RktTypographyFontWeightCaption = "400";
var RktTypographyFontWeightButton = "500";
var RktTypographyLineHeightBody16 = "1.5rem";
var RktTypographyLineHeightSubheadingOne = "1.33";
var RktTypographyLineHeightSubheadingTwo = "1.33";
var RktTypographyLineHeightCaption = "1.33";
var RktTypographyLineHeightButton = "24px";

var RktSplitBreakpoint1 = "320px";
var RktSplitBreakpoint2 = "375px";
var RktSplitBreakpoint3 = "480px";
var RktSplitBreakpoint4 = "680px";
var RktSplitBreakpoint5 = "768px";
var RktSplitBreakpoint6 = "880px";
var RktSplitBreakpoint7 = "1080px";
var RktSplitBreakpoint8 = "1290px";
var RktSplitBreakpoint9 = "1440px";
var RktSplitBreakpoint10 = "1920px";

const rktTheme = createTheme({
    spacing: [0, 4, 8, 16, 24, 32, 40, 48, 64, 80],
    palette: {
        primary: {
            main: RktRed700,
        },
        secondary: {
            main: RktGray800,
        },
        error: {
            main: RktYellow600,
        },
        text: {
            primary: RktGray900,
            disabled: RktGray400,
        },
    },
    components: {
        MuiLink: {
            defaultProps: {
                underline: 'none',
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontFamily: RktTypographyFontFamilyBody16,
                    fontSize: RktTypographyFontSizeBody16,
                    fontWeight: parseInt(RktTypographyFontWeight500, 10),
                    lineHeight: RktTypographyLineHeightBody16,
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    borderBottom: 'solid',
                    borderColor: RktGray200,
                    borderWidth: '1px',
                },
            },
        },
        MuiTypography: {
            variants: [
                {
                    props: { variant: 'button' },
                    style: {
                        fontFamily: RktTypographyFontFamilyRocket,
                        fontSize: RktTypographyFontSizeButton,
                        fontWeight: parseInt(RktTypographyFontWeightButton, 10),
                        lineHeight: RktTypographyLineHeightButton,
                        textTransform: 'none',
                    },
                },
                {
                    props: { variant: 'caption' },
                    style: {
                        fontFamily: RktTypographyFontFamilyRocket,
                        fontSize: RktTypographyFontSizeCaption,
                        fontWeight: parseInt(RktTypographyFontWeightCaption, 10),
                        lineHeight: RktTypographyLineHeightCaption,
                    },
                },
                {
                    props: { variant: 'subtitle1' },
                    style: {
                        fontFamily: RktTypographyFontFamilyRocket,
                        fontSize: RktTypographyFontSizeSubheadingOne,
                        fontWeight: parseInt(RktTypographyFontWeightSubheadingOne, 10),
                        lineHeight: RktTypographyLineHeightSubheadingOne,
                    },
                },
                {
                    props: { variant: 'subtitle2' },
                    style: {
                        fontFamily: RktTypographyFontFamilyRocket,
                        fontSize: RktTypographyFontSizeSubheadingTwo,
                        fontWeight: parseInt(RktTypographyFontWeightSubheadingTwo, 10),
                        lineHeight: RktTypographyLineHeightSubheadingTwo,
                    },
                },
            ],
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    '&.Mui-focused': {
                        color: RktTypographyColorBody16,
                    },
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                InputLabelProps: {
                    shrink: true,
                }
            }
        }
    },
    typography: {
        fontFamily: RktTypographyFontFamilyRocket,
        button: {
            fontFamily: RktTypographyFontFamilyButton,
            fontSize: RktTypographyFontSizeButton,
            fontWeight: parseInt(RktTypographyFontWeightButton, 10),
            lineHeight: RktTypographyLineHeightButton,
            textTransform: 'none',
        },
        caption: {
            fontFamily: RktTypographyFontFamilyCaption,
            fontSize: RktTypographyFontSizeCaption,
            fontWeight: parseInt(RktTypographyFontWeightCaption, 10),
            lineHeight: RktTypographyLineHeightCaption,
        },
        subtitle1: {
            fontFamily: RktTypographyFontFamilySubheadingOne,
            fontSize: RktTypographyFontSizeSubheadingOne,
            fontWeight: parseInt(RktTypographyFontWeightSubheadingOne, 10),
            lineHeight: RktTypographyLineHeightSubheadingOne,
        },
        subtitle2: {
            fontFamily: RktTypographyFontFamilySubheadingTwo,
            fontSize: RktTypographyFontSizeSubheadingTwo,
            fontWeight: parseInt(RktTypographyFontWeightSubheadingTwo, 10),
            lineHeight: RktTypographyLineHeightSubheadingTwo,
        },
    },
    /* eslint-disable */
    breakpoints: {
        values: {
            // remove the below changes when https://github.com/mui/material-ui/issues/26369 is merged
            xs: 0,
            sm: 375,
            md: 768,
            lg: 1440,
            xl: 1920,
            10: parseInt(RktSplitBreakpoint10, 10),
            9: parseInt(RktSplitBreakpoint9, 10),
            8: parseInt(RktSplitBreakpoint8, 10),
            7: parseInt(RktSplitBreakpoint7, 10),
            6: parseInt(RktSplitBreakpoint6, 10),
            5: parseInt(RktSplitBreakpoint5, 10),
            4: parseInt(RktSplitBreakpoint4, 10),
            3: parseInt(RktSplitBreakpoint3, 10),
            2: parseInt(RktSplitBreakpoint2, 10),
            1: parseInt(RktSplitBreakpoint1, 10),
            0: 0,
        },
    },
    /* eslint-enable */
});

const RktThemeToggle = (_a) => {
    var { children, rootElement, isDark = useMediaQuery('(prefers-color-scheme: dark)'), idString, onToggleChange, additionalClasses, label, labelPosition, ariaLabel = 'Toggle Theme', isDisabled = false } = _a, rest = __rest(_a, ["children", "rootElement", "isDark", "idString", "onToggleChange", "additionalClasses", "label", "labelPosition", "ariaLabel", "isDisabled"]);
    // State initially set to if user "prefers dark mode"
    const [isDarkMode, setIsDarkMode] = React__namespace.useState(isDark);
    // Run dark/light mode setup when component loads
    React__namespace.useEffect(() => {
        rktToggleDarkModeClass(isDarkMode, rootElement);
    }, []);
    /*
     * Handles change of component by updating state with toggle value
     * and toggling the dark/light mode class based on that change.
     * @param {Event} event
     */
    const handleChange = (e) => {
        if (e.target) {
            const checkedValue = e.target.checked;
            setIsDarkMode(checkedValue);
            rktToggleDarkModeClass(checkedValue, rootElement);
            if (onToggleChange)
                onToggleChange(checkedValue);
        }
    };
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(FormControlLabel$1, Object.assign({}, rest, { "aria-label": !label ? ariaLabel : undefined, "data-id": idString, labelPlacement: labelPosition, classes: { root: `rkt-SlideToggle rkt-SlideToggle--theme ${additionalClasses || ''}` }, control: jsxRuntime.exports.jsx(Switch$1, { color: "secondary", checked: isDarkMode, onChange: handleChange, disabled: isDisabled }), label: label && (jsxRuntime.exports.jsx("label", Object.assign({ className: classNames({
                        'rkt-SlideToggle__label': true,
                        'rkt-SlideToggle__label--start': labelPosition === 'start',
                        'rkt-SlideToggle__label--bottom': labelPosition === 'bottom',
                        'rkt-SlideToggle__label--end': labelPosition === 'end',
                    }) }, { children: label }))) })), children] }));
};

const RktBanner = ({ variant, idString, additionalClasses, isDismissible = true, dismissIconName = 'close-default', iconIndicator, isVisible = true, onDismiss, children, }) => {
    const [visible, setVisible] = React__namespace.useState(isVisible);
    const handleDismiss = () => {
        if (onDismiss)
            onDismiss();
        setVisible(false);
    };
    const defaultIcons = {
        success: jsxRuntime.exports.jsx(RktIcon, { iconName: "check_circle-default", additionalClasses: "rkt-Banner__icon-indicator" }),
        info: jsxRuntime.exports.jsx(RktIcon, { iconName: "info-default", additionalClasses: "rkt-Banner__icon-indicator" }),
        warn: jsxRuntime.exports.jsx(RktIcon, { iconName: "error-default", additionalClasses: "rkt-Banner__icon-indicator" }),
        white: jsxRuntime.exports.jsx(RktIcon, { iconName: "info-default", additionalClasses: "rkt-Banner__icon-indicator" }),
        primary: jsxRuntime.exports.jsx(RktIcon, { iconName: "info-default", additionalClasses: "rkt-Banner__icon-indicator" }),
        secondary: jsxRuntime.exports.jsx(RktIcon, { iconName: "info-default", additionalClasses: "rkt-Banner__icon-indicator" }),
    };
    /**
     * If `iconIndicator` is passed, it overrides the default icon based on the variant.
     */
    const getIcon = () => {
        return iconIndicator || (variant ?
            defaultIcons[variant] :
            jsxRuntime.exports.jsx(RktIcon, { iconName: "info-default", additionalClasses: "rkt-Banner__icon-indicator" }));
    };
    return (jsxRuntime.exports.jsx(Collapse$1, Object.assign({ in: visible }, { children: jsxRuntime.exports.jsx(Alert$1, Object.assign({ className: classNames('rkt-Banner', variant !== undefined ? `rkt-Banner--${variant}` : '', additionalClasses), icon: getIcon(), onClose: isDismissible ? handleDismiss : undefined, "data-id": idString, action: isDismissible && (jsxRuntime.exports.jsx("button", Object.assign({ className: "rkt-Banner__icon-button", "aria-label": "Close", onClick: handleDismiss }, { children: jsxRuntime.exports.jsx(RktIcon, { iconName: dismissIconName }) }))) }, { children: jsxRuntime.exports.jsx("div", Object.assign({ className: "rkt-Banner__content" }, { children: children })) })) })));
};

const CheckboxIcon = () => {
    return (jsxRuntime.exports.jsx(SvgIcon$1, { children: jsxRuntime.exports.jsxs("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("rect", { x: "0.75", y: "0.75", width: "22.5", height: "22.5", rx: "7.25", fill: "white" }), jsxRuntime.exports.jsx("rect", { x: "0.75", y: "0.75", width: "22.5", height: "22.5", rx: "7.25", stroke: "currentColor", strokeWidth: "1.5", className: "rkt-Checkbox__icon-border" })] })) }));
};
const CheckedIcon = () => {
    return (jsxRuntime.exports.jsx(SvgIcon$1, { children: jsxRuntime.exports.jsxs("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M8.28125 12.2143L10.618 14.551L15.7187 9.44922", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] })) }));
};
const IndeterminateIcon = () => {
    return (jsxRuntime.exports.jsx(SvgIcon$1, { children: jsxRuntime.exports.jsxs("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M7 12H16.9995", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] })) }));
};

const RktIconSprite = (_a) => {
    var { idString, additionalClasses } = _a, rest = __rest(_a, ["idString", "additionalClasses"]);
    return (
    // eslint-disable-next-line max-len
    jsxRuntime.exports.jsxs("svg", Object.assign({ className: additionalClasses, "data-id": idString }, rest, { "aria-hidden": "true", width: "0", height: "0", style: { position: 'absolute' }, fill: "currentColor", stroke: "currentColor" }, { children: [jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "3d_glasses-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.99609 15.0013L2.99609 18.0025C2.99609 19.6601 4.3398 21.0038 5.99734 21.0038H7.7998C8.2547 21.0038 8.69602 20.8487 9.051 20.5643L10.451 19.4424C10.806 19.1579 11.2473 19.0029 11.7022 19.0029H12.2975C12.7524 19.0029 13.1937 19.1579 13.5487 19.4424L14.9487 20.5643C15.3037 20.8487 15.745 21.0038 16.1999 21.0038H18.0023C19.6599 21.0038 21.0036 19.6601 21.0036 18.0025V15.0013M2.99609 15.0013C2.99609 13.8962 3.8919 13.0004 4.99693 13.0004L19.0028 13.0004C20.1078 13.0004 21.0036 13.8962 21.0036 15.0013M2.99609 15.0013L2.99609 12.4748C2.99609 12.1554 3.03432 11.8372 3.10996 11.5269L4.2013 7.05045C4.63602 5.26726 6.2281 4.00843 8.06347 3.99667M21.0036 15.0013V12.4748C21.0036 12.1554 20.9654 11.8372 20.8897 11.5269L19.7984 7.05045C19.3637 5.26726 17.7716 4.00843 15.9362 3.99667M5.99734 16.0017V17.0021", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "accessibility-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10.295 15.0497H14.495M20.039 8.33667C15.817 9.61467 8.972 9.61467 4.75 8.33667M10.291 9.23267C10.291 13.3567 10.291 18.3207 9.333 20.7947M14.499 9.23267C14.499 15.6167 14.499 16.9647 15.457 20.7947M13.6324 3.77624C14.3158 4.45965 14.3158 5.5677 13.6324 6.25111C12.949 6.93452 11.8409 6.93452 11.1575 6.25111C10.4741 5.56769 10.4741 4.45965 11.1575 3.77624C11.8409 3.09282 12.949 3.09282 13.6324 3.77624Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "accessible-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M16.248 9.87767C13.764 10.7027 9.73598 10.7027 7.25098 9.87767M10.3501 14.1637H13.1501M13.083 10.4497V10.4967C13.083 13.8807 13.083 15.2337 13.75 17.2637M10.417 10.4497V10.4967C10.417 13.8807 10.417 15.2337 9.75 17.2637M18.1139 5.89971C21.6287 9.41443 21.6287 15.1129 18.1139 18.6276C14.5992 22.1423 8.90074 22.1423 5.38604 18.6276C1.87132 15.1129 1.87132 9.41441 5.38604 5.89971C8.90076 2.38499 14.5992 2.38499 18.1139 5.89971ZM12.0859 7.1778C12.2714 7.3633 12.2714 7.66405 12.0859 7.84955C11.9004 8.03505 11.5996 8.03505 11.4141 7.84955C11.2286 7.66405 11.2286 7.3633 11.4141 7.1778C11.5996 6.9923 11.9004 6.9923 12.0859 7.1778Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M11.76 7.26367L11.755 7.26867L11.75 7.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "account_balance-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4.00125 17.2695V9.59931M20.0079 9.59931V17.2695M8.00292 9.59931V17.2695M12.0046 9.59931V17.2695M16.0062 9.59931V17.2695M23.0092 20.2708H1M12.0046 6.48601C11.9715 6.48601 11.9398 6.49922 11.9165 6.5227C11.8932 6.54618 11.8803 6.57799 11.8805 6.61106C11.8805 6.68013 11.9365 6.73611 12.0056 6.73611C12.0746 6.73611 12.1306 6.68013 12.1306 6.61106C12.1296 6.54206 12.0736 6.48654 12.0046 6.48601ZM20.9803 9.59931H3.02885C2.88884 9.59957 2.75449 9.54414 2.6554 9.44524C2.55631 9.34634 2.50063 9.21209 2.50063 9.07209V7.09526C2.50095 6.66485 2.77655 6.28288 3.18491 6.14687L11.6704 3.31769C11.8874 3.24567 12.1218 3.24567 12.3387 3.31769L20.8243 6.14687C21.2326 6.28288 21.5082 6.66485 21.5085 7.09526V9.07209C21.5085 9.21209 21.4529 9.34634 21.3538 9.44524C21.2547 9.54414 21.1203 9.59957 20.9803 9.59931ZM20.3901 17.2695H3.61909C3.24027 17.2697 2.89405 17.4839 2.72472 17.8227L2.10646 19.0592C2.03664 19.198 2.00042 19.3511 2.00042 19.5064V20.2708H22.0087V19.5064C22.0087 19.3511 21.9725 19.198 21.9027 19.0592L21.2844 17.8227C21.1151 17.4839 20.7689 17.2697 20.3901 17.2695Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "account_balance_wallet-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M20 15.2637H18C16.895 15.2637 16 14.3687 16 13.2637C16 12.1587 16.895 11.2637 18 11.2637H20M20 15.2637C20.552 15.2637 21 14.8157 21 14.2637V12.2637C21 11.7117 20.552 11.2637 20 11.2637M20 15.2637V18.2637C20 19.3687 19.105 20.2637 18 20.2637H5C3.895 20.2637 3 19.3687 3 18.2637V4.76367M20 11.2637V8.26367C20 7.15867 19.105 6.26367 18 6.26367H4.5C3.672 6.26367 3 5.59167 3 4.76367M3 4.76367C3 3.93567 3.672 3.26367 4.5 3.26367H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "account_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3.725 16.2887C3.115 15.0747 2.75 13.7157 2.75 12.2637C2.75 7.28967 6.776 3.26367 11.75 3.26367C16.724 3.26367 20.75 7.28967 20.75 12.2637C20.75 13.7137 20.387 15.0737 19.773 16.2867M5.75 18.8477C7.319 17.3227 9.442 16.3847 11.773 16.3847C14.081 16.3847 16.181 17.3037 17.75 18.8007C16.181 20.3257 14.058 21.2637 11.727 21.2637C9.419 21.2637 7.319 20.3447 5.75 18.8477ZM13.8713 8.14235C15.0429 9.31392 15.0429 11.2134 13.8713 12.385C12.6997 13.5566 10.8002 13.5566 9.62866 12.385C8.45709 11.2134 8.45709 9.31392 9.62866 8.14235C10.8002 6.97078 12.6997 6.97078 13.8713 8.14235Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "account_link-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M4.00094 16.2695V8.5993M20.0075 8.5993V12.2047M8.00265 8.5993V16.2695M12.0044 8.5993V16.2359M16.0058 8.5993V12.1734M10.5667 19.2708H2V18.5064C2 18.3511 2.03623 18.198 2.10604 18.0592L2.7243 16.8227C2.89364 16.4839 3.23985 16.2697 3.61867 16.2695H11.9729M20.1835 20.9338C21.691 20.9329 22.9129 19.711 22.9138 18.2035C22.9129 16.696 21.691 15.4741 20.1835 15.4732M17.4532 15.4732C15.9457 15.4741 14.7238 16.696 14.7229 18.2035C14.7238 19.711 15.9457 20.9329 17.4532 20.9338M20.1835 18.2035H17.4532M20.9799 8.59931H3.02846C2.88846 8.59957 2.75411 8.54414 2.65502 8.44524C2.55593 8.34634 2.50024 8.21209 2.50024 8.07209V6.09526C2.50057 5.66485 2.77617 5.28288 3.18453 5.14687L11.6701 2.31769C11.887 2.24567 12.1214 2.24567 12.3383 2.31769L20.8239 5.14687C21.2322 5.28288 21.5078 5.66485 21.5082 6.09526V8.07209C21.5082 8.21209 21.4525 8.34634 21.3534 8.44524C21.2543 8.54414 21.1199 8.59957 20.9799 8.59931Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M11.4992 5.63883C11.4661 5.63883 11.4344 5.65203 11.4111 5.67551C11.3878 5.699 11.3749 5.73081 11.3752 5.76388C11.3752 5.83294 11.4311 5.88893 11.5002 5.88893C11.5693 5.88893 11.6253 5.83294 11.6253 5.76388C11.6242 5.69488 11.5682 5.63936 11.4992 5.63883", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "account_tree-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9 17.2637H5C3.89543 17.2637 3 16.3682 3 15.2637V3.26367M9 7.26367H3M21 8.76367V5.26367C21 4.43524 20.3284 3.76367 19.5 3.76367H17.4381C17.1071 3.76367 16.7975 3.59983 16.6113 3.3261L16.1863 2.70124C16.0001 2.4275 15.6905 2.26366 15.3594 2.26367H13.5C12.6716 2.26367 12 2.93524 12 3.76367V8.76367C12 9.5921 12.6716 10.2637 13.5 10.2637H19.5C20.3284 10.2637 21 9.5921 21 8.76367ZM21 19.7637V16.2637C21 15.4352 20.3284 14.7637 19.5 14.7637H17.4381C17.1071 14.7637 16.7975 14.5998 16.6113 14.3261L16.1863 13.7012C16.0001 13.4275 15.6905 13.2637 15.3594 13.2637H13.5C12.6716 13.2637 12 13.9352 12 14.7637V19.7637C12 20.5921 12.6716 21.2637 13.5 21.2637H19.5C20.3284 21.2637 21 20.5921 21 19.7637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "ac_unit-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.75 3.26367V21.2637M13.918 4.68467L11.75 6.85367L9.582 4.68467M19.75 7.64367L3.75 16.8837M19.397 10.3517L16.436 9.55867L17.229 6.59667M4.103 14.1757L7.064 14.9687L6.271 17.9307M3.75 7.64367L19.75 16.8837M4.103 10.3517L7.064 9.55867L6.271 6.59667M19.397 14.1757L16.436 14.9687L17.229 17.9307M9.582 19.8427L11.75 17.6737L13.918 19.8427", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "add-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12 6.26367V18.2637M18 12.2637H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "add_alert-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.0029 9.62048L12.0039 13.6222M10.0027 11.6218L14.0044 11.6208M9.51245 18.2699V18.7821C9.51245 20.1568 10.6268 21.2711 12.0015 21.2711H12.0035C12.6639 21.2714 13.2973 21.0093 13.7645 20.5425C14.2317 20.0758 14.4943 19.4425 14.4945 18.7821V18.2699M17.9528 18.2699C19.0871 18.2699 20.0067 17.3504 20.0067 16.2161C20.0062 15.6399 19.7774 15.0873 19.3704 14.6794L18.0058 13.3159V9.26617C18.0058 5.95108 15.3184 3.26367 12.0033 3.26367C8.68824 3.26367 6.00083 5.95108 6.00083 9.26617V13.3159L4.63626 14.6794C4.22925 15.0873 4.00046 15.6399 4 16.2161C4 16.7608 4.21639 17.2832 4.60156 17.6684C4.98673 18.0535 5.50914 18.2699 6.05386 18.2699H17.9528Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "add_chat-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19.32 10.1628V15.2397C19.32 16.7421 18.1027 17.9594 16.6003 17.9594H12.0672L7.53408 21.5863V17.9594H5.71968C4.21728 17.9594 3 16.7421 3 15.2397V7.98596C3 6.48356 4.21728 5.26628 5.71968 5.26628H14.39M19.3204 3.26367L19.3214 7.26534M17.3202 5.26503L21.3219 5.26396", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "add_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12 8.76367V15.7637M15.5 12.2637H8.5M12 21.2637C7.02943 21.2637 3 17.2342 3 12.2637C3 7.2931 7.02943 3.26367 12 3.26367C16.9706 3.26367 21 7.2931 21 12.2637C21 17.2342 16.9706 21.2637 12 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "add_location-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12 7.76367V13.7637M15 10.7637H9M4.5 10.2637C4.5 14.6747 9.514 19.4297 11.343 21.0177C11.722 21.3467 12.279 21.3467 12.658 21.0177C14.486 19.4297 19.5 14.6747 19.5 10.2637C19.5 6.39767 16.142 3.26367 12 3.26367C7.858 3.26367 4.5 6.39767 4.5 10.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "add_photo_alternate-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M21.0075 10.2666V17.2695C21.0075 19.4796 19.2159 21.2712 17.0058 21.2712H7.00167C4.79161 21.2712 3 19.4796 3 17.2695V7.26534C3 5.05528 4.79161 3.26367 7.00167 3.26367H13.0042M3 13.2678L4.2957 11.9721C4.74804 11.5198 5.36154 11.2657 6.00125 11.2657C6.64095 11.2657 7.25445 11.5198 7.70679 11.9721L12.0037 16.2691M7.00467 21.2712L13.3025 14.9734C14.2444 14.0314 15.7716 14.0314 16.7135 14.9734L20.6544 18.9142M18.2331 3.52528V8.60096M20.771 6.06312H15.6953", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "ads_click-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5.25 11.2637H3.25M21.25 11.2637H19.25M7.3 16.2137L5.89 17.6237M18.61 4.90367L17.2 6.31367M12.25 2.26367V4.26367M5.89 4.90367L7.3 6.31367M16.84 17.6097L18.367 20.6267C18.505 20.8997 18.396 21.2327 18.123 21.3707L16.477 22.2037C16.204 22.3417 15.871 22.2327 15.733 21.9597L14.206 18.9427L11.574 20.5897L11.58 11.4547C11.58 10.9987 12.101 10.7387 12.466 11.0127L19.724 16.4647L16.84 17.6097Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "apartment-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7.7525 20.2712V3.26409C7.7525 2.71157 8.2004 2.26367 8.75292 2.26367H14.7554C15.3079 2.26367 15.7558 2.71157 15.7558 3.26409V20.2712M20.7579 20.2712V7.17872C20.7579 6.67427 20.349 6.26534 19.8445 6.26534H15.7558M7.7525 6.26534H3.6638C3.15935 6.26534 2.75042 6.67427 2.75042 7.17872V20.2712M15.7558 9.26659H18.2569M15.7558 12.2678H18.2569M15.7558 15.2691H18.2569M5.25146 9.26659H7.7525M5.25146 12.2678H7.7525M5.25146 15.2691H7.7525M10.2535 12.2678H13.2548M10.2535 15.2691H13.2548M10.2535 9.26659H13.2548M10.2535 6.26534H13.2548M11.7542 18.2703V20.2712M21.7583 20.2712H1.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "apps-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 21.2637C17.2206 21.2637 21.25 17.2342 21.25 12.2637C21.25 7.29311 17.2206 3.26367 12.25 3.26367C7.27944 3.26367 3.25 7.29311 3.25 12.2637C3.25 17.2342 7.27944 21.2637 12.25 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.75 11.0137H14.5C13.9477 11.0137 13.5 10.566 13.5 10.0137V8.76367C13.5 8.21139 13.9477 7.76367 14.5 7.76367H15.75C16.3023 7.76367 16.75 8.21139 16.75 8.76367V10.0137C16.75 10.566 16.3023 11.0137 15.75 11.0137Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 16.7637H8.75C8.19772 16.7637 7.75 16.316 7.75 15.7637V14.5137C7.75 13.9614 8.19772 13.5137 8.75 13.5137H10C10.5523 13.5137 11 13.9614 11 14.5137V15.7637C11 16.316 10.5523 16.7637 10 16.7637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 8.76367V10.0137C11 10.566 10.5523 11.0137 10 11.0137H8.75C8.19772 11.0137 7.75 10.566 7.75 10.0137V8.76367C7.75 8.21139 8.19772 7.76367 8.75 7.76367H10C10.5523 7.76367 11 8.21139 11 8.76367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.75 14.5137V15.7637C16.75 16.316 16.3023 16.7637 15.75 16.7637H14.5C13.9477 16.7637 13.5 16.316 13.5 15.7637V14.5137C13.5 13.9614 13.9477 13.5137 14.5 13.5137H15.75C16.3023 13.5137 16.75 13.9614 16.75 14.5137Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "app_store-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7.88 15.94L7.56 16.5M16.44 16.5L13.17 10.79M10.99 7L12 8.76M13.01 7L9.05 13.91M12.62 13.91H7M17 13.91H14.95M7.5 3L16.504 3C18.987 3 21 5.013 21 7.496V16.505C21 18.987 18.987 21 16.504 21H7.496C5.013 21 3 18.987 3 16.504L3 7.5C3 5.015 5.015 3 7.5 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_back-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M18.557 12.0544L4.54702 12.0544M10.537 17.8067L4.5 12.0352L10.537 6.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16 12.2637H8M16 12.2637L13 9.26367M16 12.2637L13 15.2637M12 21.2637C7.029 21.2637 3 17.2347 3 12.2637C3 7.29267 7.029 3.26367 12 3.26367C16.971 3.26367 21 7.29267 21 12.2637C21 17.2347 16.971 21.2637 12 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_downward-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.5321 5.26367L11.5321 18.7133M17.524 12.9629L11.512 18.7584L5.5 12.9629", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_drop_down-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.502 9.26367C8.6111 9.26367 8.16493 10.3408 8.7949 10.9708L11.3807 13.5566C11.7712 13.9471 12.4044 13.9471 12.7949 13.5566L15.3807 10.9708C16.0107 10.3408 15.5645 9.26367 14.6736 9.26367H9.502Z", fill: "currentColor" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_drop_down_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12 16.2637V8.26367M12 16.2637L15 13.2637M12 16.2637L9 13.2637M3 12.2637C3 7.29267 7.029 3.26367 12 3.26367C16.971 3.26367 21 7.29267 21 12.2637C21 17.2347 16.971 21.2637 12 21.2637C7.029 21.2637 3 17.2347 3 12.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_drop_up-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.502 14.8495C8.6111 14.8495 8.16493 13.7723 8.7949 13.1424L11.3807 10.5566C11.7712 10.166 12.4044 10.166 12.7949 10.5566L15.3807 13.1424C16.0107 13.7723 15.5645 14.8495 14.6736 14.8495H9.502Z", fill: "currentColor" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_forward-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4.5 12.016H18.51M12.52 6.26367L18.557 12.0352L12.52 17.8067", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_left-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14.0858 9.26568C14.0858 8.37477 13.0086 7.92861 12.3787 8.55857L9.79289 11.1444C9.40237 11.5349 9.40237 12.168 9.79289 12.5586L12.3787 15.1444C13.0086 15.7743 14.0858 15.3282 14.0858 14.4372V9.26568Z", fill: "currentColor" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_left_alt-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7.897 14.8965L5 12.0005L7.897 9.1035M19 12.0035H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_right-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.5 14.4373C9.5 15.3282 10.5771 15.7743 11.2071 15.1444L13.7929 12.5586C14.1834 12.168 14.1834 11.5349 13.7929 11.1444L11.2071 8.55857C10.5771 7.9286 9.5 8.37477 9.5 9.26568V14.4373Z", fill: "currentColor" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_right_alt-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.603 15.0567L18.5 12.1607L15.603 9.26367M4.5 12.1637H18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_upward-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.4919 18.7584V5.30881M5.5 11.0592L11.512 5.26367L17.524 11.0592", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "arrow_up_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12 8.26367V16.2637M12 8.26367L15 11.2637M12 8.26367L9 11.2637M3 12.2637C3 17.2347 7.029 21.2637 12 21.2637C16.971 21.2637 21 17.2347 21 12.2637C21 7.29267 16.971 3.26367 12 3.26367C7.029 3.26367 3 7.29267 3 12.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "attachment-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.98303 16.2637V9.2637C9.98303 8.1517 10.888 7.2507 12 7.2557C13.106 7.2597 14 8.1577 14 9.2637L14 17.7637C14 19.6967 12.433 21.2637 10.5 21.2637C8.567 21.2637 7 19.6967 7 17.7637V17.2637M7 17.3137V8.26367C7 5.50267 9.239 3.26367 12 3.26367C14.761 3.26367 17 5.50267 17 8.26367V15.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "attach_money-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.75 4.26367V6.13867M11.75 19.2637V17.3887M15.4805 8.76367C15.383 7.29967 14.1755 6.13867 12.6875 6.13867H10.6325C9.1775 6.13867 8 7.31767 8 8.77117C8 9.97867 8.822 11.0317 9.992 11.3257L13.5065 12.2077C14.678 12.5017 15.4985 13.5547 15.4985 14.7622C15.4985 16.2172 14.3195 17.3947 12.866 17.3947H10.811C9.32 17.3947 8.1125 16.2307 8.0165 14.7637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "bar_chart-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3.25 3.26367V21.2637M3.25 14.5967H15.25V18.2637C15.25 18.8157 14.802 19.2637 14.25 19.2637H3.25V14.5967ZM3.25 14.5967L20.25 14.5977C20.802 14.5977 21.25 14.1497 21.25 13.5977V10.9307C21.25 10.3787 20.802 9.93067 20.25 9.93067H3.25M3.25 14.5967V9.93067M3.25 9.93067H18.25V6.26367C18.25 5.71167 17.802 5.26367 17.25 5.26367H3.25V9.93067Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "bathtub-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M1.75 13.2637H21.75M20.75 13.2637L20.2055 16.7489C19.8894 18.7721 18.1467 20.2637 16.0989 20.2637H7.40107C5.35328 20.2637 3.61062 18.7721 3.29452 16.7489L2.75 13.2637M5.88123 19.971L4.75 21.2637M17.6188 19.971L18.75 21.2637M10.75 6.26367C10.75 4.60682 9.40685 3.26367 7.75 3.26367C6.09315 3.26367 4.75 4.60682 4.75 6.26367V13.2637M10.6382 6.26367H10.8618C11.9217 6.26367 12.8627 6.94191 13.1979 7.94744C13.2996 8.25239 13.2484 8.58761 13.0605 8.84838C12.8725 9.10915 12.5707 9.26367 12.2492 9.26367H9.25077C8.92932 9.26367 8.62747 9.10915 8.43952 8.84838C8.25157 8.58761 8.20043 8.25239 8.30208 7.94744C8.63726 6.94191 9.57827 6.26367 10.6382 6.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "bed-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.75 11.2637H19.75C20.8546 11.2637 21.75 12.1591 21.75 13.2637V17.2637C21.75 17.816 21.3023 18.2637 20.75 18.2637H2.75C2.19772 18.2637 1.75 17.816 1.75 17.2637V13.2637C1.75 12.1591 2.64543 11.2637 3.75 11.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M3.75 11.2637V6.26367C3.75 4.60682 5.09315 3.26367 6.75 3.26367H16.75C18.4069 3.26367 19.75 4.60682 19.75 6.26367V11.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M21.25 18.2637V20.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M3.25 18.2637V20.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M8.25 8.01367H10.25V6.51367H8.25V8.01367ZM11 8.76367V9.76367H12.5V8.76367H11ZM10.25 10.5137H8.25V12.0137H10.25V10.5137ZM7.5 9.76367V8.76367H6V9.76367H7.5ZM8.25 10.5137C7.83579 10.5137 7.5 10.1779 7.5 9.76367H6C6 11.0063 7.00736 12.0137 8.25 12.0137V10.5137ZM11 9.76367C11 10.1779 10.6642 10.5137 10.25 10.5137V12.0137C11.4926 12.0137 12.5 11.0063 12.5 9.76367H11ZM10.25 8.01367C10.6642 8.01367 11 8.34946 11 8.76367H12.5C12.5 7.52103 11.4926 6.51367 10.25 6.51367V8.01367ZM8.25 6.51367C7.00736 6.51367 6 7.52103 6 8.76367H7.5C7.5 8.34946 7.83579 8.01367 8.25 8.01367V6.51367Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M13.25 8.01367H15.25V6.51367H13.25V8.01367ZM16 8.76367V9.76367H17.5V8.76367H16ZM15.25 10.5137H13.25V12.0137H15.25V10.5137ZM12.5 9.76367V8.76367H11V9.76367H12.5ZM13.25 10.5137C12.8358 10.5137 12.5 10.1779 12.5 9.76367H11C11 11.0063 12.0074 12.0137 13.25 12.0137V10.5137ZM16 9.76367C16 10.1779 15.6642 10.5137 15.25 10.5137V12.0137C16.4926 12.0137 17.5 11.0063 17.5 9.76367H16ZM15.25 8.01367C15.6642 8.01367 16 8.34946 16 8.76367H17.5C17.5 7.52103 16.4926 6.51367 15.25 6.51367V8.01367ZM13.25 6.51367C12.0074 6.51367 11 7.52103 11 8.76367H12.5C12.5 8.34946 12.8358 8.01367 13.25 8.01367V6.51367Z", fill: "currentColor" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "bluetooth-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M6.25 17.2637L17.25 7.76367L11.25 3.26367V21.2637L17.25 16.7637L6.25 7.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "book-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M18 7.20367H19C20.105 7.20367 21 8.09967 21 9.20367V18.2637C21 19.3687 20.105 20.2637 19 20.2637H5C3.895 20.2637 3 19.3687 3 18.2637V6.26367C3 5.15867 3.895 4.26367 5 4.26367H9.471C9.802 4.26367 10.111 4.42767 10.297 4.70067L11.702 6.76567C11.888 7.03967 12.198 7.20367 12.529 7.20367H14M17 6.26367H15C14.448 6.26367 14 6.71167 14 7.26367V12.2637L16 11.2637L18 12.2637V7.26367C18 6.71167 17.552 6.26367 17 6.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "bookmark-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.9149 16.6342L12.3984 14.8313C12.1599 14.6604 11.8392 14.6602 11.6004 14.8308L9.08434 16.6284C8.87533 16.7778 8.60039 16.7978 8.37198 16.6802C8.14357 16.5627 8 16.3274 8 16.0705V9.51367C8 8.54717 8.7835 7.76367 9.75 7.76367H14.25C15.2165 7.76367 16 8.54717 16 9.51367V16.0767C16 16.3338 15.8563 16.5692 15.6276 16.6867C15.399 16.8041 15.1239 16.7839 14.9149 16.6342Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3.26367C18.7614 3.26367 21 5.50225 21 8.26367V16.2637C21 19.0251 18.7614 21.2637 16 21.2637H8C5.23858 21.2637 3 19.0251 3 16.2637V8.26367C3 5.50225 5.23858 3.26367 8 3.26367H16Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "bubble_chart-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M9.34375 14.2131C9.34375 15.8959 7.97962 17.26 6.29688 17.26C4.61413 17.26 3.25 15.8959 3.25 14.2131C3.25 12.5304 4.61413 11.1662 6.29688 11.1662C7.97962 11.1662 9.34375 12.5304 9.34375 14.2131Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M16.3276 18.2423C16.3276 19.3637 15.4185 20.2727 14.2972 20.2727C13.1759 20.2727 12.2668 19.3637 12.2668 18.2423C12.2668 17.121 13.1759 16.212 14.2972 16.212C15.4185 16.212 16.3276 17.121 16.3276 18.2423Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M20.1836 8.7041C20.1836 11.1565 18.1955 13.1445 15.7432 13.1445C13.2908 13.1445 11.3027 11.1565 11.3027 8.7041C11.3027 6.25172 13.2908 4.26367 15.7432 4.26367C18.1955 4.26367 20.1836 6.25172 20.1836 8.7041Z", stroke: "currentColor" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "bug_report-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 8.01367C2.25 4.83803 4.82436 2.26367 8 2.26367H16C19.1756 2.26367 21.75 4.83803 21.75 8.01367V16.0137C21.75 19.1893 19.1756 21.7637 16 21.7637H8C4.82436 21.7637 2.25 19.1893 2.25 16.0137V8.01367ZM8 3.76367C5.65279 3.76367 3.75 5.66646 3.75 8.01367V16.0137C3.75 18.3609 5.65279 20.2637 8 20.2637H16C18.3472 20.2637 20.25 18.3609 20.25 16.0137V8.01367C20.25 5.66646 18.3472 3.76367 16 3.76367H8Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M10.75 8.26367L9.75 7.26367M12.75 8.26367L13.75 7.26367M16.75 9.26367C13.9886 12.0251 9.51142 12.0251 6.75 9.26367M8.60693 14.4342C7.9198 14.7735 7.29259 15.2225 6.75 15.7637M16.75 15.7637C16.2074 15.2225 15.5802 14.7735 14.8931 14.4342M8 12.5137H6.25M17.25 12.5137H15.5M15.5 12.2637C15.5 14.4728 13.8211 16.2637 11.75 16.2637C9.67893 16.2637 8 14.4728 8 12.2637C8 10.0545 9.67893 8.26367 11.75 8.26367C13.8211 8.26367 15.5 10.0545 15.5 12.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "build-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0164 9.86496L3.39858 17.4828C2.9833 17.8981 2.75 18.4613 2.75 19.0486C2.75 19.6359 2.9833 20.1991 3.39858 20.6144C4.26333 21.4791 5.66537 21.4791 6.53013 20.6144L14.148 12.9966C15.4163 13.4303 16.806 13.3339 18.0023 12.7292C19.1986 12.1244 20.1002 11.0625 20.503 9.78405C20.7166 9.14205 20.7925 8.46226 20.7258 7.78896C20.6749 7.41172 20.4137 7.09638 20.0525 6.97613C19.6913 6.85588 19.2932 6.95169 19.0263 7.22309L17.2218 9.02759C17.1281 9.12137 17.0009 9.17406 16.8683 9.17406C16.7356 9.17406 16.6084 9.12137 16.5147 9.02759L14.9854 7.49826C14.7901 7.303 14.7896 6.9869 15.172 6.60453L16.79 4.98662C17.0614 4.71972 17.1572 4.32163 17.037 3.96047C16.9167 3.59932 16.6014 3.33809 16.2242 3.28711C15.5521 3.22056 14.8734 3.29611 14.2324 3.50884C12.953 3.91094 11.8901 4.81247 11.2847 6.00908C10.6793 7.2057 10.5825 8.59602 11.0164 9.86496Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "calculate-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.05 18.2637H18.05M15.05 15.2637H18.05M3.25 12.2637H21.25M15.25 7.76367H18.25M6.25 7.76367H9.25M7.75 9.26367V6.26367M6.69 15.7037L8.81 17.8237M6.69 17.8237L8.81 15.7037M12.25 3.26367V21.2637M21.25 18.9157C21.25 20.2127 20.198 21.2637 18.902 21.2637H5.598C4.301 21.2637 3.25 20.2127 3.25 18.9157V5.61167C3.25 4.31467 4.301 3.26367 5.598 3.26367H18.902C20.198 3.26367 21.25 4.31467 21.25 5.61167V18.9157Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "calendar_clock-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.75 3C15.75 2.58579 15.4142 2.25 15 2.25C14.5858 2.25 14.25 2.58579 14.25 3H15.75ZM14.25 5C14.25 5.41421 14.5858 5.75 15 5.75C15.4142 5.75 15.75 5.41421 15.75 5H14.25ZM7.75 3C7.75 2.58579 7.41421 2.25 7 2.25C6.58579 2.25 6.25 2.58579 6.25 3H7.75ZM6.25 5C6.25 5.41421 6.58579 5.75 7 5.75C7.41421 5.75 7.75 5.41421 7.75 5H6.25ZM3 8.25C2.58579 8.25 2.25 8.58579 2.25 9C2.25 9.41421 2.58579 9.75 3 9.75V8.25ZM19 9.75C19.4142 9.75 19.75 9.41421 19.75 9C19.75 8.58579 19.4142 8.25 19 8.25V9.75ZM18.25 10C18.25 10.4142 18.5858 10.75 19 10.75C19.4142 10.75 19.75 10.4142 19.75 10H18.25ZM10 19.75C10.4142 19.75 10.75 19.4142 10.75 19C10.75 18.5858 10.4142 18.25 10 18.25V19.75ZM18.143 15.983C18.143 15.5688 17.8072 15.233 17.393 15.233C16.9788 15.233 16.643 15.5688 16.643 15.983H18.143ZM17.393 17.741H16.643C16.643 18.0025 16.7792 18.2451 17.0024 18.3813L17.393 17.741ZM18.3844 19.2243C18.7381 19.44 19.1996 19.3282 19.4153 18.9746C19.631 18.6209 19.5192 18.1594 19.1656 17.9437L18.3844 19.2243ZM17.504 13L17.5031 13.75L17.5034 13.75L17.504 13ZM14.25 3V5H15.75V3H14.25ZM6.25 3V5H7.75V3H6.25ZM3 9.75H19V8.25H3V9.75ZM19.75 10V7H18.25V10H19.75ZM19.75 7C19.75 4.92879 18.0712 3.25 16 3.25V4.75C17.2428 4.75 18.25 5.75721 18.25 7H19.75ZM16 3.25H6V4.75H16V3.25ZM6 3.25C3.92879 3.25 2.25 4.92879 2.25 7H3.75C3.75 5.75721 4.75721 4.75 6 4.75V3.25ZM2.25 7V16H3.75V7H2.25ZM2.25 16C2.25 18.0712 3.92879 19.75 6 19.75V18.25C4.75721 18.25 3.75 17.2428 3.75 16H2.25ZM6 19.75H10V18.25H6V19.75ZM16.643 15.983V17.741H18.143V15.983H16.643ZM17.0024 18.3813L18.3844 19.2243L19.1656 17.9437L17.7836 17.1007L17.0024 18.3813ZM17.5 21.25C15.4291 21.25 13.75 19.5717 13.75 17.5H12.25C12.25 20.4003 14.6009 22.75 17.5 22.75V21.25ZM13.75 17.5C13.75 15.4802 15.484 13.7475 17.5031 13.75L17.5049 12.25C14.656 12.2465 12.25 14.6518 12.25 17.5H13.75ZM17.5034 13.75C19.5733 13.7517 21.25 15.4299 21.25 17.5H22.75C22.75 14.6021 20.4027 12.2523 17.5046 12.25L17.5034 13.75ZM21.25 17.5C21.25 19.5709 19.5717 21.25 17.5 21.25V22.75C20.4003 22.75 22.75 20.3991 22.75 17.5H21.25Z", fill: "currentColor" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "calendar_month-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M16.0402 2.26367V6.58367M7.40021 2.26367V6.58367M2.00021 9.82367H21.4402M19.28 4.42367H4.16C2.9666 4.42367 2 5.39027 2 6.58367V20.6237C2 21.8171 2.9666 22.7837 4.16 22.7837H19.28C20.4734 22.7837 21.44 21.8171 21.44 20.6237V6.58367C21.44 5.39027 20.4734 4.42367 19.28 4.42367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M6.91881 17.5337C6.76977 17.5337 6.64881 17.6546 6.64989 17.8037C6.64989 17.9527 6.77085 18.0737 6.91989 18.0737C7.06893 18.0737 7.18989 17.9527 7.18989 17.8037C7.18989 17.6546 7.06893 17.5337 6.91881 17.5337", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M11.9989 13.5337C11.8498 13.5337 11.7289 13.6546 11.73 13.8037C11.73 13.9527 11.8509 14.0737 12 14.0737C12.149 14.0737 12.27 13.9527 12.27 13.8037C12.27 13.6546 12.149 13.5337 11.9989 13.5337", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M17.079 13.5337C16.9299 13.5337 16.809 13.6546 16.81 13.8037C16.81 13.9527 16.931 14.0737 17.08 14.0737C17.2291 14.0737 17.35 13.9527 17.35 13.8037C17.35 13.6546 17.2291 13.5337 17.079 13.5337", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M6.91881 13.5337C6.76977 13.5337 6.64881 13.6546 6.64989 13.8037C6.64989 13.9527 6.77085 14.0737 6.91989 14.0737C7.06893 14.0737 7.18989 13.9527 7.18989 13.8037C7.18989 13.6546 7.06893 13.5337 6.91881 13.5337", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M11.9989 17.5337C11.8498 17.5337 11.7289 17.6546 11.73 17.8037C11.73 17.9527 11.8509 18.0737 12 18.0737C12.149 18.0737 12.27 17.9527 12.27 17.8037C12.27 17.6546 12.149 17.5337 11.9989 17.5337", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "cancel-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.52519 9.7888L14.4749 14.7385M14.4749 9.7888L9.52519 14.7385M12 21.2637C7.02943 21.2637 3 17.2342 3 12.2637C3 7.2931 7.02943 3.26367 12 3.26367C16.9706 3.26367 21 7.2931 21 12.2637C21 17.2342 16.9706 21.2637 12 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "car_garage-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M20.0034 9.98294V8.60961C20.0034 7.883 19.6094 7.21349 18.9743 6.8606L12.4721 3.24809C11.8677 2.91234 11.1329 2.91234 10.5286 3.24809L4.02538 6.86116C3.39021 7.21405 2.99628 7.88356 2.99628 8.61018V20.0033H7.99836V13.0004H10.9996M13.1398 17.618L13.7149 15.1596C13.8737 14.4808 14.479 14.0008 15.1761 14.0008H18.8281C19.5252 14.0008 20.1305 14.4808 20.2893 15.1596L20.8644 17.618M13.2397 17.1246L12 16.5019M20.7645 17.1246L22.0042 16.5019M19.0029 20.5035H15.0013V21.0037C15.0013 21.5562 14.5534 22.0041 14.0009 22.0041H13.0004C12.4479 22.0041 12 21.5562 12 21.0037V19.253C12 18.2861 12.7839 17.5023 13.7508 17.5023H20.2535C21.2204 17.5023 22.0042 18.2861 22.0042 19.253V21.0037C22.0042 21.5562 21.5563 22.0041 21.0038 22.0041H20.0034C19.4508 22.0041 19.0029 21.5562 19.0029 21.0037V20.5035Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "cash_back-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M6.47963 5.89998C9.05361 3.32599 12.9247 2.55599 16.2877 3.94902C19.6508 5.34205 21.8436 8.62377 21.8436 12.2639C21.8436 15.9041 19.6508 19.1858 16.2877 20.5789C12.9247 21.9719 9.05361 21.2019 6.47963 18.6279M12.8436 7.76397V8.76397M12.8436 8.76397C13.8076 8.70355 14.6978 9.28048 15.0364 10.1851M12.8436 8.76397C11.7243 8.65778 10.7251 9.46501 10.5936 10.5817C10.5936 11.2982 11.0994 11.9151 11.802 12.0557L13.8853 12.4723C14.5879 12.6128 15.0936 13.2298 15.0936 13.9463C14.9622 15.0629 13.963 15.8702 12.8436 15.764M12.8436 16.764V15.764M12.8436 15.764C11.8796 15.8244 10.9895 15.2475 10.6509 14.3429M4.87318 14.1371L3 12.2639M3 12.2639L4.87318 10.3908M3 12.2639L7.54848 12.264", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "celebration-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5.25 3.26367V3.76367M5.25 7.26367V6.76367M7.25 5.26367H6.75M3.25 5.26367H3.75M12.25 3.26367C12.7564 3.51689 13.1297 3.97537 13.275 4.52259C13.4204 5.06981 13.3237 5.65309 13.0097 6.12419L12.25 7.26367M17.25 12.2637L18.3895 11.504C18.8606 11.19 19.4439 11.0933 19.9911 11.2387C20.5383 11.384 20.9968 11.7573 21.25 12.2637M19.25 17.2637V17.7637M19.25 21.2637V20.7637M21.25 19.2637H20.75M17.25 19.2637H17.75M19.25 3.26367V3.76367M19.25 7.26367V6.76367M21.25 5.26367H20.75M17.25 5.26367H17.75M14.25 10.2637L15.25 9.26367M14.1223 16.8394L6.54273 20.6292C5.77995 21.0106 4.85869 20.8611 4.25566 20.2581C3.65263 19.655 3.50313 18.7338 3.88452 17.971L7.67431 10.3914C7.81805 10.1039 8.09127 9.90298 8.40858 9.85149C8.72589 9.79999 9.04861 9.90418 9.27591 10.1315L14.3822 15.2378C14.6095 15.4651 14.7137 15.7878 14.6622 16.1052C14.6107 16.4225 14.4098 16.6957 14.1223 16.8394Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "center_focus-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15 3H19C20.105 3 21 3.895 21 5V9M9 21H5C3.895 21 3 20.105 3 19V15M21 15V19C21 20.105 20.105 21 19 21H15M3 9V5C3 3.895 3.895 3 5 3H9M15 16H9C8.448 16 8 15.552 8 15V9C8 8.448 8.448 8 9 8H15C15.552 8 16 8.448 16 9V15C16 15.552 15.552 16 15 16Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "certificate_medal-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16.0017 17.3743V22.0042L18.0025 21.0038L20.0033 22.0042V17.3743M13.0004 21.0038H4.99708C3.89162 21.0038 2.99625 20.1084 2.99625 19.003L2.99625 4.99712C2.99625 3.89166 3.89162 2.99628 4.99708 2.99628L18.0025 2.99628C19.108 2.99628 20.0033 3.89166 20.0033 4.99712V7.99837M6.99791 6.99795H16.0017M6.99791 10.9996H10.9996M6.99791 15.0013H9.99916M21.504 14.5011C21.504 16.4349 19.9363 18.0025 18.0025 18.0025C16.0687 18.0025 14.501 16.4349 14.501 14.5011C14.501 12.5673 16.0687 10.9996 18.0025 10.9996C19.9363 10.9996 21.504 12.5673 21.504 14.5011Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "chair-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4.74906 11.2637V6.26367C4.74906 4.60682 6.09221 3.26367 7.74906 3.26367H15.7491C17.4059 3.26367 18.7491 4.60682 18.7491 6.26367V11.2637M4.74906 18.9836V21.2637M18.7491 18.9836V21.2637M16.2929 15.2637H7.20523L6.57265 12.7334C6.35672 11.8696 5.58063 11.2637 4.6903 11.2637C4.09282 11.2637 3.52866 11.5389 3.16096 12.0099C2.79326 12.4808 2.66304 13.0949 2.80795 13.6745L3.8265 17.7487C4.04908 18.6391 4.84905 19.2637 5.76678 19.2637H17.7313C18.6491 19.2637 19.449 18.6391 19.6716 17.7487L20.6902 13.6745C20.8351 13.0949 20.7049 12.4808 20.3372 12.0099C19.9695 11.5389 19.4053 11.2637 18.8078 11.2637C17.9175 11.2637 17.1414 11.8696 16.9255 12.7334L16.2929 15.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "chart_rates_checkmark-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5 9V5C5 3.89543 5.89543 3 7 3H19C20.1046 3 21 3.89543 21 5V18C21 19.1046 20.1046 20 19 20H15M17 9V7M17 7H15M17 7L14.0016 10M14 10L11.5 8L10 9.5M15 13H17M15 16H17M5.36783 17.0167L6.56889 18.2167L8.56782 16.2167M5 22H9C10.6569 22 12 20.6569 12 19V15C12 13.3431 10.6569 12 9 12H5C3.34315 12 2 13.3431 2 15V19C2 20.6569 3.34315 22 5 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "chat-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14 17.2427L9 21.2637V17.2637H8C5.239 17.2637 3 15.0247 3 12.2637V8.26367C3 5.50267 5.239 3.26367 8 3.26367H16C18.761 3.26367 21 5.50267 21 8.26367V12.2637C21 15.0247 18.761 17.2637 16 17.2637H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "check-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8 12.4238L10.6706 15.0943L16.5 9.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "checkroom-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.7463 11.2674V9.17477L13.1286 8.40677C13.8184 8.02358 14.2463 7.2965 14.2463 6.50739C14.1646 5.19511 13.0391 4.19471 11.7263 4.26739C10.5533 4.21872 9.51165 5.01167 9.24628 6.15532M18.9849 19.2674C19.7617 19.2713 20.4479 18.7623 20.6697 18.0178C20.8914 17.2734 20.5954 16.4718 19.9431 16.0501L13.2246 11.7036C12.3249 11.122 11.1677 11.122 10.2679 11.7036L3.54949 16.0501C2.89713 16.4718 2.60116 17.2734 2.82289 18.0178C3.04463 18.7623 3.73089 19.2713 4.50769 19.2674H18.9849Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "check_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14.803 10.8657L11.302 14.3667L9.19897 12.2657M12 21.2637C7.02943 21.2637 3 17.2342 3 12.2637C3 7.2931 7.02943 3.26367 12 3.26367C16.9706 3.26367 21 7.2931 21 12.2637C21 17.2342 16.9706 21.2637 12 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "child_friendly-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M13.6883 9.91327V2.26408C16.7891 2.23204 19.6025 4.07526 20.8114 6.93087C22.0203 9.78649 21.3855 13.0894 19.2042 15.2935C17.0229 17.4976 13.7267 18.1666 10.8587 16.9874C7.99069 15.8083 6.11836 13.0142 6.11819 9.91327V6.88501C6.11819 6.09325 5.47635 5.45141 4.6846 5.45141C4.30421 5.45115 3.93931 5.60207 3.67024 5.87095C3.40118 6.13983 3.25 6.50462 3.25 6.88501V7.36321M6.91553 9.91327H21.2575", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M17.7482 20.5138C17.6103 20.5149 17.4994 20.6273 17.5001 20.7652C17.5008 20.9031 17.613 21.0143 17.7509 21.014C17.8887 21.0136 18.0003 20.9018 18.0003 20.7639C18 20.6973 17.9733 20.6335 17.9261 20.5866C17.8788 20.5397 17.8148 20.5135 17.7482 20.5138", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M8.74921 20.5138C8.61121 20.5143 8.49974 20.6266 8.5001 20.7645C8.50047 20.9025 8.61254 21.0142 8.75054 21.014C8.88854 21.0138 9.00031 20.9019 9.00031 20.7639C9.00058 20.6973 8.97418 20.6334 8.927 20.5864C8.87982 20.5394 8.81579 20.5132 8.74921 20.5138", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "close-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7 7.26367L17 17.2637M17 7.26367L7 17.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "cloud_done-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.99995 13.0137L11.75 14.7637L14.75 11.7637M18.4389 10.3057C20.8313 10.5223 22.3565 12.5843 22.245 14.9839C22.1334 17.3836 20.1522 19.2699 17.75 19.2637H6.74995C4.34773 19.2699 2.36648 17.3836 2.25492 14.9839C2.14337 12.5843 3.94106 10.5223 6.33351 10.3057C6.80017 7.40028 9.30734 5.26367 12.25 5.26367C15.1926 5.26367 17.6997 7.40028 18.1664 10.3057H18.4389Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "cloud_download-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.25 13.2637V19.2637M12.25 19.2637L9.75 16.7637M12.25 19.2637L14.75 16.7637M6.74995 18.2637C4.34773 18.2699 2.36648 16.3836 2.25492 13.9839C2.14337 11.5843 3.94106 9.52228 6.33351 9.30566C6.80017 6.40029 9.30732 4.26367 12.2499 4.26367C15.1925 4.26367 17.6998 6.40029 18.1664 9.30566C20.5589 9.52228 22.3566 11.5843 22.245 13.9839C22.1335 16.3836 20.1522 18.2699 17.75 18.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "cloud_off-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7.49147 7.61322C6.90406 8.37967 6.49564 9.29627 6.33351 10.3057C3.94106 10.5223 2.14337 12.5843 2.25492 14.9839C2.36648 17.3836 4.34773 19.2699 6.74995 19.2637H17.75C18.0956 19.2646 18.4326 19.2263 18.7565 19.1529M10.1299 5.6504C10.7916 5.39993 11.5069 5.26367 12.25 5.26367C15.1926 5.26367 17.6998 7.40028 18.1665 10.3057H18.5158C21.9151 10.7361 22.4184 13.6039 22.245 14.9839C22.2082 15.7756 21.9679 16.5114 21.5762 17.1418M20.25 20.2637L4.25 4.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "cloud_queue-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4389 10.3057C20.8313 10.5223 22.3565 12.5843 22.245 14.9839C22.1334 17.3836 20.1522 19.2699 17.75 19.2637H6.74995C4.34773 19.2699 2.36648 17.3836 2.25492 14.9839C2.14337 12.5843 3.94106 10.5223 6.33351 10.3057C6.80017 7.40028 9.30734 5.26367 12.25 5.26367C15.1926 5.26367 17.6997 7.40028 18.1664 10.3057H18.4389Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "cloud_upload-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.25 19.2637V13.2637M12.25 13.2637L14.75 15.7637M12.25 13.2637L9.75 15.7637M17.25 18.2637H17.75C20.1522 18.2699 22.1334 16.3836 22.245 13.9839C22.3565 11.5843 20.5588 9.52228 18.1664 9.30566C17.6997 6.40028 15.1926 4.26367 12.25 4.26367C9.30734 4.26367 6.80017 6.40028 6.33351 9.30566C3.94106 9.52228 2.14337 11.5843 2.25492 13.9839C2.36648 16.3836 4.34773 18.2699 6.74995 18.2637H7.24995", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "code-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.85 14.3037L6.81 12.2637L8.85 10.2237M15.653 14.3057L17.694 12.2637L15.653 10.2217M13.18 8.76367L11.32 15.7637M18.25 21.2637H6.25C4.593 21.2637 3.25 19.9207 3.25 18.2637V6.26367C3.25 4.60667 4.593 3.26367 6.25 3.26367H18.25C19.907 3.26367 21.25 4.60667 21.25 6.26367V18.2637C21.25 19.9207 19.907 21.2637 18.25 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "compare_arrows-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.603 11.0567L18.5 8.16067L15.603 5.26367M4.5 8.16367H18.5M7.397 13.4707L4.5 16.3667L7.397 19.2637M18.5 16.3637H4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "content_copy-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16 4.26367V8.26367C16 8.81567 16.448 9.26367 17 9.26367H21M6.286 7.26367H5C3.895 7.26367 3 8.15867 3 9.26367V18.2637C3 19.3687 3.895 20.2637 5 20.2637H16C17.105 20.2637 18 19.3687 18 18.2637V17.2637M17.872 4.84967L20.415 7.39267C20.789 7.76767 21 8.27567 21 8.80667V15.2637C21 16.3687 20.105 17.2637 19 17.2637H8.28601C7.18101 17.2637 6.28601 16.3687 6.28601 15.2637V6.26367C6.28601 5.15867 7.18101 4.26367 8.28601 4.26367H16.458C16.988 4.26367 17.496 4.47467 17.872 4.84967Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "content_cut-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M13.2532 18.2695H14.8538M19.657 18.2695H21.2576M14.0374 14.5539L4.69653 9.52686M19.2586 7.17087L4.69653 15.0071M6.05817 4.26367C7.60908 4.26367 8.86634 5.52093 8.86634 7.07184C8.86634 8.62275 7.60908 9.88001 6.05817 9.88001C4.50726 9.88001 3.25 8.62275 3.25 7.07184C3.25 5.52093 4.50726 4.26367 6.05817 4.26367ZM6.05917 20.2703C7.60995 20.2698 8.86671 19.0123 8.86634 17.4615C8.86597 15.9107 7.60862 14.6538 6.05784 14.654C4.50706 14.6542 3.25 15.9114 3.25 17.4622C3.24973 18.2072 3.54565 18.9218 4.07255 19.4485C4.59946 19.9752 5.31414 20.2709 6.05917 20.2703Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "countertops-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M20.75 20.5137L2.75 20.5137V22.0137L20.75 22.0137V20.5137ZM2.5 20.2637V14.2637H1V20.2637H2.5ZM2.75 14.0137L20.75 14.0137V12.5137L2.75 12.5137V14.0137ZM21 14.2637V20.2637H22.5V14.2637H21ZM20.75 14.0137C20.8881 14.0137 21 14.1256 21 14.2637H22.5C22.5 13.2972 21.7165 12.5137 20.75 12.5137V14.0137ZM2.5 14.2637C2.5 14.1256 2.61193 14.0137 2.75 14.0137V12.5137C1.7835 12.5137 1 13.2972 1 14.2637H2.5ZM2.75 20.5137C2.61193 20.5137 2.5 20.4017 2.5 20.2637H1C1 21.2302 1.7835 22.0137 2.75 22.0137V20.5137ZM20.75 22.0137C21.7165 22.0137 22.5 21.2302 22.5 20.2637H21C21 20.4017 20.8881 20.5137 20.75 20.5137V22.0137Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M11.75 13.2637V21.2637M15.75 10.2637H17.75V13.2637M11.75 16.2637H1.75M4.75 5.26367L2.1953 6.9668C1.9171 7.15227 1.75 7.4645 1.75 7.79885V8.76367C1.75 9.03981 1.97386 9.26367 2.25 9.26367H11.25C11.5261 9.26367 11.75 9.03981 11.75 8.76367V7.79885C11.75 7.4645 11.5829 7.15227 11.3047 6.9668L8.75 5.26367V3.76367C8.75 3.48753 8.52614 3.26367 8.25 3.26367H5.25C4.97386 3.26367 4.75 3.48753 4.75 3.76367V5.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "credit_card-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3 9.26367H21M9.57 13.2637H7M18 19.2637H6C4.343 19.2637 3 17.9207 3 16.2637V8.26367C3 6.60667 4.343 5.26367 6 5.26367H18C19.657 5.26367 21 6.60667 21 8.26367V16.2637C21 17.9207 19.657 19.2637 18 19.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "credit_dial-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3.25 13.9402C3.25522 12.0668 3.87209 10.2464 5.00681 8.75579M20.603 13.9402C20.5977 12.0668 19.9809 10.2464 18.8462 8.75579M11.9264 13.0616C10.4202 13.0616 9.19922 14.2826 9.19922 15.7888C9.19922 17.295 10.4202 18.516 11.9264 18.516C13.4325 18.516 14.6535 17.295 14.6535 15.7888C14.6535 14.2826 13.4325 13.0616 11.9264 13.0616ZM11.9264 13.0616L11.9264 8.97089M9.32376 5.70512C10.1635 5.42461 11.0415 5.2757 11.9267 5.26367C12.8119 5.2757 13.69 5.42461 14.5297 5.70512", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "credit_score-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12 16.2647C12 19.0257 14.239 21.2637 17 21.2637C19.762 21.2637 22 19.0247 22 16.2637C22 13.5037 19.764 11.2657 17.005 11.2637C14.3 11.2617 12 13.5597 12 16.2647ZM12 16.2647L4 16.2637C2.895 16.2637 2 15.3687 2 14.2637V5.26367C2 4.15867 2.895 3.26367 4 3.26367H19C20.105 3.26367 21 4.15867 21 5.26367V13.2637M2 7.11367H21M19.222 15.1527L16.444 17.9307L14.778 16.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "current_location-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.3452 17.5764L18.4072 6.61739C18.7052 5.81339 17.9222 5.03039 17.1182 5.32839L6.15419 9.39339C5.23019 9.73639 5.30319 11.0664 6.25819 11.3064L11.1982 12.5474L12.4312 17.4714C12.6712 18.4274 14.0022 18.5004 14.3452 17.5764Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "data_saver_off-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.49708 10.1694C3.95359 8.26145 5.01837 6.56427 6.51683 5.32602C6.94256 4.97421 7.56669 5.10769 7.86912 5.56981L8.41674 6.40654C8.71917 6.86865 8.58252 7.48301 8.17698 7.85792C7.30998 8.65945 6.69293 9.70476 6.41473 10.8675C6.05843 12.3566 6.28492 13.9256 7.04783 15.2532C7.81074 16.5808 9.05233 17.5664 10.5183 18.0083C11.663 18.3534 12.8768 18.3465 14.0059 18.001C14.534 17.8394 15.1336 18.0306 15.3806 18.5246L15.8278 19.419C16.0748 19.913 15.8759 20.5195 15.3576 20.7102C13.5333 21.3814 11.5308 21.4469 9.6525 20.8807C7.45349 20.2178 5.5911 18.7393 4.44674 16.7479C3.30237 14.7566 2.96263 12.4031 3.49708 10.1694Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.2276 12.8975C21.1201 14.4196 20.6279 15.8838 19.8044 17.1555C19.5042 17.6191 18.8689 17.6795 18.4414 17.3298L17.6675 16.6965C17.2401 16.3468 17.1856 15.7198 17.4596 15.2402C17.9044 14.4616 18.1713 13.5892 18.2351 12.6862C18.3224 11.449 18.0242 10.215 17.3813 9.15422C16.7385 8.09343 15.7828 7.25792 14.6456 6.76268C13.8156 6.40125 12.9188 6.23402 12.0227 6.26798C11.4708 6.28889 10.9402 5.95039 10.828 5.40962L10.6249 4.43047C10.5127 3.8897 10.8603 3.35447 11.4102 3.30293C12.9187 3.16155 14.4444 3.40293 15.8434 4.01218C17.5492 4.75504 18.9828 6.0083 19.9471 7.59949C20.9113 9.19068 21.3586 11.0416 21.2276 12.8975Z", stroke: "currentColor" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "day-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.5 11.7637C8.5 9.83067 10.067 8.26367 12 8.26367C13.933 8.26367 15.5 9.83067 15.5 11.7637M19 11.2637H21M3 11.2637H5M12 4.26367V2.26367M16.95 6.31367L18.36 4.90367M5.64 4.90367L7.05 6.31367M3 15.2637H13M17 15.2637H21M20 18.2637H11M4 18.2637H7M6 21.2637H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "delete-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M17.5 6.26367V19.0137C17.5 20.2567 16.473 21.2637 15.231 21.2637H7.731C6.488 21.2637 5.5 20.2567 5.5 19.0137V6.26367M19 6.26367H4M9.5 3.26367H13.5M13.5 10.2637V17.2637M9.5 17.2637V10.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "description-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8 9.26367H16M8 12.2637H16M8 15.2637H10M18.414 6.67767L15.586 3.84967C15.211 3.47467 14.702 3.26367 14.172 3.26367H7C5.895 3.26367 5 4.15867 5 5.26367V19.2637C5 20.3687 5.895 21.2637 7 21.2637H17C18.105 21.2637 19 20.3687 19 19.2637V8.09167C19 7.56167 18.789 7.05267 18.414 6.67767ZM13 16.7637C13 15.9357 13.672 15.2637 14.5 15.2637C15.328 15.2637 16 15.9357 16 16.7637C16 17.5917 15.328 18.2637 14.5 18.2637C13.672 18.2637 13 17.5917 13 16.7637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "desktop_windows-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M21.2575 12.2678H3.25M14.2545 16.2695L14.7547 20.2712M10.2528 16.2695L9.75255 20.2712M8.39502 20.2712H16.1122M18.6854 16.2695H5.82207C4.40156 16.2695 3.25 15.118 3.25 13.6974V4.83574C3.25 3.41523 4.40156 2.26367 5.82207 2.26367H18.6844C19.3668 2.26341 20.0212 2.53427 20.5038 3.01666C20.9864 3.49905 21.2575 4.15341 21.2575 4.83574V13.6964C21.2578 14.3788 20.9869 15.0332 20.5045 15.5158C20.0221 15.9984 19.3678 16.2695 18.6854 16.2695Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "devices-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M20.25 10.7637V5.26367C20.25 4.15867 19.355 3.26367 18.25 3.26367H5.25C4.145 3.26367 3.25 4.15867 3.25 5.26367V15.2637M3.25 15.2637C2.698 15.2637 2.25 15.7117 2.25 16.2637V17.2637C2.25 17.8157 2.698 18.2637 3.25 18.2637H22.25M3.25 15.2637H15.25M21.25 21.2637H16.25C15.698 21.2637 15.25 20.8157 15.25 20.2637V11.7637C15.25 11.2117 15.698 10.7637 16.25 10.7637H21.25C21.802 10.7637 22.25 11.2117 22.25 11.7637V20.2637C22.25 20.8157 21.802 21.2637 21.25 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "device_thermostat-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.75 8.26367V14.2637M13.1642 14.8495C13.9452 15.6305 13.9452 16.8969 13.1642 17.6779C12.3832 18.459 11.1168 18.459 10.3358 17.6779C9.55472 16.8969 9.55472 15.6305 10.3358 14.8495C11.1168 14.0684 12.3831 14.0684 13.1642 14.8495ZM8.75 12.2867V6.26367C8.75 4.60667 10.093 3.26367 11.75 3.26367C13.407 3.26367 14.75 4.60667 14.75 6.26367V12.2867C15.958 13.1997 16.75 14.6337 16.75 16.2637C16.75 19.0247 14.511 21.2637 11.75 21.2637C8.989 21.2637 6.75 19.0247 6.75 16.2637C6.75 14.6337 7.542 13.1987 8.75 12.2867Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "directions_walk-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.66397 6.60829H11.7538M11.7538 6.60829L13.3825 5.61588C13.6427 5.45738 13.9609 5.42608 14.247 5.53085C14.5331 5.63562 14.7558 5.86505 14.8521 6.1541L17.1561 13.066L20.3974 17.3878C20.8067 17.9334 20.8725 18.6635 20.5675 19.2736C20.2624 19.8836 19.6389 20.269 18.9568 20.269H15.0252C13.9134 20.2697 12.8516 19.8071 12.095 18.9924L3.55042 9.79562C2.99552 9.19713 2.70828 8.39846 2.75491 7.58363C2.80153 6.76881 3.17798 6.00811 3.79752 5.47682L7.22195 2.5426C7.56576 2.24808 8.04955 2.1806 8.46083 2.3698C8.87211 2.55899 9.13567 2.97025 9.13575 3.42296V6.60829H11.7538ZM2.75009 16.7675H4.75092M7.75217 20.269H2.75009M20.3044 17.2677H15.2783C14.4455 17.27 13.6497 16.924 13.0834 16.3133L3.40536 5.89099M12.7543 12.2656L16.6609 11.5894M11.7538 9.76461L15.8195 9.06131", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "document_cash-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4 8.50003H7.5C8.60457 8.50003 9.5 7.6046 9.5 6.50003V3.00003M15 21H7C5.34315 21 4 19.6569 4 18L4 8.50934C4 7.7137 4.31607 6.95064 4.87868 6.38803L7.388 3.87871C7.95061 3.31611 8.71366 3.00004 9.50931 3.00003L17 3.00003C18.6569 3.00003 20 4.34318 20 6.00003V9.00003M13 15H15M14 18H15M20 12V12.8079M20 12.8079C19.005 12.7135 18.1168 13.431 18 14.4236C18 15.1076 18.4828 15.6966 19.1536 15.8307L20.8464 16.1693C21.5172 16.3035 22 16.8924 22 17.5765C21.8832 18.569 20.995 19.2866 20 19.1922M20 12.8079C20.8569 12.7542 21.6482 13.267 21.9491 14.0711M20 20V19.1922M20 19.1922C19.1431 19.2459 18.3518 18.7331 18.0509 17.929", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "dollar_sign_shining-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M18.75 12.0001L18 11.9999M6 12.0001L5.25 11.9999M16.9498 7.0503L16.4496 7.5503M7.55019 16.4499L7.05019 16.9497M16.9497 16.9498L16.4499 16.4498M7.55013 7.55017L7.05032 7.05017M12 7.49998V8.49998M12 8.49998C12.964 8.43956 13.8542 9.01649 14.1927 9.9211M12 8.49998C10.8807 8.39379 9.88145 9.20102 9.75 10.3177C9.75 11.0342 10.2558 11.6511 10.9584 11.7917L13.0416 12.2083C13.7442 12.3488 14.25 12.9658 14.25 13.6823C14.1186 14.7989 13.1193 15.6062 12 15.5M12 16.5V15.5M12 15.5C11.036 15.5604 10.1458 14.9835 9.80729 14.0789M5.25 21H18.75C19.9926 21 21 19.9926 21 18.75V5.24998C21 4.00734 19.9926 2.99998 18.75 2.99998L5.25 2.99998C4.00736 2.99998 3 4.00734 3 5.24998L3 18.75C3 19.9926 4.00736 21 5.25 21Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "donut_large-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.49708 10.1694C3.95359 8.26146 5.01837 6.56427 6.51683 5.32602C6.94256 4.97421 7.56669 5.1077 7.86912 5.56981L8.41674 6.40654C8.71917 6.86866 8.58252 7.48301 8.17698 7.85792C7.30998 8.65945 6.69293 9.70476 6.41473 10.8675C6.05843 12.3566 6.28492 13.9256 7.04783 15.2532C7.81074 16.5808 9.05233 17.5664 10.5183 18.0083C11.663 18.3534 12.8768 18.3466 14.0059 18.001C14.534 17.8394 15.1336 18.0307 15.3806 18.5246L15.8278 19.4191C16.0748 19.913 15.8759 20.5195 15.3576 20.7102C13.5333 21.3814 11.5308 21.4469 9.6525 20.8807C7.45349 20.2178 5.5911 18.7393 4.44674 16.7479C3.30237 14.7566 2.96263 12.4031 3.49708 10.1694Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.8343 14.9673C20.5796 15.7759 20.2125 16.5429 19.7449 17.2462C19.4392 17.7061 18.8032 17.7589 18.38 17.404L17.6137 16.7615C17.1905 16.4066 17.1436 15.779 17.4233 15.3028C17.652 14.9135 17.8366 14.4987 17.9728 14.0661C18.1091 13.6334 18.1955 13.1877 18.2312 12.7377C18.2748 12.1871 18.673 11.6997 19.2231 11.6514L20.2193 11.5639C20.7695 11.5156 21.2605 11.9232 21.2475 12.4754C21.2276 13.3196 21.089 14.1586 20.8343 14.9673Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.3916 4.27329C17.8154 5.0113 19.0106 6.11329 19.8604 7.45932C20.1552 7.92633 19.9434 8.52839 19.4466 8.76961L18.547 9.20637C18.0502 9.44758 17.4582 9.23391 17.1379 8.78399C16.5883 8.01205 15.8608 7.37718 15.0111 6.93676C14.1614 6.49633 13.2232 6.26779 12.2756 6.26373C11.7234 6.26136 11.2075 5.90079 11.1182 5.35577L10.9565 4.36893C10.8673 3.82391 11.2371 3.30381 11.7887 3.2755C13.3784 3.19391 14.9678 3.53529 16.3916 4.27329Z", stroke: "currentColor" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "download_done-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5.83178 16.2689C3.37119 14.5598 2.37266 11.4064 3.40111 8.59254C4.42956 5.7787 7.22625 4.01237 10.209 4.29282C13.1917 4.57328 15.6102 6.82998 16.0961 9.78621C16.2361 9.77625 16.3662 9.7662 16.5062 9.7662C18.6986 9.76543 20.5724 11.3445 20.9433 13.5053C21.3141 15.666 20.074 17.7796 18.0069 18.5098M9.396 16.4914L11.6773 18.7727L16.6571 13.7919", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "drafts-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3 10.2637L10.2 15.6637C11.2667 16.4637 12.7333 16.4637 13.8 15.6637L21 10.2637M20.216 8.77667L13.824 3.88182C12.7477 3.05762 11.2524 3.05762 10.1761 3.88182L3.784 8.77667C3.2898 9.15513 2.99999 9.74212 3 10.3646V18.2637C3 19.9205 4.34315 21.2637 6 21.2637H18C19.6569 21.2637 21 19.9205 21 18.2637V10.3645C21 9.74208 20.7102 9.15512 20.216 8.77667Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "drag_handle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4 13.7636H20M4 9.26367H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "draw-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.3678 14.6886C12.4931 17.8139 16.7709 18.6062 18.9168 16.4573C20.7255 14.6486 20.4444 11.3352 18.4486 8.46802M15.8455 5.77289C12.0869 2.88169 7.38699 2.52054 4.7689 5.13863C1.83868 8.06885 2.63101 13.6112 6.53763 17.5178C8.24819 19.2565 10.3626 20.5447 12.6922 21.2673M12.4231 12.6638L14.2909 12.2896C14.561 12.2365 14.8094 12.105 15.0052 11.9115L20.4595 6.46118C21.1907 5.72952 21.1907 4.54374 20.4595 3.81208C19.7278 3.08087 18.542 3.08087 17.8104 3.81208L12.3561 9.26235C12.1611 9.4576 12.0282 9.7061 11.9739 9.97665L11.6038 11.8444C11.5602 12.0723 11.6324 12.307 11.7964 12.4711C11.9605 12.6352 12.1952 12.7073 12.4231 12.6638Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "drive_eta-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M22.25 14.2637V17.7637C22.25 18.316 21.8023 18.7637 21.25 18.7637H18.25C17.6977 18.7637 17.25 18.316 17.25 17.7637V16.2637L15.5502 14.139C15.3605 13.9018 15.0732 13.7637 14.7694 13.7637H9.73062C9.42684 13.7637 9.13953 13.9018 8.94976 14.139L7.25 16.2637V17.7637C7.25 18.316 6.80228 18.7637 6.25 18.7637H3.25C2.69772 18.7637 2.25 18.316 2.25 17.7637V14.2637M22.25 14.2637C22.25 15.3682 21.3546 16.2637 20.25 16.2637H4.25C3.14543 16.2637 2.25 15.3682 2.25 14.2637M22.25 14.2637V10.7637C22.25 9.6591 21.3546 8.76367 20.25 8.76367M2.25 14.2637V10.7637C2.25 9.6591 3.14543 8.76367 4.25 8.76367M22.25 11.7637L18.25 12.7637M2.25 11.7637L6.25 12.7637M19.1389 6.76367H21.25M3.25 6.76367H5.36111M20.25 8.76367L17.25 9.76367H7.25L4.25 8.76367M20.25 8.76367L18.3215 5.29238C17.9688 4.65745 17.2995 4.26367 16.5732 4.26367H7.92681C7.20047 4.26367 6.53123 4.65745 6.17849 5.29238L4.25 8.76367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "earth_globe-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5 9.26567H7.897C8.982 9.26567 9.861 8.38667 9.861 7.30167C9.861 6.78067 9.654 6.28067 9.286 5.91267L7.582 4.20867M15.619 13.7367L14.385 11.8857C14.162 11.5507 13.786 11.3497 13.383 11.3497C12.927 11.3497 12.51 11.0917 12.306 10.6837L12.214 10.4987C12.044 10.1597 12.044 9.76067 12.214 9.42167L13.001 7.84867C13.205 7.44067 13.622 7.18267 14.078 7.18267H17.139M14.25 21.2637H8.25M4.25 16.2637L4.886 15.6277C8.4 19.1417 14.1 19.1427 17.614 15.6277C21.128 12.1137 21.128 6.41367 17.614 2.89967C17.273 2.55867 16.906 2.26067 16.528 1.98567L17.25 1.26367M11.25 18.2637V21.2637M15.6694 4.84625C18.1102 7.28703 18.1102 11.2443 15.6694 13.6851C13.2286 16.1259 9.27134 16.1259 6.83057 13.6851C4.38979 11.2443 4.38979 7.28702 6.83057 4.84625C9.27135 2.40547 13.2286 2.40547 15.6694 4.84625Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "public-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5 9.26567H7.897C8.982 9.26567 9.861 8.38667 9.861 7.30167C9.861 6.78067 9.654 6.28067 9.286 5.91267L7.582 4.20867M15.619 13.7367L14.385 11.8857C14.162 11.5507 13.786 11.3497 13.383 11.3497C12.927 11.3497 12.51 11.0917 12.306 10.6837L12.214 10.4987C12.044 10.1597 12.044 9.76067 12.214 9.42167L13.001 7.84867C13.205 7.44067 13.622 7.18267 14.078 7.18267H17.139M14.25 21.2637H8.25M4.25 16.2637L4.886 15.6277C8.4 19.1417 14.1 19.1427 17.614 15.6277C21.128 12.1137 21.128 6.41367 17.614 2.89967C17.273 2.55867 16.906 2.26067 16.528 1.98567L17.25 1.26367M11.25 18.2637V21.2637M15.6694 4.84625C18.1102 7.28703 18.1102 11.2443 15.6694 13.6851C13.2286 16.1259 9.27134 16.1259 6.83057 13.6851C4.38979 11.2443 4.38979 7.28702 6.83057 4.84625C9.27135 2.40547 13.2286 2.40547 15.6694 4.84625Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "edit-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M13.75 7.42316L16.84 10.5132M5.293 15.8822L15.619 5.55617C16.009 5.16617 16.642 5.16617 17.032 5.55617L18.708 7.23217C19.098 7.62217 19.098 8.25517 18.708 8.64517L8.381 18.9702C8.194 19.1582 7.94 19.2632 7.675 19.2632H5V16.5882C5 16.3232 5.105 16.0692 5.293 15.8822Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "edit_note-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.0025 21.2712H4.00083C2.8958 21.2712 2 20.3754 2 19.2703V5.26451C2 4.15948 2.8958 3.26367 4.00083 3.26367H16.0058C17.1109 3.26367 18.0067 4.15948 18.0067 5.26451V8.26576M5.50146 7.26535H13.5048M5.50146 10.7668H9.50313M11.0038 21.2712L13.6288 20.947C13.8135 20.9242 13.9853 20.8404 14.1171 20.7089L20.4777 14.3483C21.1822 13.6468 21.1849 12.5071 20.4837 11.8022L20.4777 11.7972C19.7762 11.0927 18.6365 11.09 17.9316 11.7912V11.7972L11.629 18.0999C11.5008 18.2272 11.4179 18.3931 11.3929 18.5721L11.0038 21.2712ZM7.00209 17.2695C6.17332 17.2695 5.50146 16.5976 5.50146 15.7689C5.50146 14.9401 6.17332 14.2682 7.00209 14.2682C7.83086 14.2682 8.50272 14.9401 8.50272 15.7689C8.50272 16.5976 7.83086 17.2695 7.00209 17.2695Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "edit_notifications-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.95801 18.6077V18.9727C9.95801 20.2377 10.984 21.2637 12.25 21.2637C13.516 21.2637 14.542 20.2377 14.542 18.9717V18.6067M14.083 6.01467V5.09667C14.083 4.08467 13.263 3.26367 12.25 3.26367C11.237 3.26367 10.417 4.08467 10.417 5.09667V6.01467M14.6925 6.18743C14.2131 6.01476 13.696 5.92065 13.157 5.92065H11.344C8.842 5.92065 6.813 7.94865 6.813 10.4517V13.2487C6.813 13.7787 6.602 14.2877 6.227 14.6627L5.586 15.3037C5.211 15.6787 5 16.1877 5 16.7177C5 17.7617 5.846 18.6077 6.89 18.6077H17.611C18.655 18.6077 19.501 17.7617 19.501 16.7177C19.501 16.1877 19.29 15.6787 18.915 15.3037L18.5945 14.9832M12.9094 12.2616L17.3208 7.85013C17.4402 7.73076 17.6021 7.6637 17.7709 7.6637C17.9397 7.6637 18.1016 7.73076 18.2209 7.85013L19.3011 8.93034C19.5497 9.17891 19.5497 9.58192 19.3011 9.83049L14.8897 14.2419C14.7923 14.3393 14.666 14.4025 14.5296 14.422L12.8493 14.662C12.7502 14.6762 12.6501 14.6428 12.5793 14.572C12.5085 14.5011 12.4751 14.4011 12.4893 14.3019L12.7293 12.6216C12.7488 12.4853 12.812 12.359 12.9094 12.2616Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "elevator-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.25 3.26367H21.25M1.75 21.2637H21.75M11.75 21.2637V3.26367M20.75 3.26367V21.2637M8.75 12.8067L7.293 14.2637M7.293 14.2637L5.75 12.7207M7.293 14.2637V10.2637M2.75 21.2637V3.26367M14.75 11.7207L16.207 10.2637M16.207 10.2637L17.75 11.8067M16.207 10.2637V14.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "emoji_events-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.25 15.2637C15.0114 15.2637 17.25 13.0251 17.25 10.2637V4.26367C17.25 3.71139 16.8023 3.26367 16.25 3.26367H8.25C7.69772 3.26367 7.25 3.71139 7.25 4.26367V10.2637C7.25 13.0251 9.48858 15.2637 12.25 15.2637ZM12.25 15.2637L12.25 18.2637M7.66668 12.2637H7.25C5.04086 12.2637 3.25 10.4728 3.25 8.26367V6.26367C3.25 5.71139 3.69772 5.26367 4.25 5.26367H7.25M16.8331 12.2637H17.25C19.4591 12.2637 21.25 10.4728 21.25 8.26367V6.26367C21.25 5.71139 20.8023 5.26367 20.25 5.26367H17.25M15.9159 18.2637H8.58409C8.15366 18.2637 7.77152 18.5391 7.6354 18.9474L7.30207 19.9474C7.20042 20.2524 7.25156 20.5876 7.43951 20.8484C7.62746 21.1091 7.92931 21.2637 8.25075 21.2637H16.2492C16.5707 21.2637 16.8725 21.1091 17.0605 20.8484C17.2484 20.5876 17.2996 20.2524 17.1979 19.9474L16.8646 18.9474C16.7285 18.5391 16.3463 18.2637 15.9159 18.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "empty_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21.2637C7.02943 21.2637 3 17.2342 3 12.2637C3 7.2931 7.02943 3.26367 12 3.26367C16.9706 3.26367 21 7.2931 21 12.2637C21 17.2342 16.9706 21.2637 12 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "entryway-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.75 11.2629V13.2629M15.75 20.2629H18.5C19.0966 20.2631 19.6688 20.0262 20.0907 19.6045C20.5127 19.1828 20.7498 18.6107 20.75 18.0141V6.51289C20.7503 5.27059 19.7435 4.26324 18.5012 4.26289H15.75M2.75 17.9511V6.57473C2.75 5.64791 3.39439 4.84572 4.29941 4.64589L10.3488 3.31015C10.9334 3.18107 11.545 3.32408 12.0117 3.69901C12.4785 4.07393 12.75 4.64031 12.75 5.23899V19.2868C12.75 19.8855 12.4785 20.4518 12.0117 20.8268C11.545 21.2017 10.9334 21.3447 10.3488 21.2156L4.29942 19.8799C3.39439 19.6801 2.75 18.8779 2.75 17.9511Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "error-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M12 12.7637V8.26367M12 21.2637C7.02943 21.2637 3 17.2342 3 12.2637C3 7.2931 7.02943 3.26367 12 3.26367C16.9706 3.26367 21 7.2931 21 12.2637C21 17.2342 16.9706 21.2637 12 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M12.0075 15.5967C11.9155 15.5967 11.8405 15.6717 11.8415 15.7637C11.8415 15.8557 11.9165 15.9307 12.0085 15.9307C12.1005 15.9307 12.1755 15.8557 12.1755 15.7637C12.1755 15.6717 12.1005 15.5967 12.0075 15.5967", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "event_available-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M13.6779 20.2712H5.00125C3.34371 20.2712 2 18.9275 2 17.2699V5.26492C2 3.60738 3.34371 2.26367 5.00125 2.26367H17.0063C18.6638 2.26367 20.0075 3.60738 20.0075 5.26492V13.9405M20.0075 7.26576H2M18.0067 16.0194L16.1319 17.8952L15.0054 16.7697M16.506 12.2678C18.9924 12.2678 21.0079 14.2834 21.0079 16.7697C21.0079 19.256 18.9924 21.2716 16.506 21.2716C14.0197 21.2716 12.0042 19.256 12.0042 16.7697C12.0042 14.2834 14.0197 12.2678 16.506 12.2678Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M13.1667 10.7149C13.1396 10.7149 13.1177 10.7368 13.1177 10.7639C13.1177 10.791 13.1396 10.8129 13.1667 10.8129C13.1938 10.8129 13.2157 10.791 13.2157 10.7639C13.2157 10.7368 13.1938 10.7149 13.1667 10.7149", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M9.49921 10.7149C9.4863 10.7149 9.47393 10.7201 9.4649 10.7293C9.45586 10.7385 9.45092 10.751 9.45119 10.7639C9.4512 10.7838 9.46325 10.8017 9.48169 10.8093C9.50013 10.8168 9.52129 10.8124 9.53523 10.7982C9.54917 10.784 9.55311 10.7627 9.54521 10.7444C9.5373 10.7261 9.51913 10.7145 9.49921 10.7149", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M5.51927 10.7144C5.50601 10.7141 5.49322 10.7193 5.48393 10.7288C5.47465 10.7382 5.4697 10.7511 5.47025 10.7644C5.47026 10.7843 5.48231 10.8022 5.50075 10.8098C5.51919 10.8173 5.54035 10.8129 5.55429 10.7987C5.56823 10.7845 5.57217 10.7632 5.56427 10.7449C5.55636 10.7266 5.53818 10.715 5.51827 10.7154", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M9.49921 13.7149C9.4863 13.7149 9.47393 13.7201 9.4649 13.7293C9.45586 13.7385 9.45092 13.751 9.45119 13.7639C9.4512 13.7838 9.46325 13.8017 9.48169 13.8093C9.50013 13.8168 9.52129 13.8124 9.53523 13.7982C9.54917 13.784 9.55311 13.7627 9.54521 13.7444C9.5373 13.7261 9.51913 13.7145 9.49921 13.7149", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M5.51927 13.7148C5.50601 13.7145 5.49322 13.7197 5.48393 13.7292C5.47465 13.7387 5.4697 13.7515 5.47025 13.7648C5.47026 13.7847 5.48231 13.8027 5.50075 13.8102C5.51919 13.8177 5.54035 13.8133 5.55429 13.7991C5.56823 13.7849 5.57217 13.7636 5.56427 13.7453C5.55636 13.7271 5.53818 13.7154 5.51827 13.7158", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M9.49921 16.7149C9.4863 16.7149 9.47393 16.7201 9.4649 16.7293C9.45586 16.7385 9.45092 16.751 9.45119 16.7639C9.4512 16.7838 9.46325 16.8017 9.48169 16.8093C9.50013 16.8168 9.52129 16.8124 9.53523 16.7982C9.54917 16.784 9.55311 16.7627 9.54521 16.7444C9.5373 16.7261 9.51913 16.7145 9.49921 16.7149", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M5.51925 16.7157C5.50617 16.7154 5.49354 16.7205 5.48429 16.7298C5.47504 16.739 5.46996 16.7516 5.47024 16.7647C5.47024 16.7846 5.48229 16.8026 5.50074 16.8101C5.51918 16.8176 5.54034 16.8133 5.55427 16.799C5.56821 16.7848 5.57216 16.7635 5.56425 16.7453C5.55635 16.727 5.53817 16.7153 5.51826 16.7157", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "event_repeat-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7.01367C2 4.9426 3.67893 3.26367 5.75 3.26367H17.75C19.8211 3.26367 21.5 4.9426 21.5 7.01367V17.5137C21.5 19.5847 19.8211 21.2637 17.75 21.2637H5.75C3.67893 21.2637 2 19.5847 2 17.5137V7.01367ZM5.75 4.76367C4.50736 4.76367 3.5 5.77103 3.5 7.01367V17.5137C3.5 18.7563 4.50736 19.7637 5.75 19.7637H17.75C18.9926 19.7637 20 18.7563 20 17.5137V7.01367C20 5.77103 18.9926 4.76367 17.75 4.76367H5.75Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M8 3.26367V6.26367M17 3.26367V6.26367M16.5 15.8781V13.8776H14.5M8.5 14.6633C10.0267 16.3318 12.4936 16.746 14.4815 15.6675C15.227 15.2616 15.8396 14.649 16.2456 13.9034", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M16.55 9.76361C16.55 9.73601 16.5276 9.71366 16.5 9.71367C16.4724 9.71368 16.45 9.73605 16.45 9.76365C16.45 9.79125 16.4723 9.81364 16.4999 9.81367C16.5132 9.81369 16.526 9.80842 16.5354 9.79903C16.5447 9.78964 16.55 9.77689 16.55 9.76361", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M12.55 9.76361C12.55 9.73601 12.5276 9.71366 12.5 9.71367C12.4724 9.71368 12.45 9.73605 12.45 9.76365C12.45 9.79125 12.4723 9.81364 12.4999 9.81367C12.5132 9.81369 12.526 9.80842 12.5354 9.79903C12.5447 9.78964 12.55 9.77689 12.55 9.76361", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M7.55 9.76361C7.54997 9.73601 7.52758 9.71366 7.49998 9.71367C7.47238 9.71368 7.45001 9.73605 7.45 9.76365C7.44999 9.79125 7.47234 9.81364 7.49994 9.81367C7.51322 9.81369 7.52596 9.80842 7.53536 9.79903C7.54475 9.78964 7.55002 9.77689 7.55 9.76361", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "exclude_draw-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7 13.2805H5C3.895 13.2805 3 14.1755 3 15.2805C3 16.3855 3.895 17.2805 5 17.2805H6M15 21.2805H19C20.105 21.2805 21 20.3855 21 19.2805C21 18.1755 20.105 17.2805 19 17.2805H15.0365M8.69233 15.7247L11.9922 19.0245M11.9922 15.7247L8.69233 19.0245M11 10.1636V13.2806H14.117L20.717 6.78856C21.113 6.39856 21.116 5.76156 20.723 5.36856L18.911 3.55656C18.518 3.16356 17.88 3.16656 17.491 3.56256L11 10.1636Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "expand_less-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16 13L12 9L8 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "expand_more-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8 10L12 14L16 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 51 50", id: "facebook-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M0.100098 25C0.100098 11.1929 11.293 0 25.1001 0C38.9072 0 50.1001 11.1929 50.1001 25C50.1001 38.8071 38.9072 50 25.1001 50C11.293 50 0.100098 38.8071 0.100098 25Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.4333 28.1111H31.7107C32.0676 28.1111 32.3787 27.8682 32.4653 27.522L33.6319 22.8553C33.69 22.623 33.6378 22.3768 33.4904 22.188C33.343 21.9992 33.1169 21.8889 32.8774 21.8889H27.4333V18.7778C27.4333 17.9187 28.1298 17.2222 28.9889 17.2222H32.8778C33.3073 17.2222 33.6555 16.874 33.6555 16.4444V11.7778C33.6555 11.3482 33.3073 11 32.8778 11H28.9889C24.6933 11 21.2111 14.4822 21.2111 18.7778V21.8889H17.3222C16.8927 21.8889 16.5444 22.2371 16.5444 22.6667V27.3333C16.5444 27.7629 16.8927 28.1111 17.3222 28.1111H21.2111V38.2222C21.2111 38.6518 21.5593 39 21.9889 39H26.6555C27.0851 39 27.4333 38.6518 27.4333 38.2222V28.1111Z", fill: "#F2F2F2" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "favorite-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.494 6.01134C20.5046 7.02697 21.0486 8.41625 20.9965 9.84805C20.9444 11.2798 20.3007 12.6259 19.219 13.5653L12.6536 19.256C12.2786 19.5814 11.7214 19.5814 11.3464 19.256L4.781 13.5654C3.69925 12.6259 3.05561 11.2799 3.00349 9.84808C2.95136 8.41628 3.49543 7.027 4.506 6.01137C6.40791 4.09965 9.46549 3.98754 11.5023 5.75484L12 6.18624L12.4978 5.75481C14.5345 3.98753 17.5921 4.09965 19.494 6.01134Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "fence-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.375 17.0193C9.375 18.1151 8.31168 19.0035 7 19.0035C5.68832 19.0035 4.625 18.1151 4.625 17.0193V7.52343C4.625 6.87945 4.87501 6.25284 5.3375 5.73765L6.45714 4.49044C6.58529 4.34769 6.78641 4.26367 7 4.26367C7.21359 4.26367 7.41471 4.34769 7.54286 4.49044L8.69643 5.77544C9.1369 6.2661 9.375 6.86287 9.375 7.47619V17.0193ZM9.375 17.0193V7.52343C9.375 6.87945 9.62501 6.25284 10.0875 5.73765L11.2071 4.49044C11.3353 4.34769 11.5364 4.26367 11.75 4.26367C11.9636 4.26367 12.1647 4.34769 12.2929 4.49044L13.4464 5.77544C13.8869 6.2661 14.125 6.86287 14.125 7.47619V17.0193M9.375 17.0193C9.375 18.1151 10.4383 19.0035 11.75 19.0035C13.0617 19.0035 14.125 18.1151 14.125 17.0193M14.125 17.0193V7.52343C14.125 6.87945 14.375 6.25284 14.8375 5.73765L15.9571 4.49044C16.0853 4.34769 16.2864 4.26367 16.5 4.26367C16.7136 4.26367 16.9147 4.34769 17.0429 4.49044L18.1964 5.77544C18.6369 6.2661 18.875 6.86287 18.875 7.47619V17.0193C18.875 18.1151 17.8117 19.0035 16.5 19.0035C15.1883 19.0035 14.125 18.1151 14.125 17.0193ZM2.75 15.0928H21.1302M2.75 10.2901H21.1302", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "file_download-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7.99312 17.2699L10.9938 20.2711M10.9938 20.2711L13.9956 17.2711M10.9938 20.2711L10.9951 13.2682M4.99187 14.5694C2.94274 12.5742 2.41537 9.48467 3.68665 6.92274C4.95792 4.36081 7.73726 2.91208 10.5655 3.33714C13.3937 3.7622 15.6244 5.9639 16.0865 8.78634C16.2266 8.77639 16.3566 8.76633 16.4967 8.76633C18.8837 8.76002 20.8584 10.6225 20.9915 13.0058C21.1247 15.3891 19.3697 17.46 16.9969 17.7196", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "file_upload-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5.83178 16.2689C3.37119 14.5598 2.37266 11.4064 3.40111 8.59254C4.42956 5.7787 7.22625 4.01237 10.209 4.29282C13.1917 4.57328 15.6102 6.82998 16.0961 9.78621C16.2361 9.77625 16.3662 9.7662 16.5062 9.7662C18.6986 9.76543 20.5724 11.3445 20.9433 13.5053C21.3141 15.666 20.074 17.7796 18.0069 18.5098M15.0056 15.2687L12.0044 12.2675M12.0044 12.2675L9.0031 15.2687M12.0044 12.2675L12.0044 20.2706", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "filter-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5 12.7637L19.707 7.55667C19.895 7.36867 20 7.11467 20 6.84967V4.26367C20 3.71167 19.552 3.26367 19 3.26367H5C4.448 3.26367 4 3.71167 4 4.26367V6.84967C4 7.11467 4.105 7.36967 4.293 7.55667L9.5 12.7637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 12.7637V19.0127C9.5 19.8257 10.264 20.4227 11.053 20.2257L13.553 19.6007C14.109 19.4617 14.5 18.9617 14.5 18.3877V12.7637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "filter_handles-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M20 7H9M4 17H15M8.12132 4.87868C9.29289 6.05025 9.29289 7.94975 8.12132 9.12132C6.94975 10.2929 5.05025 10.2929 3.87868 9.12132C2.70711 7.94975 2.70711 6.05025 3.87868 4.87868C5.05025 3.70711 6.94975 3.70711 8.12132 4.87868ZM20.1213 14.8787C21.2929 16.0503 21.2929 17.9498 20.1213 19.1213C18.9497 20.2929 17.0502 20.2929 15.8787 19.1213C14.7071 17.9498 14.7071 16.0503 15.8787 14.8787C17.0502 13.7071 18.9497 13.7071 20.1213 14.8787Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "find_in_page-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M21 15.2637L19.284 13.5477M20 18.2637V19.2637C20 20.3682 19.1046 21.2637 18 21.2637H5C3.89543 21.2637 3 20.3682 3 19.2637V5.26367C3 4.1591 3.89543 3.26367 5 3.26367H18C19.1046 3.26367 20 4.1591 20 5.26367V6.26367M7 12.2637H10M7 16.2637H12M7 8.26367H11M20 11.5137C20 13.3086 18.5449 14.7637 16.75 14.7637C14.9551 14.7637 13.5 13.3086 13.5 11.5137C13.5 9.71875 14.9551 8.26367 16.75 8.26367C18.5449 8.26367 20 9.71875 20 11.5137Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "fireplace-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3 21V3H21V21M21 6.00001H3M22 3.00001H2M17.5 21V11.1C13.98 9.63333 10.02 9.63333 6.5 11.1V21M22 21H2M10.1237 20.107C9.29211 19.1121 9.29211 17.6646 10.1237 16.6697L11.2328 15.3428C11.4228 15.1155 11.7038 14.9842 12 14.9842C12.2962 14.9842 12.5772 15.1155 12.7672 15.3428L13.8763 16.6697C14.7079 17.6646 14.7079 19.1121 13.8763 20.107C13.4117 20.6629 12.7245 20.9841 12 20.9841C11.2755 20.9841 10.5883 20.6629 10.1237 20.107Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "fitness_center-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2322 7.15312L16.8693 9.79031L10.2757 16.384L7.63847 13.7468L14.2322 7.15312Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.68282 11.109C4.04679 10.745 4.6369 10.745 5.00087 11.109L12.9137 19.0218C13.2777 19.3858 13.2777 19.9759 12.9137 20.3399L12.2539 20.9997C11.8899 21.3637 11.2998 21.3637 10.9358 20.9997L3.02298 13.0869C2.65901 12.7229 2.65901 12.1328 3.02298 11.7688L3.68282 11.109Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.68299 15.0657C4.04696 14.7017 4.63707 14.7017 5.00104 15.0657L8.95809 19.0227C9.32206 19.3867 9.32205 19.9768 8.95809 20.3408L8.29824 21.0006C7.93427 21.3646 7.34416 21.3646 6.98019 21.0006L3.02315 17.0436C2.65918 16.6796 2.65918 16.0895 3.02315 15.7255L3.68299 15.0657Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.8254 12.429C20.4615 12.793 19.8714 12.793 19.5074 12.429L11.5945 4.51618C11.2306 4.15221 11.2306 3.5621 11.5945 3.19813L12.2544 2.53828C12.6184 2.17432 13.2085 2.17432 13.5724 2.53828L21.4853 10.4511C21.8492 10.8151 21.8492 11.4052 21.4853 11.7692L20.8254 12.429Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.8257 8.47159C20.4618 8.83556 19.8717 8.83556 19.5077 8.47159L15.5507 4.51454C15.1867 4.15057 15.1867 3.56046 15.5507 3.1965L16.2105 2.53665C16.5745 2.17268 17.1646 2.17268 17.5286 2.53665L21.4856 6.49369C21.8496 6.85766 21.8496 7.44777 21.4856 7.81174L20.8257 8.47159Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "flag-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5.25 21.2637V4.19367M19.25 14.2837V4.26367C19.25 4.26367 18.375 4.99067 15.75 4.99067C13.125 4.99067 11.375 3.26367 8.75 3.26367C6.125 3.26367 5.25 4.19567 5.25 4.19567M5.25 14.2637C5.25 14.2637 6.125 13.5367 8.75 13.5367C11.375 13.5367 13.125 15.2637 15.75 15.2637C18.375 15.2637 19.25 14.2867 19.25 14.2867", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "folder_copy-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4 11.5324V8.26367C4 7.71139 4.44772 7.26367 5 7.26367M5 7.26367H19M5 7.26367V4.26367C5 3.71139 5.44772 3.26367 6 3.26367H18C18.5523 3.26367 19 3.71139 19 4.26367V7.26367M19 7.26367C19.5523 7.26367 20 7.71139 20 8.26367V13.5321M7 17.2637H9M3 19.2637V13.2637C3 12.1591 3.89543 11.2637 5 11.2637H11.1716C11.702 11.2637 12.2107 11.4744 12.5858 11.8495L13.4142 12.6779C13.7893 13.053 14.298 13.2637 14.8284 13.2637H19C20.1046 13.2637 21 14.1591 21 15.2637V19.2637C21 20.3682 20.1046 21.2637 19 21.2637H5C3.89543 21.2637 3 20.3682 3 19.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "folder_delete-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7.5 18.5L4.5 15.5M4.5 18.5L7.5 15.5M3 12V6C3 4.89543 3.89543 4 5 4H9.47056C9.80157 4 10.1111 4.1638 10.2973 4.43748L11.7432 6.56248C11.9294 6.83618 12.239 7 12.57 7H19C20.1046 7 21 7.89543 21 9V18C21 19.1046 20.1046 20 19 20H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "folder_edit-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M17.225 19.25H19.225C20.3296 19.25 21.225 18.3546 21.225 17.25V8.19C21.225 7.08543 20.3296 6.19 19.225 6.19H12.7542C12.4232 6.19 12.1136 6.0262 11.9274 5.75253L10.5224 3.68747C10.3362 3.41379 10.0266 3.24999 9.69558 3.25H5.22504C4.12047 3.25 3.22504 4.14543 3.22504 5.25V15.25M9.51793 17.5844L12.5594 14.5429C12.747 14.3554 13.0013 14.25 13.2666 14.25C13.5318 14.25 13.7861 14.3554 13.9737 14.5429L14.9322 15.5014C15.3227 15.8919 15.3227 16.5251 14.9322 16.9156L11.8906 19.9571C11.7031 20.1446 11.4487 20.25 11.1835 20.25H9.72504C9.44889 20.25 9.22504 20.0262 9.22504 19.75V18.2915C9.22504 18.0263 9.33039 17.772 9.51793 17.5844Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M6.32502 20.2501C6.32499 20.2777 6.3026 20.3 6.275 20.3C6.24741 20.3 6.22504 20.2776 6.22502 20.25C6.22501 20.2224 6.24737 20.2 6.27496 20.2C6.28825 20.2 6.30099 20.2053 6.31038 20.2146C6.31977 20.224 6.32504 20.2368 6.32502 20.2501", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M3.32502 20.2501C3.32499 20.2777 3.3026 20.3 3.275 20.3C3.24741 20.3 3.22504 20.2776 3.22502 20.25C3.22501 20.2224 3.24737 20.2 3.27496 20.2C3.28825 20.2 3.30099 20.2053 3.31038 20.2146C3.31977 20.224 3.32504 20.2368 3.32502 20.2501", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "format_paint-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.28628 12.3368L3.57145 17.1725C3.07615 17.5916 2.77897 18.1989 2.75201 18.8472C2.72504 19.4954 2.97076 20.1253 3.42954 20.5841C3.88832 21.0429 4.51825 21.2886 5.16651 21.2617C5.81476 21.2347 6.42211 20.9375 6.84121 20.4422L11.6768 14.7274M16.8106 14.3243L9.68933 7.20303M14.75 3.55658L20.4571 9.2637C20.8476 9.65422 20.8476 10.2874 20.4571 10.6779L15.4571 15.6779C14.676 16.459 13.4097 16.459 12.6286 15.6779L8.33573 11.385C7.55468 10.604 7.55468 9.33764 8.33573 8.55659L13.3358 3.55655C13.7263 3.16603 14.3594 3.16605 14.75 3.55658Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "for_sale-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M8.75 8.01367H19.75V6.51367H8.75V8.01367ZM21 9.26367V16.2637H22.5V9.26367H21ZM19.75 17.5137H8.75V19.0137H19.75V17.5137ZM7.5 16.2637V9.26367H6V16.2637H7.5ZM8.75 17.5137C8.05964 17.5137 7.5 16.954 7.5 16.2637H6C6 17.7825 7.23122 19.0137 8.75 19.0137V17.5137ZM21 16.2637C21 16.954 20.4404 17.5137 19.75 17.5137V19.0137C21.2688 19.0137 22.5 17.7825 22.5 16.2637H21ZM19.75 8.01367C20.4404 8.01367 21 8.57332 21 9.26367H22.5C22.5 7.74489 21.2688 6.51367 19.75 6.51367V8.01367ZM8.75 6.51367C7.23122 6.51367 6 7.74489 6 9.26367H7.5C7.5 8.57332 8.05964 8.01367 8.75 8.01367V6.51367Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M10.25 5.76364V7.26356M17.25 5.76364V7.26364M2.75 21.2637V6.26367C2.75 4.60682 4.09315 3.26367 5.75 3.26367H20.75M11.75 14.0137V12.4435C11.75 12.2157 11.8536 12.0002 12.0315 11.8579L13.1253 10.9828C13.4905 10.6906 14.0095 10.6906 14.3747 10.9828L15.4685 11.8579C15.6464 12.0002 15.75 12.2157 15.75 12.4435V14.0137C15.75 14.4279 15.4142 14.7637 15 14.7637H12.5C12.0858 14.7637 11.75 14.4279 11.75 14.0137Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "foundation-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19.7575 7.81702V18.2754M21.7583 9.27164L12.3794 2.4538C12.0293 2.2003 11.556 2.2003 11.2059 2.4538L1.75 9.27164M21.7583 18.2754H1.75M18.1986 21.5139L5.30975 21.5139M3.75082 7.82904V18.2754M11.7542 2.62785V21.5114", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "gite-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M17.0413 6.226L20.8235 11.5948M13.7993 10.8276V18.753M3.29019 10.8276V17.753C3.29019 18.3052 3.73791 18.753 4.29019 18.753H19.101C19.6533 18.753 20.101 18.3052 20.101 17.753V10.5456M2.75 11.5948L6.53219 6.226H17.0085L13.2865 11.5948H2.75ZM9.81083 7.94569V5.26367H8.48124V7.94569H9.81083Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "goal-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.251 14.2644C10.1464 14.2644 9.25095 13.3689 9.25095 12.2644C9.25095 11.1598 10.1464 10.2644 11.251 10.2644M15.251 12.2644L17.1045 14.1179C17.1983 14.2117 17.3255 14.2644 17.4581 14.2644H20.7502C20.9319 14.2644 21.0994 14.1657 21.1875 14.0068C21.2756 13.8478 21.2705 13.6535 21.1742 13.4994L20.4023 12.2644L21.1742 11.0294C21.2705 10.8752 21.2756 10.681 21.1875 10.522C21.0994 10.363 20.9319 10.2644 20.7502 10.2644H17.4581C17.3255 10.2644 17.1983 10.317 17.1045 10.4108L15.251 12.2644ZM15.251 12.2644H13.251M15.018 8.26437C12.839 6.20793 9.4148 6.274 7.3167 8.41298C5.2186 10.552 5.2186 13.9768 7.3167 16.1158C9.4148 18.2547 12.839 18.3208 15.018 16.2644M18.7333 7.26437C16.5309 3.96814 12.4311 2.50114 8.63751 3.65188C4.84391 4.80262 2.25 8.30008 2.25 12.2644C2.25 16.2287 4.84391 19.7261 8.63751 20.8769C12.4311 22.0276 16.5309 20.5606 18.7333 17.2644", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "grade-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.98502 21.104C7.47795 21.3687 6.86451 21.3221 6.40324 20.9839C5.94197 20.6456 5.71311 20.0745 5.81312 19.5114L6.62246 14.8724L3.21504 11.6071C2.79854 11.2099 2.6459 10.6095 2.82213 10.0616C2.99837 9.5137 3.47242 9.11488 4.04238 9.03499L8.77335 8.35871L10.9092 4.09794C11.1625 3.58695 11.6835 3.26367 12.2538 3.26367C12.8241 3.26367 13.3451 3.58695 13.5984 4.09794L15.7343 8.35871L20.4652 9.03499C21.0352 9.11488 21.5092 9.5137 21.6855 10.0616C21.8617 10.6095 21.7091 11.2099 21.2926 11.6071L17.8851 14.8724L18.6945 19.5124C18.7945 20.0755 18.5656 20.6466 18.1044 20.9849C17.6431 21.3231 17.0297 21.3697 16.5226 21.105L12.2538 18.8991L7.98502 21.104Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "group-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M1.75 19.2765C1.75 17.0765 3.55 15.2765 5.75 15.2765H9.75C11.95 15.2765 13.75 17.0765 13.75 19.2765M15.75 14.2765H18.75C20.45 14.2765 21.75 15.5765 21.75 17.2765M10.25 6.27652C11.65 7.67652 11.65 9.87652 10.25 11.1765C8.85 12.4765 6.65 12.5765 5.35 11.1765C4.05 9.77652 3.95 7.67652 5.25 6.27652C6.55 4.87652 8.85 4.97652 10.25 6.27652ZM19.05 6.97652C20.05 7.97652 20.05 9.57652 19.05 10.4765C18.05 11.3765 16.45 11.4765 15.55 10.4765C14.65 9.47652 14.55 7.87652 15.55 6.97652C16.45 6.07652 18.05 6.07652 19.05 6.97652Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "groups-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M22.75 19.2637V18.1677C22.75 16.7867 21.631 15.6677 20.25 15.6677H19.449M0.75 19.2637V18.1677C0.75 16.7867 1.869 15.6677 3.25 15.6677H4.051M17.089 19.2637V17.6627C17.089 15.7297 15.522 14.1627 13.589 14.1627H9.91C7.977 14.1627 6.41 15.7297 6.41 17.6627V19.2637M20.5425 9.78719C21.3325 10.5772 21.3325 11.8581 20.5425 12.6481C19.7525 13.4382 18.4716 13.4382 17.6816 12.6481C16.8915 11.8581 16.8915 10.5772 17.6816 9.78719C18.4716 8.99716 19.7525 8.99716 20.5425 9.78719ZM13.9526 6.17603C15.1691 7.39251 15.1691 9.36482 13.9526 10.5813C12.7361 11.7978 10.7638 11.7978 9.54732 10.5813C8.33084 9.36483 8.33084 7.39252 9.54732 6.17603C10.7638 4.95955 12.7361 4.95955 13.9526 6.17603ZM5.81848 9.78719C6.60851 10.5772 6.60851 11.8581 5.81848 12.6481C5.02845 13.4382 3.74756 13.4382 2.95753 12.6481C2.1675 11.8581 2.1675 10.5772 2.95753 9.78719C3.74756 8.99716 5.02845 8.99716 5.81848 9.78719Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "hamburger-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4 17.2635H12M4 11.7636H20M4 6.26367H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "hamburger_open-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10 17.4999H20M4 12H20M4 12L7 9.00002M4 12L7 15M10 6.50006H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "handshake-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19.0376 15.0903H17.6855C17.3179 15.09 16.9545 15.1689 16.6201 15.3216L11.2137 17.7839M21.2348 6.8115C20.0568 6.8115 19.1019 7.76642 19.1019 8.94436V14.632C19.1019 15.8099 20.0568 16.7649 21.2348 16.7649M2.75 16.7649C3.92795 16.7649 4.88286 15.81 4.88286 14.6321V8.94444C4.88286 7.76649 3.92795 6.81157 2.75 6.81157M19.6782 7.41997L15.2744 5.48141C14.4824 5.13283 13.568 5.20625 12.8417 5.67676L9.48766 7.84985C8.98361 8.17653 8.65981 8.71874 8.61124 9.31743C8.56267 9.91612 8.79483 10.5034 9.23962 10.9071C9.817 11.4299 10.6514 11.556 11.3575 11.227L13.357 10.2928L14.7627 11.5686C15.1734 11.9414 15.4193 12.4621 15.4461 13.0162C15.473 13.5703 15.2786 14.1124 14.9057 14.5232C14.8623 14.571 14.8167 14.6167 14.769 14.6604L11.7905 17.3866C10.8115 18.2825 9.3114 18.2859 8.32841 17.3944L6.53788 15.7704C6.0971 15.3791 5.54295 15.1387 4.95608 15.0842M4.91164 8.30971L8.01647 7.19067C8.73056 6.94031 9.51888 7.01937 10.169 7.40655", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "handshake_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3.817 15.75H5.334C5.688 15.75 6.027 15.61 6.277 15.36C6.527 15.11 6.667 14.771 6.667 14.417V9.083C6.667 8.729 6.527 8.39 6.277 8.14C6.027 7.89 5.688 7.75 5.334 7.75H4.065M19.935 7.75H18.667C18.313 7.75 17.974 7.89 17.724 8.14C17.474 8.39 17.334 8.729 17.334 9.083V14.417C17.334 14.771 17.474 15.11 17.724 15.36C17.974 15.61 18.313 15.75 18.667 15.75H20.184M17.354 14.647H16.494C16.208 14.647 15.925 14.708 15.665 14.827L11.458 16.743M10.645 8.668C10.141 8.375 9.532 8.302 8.97 8.504L6.667 9.333M17.494 8.436L14.618 7.17C14.002 6.899 13.29 6.956 12.725 7.322L10.115 9.013C9.285 9.55 9.19 10.728 9.922 11.392C10.371 11.799 11.021 11.897 11.57 11.641L13.126 10.915L13.916 11.631C14.789 12.422 14.792 13.792 13.924 14.588L11.907 16.434C11.146 17.132 9.978 17.134 9.214 16.441L7.828 15.184C7.5 14.887 7.082 14.72 6.643 14.684M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "handshake_square-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M18.5 5.49999L19.5 4.49999M19.5 8.49999H20.9142M15.5 4.39999V2.98578M15 12.5V8.99999M15 8.99999H11.5M15 8.99999L14.1738 10.0169C12.6403 11.9042 10.3381 13 7.90635 13C6.65269 13 5.41624 12.7081 4.29493 12.1474L4 12M20 12V18.2222C20 19.204 19.2041 20 18.2222 20H5.77778C4.79594 20 4 19.204 4 18.2222V5.77777C4 4.79593 4.79594 3.99999 5.77778 3.99999H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "handyman-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.8268 7.92894V6.6194L12.0605 5.85308C11.7134 5.50606 11.2428 5.31104 10.752 5.31085H10.0177C9.83052 5.31111 9.6617 5.1985 9.59005 5.02562C9.5184 4.85274 9.55807 4.65372 9.69052 4.52152L10.864 3.34803C11.5582 2.65373 12.4998 2.26367 13.4816 2.26367C14.4634 2.26367 15.405 2.65373 16.0992 3.34803L18.7163 5.96512L18.4192 6.97354L19.3706 7.92594H20.6801L21.2413 8.48717C21.4398 8.68502 21.5514 8.95374 21.5514 9.23398C21.5514 9.51423 21.4398 9.78295 21.2413 9.9808L18.8093 12.4138C18.3968 12.8261 17.7282 12.8261 17.3157 12.4138L16.7535 11.8516V10.543L15.8011 9.59163L14.7906 9.89176M12.8268 7.92894L14.7906 9.89176M12.8268 7.92894L3.3589 16.0984C2.85919 16.5298 2.56159 17.1497 2.53748 17.8094C2.51338 18.4691 2.76495 19.1091 3.23185 19.5758C3.7016 20.0454 4.34651 20.2968 5.01012 20.269C5.67373 20.2413 6.2954 19.9369 6.7243 19.4297L14.7906 9.89176M5.88086 7.84777V5.45577C5.88222 5.00229 5.59268 4.59903 5.16256 4.45535L3.03567 3.74706C2.84612 3.68255 2.63638 3.73188 2.49545 3.87411L1.9042 4.46536C1.76314 4.6057 1.7139 4.81391 1.77715 5.00258L2.48545 7.12947C2.62913 7.55958 3.03238 7.84912 3.48586 7.84777H5.88086ZM5.88086 7.84777L7.49 9.45691M14.8396 16.8065L13.3099 15.4109M11.8433 16.9606L14.2503 19.3676V20.6711L14.9936 21.4144C15.1907 21.6118 15.4581 21.7226 15.7369 21.7226C16.0158 21.7226 16.2832 21.6118 16.4802 21.4144L17.9679 19.9268L19.4505 18.4472C19.6478 18.2502 19.7587 17.9827 19.7587 17.7039C19.7587 17.425 19.6478 17.1576 19.4505 16.9606L18.7072 16.2173H17.4066L14.9936 13.8043", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "hand_key-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M6.75 20.2714H8.25863C8.58576 20.2714 8.9109 20.3114 9.22803 20.3915L11.8791 21.0537C12.4544 21.1978 13.0536 21.2118 13.6349 21.0958L16.5661 20.5095C17.3404 20.3544 18.0527 19.9733 18.6109 19.4151L20.6848 17.3412C21.277 16.7499 21.277 15.7905 20.6848 15.1983C20.1516 14.6651 19.3072 14.605 18.704 15.0572L16.287 16.87C15.9408 17.1301 15.5197 17.2702 15.0865 17.2702H12.7525L14.2381 17.2697C15.0755 17.2697 15.7537 16.5915 15.7537 15.7541V15.451C15.7537 14.7557 15.2806 14.1494 14.6063 13.9814L12.3133 13.4081C11.9402 13.3151 11.558 13.2681 11.1738 13.2681C10.2465 13.2681 9.33908 13.5422 8.56776 14.0574L6.75 15.2689M13.2019 4.43858L8.57501 4.44158C8.3099 4.44158 8.05579 4.54763 7.86872 4.7347L7.04337 5.56005C6.65221 5.95121 6.65221 6.58448 7.04337 6.97464L7.87172 7.80298C8.0588 7.99006 8.3139 8.0961 8.57901 8.0951L13.2049 8.0921L13.2159 8.0931C13.8792 9.38064 15.2068 10.269 16.7564 10.267C18.9653 10.261 20.7561 8.46526 20.7561 6.25734C20.7571 4.04842 18.9683 2.26167 16.7594 2.26367C15.2158 2.26768 13.8912 3.15705 13.2249 4.43958M5.75125 21.2716H3.75042C3.19819 21.2716 2.75 20.8234 2.75 20.2712V14.2687C2.75 13.7164 3.19819 13.2683 3.75042 13.2683H5.75125C6.30348 13.2683 6.75167 13.7164 6.75167 14.2687V20.2712C6.75167 20.8234 6.30348 21.2716 5.75125 21.2716Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M16.7554 6.52914C16.8994 6.52914 17.0155 6.41209 17.0155 6.26803C17.0155 6.12397 16.8974 6.00692 16.7544 6.00692C16.6103 6.00692 16.4932 6.12397 16.4932 6.26803C16.4932 6.41209 16.6103 6.52914 16.7554 6.52914", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "headset_mic-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M18 17.2637H19C20.105 17.2637 21 16.3687 21 15.2637V12.2637C21 11.1587 20.105 10.2637 19 10.2637H18C17.448 10.2637 17 10.7117 17 11.2637V16.2637C17 16.8157 17.448 17.2637 18 17.2637ZM18 17.2637V18.2637C18 19.3687 17.105 20.2637 16 20.2637H13.875M18.5 10.2637V9.76367C18.5 6.17367 15.59 3.26367 12 3.26367C8.41 3.26367 5.5 6.17367 5.5 9.76367V10.2637M13.875 20.2637C13.875 19.5737 13.315 19.0137 12.625 19.0137H11.375C10.685 19.0137 10.125 19.5737 10.125 20.2637C10.125 20.9537 10.685 21.5137 11.375 21.5137H12.625C13.315 21.5137 13.875 20.9537 13.875 20.2637ZM6 17.2637H5C3.895 17.2637 3 16.3687 3 15.2637V12.2637C3 11.1587 3.895 10.2637 5 10.2637H6C6.552 10.2637 7 10.7117 7 11.2637V16.2637C7 16.8157 6.552 17.2637 6 17.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "help-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M12 13.5137V13.2637C12 12.4467 12.505 12.0037 13.011 11.6637C13.505 11.3307 14 10.8967 14 10.0967C14 8.99168 13.105 8.09668 12 8.09668C10.895 8.09668 10 8.99168 10 10.0967M12 21.2637C7.029 21.2637 3 17.2347 3 12.2637C3 7.29267 7.029 3.26367 12 3.26367C16.971 3.26367 21 7.29267 21 12.2637C21 17.2347 16.971 21.2637 12 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M12.01 16.2637L12.005 16.2687L12 16.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "history-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M6.5 12.2637L4.25 14.5137L2 12.2637M4.485 14.2787C4.336 13.6297 4.25 12.9577 4.25 12.2637C4.25 7.29267 8.279 3.26367 13.25 3.26367C18.221 3.26367 22.25 7.29267 22.25 12.2637C22.25 17.2347 18.221 21.2637 13.25 21.2637C10.198 21.2637 7.506 19.7417 5.879 17.4187M16.621 15.1347L12.969 12.9617V8.24867", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "history_edu-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 17.0137C2 16.0472 2.7835 15.2637 3.75 15.2637H13.75C14.7165 15.2637 15.5 16.0472 15.5 17.0137V20.0137C15.5 20.9802 14.7165 21.7637 13.75 21.7637H3.75C2.7835 21.7637 2 20.9802 2 20.0137V17.0137ZM3.75 16.7637C3.61193 16.7637 3.5 16.8756 3.5 17.0137V20.0137C3.5 20.1517 3.61193 20.2637 3.75 20.2637H13.75C13.8881 20.2637 14 20.1517 14 20.0137V17.0137C14 16.8756 13.8881 16.7637 13.75 16.7637H3.75Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M5 16.2637V14.2637C5 13.7114 5.44772 13.2637 6 13.2637H11C11.5523 13.2637 12 13.7114 12 14.2637V16.2637M8.91422 10.2637H12.8149C16.9085 10.2637 20.4768 7.47762 21.4697 3.50621C21.5443 3.20747 21.4772 2.89098 21.2877 2.64826C21.0982 2.40554 20.8074 2.26367 20.4995 2.26367H19.5C13.4249 2.26367 8.5 7.18854 8.5 13.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.5 20.4522V16.4522C9.5 15.0715 10.6193 13.9522 12 13.9522C13.3807 13.9522 14.5 15.0715 14.5 16.4522V20.4522C14.5 20.5903 14.6119 20.7022 14.75 20.7022H20C20.1381 20.7022 20.25 20.5903 20.25 20.4522V11.4152C20.25 11.1215 20.1209 10.8427 19.897 10.6527L12.647 4.50116C12.2738 4.18451 11.7262 4.18451 11.353 4.50116L4.10302 10.6527C3.87909 10.8427 3.75 11.1215 3.75 11.4152V20.4522C3.75 20.5903 3.86193 20.7022 4 20.7022H9.25C9.38807 20.7022 9.5 20.5903 9.5 20.4522Z", stroke: "currentColor" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_add-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M21 11.0001V16.0001C21 18.7615 18.7614 21.0001 16 21.0001H8C5.23858 21.0001 3 18.7615 3 16.0001L3 8.00006C3 5.23864 5.23858 3.00006 8 3.00006L13 3.00006M19 7.00006V3.00006M17 5.00006H21M8 14.5001V11.5001C8.00001 11.0444 8.20716 10.6134 8.563 10.3288L11.063 8.32876C11.6108 7.8905 12.3893 7.8905 12.9371 8.32876L15.4371 10.3288C15.7929 10.6134 16 11.0444 16 11.5001V14.5001C16 15.3285 15.3284 16.0001 14.5 16.0001H9.5C8.67157 16.0001 8 15.3285 8 14.5001Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_edit-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.75 16.2637H13.75M18.75 21.2637C19.8546 21.2637 20.75 20.3683 20.75 19.2637V10.469C20.75 9.8537 20.4668 9.27265 19.9821 8.89359L13.5982 3.90059C12.5124 3.05136 10.9876 3.05136 9.90179 3.90059L3.51788 8.89359C3.03321 9.27265 2.75 9.8537 2.75 10.469V19.2637C2.75 20.3683 3.64543 21.2637 4.75 21.2637H18.75ZM7.75 13.6191L10.8104 10.5588C10.9993 10.3698 11.2555 10.2637 11.5227 10.2637C11.7899 10.2637 12.0462 10.3698 12.2351 10.5588L13.4549 11.7786C13.6439 11.9675 13.75 12.2238 13.75 12.4909C13.75 12.7581 13.6439 13.0144 13.4549 13.2033L10.3945 16.2637H7.75V13.6191Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_hide-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19.7575 8.81702V15.5646M21.7583 10.2716L12.3794 3.4538C12.0293 3.2003 11.556 3.2003 11.2059 3.4538L9.15285 4.93411M6.47797 6.86272L1.75 10.2716M3.75082 8.82904V18.2754C3.75082 18.8277 4.19853 19.2754 4.75082 19.2754H18.9005M3.43871 3.31567L20.0696 19.9466", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_house_basket_buy-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8 10H9.174L10.075 14.5H14.905L15.5 11.508V11.5H9.474M14.4061 16.9205C14.4243 16.9388 14.4242 16.9682 14.4059 16.9864C14.3877 17.0046 14.3582 17.0045 14.34 16.9863C14.3218 16.9681 14.3218 16.9386 14.3399 16.9204C14.3581 16.9022 14.3879 16.9024 14.4061 16.9205ZM10.6467 16.9205C10.6648 16.9388 10.6647 16.9683 10.6465 16.9864C10.6282 17.0046 10.5987 17.0045 10.5805 16.9863C10.5623 16.9681 10.5623 16.9386 10.5805 16.9204C10.5986 16.9022 10.6284 16.9024 10.6467 16.9205ZM3 17V11.1C3 9.73298 3.6214 8.44008 4.68886 7.5861L9.18886 3.9861C10.8323 2.6713 13.1677 2.6713 14.8111 3.9861L19.3111 7.5861C20.3786 8.44008 21 9.73298 21 11.1V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_message-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 20.4991C3.00002 20.6904 3.10916 20.8649 3.28114 20.9486C3.45311 21.0324 3.65778 21.0106 3.80835 20.8927L7.5 18H18C19.6569 18 21 16.6569 21 15V6C21 4.34315 19.6569 3 18 3H6C4.34315 3 3 4.34315 3 6V20.4991Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M14.2969 7.75C14.2969 8.99264 13.2895 10 12.0469 10C10.8042 10 9.79688 8.99264 9.79688 7.75C9.79688 6.50736 10.8042 5.5 12.0469 5.5C13.2895 5.5 14.2969 6.50736 14.2969 7.75Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 15V14.5C16 13.3954 15.1046 12.5 14 12.5H10C8.89543 12.5 8 13.3954 8 14.5V15C8 15.2761 8.22386 15.5 8.5 15.5H15.5C15.7761 15.5 16 15.2761 16 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_percent-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.5 16.0137L14 11.5137M9.375 11.7637C9.375 11.8327 9.31904 11.8887 9.25 11.8887C9.18096 11.8887 9.125 11.8327 9.125 11.7637M14.125 15.7637C14.125 15.6947 14.181 15.6387 14.25 15.6387C14.319 15.6387 14.375 15.6947 14.375 15.7637M20.75 19.2637V10.469C20.75 9.8537 20.4668 9.27265 19.9821 8.89359L13.5982 3.90059C12.5124 3.05136 10.9876 3.05136 9.90179 3.90059L3.51788 8.89359C3.03321 9.27265 2.75 9.8537 2.75 10.469L2.75 19.2637C2.75 20.3683 3.64543 21.2637 4.75 21.2637H18.75C19.8546 21.2637 20.75 20.3683 20.75 19.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_price_down-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.2412 13.2637L15.2688 15.2637M15.2688 15.2637H13.2412M15.2688 15.2637L12.2688 12.2637L9.76878 14.2637L7.76878 12.2637M2.75 17.2637V11.3637C2.75 9.99665 3.3714 8.70375 4.43886 7.84977L8.93886 4.24977C10.5823 2.93497 12.9177 2.93497 14.5611 4.24977L19.0611 7.84977C20.1286 8.70375 20.75 9.99665 20.75 11.3637V17.2637C20.75 19.4728 18.9591 21.2637 16.75 21.2637H6.75C4.54086 21.2637 2.75 19.4728 2.75 17.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_price_up-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.2412 14.2637L15.2688 12.2637M15.2688 12.2637H13.2412M15.2688 12.2637L12.2688 15.2637L9.76878 13.2637L7.76878 15.2637M2.75 17.2637V11.3637C2.75 9.99665 3.3714 8.70375 4.43886 7.84977L8.93886 4.24977C10.5823 2.93497 12.9177 2.93497 14.5611 4.24977L19.0611 7.84977C20.1286 8.70375 20.75 9.99665 20.75 11.3637V17.2637C20.75 19.4728 18.9591 21.2637 16.75 21.2637H6.75C4.54086 21.2637 2.75 19.4728 2.75 17.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_share-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3 11V7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V17C21 19.2091 19.2091 21 17 21H15M14 10L17 7.00001M17 7.00001L14 7M17 7.00001V10M3.69434 14.5253L6.34434 12.4054C7.01998 11.8649 7.98002 11.8649 8.65566 12.4054L11.3057 14.5253C11.7445 14.8764 12 15.4079 12 15.9699V19.65C12 20.008 11.8578 20.3514 11.6046 20.6046C11.3514 20.8578 11.008 21 10.65 21H4.35C3.60442 21 3 20.3956 3 19.65V15.9699C3 15.4079 3.25548 14.8764 3.69434 14.5253Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_shield-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10.75 13.0001L11.75 14.0001L13.25 12.5001M21 17.0001V11.1001C21 9.73304 20.3786 8.44014 19.3111 7.58616L14.8111 3.98616C13.1677 2.67136 10.8323 2.67136 9.18886 3.98616L4.68886 7.58616C3.6214 8.44014 3 9.73304 3 11.1001L3 17.0001C3 19.2092 4.79086 21.0001 7 21.0001H17C19.2091 21.0001 21 19.2092 21 17.0001ZM11.4705 17.9476C9.16181 17.4859 7.50001 15.4588 7.5 13.1045V11.5001C7.5 10.1193 8.61929 9.00006 10 9.00006H14C15.3807 9.00006 16.5 10.1194 16.5 11.5001V13.1044C16.5 15.4588 14.8383 17.4858 12.5296 17.9476C12.1801 18.0175 11.82 18.0175 11.4705 17.9476Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_size-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.75 9.26367H19.75C20.3023 9.26367 20.75 8.81596 20.75 8.26367V4.26367C20.75 3.71139 20.3023 3.26367 19.75 3.26367H3.75C3.19772 3.26367 2.75 3.71139 2.75 4.26367V20.2637C2.75 20.816 3.19772 21.2637 3.75 21.2637H7.75C8.30228 21.2637 8.75 20.816 8.75 20.2637V3.26367M6.75002 18.2637H8.75M6.75002 14.2637H8.75M6.75002 10.2637H8.75M6.75002 6.26367H8.75M13.75 7.26367V9.26367M17.75 7.26367V9.26367M13.5405 16.1124V19.7637C13.5421 20.3153 13.9889 20.762 14.5405 20.7637H19.0405C19.5928 20.7637 20.0405 20.3159 20.0405 19.7637V16.1791M20.75 16.7636L17.3859 13.9918C17.0166 13.6875 16.4834 13.6875 16.1141 13.9918L12.75 16.7636", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "home_stars-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.75293 20.2708V15.2687C9.75293 14.7162 10.2008 14.2683 10.7533 14.2683H12.7542M2.75 10.8471L10.4516 4.24559C11.2009 3.60332 12.3066 3.60332 13.0559 4.24559L20.7575 10.8471M11.7537 20.2707H2.75M15.3789 6.23673V4.01398C15.3789 3.5996 15.7148 3.26367 16.1292 3.26367L18.7212 3.26367C19.1356 3.26367 19.4715 3.5996 19.4715 4.01398V9.74476M4.03634 9.74478L4.03634 20.2708M18.2568 21.2712C18.2568 19.3374 16.6892 17.7697 14.7554 17.7697C16.6892 17.7697 18.2568 16.2021 18.2568 14.2683C18.2568 16.2021 19.8245 17.7697 21.7583 17.7697C19.8245 17.7697 18.2568 19.3374 18.2568 21.2712Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "hotel_class-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.6471 19.1772L19.6161 20.2032C19.9991 20.4032 20.4471 20.0802 20.3741 19.6572L19.9981 17.4822L21.5911 15.9422C21.9011 15.6422 21.7301 15.1192 21.3011 15.0572L19.1001 14.7392L18.1151 12.7582C17.9231 12.3722 17.3691 12.3722 17.1781 12.7582L16.1931 14.7392L13.9921 15.0572C13.5641 15.1192 13.3921 15.6422 13.7021 15.9422L15.2951 17.4822L14.9191 19.6572C14.8461 20.0802 15.2941 20.4042 15.6771 20.2032L17.6471 19.1772Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.75 10.9712L13.719 11.9972C14.102 12.1972 14.55 11.8742 14.477 11.4512L14.101 9.27617L15.694 7.73617C16.004 7.43617 15.833 6.91317 15.404 6.85117L13.2041 6.53417L12.219 4.55317C12.027 4.16717 11.4731 4.16717 11.2821 4.55317L10.298 6.53417L8.09605 6.85217C7.66805 6.91417 7.49605 7.43717 7.80605 7.73717L9.39905 9.27717L9.02305 11.4522C8.95005 11.8752 9.39805 12.1992 9.78105 11.9982L11.75 10.9712Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.85306 19.1772L7.82205 20.2032C8.20505 20.4032 8.65305 20.0802 8.58005 19.6572L8.20405 17.4822L9.79706 15.9422C10.1071 15.6422 9.93605 15.1192 9.50705 15.0572L7.30606 14.7392L6.32105 12.7582C6.12905 12.3722 5.57505 12.3722 5.38405 12.7582L4.39906 14.7392L2.19805 15.0572C1.77005 15.1192 1.59805 15.6422 1.90805 15.9422L3.50105 17.4822L3.12505 19.6572C3.05205 20.0802 3.50005 20.4042 3.88305 20.2032L5.85306 19.1772Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "hourglass_top-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5 3.26367H18.5206M5.00021 21.2911H18.5208M7.25389 3.26367V7.77053M7.25389 7.77053C7.25389 8.48036 7.5874 9.14737 8.15526 9.57327L11.7607 12.2774M7.25389 7.77053H16.2676M11.7607 12.2774L15.3662 9.57327C15.9341 9.14737 16.2676 8.48036 16.2676 7.77053M11.7607 12.2774L15.3662 14.9815C15.9341 15.4074 16.2676 16.0744 16.2676 16.7842V21.2911M11.7607 12.2774L8.15526 14.9815C7.5874 15.4074 7.25389 16.0744 7.25389 16.7842V21.2911M16.2676 7.77053V3.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "house-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4.66919 9.31647V20.2637H19.2292V9.42847M2.75 10.6637L11.87 4.26367L20.99 10.6637M14.5102 20.2637V15.7837C14.5102 14.8237 13.7102 14.0237 12.7502 14.0237H10.9902C10.0302 14.0237 9.23022 14.8237 9.23022 15.7837V20.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "houseboat-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.75 18.6535C3.85046 18.1533 5.25104 18.1533 6.3515 18.6535C7.45196 19.1537 8.85254 19.1537 9.953 18.6535C11.0535 18.1533 12.454 18.1533 13.5545 18.6535C14.655 19.1537 16.0555 19.1537 17.156 18.6535C18.2565 18.1533 19.657 18.1533 20.7575 18.6535M6.3515 21.6547C7.45196 22.1549 8.85254 22.1549 9.953 21.6547C11.0535 21.1545 12.454 21.1545 13.5545 21.6547C14.655 22.1549 16.0555 22.1549 17.156 21.6547M19.657 18.3284L20.7575 15.027H3.50031L5.14499 18.3173M6.12167 6.21613V14.7794M17.511 14.7794V6.30374M4.61978 7.26998L11.7538 2.26367L18.8878 7.26998M13.8189 14.7794V11.275C13.8189 10.5241 13.1931 9.89828 12.4422 9.89828H11.0654C10.3145 9.89828 9.68869 10.5241 9.68869 11.275V14.7794", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "house_certificate-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.0013 21.0037H17.7164C18.8219 21.0037 19.7172 20.1083 19.7172 19.0029V3.99663C19.7172 3.4444 19.2691 2.99622 18.7168 2.99622L16.8591 2.99622C16.3068 2.99622 15.8586 3.4444 15.8586 3.99663V6.30359M2.99628 10.7134L10.6975 4.11268C11.4468 3.47041 12.5523 3.47041 13.3016 4.11268L21.0038 10.7134M9.55501 16.2247L7.6092 18.1705L6.44172 17.003M3.2714 17.8164L3.93567 18.6858L4.07973 19.7672C4.15977 20.3675 4.63096 20.8396 5.23121 20.9197L6.31567 21.0647L7.18403 21.729C7.66423 22.0962 8.33151 22.0962 8.81171 21.729L9.68107 21.0647H9.68007L10.7625 20.9207C11.3628 20.8406 11.835 20.3695 11.915 19.7692L12.0601 18.6848C12.0601 18.6848 12.3962 18.2456 12.7243 17.8164C13.0915 17.3362 13.0915 16.6689 12.7243 16.1887L12.0601 15.3193L11.916 14.2379C11.836 13.6376 11.3648 13.1655 10.7645 13.0854L9.68007 12.9404L8.81171 12.2761C8.33151 11.9089 7.66423 11.9089 7.18403 12.2761L6.31466 12.9404H6.31567L5.23321 13.0844C4.63296 13.1645 4.16077 13.6356 4.08073 14.2359L3.93567 15.3203C3.93567 15.3203 3.59953 15.7595 3.2714 16.1887C2.90424 16.6689 2.90424 17.3352 3.2714 17.8164Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "house_checkmark-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19.471 8.87843V3.26409C19.471 2.71186 19.0228 2.26367 18.4706 2.26367H16.6128C16.0606 2.26367 15.6124 2.71186 15.6124 3.26409V5.57105M2.75 9.98089L10.4512 3.38014C11.2005 2.73787 12.306 2.73787 13.0553 3.38014L20.7575 9.98089M4.03656 8.87842V18.2703C4.03656 19.3758 4.93193 20.2712 6.03739 20.2712H10.7534M19.0348 15.8804L16.8119 18.1033L15.4773 16.7697M17.256 21.2716C14.77 21.2716 12.7542 19.2557 12.7542 16.7697C12.7542 14.2837 14.77 12.2678 17.256 12.2678C19.7431 12.2678 21.7579 14.2837 21.7579 16.7697C21.7579 19.2557 19.7431 21.2716 17.256 21.2716Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "house_complete-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.5 10.5L12 14L10.5 12.5M13.5151 8.78483C13.0314 8.59942 12.5181 8.50292 12 8.49996C9.51472 8.49996 7.5 10.5147 7.5 13C7.5 15.4852 9.51472 17.5 12 17.5C14.4853 17.5 16.5 15.4852 16.5 13M19 21C20.1046 21 21 20.1045 21 19V10.2053C21 9.58996 20.7168 9.00892 20.2321 8.62986L13.8482 3.63686C12.7624 2.78763 11.2376 2.78763 10.1518 3.63686L3.76788 8.62986C3.28321 9.00892 3 9.58997 3 10.2053L3 19C3 20.1045 3.89543 21 5 21H19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "house_exterior-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.75 16.6312H20.75M21.75 21.1312H1.75M11.75 21.1312V16.6312M15.75 16.6312V12.1312M7.75 16.6312V12.1312M5.58496 7.63116H17.7605M2.75 12.1312H20.75M11.75 12.1312V7.63116M2.75 21.1312V10.1567M20.75 10.1567V21.1312M21.7584 10.2716L12.3795 3.4538C12.0294 3.2003 11.5561 3.2003 11.206 3.4538L1.75006 10.2716", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "house_garage-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.99852 15.0012H15.001M8.99852 18.0025H15.001M2.99602 21.0037V10.0322C2.99602 9.30558 3.39024 8.63619 4.02545 8.28344L11.5146 4.1227C11.8166 3.95495 12.1839 3.95495 12.486 4.1227L19.9741 8.28244C20.6096 8.63537 21.0037 9.30522 21.0035 10.0322V21.0037M22.0039 21.0037H1.99561M5.99727 21.0037V13.0004C5.99727 12.4479 6.44517 12 6.99769 12H17.0019C17.5544 12 18.0023 12.4479 18.0023 13.0004V21.0037M9.99894 8.99873H14.0006", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "image-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.5 16.0137C21.5 19.1893 18.9256 21.7637 15.75 21.7637H7.75C4.57436 21.7637 2 19.1893 2 16.0137V8.01367C2 4.83804 4.57436 2.26367 7.75 2.26367H15.75C18.9256 2.26367 21.5 4.83804 21.5 8.01367V16.0137ZM15.75 20.2637C18.0972 20.2637 20 18.3609 20 16.0137V8.01367C20 5.66646 18.0972 3.76367 15.75 3.76367H7.75C5.40279 3.76367 3.5 5.66646 3.5 8.01367V16.0137C3.5 18.3609 5.40279 20.2637 7.75 20.2637H15.75Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M3 18.1311L7.28168 13.8495C7.65675 13.4744 8.16546 13.2637 8.6959 13.2637C9.22633 13.2637 9.73504 13.4744 10.1101 13.8495L17.2569 20.9963M20.6396 14.9692L17.5198 11.8495C17.1448 11.4744 16.6361 11.2637 16.1056 11.2637C15.5752 11.2637 15.0665 11.4744 14.6914 11.8495L11.4026 15.1382", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M8.41569 8.67557L8.41591 8.67536C8.46466 8.62894 8.54181 8.63081 8.58826 8.67953C8.63471 8.72825 8.63289 8.8054 8.5842 8.85188C8.5355 8.89836 8.45836 8.89659 8.41185 8.84792C8.36534 8.79926 8.36706 8.72211 8.41569 8.67557", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "image_search-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M21.0075 13.7685V16.7697C21.0075 18.9798 19.2159 20.7714 17.0058 20.7714H7.00167C4.79161 20.7714 3 18.9798 3 16.7697V6.76555C3 4.55549 4.79161 2.76389 7.00167 2.76389H10.0029M3 12.7694L4.2957 11.4737C4.74804 11.0213 5.36154 10.7672 6.00125 10.7672C6.64095 10.7672 7.25445 11.0213 7.70679 11.4737L12.0037 15.7706M7.00586 20.7714L13.3023 14.4749C14.2443 13.533 15.7715 13.533 16.7134 14.4749L20.6542 18.4157M19.5068 8.26617L21.0075 9.7668M19.4818 3.28924C20.8492 4.65665 20.8492 6.87364 19.4818 8.24104C18.1143 9.60844 15.8974 9.60844 14.53 8.24104C13.1625 6.87364 13.1625 4.65665 14.5299 3.28924C15.1866 2.63258 16.0772 2.26367 17.0059 2.26367C17.9345 2.26367 18.8251 2.63258 19.4818 3.28924Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "inbox-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3 15.2637H7.382C7.76093 15.2637 8.10731 15.4779 8.27662 15.8169L8.72294 16.7105C8.89225 17.0495 9.23861 17.2637 9.61753 17.2637H14.3815C14.7602 17.2637 15.1065 17.0497 15.2759 16.7109L15.7231 15.8165C15.8925 15.4777 16.2388 15.2637 16.6175 15.2637H21M18 3.26367C19.6569 3.26367 21 4.60682 21 6.26367V18.2637C21 19.9205 19.6569 21.2637 18 21.2637H6C4.34315 21.2637 3 19.9205 3 18.2637V6.26367C3 4.60682 4.34315 3.26367 6 3.26367H18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "info-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10.9995 15.7651H13.3098M12.159 15.7651V11.5134H11.0085M12.0999 8.50937C12.0999 8.6475 11.9879 8.75948 11.8498 8.75948C11.7117 8.75948 11.5997 8.6475 11.5997 8.50937C11.5997 8.37124 11.7117 8.25927 11.8498 8.25927M12 21.2637C7.02943 21.2637 3 17.2342 3 12.2637C3 7.2931 7.02943 3.26367 12 3.26367C16.9706 3.26367 21 7.2931 21 12.2637C21 17.2342 16.9706 21.2637 12 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "insert_chart-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.25208 3.26367V7.26534C8.25208 7.81785 7.80418 8.26576 7.25167 8.26576H3.25M10.7531 16.2691V12.5175H7.75187V16.2691H10.7531ZM10.7531 16.2691L13.7544 16.2691M10.7531 16.2691V8.26575H13.7544V16.2691M13.7544 16.2691H16.7556V10.5167H13.7544L13.7544 16.2691ZM5.25083 21.2712H19.2567C20.3617 21.2712 21.2575 20.3754 21.2575 19.2703V5.26451C21.2575 4.15948 20.3617 3.26367 19.2567 3.26367H8.08001C7.54989 3.26367 7.04148 3.47427 6.66642 3.84892L3.83624 6.67909C3.46074 7.05448 3.25 7.56373 3.25 8.09468V19.2703C3.25 20.3754 4.1458 21.2712 5.25083 21.2712Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "insert_emoticon-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.75 9.26367V10.2637M15.75 9.26367V10.2637M18.6139 5.89971C22.1287 9.41443 22.1287 15.1129 18.6139 18.6276C15.0992 22.1423 9.40074 22.1423 5.88604 18.6276C2.37132 15.1129 2.37132 9.41441 5.88604 5.89971C9.40076 2.38499 15.0992 2.38499 18.6139 5.89971ZM12.25 17.2637C13.917 17.2637 15.25 15.9307 15.25 14.2637H9.25C9.25 15.9307 10.583 17.2637 12.25 17.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 51 50", id: "instagram-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M0.100098 25C0.100098 11.1929 11.293 0 25.1001 0C38.9072 0 50.1001 11.1929 50.1001 25C50.1001 38.8071 38.9072 50 25.1001 50C11.293 50 0.100098 38.8071 0.100098 25Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.5943 13C15.5587 13 13.1001 15.4598 13.1001 18.4942V31.5058C13.1001 34.5413 15.5599 37 18.5943 37H31.6059C34.6416 37 37.1001 34.54 37.1001 31.5072V18.4942C37.1001 15.4585 34.6401 13 31.6073 13H18.5943ZM18.5943 11H31.6073C35.7447 11 39.1001 14.3539 39.1001 18.4942V31.5072C39.1001 35.6446 35.7462 39 31.6059 39H18.5943C14.4556 39 11.1001 35.6462 11.1001 31.5058V18.4942C11.1001 14.3555 14.4539 11 18.5943 11Z", fill: "#F2F2F2" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.0693 22.0302C26.4291 20.39 23.7698 20.39 22.1296 22.0302C20.4894 23.6704 20.4894 26.3297 22.1296 27.9699C23.7698 29.6101 26.4291 29.6101 28.0693 27.9699C29.7095 26.3297 29.7095 23.6704 28.0693 22.0302ZM29.4835 20.616C27.0622 18.1947 23.1366 18.1947 20.7154 20.616C18.2941 23.0372 18.2941 26.9628 20.7154 29.3841C23.1366 31.8053 27.0622 31.8053 29.4835 29.3841C31.9047 26.9628 31.9047 23.0372 29.4835 20.616Z", fill: "#F2F2F2" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.1203 17.8535L33.7367 17.8568C33.7411 17.026 33.067 16.3643 32.2504 16.3632L32.2485 16.3632L32.2458 16.3632L32.2431 16.3632L32.2412 16.3633C31.4264 16.3687 30.7617 17.0301 30.7617 17.8515C30.7617 18.6763 31.4328 19.3382 32.2499 19.3382C33.0709 19.3382 33.7367 18.6724 33.7367 17.8515H33.1214", fill: "#F2F2F2" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "in_progress-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4 12.2637H20M8 16.1167H16M12 21.2637C7.02943 21.2637 3 17.2342 3 12.2637C3 7.2931 7.02943 3.26367 12 3.26367C16.9706 3.26367 21 7.2931 21 12.2637C21 17.2342 16.9706 21.2637 12 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "ios_share-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8 10.2637H6C4.895 10.2637 4 11.1587 4 12.2637V19.2637C4 20.3687 4.895 21.2637 6 21.2637H18C19.105 21.2637 20 20.3687 20 19.2637V12.2637C20 11.1587 19.105 10.2637 18 10.2637H16M12 3.26367V14.2637M12 3.26367L9.001 6.26367M12 3.26367L15 6.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "keyboard-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M17.251 13.9457C17.351 13.9457 17.433 13.8647 17.432 13.7637C17.432 13.6637 17.351 13.5817 17.25 13.5817C17.149 13.5817 17.068 13.6627 17.068 13.7637C17.068 13.8647 17.15 13.9457 17.251 13.9457", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M10.2295 13.9037H13.7695M17.9185 18.2637H6.08051C4.79351 18.2637 3.74951 17.2207 3.74951 15.9327V8.59467C3.74951 7.30667 4.79251 6.26367 6.08051 6.26367H17.9195C19.2065 6.26367 20.2505 7.30667 20.2505 8.59467V15.9337C20.2495 17.2207 19.2065 18.2637 17.9185 18.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M17.251 10.9457C17.351 10.9457 17.433 10.8647 17.432 10.7637C17.432 10.6637 17.351 10.5817 17.25 10.5817C17.149 10.5817 17.068 10.6627 17.068 10.7637C17.068 10.8647 17.15 10.9457 17.251 10.9457", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M13.751 10.9457C13.851 10.9457 13.933 10.8647 13.932 10.7637C13.932 10.6637 13.851 10.5817 13.75 10.5817C13.65 10.5817 13.568 10.6627 13.568 10.7637C13.569 10.8647 13.65 10.9457 13.751 10.9457", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M10.251 10.9457C10.351 10.9457 10.433 10.8647 10.432 10.7637C10.432 10.6637 10.351 10.5817 10.25 10.5817C10.15 10.5817 10.068 10.6627 10.068 10.7637C10.069 10.8647 10.15 10.9457 10.251 10.9457", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M6.751 10.9457C6.851 10.9457 6.933 10.8647 6.932 10.7637C6.932 10.6637 6.851 10.5817 6.75 10.5817C6.649 10.5817 6.568 10.6627 6.568 10.7637C6.568 10.8647 6.65 10.9457 6.751 10.9457", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M6.751 13.9457C6.851 13.9457 6.933 13.8647 6.932 13.7637C6.932 13.6637 6.851 13.5817 6.75 13.5817C6.649 13.5817 6.568 13.6627 6.568 13.7637C6.568 13.8647 6.65 13.9457 6.751 13.9457", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "kitchen-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19.25 11.3737H4.75M16 6.26367V8.26367M16 14.2637V16.2637M17.25 21.2637H6.75C5.645 21.2637 4.75 20.3687 4.75 19.2637V4.26367C4.75 3.15867 5.645 2.26367 6.75 2.26367H17.25C18.355 2.26367 19.25 3.15867 19.25 4.26367V19.2637C19.25 20.3687 18.355 21.2637 17.25 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "landscape-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M22.25 20.2638L15.6333 7.79504C15.4599 7.46816 15.1201 7.2638 14.75 7.2638C14.3799 7.2638 14.0401 7.46816 13.8667 7.79504L7.25 20.2638M18.3303 12.8774L16.5401 13.8774L14.75 12.8774L12.9598 13.8774L11.1697 12.8774M23.25 20.2638H1.25M10.2097 14.6865L8.628 11.7852C8.45283 11.4637 8.11604 11.2637 7.75 11.2637C7.38396 11.2637 7.04717 11.4637 6.872 11.7852L2.25 20.2638M8.68506 3.78247C9.60978 3.8786 10.2968 4.68272 10.2475 5.61111C10.1981 6.5395 9.4297 7.26625 8.5 7.26379H4.75C3.92157 7.26379 3.25 6.59222 3.25 5.76379C3.25 4.93537 3.92157 4.26379 4.75 4.26379C4.74826 3.25357 5.50139 2.40124 6.50414 2.27858C7.5069 2.15593 8.44325 2.80161 8.68506 3.78247Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "language-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7 4.26367V7.26367M20 20.2637L16 11.2637L12 20.2637M12.89 18.2637H19.11M3 15.2637C7.095 14.9397 10.676 11.3587 11.001 7.26367H3.001M11 15.2637C8.441 15.0617 6.202 12.8227 6 10.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "laptop_windows-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.875 15.0137H20.625M9.47076 18.2637H14.0292M3.25006 14.2637L1.46118 17.8414C1.32234 18.1191 1.25003 18.4253 1.25 18.7357V19.7587C1.24998 20.583 1.91518 21.2529 2.7395 21.2587L3.45006 21.2637H20.0499L20.7553 21.2612C21.5817 21.2583 22.2501 20.5875 22.25 19.7611V18.7357C22.25 18.4253 22.1777 18.1191 22.0389 17.8414L20.25 14.2637V5.26367C20.25 4.1591 19.3546 3.26367 18.25 3.26367H5.25C4.14543 3.26367 3.25 4.1591 3.25 5.26367L3.25006 14.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "layers-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.686 14.7477L21.25 17.2397L12.237 21.2637L3.25 17.2397L8.814 14.7547M15.686 9.77267L21.25 12.2637L12.237 16.2877L3.25 12.2637L8.814 9.77967M3.25 7.28767L12.237 11.3127L21.25 7.28767L12.263 3.26367L3.25 7.28767Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "lightbulb-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.49993 20.7615H15.4999M9.03993 15.2115H15.9499M15.4989 16.9205V17.9865H9.49893V16.9205C9.49893 15.8635 9.00893 14.8765 8.19393 14.2025C6.78293 13.0335 5.85493 11.3035 5.75793 9.35152C5.57293 5.61052 8.64793 2.32152 12.3929 2.26452C16.1699 2.20552 19.2499 5.24852 19.2499 9.01152C19.2499 11.1135 18.2869 12.9875 16.7789 14.2235C15.9699 14.8865 15.4989 15.8745 15.4989 16.9205Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "linear_scale-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5.79028 12.0137H10.3938M13.7073 12.0137H18.3108M5.23743 10.7763C5.92085 11.4597 5.92085 12.5677 5.23743 13.2511C4.55402 13.9346 3.44597 13.9346 2.76256 13.2511C2.07915 12.5677 2.07915 11.4597 2.76256 10.7763C3.44598 10.0929 4.55402 10.0929 5.23743 10.7763ZM10.256 12.0137C10.256 11.0477 11.039 10.2637 12.006 10.2637C12.973 10.2637 13.756 11.0467 13.756 12.0137C13.756 12.9807 12.973 13.7637 12.006 13.7637C11.043 13.7677 10.26 12.9907 10.256 12.0277C10.256 12.0227 10.256 12.0187 10.256 12.0137ZM21.2494 10.7762C21.9328 11.4597 21.9328 12.5677 21.2494 13.2511C20.566 13.9345 19.4579 13.9345 18.7745 13.2511C18.0911 12.5677 18.0911 11.4597 18.7745 10.7762C19.4579 10.0928 20.566 10.0928 21.2494 10.7762Z", stroke: "currentColor", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "link-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M13.2647 18.2784L11.7353 19.8078C9.79415 21.749 6.64697 21.749 4.70584 19.8078C2.76472 17.8667 2.76472 14.7195 4.70584 12.7784L6.69975 10.7845C7.63743 9.84682 8.9092 9.32004 10.2353 9.32004C11.5614 9.32004 12.8331 9.84682 13.7708 10.7845M11.2353 6.24895L12.7647 4.71951C14.7058 2.77839 17.853 2.77839 19.7941 4.71951C21.7353 6.66064 21.7353 9.80782 19.7941 11.7489L17.8002 13.7428C15.8476 15.6955 12.6818 15.6955 10.7292 13.7428", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 51 50", id: "linkedin-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M0.100098 25C0.100098 11.1929 11.293 0 25.1001 0C38.9072 0 50.1001 11.1929 50.1001 25C50.1001 38.8071 38.9072 50 25.1001 50C11.293 50 0.100098 38.8071 0.100098 25Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.1868 18.2174C16.6477 18.2174 17.7955 17.0696 17.7955 15.6087C17.7955 14.1478 16.6477 13 15.1868 13C13.726 13 12.5781 14.1478 12.5781 15.6087C12.5781 17.0696 13.726 18.2174 15.1868 18.2174ZM13.5781 37C13.0258 37 12.5781 36.5523 12.5781 36V21.3043C12.5781 20.7521 13.0258 20.3043 13.5781 20.3043H16.7955C17.3478 20.3043 17.7955 20.7521 17.7955 21.3043V36C17.7955 36.5523 17.3478 37 16.7955 37H13.5781ZM20.926 21.3043C20.926 20.7521 21.3737 20.3043 21.926 20.3043H25.1433C25.6956 20.3043 26.1433 20.7521 26.1433 21.3043V22.6C28.3346 18.5304 37.6216 18.2174 37.6216 26.4609V36C37.6216 36.5523 37.1739 37 36.6216 37H33.4042C32.8519 37 32.4042 36.5523 32.4042 36V28.2348C32.4042 22.913 26.1433 23.3304 26.1433 28.2348V36C26.1433 36.5523 25.6956 37 25.1433 37H21.926C21.3737 37 20.926 36.5523 20.926 36V21.3043Z", fill: "#F2F2F2" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "list-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.22455 12.2639H21.0075M9.22455 5.76431H21.0075M9.22455 18.7666H21.0075M5.25094 13.7645H3.75031C3.33599 13.7643 3.00015 13.4285 3 13.0142V11.5135C3.00015 11.0992 3.33599 10.7634 3.75031 10.7632H5.25094C5.66526 10.7634 6.0011 11.0992 6.00125 11.5135V13.0142C6.0011 13.4285 5.66526 13.7643 5.25094 13.7645ZM5.25094 7.26492H3.75031C3.33599 7.26477 3.00015 6.92893 3 6.51461V5.01398C3.00015 4.59966 3.33599 4.26382 3.75031 4.26367H5.25094C5.66526 4.26382 6.0011 4.59966 6.00125 5.01398V6.51461C6.0011 6.92893 5.66526 7.26477 5.25094 7.26492ZM5.25094 20.2672H3.75031C3.33599 20.267 3.00015 19.9312 3 19.5169V18.0163C3.00015 17.6019 3.33599 17.2661 3.75031 17.2659H5.25094C5.66526 17.2661 6.0011 17.6019 6.00125 18.0163V19.5169C6.0011 19.9312 5.66526 20.267 5.25094 20.2672Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "list_alt-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 8.01367C2 4.83803 4.57436 2.26367 7.75 2.26367H15.75C18.9256 2.26367 21.5 4.83803 21.5 8.01367V16.0137C21.5 19.1893 18.9256 21.7637 15.75 21.7637H7.75C4.57436 21.7637 2 19.1893 2 16.0137V8.01367ZM7.75 3.76367C5.40279 3.76367 3.5 5.66646 3.5 8.01367V16.0137C3.5 18.3609 5.40279 20.2637 7.75 20.2637H15.75C18.0972 20.2637 20 18.3609 20 16.0137V8.01367C20 5.66646 18.0972 3.76367 15.75 3.76367H7.75Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M16.755 15.2687H11.255M16.755 11.7687H11.255M16.755 8.26867H11.255M8.01 15.2687L8.005 15.2737L8 15.2687L8.005 15.2637L8.01 15.2687ZM8.01 11.7687L8.005 11.7737L8 11.7687L8.005 11.7637L8.01 11.7687ZM8.01 8.26867L8.005 8.27367L8 8.26867L8.005 8.26367L8.01 8.26867Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "local_cafe-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M6.74999 3.26367V6.26367M10.25 3.26367V6.26367M13.75 3.26367V6.26367M16.75 17.2637H18.75C20.4069 17.2637 21.75 15.9205 21.75 14.2637V11.7637C21.75 10.383 20.6307 9.26367 19.25 9.26367H15.75M15.75 9.26367H3.75C3.19772 9.26367 2.75 9.71139 2.75 10.2637V17.7637C2.75 19.6967 4.317 21.2637 6.25 21.2637H13.25C15.183 21.2637 16.75 19.6967 16.75 17.7637V10.2637C16.75 9.71139 16.3023 9.26367 15.75 9.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "local_fire_department-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.807 11.3415C9.81296 12.3356 8.13924 12.063 7.51046 10.8072L6.76901 9.32069C5.47691 10.6128 4.75 12.3665 4.75 14.1965V14.3691C4.75 18.2726 7.9139 21.4365 11.8174 21.4365C15.721 21.4365 18.8849 18.2726 18.8849 14.3691C18.8849 12.4537 18.018 10.6419 16.526 9.44063L15.4302 8.55743C14.3216 7.66332 13.5457 6.42212 13.2295 5.03371L12.826 3.26367C10.9342 5.15547 10.1128 7.86868 10.638 10.4928L10.807 11.3415Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "local_florist-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M17.25 12.0917V13.2637C17.25 16.0247 15.011 18.2637 12.25 18.2637M12.25 18.2637C9.489 18.2637 7.25 16.0247 7.25 13.2637V11.5047M12.25 18.2637V21.2637M16.25 6.26367C17.907 6.26367 19.25 7.60667 19.25 9.26367C19.25 10.9207 17.907 12.2637 16.25 12.2637H9.75C7.265 12.2637 5.25 10.2487 5.25 7.76367C5.25 5.27867 7.265 3.26367 9.75 3.26367H13.25C14.907 3.26367 16.25 4.60667 16.25 6.26367ZM16.25 6.26367C16.25 7.92067 14.907 9.26367 13.25 9.26367H10.328C9.5 9.26367 8.828 8.59167 8.828 7.76367C8.828 6.93567 9.5 6.26367 10.328 6.26367H12.358", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "local_gas_station-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7.25 14.2637H11.25M3.25 20.2637V4.26367C3.25 3.15867 4.145 2.26367 5.25 2.26367H13.25C14.355 2.26367 15.25 3.15867 15.25 4.26367V20.2637M19.25 4.26367L20.664 5.67767C21.039 6.05267 21.25 6.56167 21.25 7.09167V16.7637C21.25 17.5917 20.578 18.2637 19.75 18.2637C18.922 18.2637 18.25 17.5917 18.25 16.7637V15.2637C18.25 14.7117 17.802 14.2637 17.25 14.2637H15.25M21.25 11.2637H19.383C18.782 11.2637 18.316 10.7367 18.391 10.1397L18.641 8.13967C18.703 7.63967 19.128 7.26367 19.633 7.26367H21.25M2.25 20.2637H16.25M6.25 6.26367H12.25V10.2637H6.25V6.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "local_laundry-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M20.53 8.26367H2.75M8.286 16.7637C7.785 15.8957 8.04 14.7887 8.87 14.2277L8.871 14.2267C9.537 13.7757 10.414 13.7907 11.064 14.2637L12.436 15.2627C13.086 15.7357 13.963 15.7507 14.629 15.2997L14.63 15.2987C15.46 14.7377 15.714 13.6307 15.214 12.7627M15.75 5.76367H17.75M4.75 21.2637H18.529C19.634 21.2637 20.529 20.3687 20.529 19.2637V5.26367C20.529 4.15867 19.634 3.26367 18.529 3.26367H4.75C3.645 3.26367 2.75 4.15867 2.75 5.26367V19.2637C2.75 20.3687 3.645 21.2637 4.75 21.2637ZM14.5784 11.9353C16.1405 13.4974 16.1405 16.03 14.5784 17.5921C13.0163 19.1542 10.4836 19.1542 8.92155 17.5921C7.35945 16.03 7.35945 13.4974 8.92155 11.9353C10.4837 10.3732 13.0163 10.3732 14.5784 11.9353Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "local_offer-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M20 10.2637L13.494 3.84067C13.119 3.47067 12.615 3.26367 12.089 3.26367H8M12.21 6.55367L19.42 13.7637C20.192 14.5357 20.192 15.7877 19.42 16.5597L15.296 20.6837C14.524 21.4557 13.272 21.4557 12.5 20.6837L5.29 13.4737C5.105 13.2887 5 13.0367 5 12.7747V7.25267C5 6.70667 5.443 6.26367 5.989 6.26367H11.512C11.774 6.26367 12.025 6.36767 12.21 6.55367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M8.75951 10.5042C8.90283 10.6475 8.90283 10.8799 8.75951 11.0232C8.61619 11.1665 8.38381 11.1665 8.24049 11.0232C8.09717 10.8799 8.09717 10.6475 8.24049 10.5042C8.38381 10.3608 8.61619 10.3608 8.75951 10.5042", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "local_printshop-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7.25 8.26367V4.26367C7.25 3.71167 7.698 3.26367 8.25 3.26367H16.25C16.802 3.26367 17.25 3.71167 17.25 4.26367V8.26367M7.25 17.2637H5.25C4.145 17.2637 3.25 16.3687 3.25 15.2637V10.2637C3.25 9.15867 4.145 8.26367 5.25 8.26367H19.25C20.355 8.26367 21.25 9.15867 21.25 10.2637V15.2637C21.25 16.3687 20.355 17.2637 19.25 17.2637H17.25M7.25 11.2637H8.25M7.25 14.0637H17.25V20.2637C17.25 20.8157 16.802 21.2637 16.25 21.2637H8.25C7.698 21.2637 7.25 20.8157 7.25 20.2637V14.0637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "local_shipping-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16.3315 18.2637H8.16046M19.1567 18.2637H21.25C21.8023 18.2637 22.25 17.816 22.25 17.2637V11.6493C22.25 11.3948 22.2014 11.1427 22.1069 10.9064L20.7523 7.52073C20.4485 6.7615 19.7131 6.26367 18.8954 6.26367H15.25M5.33159 18.2637H3.25C2.69772 18.2637 2.25 17.816 2.25 17.2637V11.2637M22.25 13.2637H18.75C18.4739 13.2637 18.25 13.0398 18.25 12.7637V9.26367H21.45M7.80661 17.703C8.23563 18.1319 8.364 18.7771 8.13185 19.3376C7.89971 19.8981 7.35278 20.2636 6.74608 20.2637C6.13939 20.2637 5.59242 19.8983 5.36022 19.3378C5.12801 18.7773 5.25632 18.1321 5.68529 17.7031C6.27094 17.1174 7.22096 17.1173 7.80661 17.703ZM2.25 14.2637H14.25C14.8023 14.2637 15.25 13.816 15.25 13.2637V5.26367C15.25 4.71139 14.8023 4.26367 14.25 4.26367H3.25022C2.69794 4.26367 2.25023 4.71137 2.25022 5.26365L2.25 14.2637ZM19.246 18.7636C19.246 19.592 18.5744 20.2636 17.746 20.2636C16.9176 20.2636 16.246 19.592 16.246 18.7636C16.246 17.9352 16.9176 17.2636 17.746 17.2636C18.5744 17.2636 19.246 17.9352 19.246 18.7636Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "location-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 13.2637C10.843 13.2637 9.5 11.9207 9.5 10.2637C9.5 8.60667 10.843 7.26367 12.5 7.26367C14.157 7.26367 15.5 8.60667 15.5 10.2637C15.5 11.9207 14.157 13.2637 12.5 13.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 21.2637C12.5 21.2637 5.5 15.5137 5.5 10.2637C5.5 6.39767 8.634 3.26367 12.5 3.26367C16.366 3.26367 19.5 6.39767 19.5 10.2637C19.5 15.5137 12.5 21.2637 12.5 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "location_off-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M6.03192 6.60362C5.37744 7.66855 5 8.92203 5 10.2637C5 15.5137 12 21.2637 12 21.2637C12 21.2637 14.3825 19.3066 16.3676 16.6336M18.2063 13.5733C18.6925 12.4865 19 11.3641 19 10.2637C19 6.39767 15.866 3.26367 12 3.26367C10.8114 3.26367 9.69199 3.55992 8.71158 4.0826M3.5 3.76367L20.5 20.7637M12 13.2637C10.343 13.2637 9 11.9207 9 10.2637C9 8.60667 10.343 7.26367 12 7.26367C13.657 7.26367 15 8.60667 15 10.2637C15 11.9207 13.657 13.2637 12 13.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "lock-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.5 10.2637V7.26367C8.5 5.05467 10.291 3.26367 12.5 3.26367C14.709 3.26367 16.5 5.05467 16.5 7.26367V10.2637M12.5 14.2637V17.2637M17.5 21.2637H7.5C6.395 21.2637 5.5 20.3687 5.5 19.2637V12.2637C5.5 11.1587 6.395 10.2637 7.5 10.2637H17.5C18.605 10.2637 19.5 11.1587 19.5 12.2637V19.2637C19.5 20.3687 18.605 21.2637 17.5 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "lock_open-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.5 14.2637V17.2637M8.634 6.28667C9.072 4.55267 10.63 3.26367 12.5 3.26367C14.709 3.26367 16.5 5.05467 16.5 7.26367V10.2637M17.5 21.2637H7.5C6.395 21.2637 5.5 20.3687 5.5 19.2637V12.2637C5.5 11.1587 6.395 10.2637 7.5 10.2637H17.5C18.605 10.2637 19.5 11.1587 19.5 12.2637V19.2637C19.5 20.3687 18.605 21.2637 17.5 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "lock_open_right-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M13.291 10.0967V7.59667C13.291 5.20367 15.231 3.26367 17.624 3.26367C20.017 3.26367 21.957 5.20367 21.957 7.59667V9.76367M9.498 14.0967V17.0967M14.5 21.0967H4.5C3.395 21.0967 2.5 20.2017 2.5 19.0967V12.0967C2.5 10.9917 3.395 10.0967 4.5 10.0967H14.5C15.605 10.0967 16.5 10.9917 16.5 12.0967V19.0967C16.5 20.2017 15.605 21.0967 14.5 21.0967Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "login-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M21 11.2637H15M15 11.2637L17 9.26367M15 11.2637L17 13.2637M11 19.2637H15C16.105 19.2637 17 18.3687 17 17.2637V16.2637M17 6.26367V5.26367C17 4.15867 16.105 3.26367 15 3.26367H5M11 19.2617V7.76668C11 7.07668 10.645 6.43568 10.06 6.07068L6.06 3.57068C4.728 2.73868 3 3.69568 3 5.26668V16.7607C3 17.4507 3.355 18.0917 3.94 18.4567L7.94 20.9567C9.272 21.7897 11 20.8317 11 19.2617Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "logout-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15 11.2637H21M21 11.2637L19 13.2637M21 11.2637L19 9.26367M11 19.2637H15C16.105 19.2637 17 18.3687 17 17.2637V16.2637M17 6.26367V5.26367C17 4.15867 16.105 3.26367 15 3.26367H5M11 19.6557V7.76667C11 7.07667 10.645 6.43567 10.06 6.07067L6.06 3.57067C4.728 2.73867 3 3.69567 3 5.26667V17.1547C3 17.8447 3.355 18.4857 3.94 18.8507L7.94 21.3507C9.272 22.1837 11 21.2257 11 19.6557Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "lot_size-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.75 9.26367H19.75C20.3023 9.26367 20.75 8.81596 20.75 8.26367V4.26367C20.75 3.71139 20.3023 3.26367 19.75 3.26367H3.75C3.19772 3.26367 2.75 3.71139 2.75 4.26367V20.2637C2.75 20.816 3.19772 21.2637 3.75 21.2637H7.75C8.30228 21.2637 8.75 20.816 8.75 20.2637V3.26367M6.75001 18.2637H8.74999M6.75002 14.2637H8.75M6.75002 10.2637H8.75M6.75001 6.26367H8.74999M13.75 7.26367V9.26367M17.75 7.26367V9.26367M16.0632 17.0736V21.4436M18.75 15.936C18.75 17.9145 17.5471 19.5184 16.0632 19.5184C14.5794 19.5184 13.3765 17.9145 13.3765 15.936C13.3765 13.9575 14.5794 12.3536 16.0632 12.3536C17.5471 12.3536 18.75 13.9575 18.75 15.936Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "lower_cost-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M6.74637 17.9611L4.87318 19.8343M4.87318 19.8343L3 17.9611M4.87318 19.8343L4.87329 14.2147M10.7871 19.7434C14.2184 20.8038 17.9447 19.5732 20.0696 16.6779C22.1945 13.7827 22.2511 9.85885 20.2106 6.90347C18.1701 3.94809 14.4809 2.61054 11.0205 3.57154C7.56006 4.53254 5.08885 7.58093 4.86453 11.1653M13.3179 8.59926V7.59884M13.3179 14.6018V15.6022M11.5831 13.8875C11.8402 14.3263 12.309 14.5976 12.8176 14.6018H13.9181C14.6388 14.6199 15.2556 14.088 15.3435 13.3725C15.4315 12.6569 14.9619 11.9915 14.2582 11.8346L12.3834 11.3634C11.6882 11.2005 11.2268 10.5406 11.3125 9.83168C11.3982 9.12275 12.0035 8.59181 12.7176 8.59925H13.818C14.327 8.6027 14.7966 8.87415 15.0535 9.31355", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "mail-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M17.0975 9.37937L12.5923 12.0678C12.3151 12.2332 11.9745 12.2332 11.6972 12.0678L7.19746 9.38259M5.8 18.3886C4.80589 18.3886 4 17.5491 4 16.5136V7.13867C4 6.10314 4.80589 5.26367 5.8 5.26367H18.4C19.3941 5.26367 20.2 6.10314 20.2 7.13867V16.5136C20.2 17.0109 20.0103 17.4878 19.6728 17.8395C19.3352 18.1911 18.8773 18.3886 18.3999 18.3886L5.8 18.3886Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "manufactured_home-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4.44271 19.2835H3.59446C2.8538 19.2835 2.22391 18.8286 2.11124 18.2125L1.77501 17.2143C1.61225 16.3528 2.25939 15.5297 3.26507 15.319L21.7583 15.3244V18.0205C21.7583 18.7181 21.0864 19.2836 20.2576 19.2836H16.083M12.2029 19.3602H8.69077M19.2937 21.0563V19.5846M6.1221 6.21613V15.2003M17.5114 15.2003V6.30804M4.62021 7.26998L11.7542 2.26367L18.8882 7.26998M13.8193 14.7795V11.2751C13.8193 10.5241 13.1935 9.89832 12.4426 9.89832H11.0659C10.3149 9.89832 9.68912 10.5241 9.68912 11.2751V14.7795M8.15606 19.2789C8.15606 20.2458 7.37223 21.0296 6.40533 21.0296C5.43843 21.0296 4.6546 20.2458 4.6546 19.2789C4.6546 18.312 5.43843 17.5281 6.40533 17.5281C7.37223 17.5281 8.15606 18.312 8.15606 19.2789ZM15.9 19.2789C15.9 20.2458 15.1162 21.0296 14.1493 21.0296C13.1824 21.0296 12.3985 20.2458 12.3985 19.2789C12.3985 18.312 13.1824 17.5281 14.1493 17.5281C15.1162 17.5281 15.9 18.312 15.9 19.2789Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "map-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.5 4.27355V17.7435M9.5 6.04355V20.2635M16.132 4.36655L20.816 5.92755C21.225 6.06355 21.5 6.44555 21.5 6.87655V18.8815C21.5 19.6245 20.718 20.1085 20.053 19.7755L16.395 17.9465C15.832 17.6645 15.169 17.6645 14.606 17.9465L10.395 20.0525C9.832 20.3345 9.169 20.3345 8.606 20.0525L4.053 17.7765C3.714 17.6065 3.5 17.2605 3.5 16.8815V5.54255C3.5 4.85955 4.169 4.37755 4.816 4.59355L8.867 5.94355C9.278 6.08055 9.721 6.08055 10.132 5.94355L14.867 4.36555C15.278 4.22955 15.722 4.22955 16.132 4.36655Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "markunread_mailbox-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M13.75 2.26367V1.51367C13.3358 1.51367 13 1.84946 13 2.26367H13.75ZM18.75 2.26367H19.5C19.5 1.84946 19.1642 1.51367 18.75 1.51367V2.26367ZM18.75 5.26367V6.01367C19.1642 6.01367 19.5 5.67789 19.5 5.26367H18.75ZM13.75 5.26367H13C13 5.67789 13.3358 6.01367 13.75 6.01367V5.26367ZM13.75 3.01367H18.75V1.51367H13.75V3.01367ZM18 2.26367V5.26367H19.5V2.26367H18ZM18.75 4.51367H13.75V6.01367H18.75V4.51367ZM14.5 5.26367V2.26367H13V5.26367H14.5Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M13.75 18.2637V22.2637H9.75V11.7637C9.75 9.83067 8.183 8.26367 6.25 8.26367M5.75 12.2637H6.75M6.25 8.26367H17.25C19.183 8.26367 20.75 9.83067 20.75 11.7637V17.2637C20.75 17.8157 20.302 18.2637 19.75 18.2637H3.75C3.198 18.2637 2.75 17.8157 2.75 17.2637V11.7637C2.75 9.83067 4.317 8.26367 6.25 8.26367ZM13.75 5.26367V12.2637M13.749 11.8887C13.542 11.8897 13.375 12.0577 13.375 12.2647C13.375 12.4717 13.543 12.6397 13.75 12.6387C13.957 12.6387 14.125 12.4707 14.125 12.2637C14.125 12.0567 13.957 11.8887 13.749 11.8887Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "maximize-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3 12.2636H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "medical_services-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.75 13.7637H14.75M12.25 11.2637V16.2637M16.25 7.26367L15.629 4.77867C15.406 3.88867 14.606 3.26367 13.688 3.26367H10.811C9.893 3.26367 9.093 3.88867 8.871 4.77867L8.25 7.26367M5.25 7.26367H19.25C20.355 7.26367 21.25 8.15867 21.25 9.26367V18.2637C21.25 19.3687 20.355 20.2637 19.25 20.2637H5.25C4.145 20.2637 3.25 19.3687 3.25 18.2637V9.26367C3.25 8.15867 4.145 7.26367 5.25 7.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "menu-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4 17.2635H20M4 11.7636H20M4 6.26367H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "menu_minimized-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M17.4545 9.27274H6.54541M17.4545 14.7273H6.54541", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "military-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16.25 3.26367V11.0037M8.25 11.0037V3.26367M10.312 12.1857L6.255 9.85967C5.634 9.50367 5.25 8.84167 5.25 8.12467V5.26367C5.25 4.15867 6.145 3.26367 7.25 3.26367H17.25C18.355 3.26367 19.25 4.15867 19.25 5.26367V8.12467C19.25 8.84167 18.867 9.50367 18.245 9.85967L14.188 12.1857M12.249 19.5897L15.257 21.1707C15.843 21.4787 16.527 20.9807 16.415 20.3287L15.84 16.9797L18.274 14.6087C18.748 14.1467 18.487 13.3417 17.832 13.2467L14.469 12.7577L12.965 9.70867C12.672 9.11467 11.826 9.11467 11.533 9.70867L10.03 12.7577L6.667 13.2467C6.012 13.3417 5.751 14.1467 6.225 14.6087L8.659 16.9797L8.084 20.3287C7.972 20.9807 8.656 21.4777 9.242 21.1707L12.249 19.5897Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "minimize-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7 12.2636H16.9995", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "mobile_device-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M10 4V5.8C10 6.131 10.224 6.4 10.5 6.4H13.5C13.776 6.4 14 6.131 14 5.8V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M10.88 17.5H13.12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 4H15C16.105 4 17 4.895 17 6V18C17 19.105 16.105 20 15 20H9C7.895 20 7 19.105 7 18V6C7 4.895 7.895 4 9 4Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "mode_comment-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 20.2637V6.04167C20 5.05967 19.204 4.26367 18.222 4.26367H5.778C4.796 4.26367 4 5.05967 4 6.04167V16.7087C4 17.6907 4.796 18.4867 5.778 18.4867H16.667L20 20.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M8.01 11.2637L8.005 11.2687L8 11.2637M12.0303 11.2637L12.0253 11.2687L12.0203 11.2637M15.9935 11.2637L15.9885 11.2687L15.9835 11.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "money-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M17.556 18.5977V17.5717C17.556 15.8727 19.048 14.4947 20.889 14.4947H22M6.444 5.26367V6.28967C6.444 7.98867 4.952 9.36667 3.111 9.36667H2M2 14.4947H3.111C4.952 14.4947 6.444 15.8727 6.444 17.5717V18.5977M22 9.36667H20.889C19.048 9.36667 17.556 7.98867 17.556 6.28967V5.26367M20 18.5977H4C2.895 18.5977 2 17.7027 2 16.5977L2 7.26367C2 6.15867 2.895 5.26367 4 5.26367L20 5.26367C21.105 5.26367 22 6.15867 22 7.26367V16.5967C22 17.7017 21.105 18.5977 20 18.5977ZM13.7678 10.1629C14.7441 11.1392 14.7441 12.7221 13.7678 13.6984C12.7915 14.6747 11.2086 14.6747 10.2323 13.6984C9.25596 12.7221 9.25596 11.1392 10.2323 10.1629C11.2086 9.18656 12.7915 9.18656 13.7678 10.1629Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "money_hand-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7 20.2637V14.2637C7 13.7117 6.552 13.2637 6 13.2637H4C3.448 13.2637 3 13.7117 3 14.2637V20.2637C3 20.8157 3.448 21.2637 4 21.2637H6C6.552 21.2637 7 20.8157 7 20.2637ZM7 20.2637H8.508C8.835 20.2637 9.16 20.3037 9.477 20.3837L12.127 21.0457C12.702 21.1897 13.301 21.2037 13.882 21.0877L16.812 20.5017C17.586 20.3467 18.298 19.9657 18.856 19.4077L20.929 17.3347C21.521 16.7437 21.521 15.7847 20.929 15.1927C20.396 14.6597 19.552 14.5997 18.949 15.0517L16.533 16.8637C16.187 17.1237 15.766 17.2637 15.333 17.2637H13H14.485C15.322 17.2637 16 16.5857 16 15.7487V15.4457C16 14.7507 15.527 14.1447 14.853 13.9767L12.561 13.4037C12.188 13.3107 11.806 13.2637 11.422 13.2637C10.495 13.2637 9.588 13.5377 8.817 14.0527L7 15.2637M14.631 4.63867C14.538 4.07367 14.28 3.53067 13.844 3.09467C12.736 1.98667 10.939 1.98667 9.831 3.09467C8.723 4.20267 8.723 5.99967 9.831 7.10767C10.521 7.79767 11.477 8.05667 12.368 7.88767M17.1688 5.4189C18.2771 6.52721 18.2771 8.32413 17.1688 9.43244C16.0605 10.5408 14.2636 10.5408 13.1553 9.43244C12.047 8.32413 12.047 6.52721 13.1553 5.4189C14.2636 4.31059 16.0605 4.31059 17.1688 5.4189Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "money_off-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M6.22 5.37367C7.782 4.05767 9.797 3.26367 12 3.26367C16.971 3.26367 21 7.29267 21 12.2637C21 13.7107 20.65 15.0737 20.043 16.2847L17.362 14.9447M17.78 19.1537C16.218 20.4697 14.203 21.2637 12 21.2637C7.029 21.2637 3 17.2337 3 12.2637C3 10.8167 3.35 9.45367 3.957 8.24267L6.638 9.58267M12 7.26367V8.51367M12 17.2637V16.0137M14.487 10.2637C14.422 9.28767 13.617 8.51367 12.625 8.51367H11.255C10.285 8.51367 9.5 9.29967 9.5 10.2687C9.5 11.0737 10.048 11.7757 10.828 11.9717L13.171 12.5597C13.952 12.7557 14.499 13.4577 14.499 14.2627C14.499 15.2327 13.713 16.0177 12.744 16.0177H11.374C10.38 16.0177 9.575 15.2417 9.511 14.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "money_stars-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M21 11.2637V17.2637C21 18.9205 19.6569 20.2637 18 20.2637H6C4.34315 20.2637 3 18.9205 3 17.2637L3 9.26367C3 7.60682 4.34315 6.26367 6 6.26367H11M13.7678 15.0315C12.7915 16.0078 11.2085 16.0078 10.2322 15.0315C9.25592 14.0551 9.25592 12.4722 10.2322 11.4959M15 11.2637V8.26367M16.5 9.76367H13.5M19.5 6.26367V3.26367M18 4.76367H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "more_horiz-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.005 11.7669C17.005 12.042 17.2301 12.2671 17.5052 12.2641C17.7803 12.2641 18.0054 12.039 18.0054 11.7639C18.0054 11.4888 17.7803 11.2637 17.5052 11.2637C17.2301 11.2637 17.005 11.4888 17.005 11.7669Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0025 11.7669C11.0025 12.042 11.2276 12.2671 11.5027 12.2641C11.7778 12.2641 12.0029 12.039 12.0029 11.7639C12.0029 11.4888 11.7778 11.2637 11.5027 11.2637C11.2276 11.2637 11.0025 11.4888 11.0025 11.7669Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 11.7669C5 12.042 5.22509 12.2671 5.50021 12.2641C5.77532 12.2641 6.00042 12.039 6.00042 11.7639C6.00042 11.4888 5.77532 11.2637 5.50021 11.2637C5.22509 11.2637 5 11.4888 5 11.7669Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "more_vert-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.4972 17.2687C11.2221 17.2687 10.997 17.4938 11 17.7689C11 18.044 11.2251 18.2691 11.5002 18.2691C11.7754 18.2691 12.0004 18.044 12.0004 17.7689C12.0004 17.4938 11.7754 17.2687 11.4972 17.2687Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.4972 11.2662C11.2221 11.2662 10.997 11.4913 11 11.7664C11 12.0415 11.2251 12.2666 11.5002 12.2666C11.7754 12.2666 12.0004 12.0415 12.0004 11.7664C12.0004 11.4913 11.7754 11.2662 11.4972 11.2662Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.4972 5.26367C11.2221 5.26367 10.997 5.48877 11 5.76388C11 6.03899 11.2251 6.26409 11.5002 6.26409C11.7754 6.26409 12.0004 6.03899 12.0004 5.76388C12.0004 5.48877 11.7754 5.26367 11.4972 5.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "mortgage-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.75 10.6387V9.76367M11.75 15.8887V16.7637M10.232 15.2637C10.459 15.6347 10.846 15.8917 11.313 15.8917H12.272C12.951 15.8917 13.5 15.3417 13.5 14.6637C13.5 14.0997 13.116 13.6087 12.57 13.4707L10.93 13.0587C10.385 12.9217 10 12.4297 10 11.8657C10 11.1867 10.55 10.6377 11.228 10.6377H12.187C12.654 10.6377 13.04 10.8927 13.267 11.2627M20.75 19.2637V10.469C20.75 9.8537 20.4668 9.27265 19.9821 8.89359L13.5982 3.90059C12.5124 3.05136 10.9876 3.05136 9.90179 3.90059L3.51788 8.89359C3.03321 9.27265 2.75 9.8537 2.75 10.469V19.2637C2.75 20.3683 3.64543 21.2637 4.75 21.2637H18.75C19.8546 21.2637 20.75 20.3683 20.75 19.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "mouse-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M17.25 13.2637H7.25M17.25 2.26367C17.25 3.36824 16.3546 4.26367 15.25 4.26367H14.25C13.1454 4.26367 12.25 5.1591 12.25 6.26367V13.2637M10.25 7.26367H14.25C15.9069 7.26367 17.25 8.60682 17.25 10.2637V16.2637C17.25 19.0251 15.0114 21.2637 12.25 21.2637C9.48858 21.2637 7.25 19.0251 7.25 16.2637V10.2637C7.25 8.60682 8.59315 7.26367 10.25 7.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "move_to_inbox-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3 15.2637H7.382C7.76093 15.2637 8.10731 15.4779 8.27662 15.8169L8.72294 16.7105C8.89225 17.0495 9.23861 17.2637 9.61753 17.2637H14.3815C14.7602 17.2637 15.1065 17.0497 15.2759 16.7109L15.7231 15.8165C15.8925 15.4777 16.2388 15.2637 16.6175 15.2637H21M12 12.7082V7.70819M12 12.7082L10 10.7087M12 12.7082L14 10.7087M18 3.26367C19.6569 3.26367 21 4.60682 21 6.26367V18.2637C21 19.9205 19.6569 21.2637 18 21.2637H6C4.34315 21.2637 3 19.9205 3 18.2637V6.26367C3 4.60682 4.34315 3.26367 6 3.26367H18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "multiline_chart-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M20.0088 12.1277L15.4433 16.6201L8.52097 10.1891L4.25 14.4041M19.3178 7.26367L15.0916 11.3805L13.6431 10.1891L8.52072 15.2714", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "multi_family_home-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10.75 10.6325L16.0135 5.26367L21.277 10.6325M20.3823 17.7906V10.1111M14.8873 17.7906V13.3164H17.5793V17.7906M11.6446 9.86526V17.7907M6.75 10.6325L12.0135 5.26367M7.64459 9.86526V17.7907M2.75 10.6325L8.01348 5.26367M3.64459 9.86526V17.7907", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "music_note-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.24999 17.3194V7.50236C9.24999 7.08736 9.50599 6.71536 9.89399 6.56836L18.394 3.33036C19.049 3.08036 19.75 3.56436 19.75 4.26436V15.3134M19.0178 13.5456C19.9941 14.5219 19.9941 16.1048 19.0178 17.0811C18.0415 18.0574 16.4586 18.0574 15.4823 17.0811C14.506 16.1048 14.506 14.5219 15.4823 13.5456C16.4586 12.5692 18.0415 12.5692 19.0178 13.5456ZM8.51776 15.5456C9.49407 16.5219 9.49407 18.1048 8.51776 19.0811C7.54145 20.0574 5.95854 20.0574 4.98223 19.0811C4.00592 18.1048 4.00592 16.5219 4.98223 15.5456C5.95854 14.5692 7.54145 14.5692 8.51776 15.5456Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "nature_people-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.25002 17.2637V20.2637M11.2001 12.2637L14.0145 15.6213C14.2641 15.919 14.3186 16.3344 14.1543 16.6865C13.99 17.0386 13.6366 17.2637 13.2481 17.2637H5.25192C4.86338 17.2637 4.51002 17.0386 4.34572 16.6865C4.18143 16.3344 4.23595 15.919 4.48554 15.6213L7.29993 12.2637M3.25 20.2637H21.25M17.25 20.2637V16.2637C18.7915 16.2718 20.1991 15.3888 20.8626 13.9973C21.5261 12.6058 21.3262 10.9563 20.3494 9.76367C21.452 8.39758 21.5328 6.47159 20.5486 5.01791C19.5645 3.56423 17.7462 2.92395 16.0684 3.44023C14.3905 3.9565 13.2467 5.50818 13.25 7.26367M8.54252 7.55582L5.54452 10.5569C5.25872 10.843 5.17334 11.273 5.32818 11.6466C5.48303 12.0202 5.84762 12.2637 6.252 12.2637H12.248C12.6524 12.2637 13.017 12.0202 13.1718 11.6466C13.3267 11.273 13.2413 10.843 12.9555 10.5569L9.95748 7.55581C9.56625 7.1663 8.93375 7.1663 8.54252 7.55582ZM6.25 3.76367C6.25 4.5921 5.57843 5.26367 4.75 5.26367C3.92157 5.26367 3.25 4.5921 3.25 3.76367C3.25 2.93524 3.92157 2.26367 4.75 2.26367C5.57843 2.26367 6.25 2.93524 6.25 3.76367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "navigate_before-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M13.5 8L9.5 12L13.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "navigate_beginning-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10.5 16.2637L6.5 12.2637L10.5 8.26367M17.5 17.2637L12.5 12.2637L17.5 7.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "navigate_end-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M13.5 16.2637L17.5 12.2637L13.5 8.26367M6.5 17.2637L11.5 12.2637L6.5 7.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "navigate_next-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10.5 16L14.5 12L10.5 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "new_construction-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.75 9.9625L10.6884 3.15804C11.3014 2.63254 12.2061 2.63254 12.8191 3.15804L20.7575 9.9625M19.4715 8.87904V3.08219C19.4715 2.86511 19.3852 2.65691 19.2317 2.50341C19.0782 2.34991 18.87 2.26367 18.6529 2.26367H16.1974C15.7453 2.26367 15.3788 2.63014 15.3788 3.08219V5.37097M9.29818 19.2708V14.0868C9.29818 13.6347 9.66465 13.2683 10.1167 13.2683H11.7537M4.03604 8.87904V19.2708M11.7537 19.2708H2.75M20.6581 12.1195V13.6702M21.4334 12.8948H19.8827M20.0457 19.5469V21.0976M20.8211 20.3223H19.2704M19.4081 16.2462L18.5814 15.932C17.96 15.6959 17.4693 15.2052 17.2332 14.5839L16.9191 13.7571C16.8619 13.6067 16.7177 13.5072 16.5567 13.5072C16.3957 13.5072 16.2515 13.6067 16.1943 13.7571L15.8802 14.5839C15.6441 15.2052 15.1534 15.6959 14.532 15.932L13.7053 16.2462C13.5548 16.3033 13.4553 16.4476 13.4553 16.6085C13.4553 16.7695 13.5548 16.9138 13.7053 16.9709L14.532 17.2851C15.1534 17.5212 15.6441 18.0119 15.8802 18.6332L16.1943 19.46C16.2515 19.6104 16.3957 19.7099 16.5567 19.7099C16.7177 19.7099 16.8619 19.6104 16.9191 19.46L17.2332 18.6332C17.4693 18.0119 17.96 17.5212 18.5814 17.2851L19.4081 16.9709C19.5586 16.9138 19.6581 16.7695 19.6581 16.6085C19.6581 16.4476 19.5586 16.3033 19.4081 16.2462Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "night-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15 5.26367V3.26367M14 4.26367H16M20 6.26367V10.2637M22 8.26367H18M18.4 15.2637C15.9 16.0637 13 15.5637 11 13.5637C8.5 11.0637 8.3 7.06367 10.3 4.26367C6.2 4.66367 3 8.06367 3 12.2637C3 16.6637 6.6 20.2637 11 20.2637C14.3 20.2637 17.2 18.1637 18.4 15.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "notifications-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.95801 18.6077V18.9727C9.95801 20.2377 10.984 21.2637 12.25 21.2637C13.516 21.2637 14.542 20.2377 14.542 18.9717V18.6067M14.083 6.01467V5.09667C14.083 4.08467 13.263 3.26367 12.25 3.26367C11.237 3.26367 10.417 4.08467 10.417 5.09667V6.01467M6.813 10.4517C6.813 7.94865 8.842 5.92065 11.344 5.92065H13.157C15.66 5.92065 17.688 7.94965 17.688 10.4517V13.2487C17.688 13.7787 17.899 14.2877 18.274 14.6627L18.915 15.3037C19.29 15.6787 19.501 16.1877 19.501 16.7177C19.501 17.7617 18.655 18.6077 17.611 18.6077H6.89C5.846 18.6077 5 17.7617 5 16.7177C5 16.1877 5.211 15.6787 5.586 15.3037L6.227 14.6627C6.602 14.2877 6.813 13.7787 6.813 13.2487V10.4517Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "notifications_active-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M13.5999 20.2147H10.3999M18.9509 6.26367C18.2389 5.01367 17.2009 3.97567 15.9509 3.26367M5.04907 6.26367C5.76107 5.01367 6.79907 3.97567 8.04907 3.26367M17 10.2147C17 7.45366 14.761 5.21466 12 5.21466C9.239 5.21466 7 7.45366 7 10.2147V12.7187C7 13.0427 6.817 13.3377 6.528 13.4827L6.025 13.7337C5.397 14.0487 5 14.6907 5 15.3927C5 16.4167 5.83 17.2467 6.854 17.2467H17.146C18.17 17.2467 19 16.4167 19 15.3927C19 14.6907 18.603 14.0487 17.975 13.7347L17.472 13.4837C17.183 13.3377 17 13.0427 17 12.7187V10.2147Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "notifications_off-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.70752 18.6077V18.9727C9.70752 20.2377 10.7335 21.2637 11.9995 21.2637C13.2655 21.2637 14.2915 20.2377 14.2915 18.9717V18.6067M13.8325 6.01467V5.09667C13.8325 4.08467 13.0125 3.26367 11.9995 3.26367C10.9865 3.26367 10.1665 4.08467 10.1665 5.09667V6.01467M19.2505 16.7177C19.2505 16.1877 19.0395 15.6787 18.6645 15.3037L18.0235 14.6627C17.6485 14.2877 17.4375 13.7787 17.4375 13.2487V10.4517C17.4375 7.94965 15.4095 5.92065 12.9065 5.92065H11.0935C10.3739 5.92065 9.69333 6.08844 9.08896 6.38704M6.87262 8.80078C6.67242 9.31229 6.56251 9.86911 6.56251 10.4517V13.2487C6.56251 13.7787 6.35151 14.2877 5.97651 14.6627L5.33551 15.3037C4.96051 15.6787 4.74951 16.1877 4.74951 16.7177C4.74951 17.7617 5.59551 18.6077 6.63951 18.6077H16.8438M4 5.76367L19 20.7637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "notification_important-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.95996 18.614V18.9792C9.96028 20.2453 10.9868 21.2714 12.2529 21.2711C12.8611 21.2712 13.4443 21.0296 13.8743 20.5996C14.3044 20.1696 14.5459 19.5863 14.5459 18.9782V18.613M14.0867 6.01582V5.09744C14.0868 4.61107 13.8936 4.14462 13.5497 3.80071C13.2058 3.4568 12.7393 3.26362 12.253 3.26367C11.7666 3.26362 11.3001 3.4568 10.9562 3.80071C10.6123 4.14462 10.4191 4.61107 10.4192 5.09744V6.01582M12.2529 12.0125V9.43799M12.3779 14.9713C12.3779 15.0403 12.322 15.0963 12.2529 15.0963C12.1838 15.0963 12.1278 15.0403 12.1278 14.9713C12.1278 14.9022 12.1838 14.8462 12.2529 14.8462M6.81376 10.4546C6.81372 9.25243 7.29128 8.09946 8.14137 7.24937C8.99146 6.39928 10.1444 5.92175 11.3466 5.92175H13.1604C14.3626 5.92175 15.5156 6.39928 16.3657 7.24937C17.2158 8.09946 17.6933 9.25243 17.6933 10.4546V13.2528C17.6935 13.7834 17.9043 14.2922 18.2795 14.6674L18.9208 15.3087C19.296 15.6838 19.5069 16.1927 19.507 16.7233C19.507 17.2247 19.3079 17.7057 18.9533 18.0603C18.5987 18.4149 18.1177 18.614 17.6163 18.614H6.89079C6.3893 18.614 5.90834 18.4149 5.55373 18.0603C5.19913 17.7057 5 17.2247 5 16.7233C5.00018 16.1927 5.21105 15.6838 5.58624 15.3087L6.22751 14.6674C6.60271 14.2922 6.81357 13.7834 6.81376 13.2528V10.4546Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "offline_bolt-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M18.25 6.51366H20.25M18.25 3.51366H20.25M13.75 5.01366H12.25C7.83172 5.01366 4.25 8.59538 4.25 13.0137C4.25 17.4319 7.83172 21.0137 12.25 21.0137C14.3717 21.0137 16.4066 20.1708 17.9069 18.6705C19.4071 17.1702 20.25 15.1354 20.25 13.0137M11.844 10.0137L10.25 13.0137H14.25L12.656 16.0137M18.25 2.76367V7.26367C18.25 7.53981 18.0262 7.76367 17.75 7.76367H16.25C15.587 7.76367 14.9511 7.50028 14.4822 7.03144C14.0134 6.5626 13.75 5.92671 13.75 5.26367V4.76367C13.75 3.38296 14.8693 2.26367 16.25 2.26367H17.75C18.0262 2.26367 18.25 2.48753 18.25 2.76367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "off_street_parking-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10.5 8V13M10.5 8H12.8375C13.7557 8 14.5 8.74433 14.5 9.6625C14.5 10.5807 13.7557 11.325 12.8375 11.325H10.5V8ZM8 17H16M6 21H18C19.1046 21 20 20.1046 20 19V5C20 3.89543 19.1046 3 18 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "open_in_new-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10.272 10.1917H14.515V14.4347M14.521 10.1857L6.996 17.7107C6.468 18.2387 5.611 18.2387 5.083 17.7107C3.753 16.3807 3.004 14.5767 3 12.6957C3 11.4657 3.238 10.2357 3.711 9.07867C4.177 7.93967 4.87 6.87267 5.795 5.94867C7.454 4.28967 9.746 3.26367 12.277 3.26367C14.808 3.26367 17.1 4.28967 18.759 5.94867C20.418 7.60767 21.444 9.89867 21.444 12.4307C21.444 14.9617 20.418 17.2537 18.759 18.9127C17.1 20.5717 14.809 21.5977 12.277 21.5977C11.29 21.5977 10.305 21.4277 9.36 21.1097", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "other_houses-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.75 19.2637V10.469C20.75 9.8537 20.4668 9.27265 19.9821 8.89359L13.5982 3.90059C12.5124 3.05136 10.9876 3.05136 9.90179 3.90059L3.51788 8.89359C3.03321 9.27265 2.75 9.8537 2.75 10.469V19.2637C2.75 20.3683 3.64543 21.2637 4.75 21.2637H18.75C19.8546 21.2637 20.75 20.3683 20.75 19.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M15.75 13.9C15.75 14.1012 15.9146 14.2658 16.1159 14.2637C16.3171 14.2637 16.4817 14.099 16.4817 13.8978C16.4817 13.6966 16.3171 13.5319 16.1159 13.5319C15.9146 13.5319 15.75 13.6966 15.75 13.9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M11.75 13.9C11.75 14.1012 11.9146 14.2658 12.1159 14.2637C12.3171 14.2637 12.4817 14.099 12.4817 13.8978C12.4817 13.6966 12.3171 13.5319 12.1159 13.5319C11.9146 13.5319 11.75 13.6966 11.75 13.9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M6.75 13.9C6.75 14.1012 6.91464 14.2658 7.11586 14.2637C7.31708 14.2637 7.48172 14.099 7.48172 13.8978C7.48172 13.6966 7.31708 13.5319 7.11586 13.5319C6.91464 13.5319 6.75 13.6966 6.75 13.9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "pageview-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19 11.2637V8.09167C19 7.56167 18.789 7.05267 18.414 6.67767L15.586 3.84967C15.211 3.47467 14.702 3.26367 14.172 3.26367H5C3.895 3.26367 3 4.15867 3 5.26367V19.2637C3 20.3687 3.895 21.2637 5 21.2637H12M19 8.26367H15C14.448 8.26367 14 7.81567 14 7.26367V3.26367M21 21.2637L19.12 19.3837M19.121 15.1427C20.419 16.4407 20.279 18.6297 18.703 19.7367C17.7 20.4407 16.299 20.4407 15.296 19.7367C13.719 18.6307 13.58 16.4407 14.878 15.1427C16.05 13.9707 17.95 13.9707 19.121 15.1427Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "paid-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.9999 6.26367V7.76367M11.9999 18.2637V16.7637M8.99994 14.5187C8.99994 15.7617 10.0069 16.7687 11.2499 16.7687H12.8929C14.0559 16.7687 14.9999 15.8257 14.9999 14.6617C14.9999 13.6957 14.3429 12.8537 13.4059 12.6187L10.5939 11.9137C9.65694 11.6787 8.99994 10.8367 8.99994 9.87067C8.99994 8.70667 9.94294 7.76367 11.1069 7.76367H12.7499C13.9929 7.76367 14.9999 8.77067 14.9999 10.0137M18.3639 5.89971C21.8787 9.41443 21.8787 15.1129 18.3639 18.6276C14.8492 22.1423 9.15074 22.1423 5.63604 18.6276C2.12132 15.1129 2.12132 9.41441 5.63604 5.89971C9.15076 2.38499 14.8492 2.38499 18.3639 5.89971Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "paperless-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.9822 11.3215C8.49326 11.9051 5.4185 13.9481 3.52856 16.9383M11.2291 5.76133C7.7835 5.76133 4.99028 8.55454 4.99028 12.0001C4.99028 15.4458 7.7835 18.239 11.2291 18.239C16.3116 18.239 17.559 11.9984 20.4714 10.3352C18.3 7.41945 14.8643 5.71914 11.2291 5.76133Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "parking_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.4039 16.8725L12.979 14.4141C13.1378 13.7353 13.7431 13.2553 14.4402 13.2553H18.0922C18.7893 13.2553 19.3946 13.7353 19.5534 14.4141L20.1285 16.8725M12.5038 16.3791L11.2641 15.7564M20.0286 16.3791L21.2683 15.7564M8.26287 11.7547V7.25281H9.83853C10.2166 7.25281 10.5792 7.40301 10.8466 7.67036C11.1139 7.93771 11.2641 8.30032 11.2641 8.67841C11.2641 9.46574 10.6259 10.104 9.83853 10.104H8.26287M16.2662 9.2771C16.2686 7.41447 15.5308 5.62721 14.2151 4.30872L14.1917 4.28527C11.4392 1.56925 7.00791 1.59296 4.28463 4.33827C1.56135 7.08358 1.57335 11.515 4.31146 14.2455L7.31296 17.257M18.267 19.758H14.2654V20.2582C14.2654 20.8107 13.8175 21.2586 13.265 21.2586H12.2645C11.712 21.2586 11.2641 20.8107 11.2641 20.2582V18.5075C11.2641 17.5406 12.048 16.7568 13.0149 16.7568H19.5176C20.4845 16.7568 21.2683 17.5406 21.2683 18.5075V20.2582C21.2683 20.8107 20.8204 21.2586 20.2679 21.2586H19.2675C18.7149 21.2586 18.267 20.8107 18.267 20.2582V19.758Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "patio-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12 10V21M16.5 15H7.5M21 21V14M3 14V21M8 10C8 6.134 9.79086 3 12 3M12 3C14.2091 3 16 6.134 16 10M12 3C16.4762 3 20.1989 5.476 20.9711 8.74126C21.0472 9.04201 20.981 9.36103 20.7915 9.60665C20.602 9.85227 20.3102 9.99728 20 10H3.99956C3.68935 9.99728 3.39757 9.85227 3.20807 9.60665C3.01858 9.36103 2.95236 9.042 3.02844 8.74125C3.8007 5.476 7.5238 3 12 3ZM8 21V19C8 18.4477 7.55228 18 7 18H3M16 21V19C16 18.4477 16.4477 18 17 18H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "payments-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3 7.11367H22M7.5 16.2637H5C3.895 16.2637 3 15.3687 3 14.2637V5.26367C3 4.15867 3.895 3.26367 5 3.26367H20C21.105 3.26367 22 4.15867 22 5.26367V14.2637C22 15.3687 21.105 16.2637 20 16.2637H17.5M7.5 16.2637C7.5 13.5137 9.75 11.2637 12.5 11.2637C15.25 11.2637 17.5 13.5137 17.5 16.2637M7.5 16.2637C7.5 17.3857 7.879 18.4207 8.509 19.2567C9.423 20.4717 10.872 21.2637 12.5 21.2637C15.25 21.2637 17.5 19.0137 17.5 16.2637M12.5 14.0137V13.2637M12.5 18.5137V19.2637M11.198 17.9777C11.392 18.2957 11.724 18.5157 12.125 18.5157H12.947C13.529 18.5157 14 18.0437 14 17.4627C14 16.9797 13.671 16.5587 13.203 16.4407L11.797 16.0877C11.329 15.9697 11 15.5487 11 15.0657C11 14.4837 11.472 14.0127 12.053 14.0127H12.875C13.275 14.0127 13.606 14.2317 13.8 14.5487", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "pedal_bike-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M16.9915 7.41509L9.0036 9.53125L7.50297 11.3747C6.04338 10.2047 3.96843 10.2005 2.50406 11.3645C1.0397 12.5285 0.575718 14.5509 1.38625 16.2368C2.19679 17.9227 4.06609 18.8234 5.88971 18.4066C7.71333 17.9899 9.00585 16.3666 9.0036 14.496H10.4805C10.773 14.496 11.0508 14.368 11.2408 14.1456L16.9915 7.41509ZM16.9915 7.41509L18.0076 10.6204M23.0096 14.496C23.0096 16.7061 21.218 18.4977 19.0079 18.4977C16.7978 18.4977 15.0062 16.7061 15.0062 14.496C15.0062 12.286 16.7978 10.4943 19.0079 10.4943C21.218 10.4943 23.0096 12.286 23.0096 14.496Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M19.0077 14.496L16.5067 5.49225H14.5059", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M7.00281 6.99288H10.0041M9.00374 9.49391L5.00208 14.496H10.5044L8.0033 6.99286", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "percent-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M7 16.9481L17.6845 6.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M17.4316 16.8465C17.6605 17.0828 17.6565 17.4594 17.4226 17.6908C17.1887 17.9222 16.8121 17.9222 16.5782 17.6908C16.3444 17.4594 16.3403 17.0828 16.5692 16.8465C16.6823 16.7297 16.8379 16.6638 17.0004 16.6638C17.1629 16.6638 17.3185 16.7297 17.4316 16.8465", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M8.03143 7.44633C8.26032 7.68267 8.2563 8.05922 8.02242 8.29062C7.78854 8.52202 7.41196 8.52202 7.17808 8.29062C6.9442 8.05922 6.94018 7.68267 7.16907 7.44633C7.28214 7.32958 7.43772 7.26367 7.60025 7.26367C7.76278 7.26367 7.91836 7.32958 8.03143 7.44633", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "person-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M17.4569 19.2217C16.0219 17.7107 13.9979 16.7637 11.7499 16.7637C9.50194 16.7637 7.47794 17.7107 6.04294 19.2227M18.1139 5.89971C21.6287 9.41443 21.6287 15.1129 18.1139 18.6276C14.5992 22.1423 8.90074 22.1423 5.38604 18.6276C1.87132 15.1129 1.87132 9.41441 5.38604 5.89971C8.90076 2.38499 14.5992 2.38499 18.1139 5.89971ZM13.739 8.58758C14.8376 9.68612 14.8376 11.4672 13.739 12.5658C12.6405 13.6643 10.8594 13.6643 9.76086 12.5658C8.66232 11.4672 8.66232 9.68612 9.76086 8.58758C10.8594 7.48904 12.6405 7.48904 13.739 8.58758Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "person_off-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.7474 16.2667H9.23941C8.48341 16.2667 7.75541 16.5527 7.20041 17.0657L7.13641 17.1257C6.78441 17.4517 6.51041 17.8517 6.33241 18.2977L5.98241 19.1767M12.9334 13.4517C14.2784 12.9667 15.2474 11.7007 15.2474 10.1867C15.2474 8.25367 13.6804 6.68567 11.7464 6.68567C10.2324 6.68567 8.96641 7.65467 8.48141 9.00067M3.70741 8.22667C2.01241 11.6007 2.56641 15.8157 5.38241 18.6317C8.19941 21.4487 12.4154 22.0017 15.7894 20.3057M5.38141 5.90067C8.89741 2.38467 14.5974 2.38467 18.1124 5.90067C21.6274 9.41567 21.6274 15.1147 18.1134 18.6307M19.7474 20.2657L3.74741 4.26567", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "pets-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M11.7537 13.7651C11.4775 13.7651 11.2535 13.5411 11.2535 13.2649C11.2535 13.1728 11.3282 13.0981 11.4203 13.0981H12.0872C12.1793 13.0982 12.254 13.1728 12.254 13.2649C12.254 13.5411 12.03 13.7651 11.7537 13.7651ZM11.7537 13.7651V15.4848M9.56602 16.391C9.80611 16.6317 10.1322 16.7668 10.4722 16.7663C11.18 16.7663 11.7537 16.1926 11.7537 15.4848M11.7537 15.4848C11.7538 16.0031 12.066 16.4704 12.5449 16.6688C13.0238 16.8671 13.575 16.7575 13.9415 16.391M16.7558 12.071L20.7575 11.4041M20.7575 15.2657L16.7558 14.5988M6.75167 12.071L2.75 11.4041M2.75 15.2657L6.75167 14.5988M14.8294 5.68104L17.2187 3.63374C17.6747 3.24301 18.3164 3.15346 18.862 3.40444C19.4075 3.65541 19.7571 4.20099 19.7571 4.80149V12.2645C19.7571 16.6846 16.1739 20.2678 11.7537 20.2678C7.33363 20.2678 3.75042 16.6846 3.75042 12.2645V4.80149C3.75042 4.20099 4.09997 3.65541 4.64552 3.40444C5.19107 3.15346 5.8328 3.24301 6.2888 3.63374L8.67815 5.68104C10.6682 4.97746 12.8393 4.97746 14.8294 5.68104Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M9.76 10.2637L9.755 10.2687L9.75 10.2637M13.8503 10.2637L13.8453 10.2687L13.8403 10.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "phone-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1315 12.6834C9.96154 11.5134 9.07954 10.2034 8.49354 8.87442C8.36954 8.59342 8.44254 8.26442 8.65954 8.04742L9.47854 7.22942C10.1495 6.55842 10.1495 5.60942 9.56354 5.02342L8.38954 3.84942C7.60854 3.06842 6.34254 3.06842 5.56154 3.84942L4.90954 4.50142C4.16854 5.24242 3.85954 6.31142 4.05954 7.37142C4.55354 9.98442 6.07154 12.8454 8.52054 15.2944C10.9695 17.7434 13.8305 19.2614 16.4435 19.7554C17.5035 19.9554 18.5725 19.6464 19.3135 18.9054L19.9645 18.2544C20.7455 17.4734 20.7455 16.2074 19.9645 15.4264L18.7915 14.2534C18.2055 13.6674 17.2555 13.6674 16.6705 14.2534L15.7675 15.1574C15.5505 15.3744 15.2215 15.4474 14.9405 15.3234C13.6115 14.7364 12.3015 13.8534 11.1315 12.6834Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "phone_in_talk-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.9995 7.29067C14.0305 7.27667 15.0665 7.65867 15.8535 8.44567C16.6405 9.23267 17.0225 10.2687 17.0085 11.2997M12.9995 3.26367C15.0555 3.26367 17.1125 4.04867 18.6815 5.61767C20.2505 7.18667 21.0355 9.24367 21.0355 11.2997M18.9645 16.9097L17.7915 15.7367C17.2055 15.1507 16.2555 15.1507 15.6705 15.7367L14.7485 16.6587C14.5425 16.8647 14.2305 16.9337 13.9645 16.8167C12.6285 16.2317 11.3085 15.3447 10.1315 14.1677C8.95954 12.9957 8.07554 11.6817 7.48954 10.3507C7.36754 10.0757 7.43854 9.75267 7.65154 9.53967L8.47754 8.71367C9.14854 8.04267 9.14854 7.09367 8.56254 6.50767L7.38954 5.33467C6.60854 4.55367 5.34254 4.55367 4.56154 5.33467L3.90954 5.98567C3.16854 6.72667 2.85954 7.79567 3.05954 8.85567C3.55354 11.4687 5.07154 14.3297 7.52054 16.7787C9.96954 19.2277 12.8305 20.7457 15.4435 21.2397C16.5035 21.4397 17.5725 21.1307 18.3135 20.3897L18.9645 19.7387C19.7455 18.9577 19.7455 17.6917 18.9645 16.9097Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "photo_camera-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.1292 10.4315C16.6862 11.9885 16.6862 14.5129 15.1292 16.0699C13.5722 17.627 11.0478 17.627 9.49073 16.0699C7.93371 14.5129 7.93371 11.9885 9.49073 10.4315C11.0478 8.87445 13.5722 8.87445 15.1292 10.4315Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.25 9.26367V18.2637C21.25 19.3687 20.355 20.2637 19.25 20.2637H5.25C4.145 20.2637 3.25 19.3687 3.25 18.2637V9.26367C3.25 8.15867 4.145 7.26367 5.25 7.26367H7.25L8.712 4.75967C8.891 4.45267 9.22 4.26367 9.576 4.26367H14.88C15.231 4.26367 15.556 4.44767 15.737 4.74767L17.25 7.26367H19.25C20.355 7.26367 21.25 8.15867 21.25 9.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "pie_chart-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.2202 2.27454C18.4982 2.76754 21.0902 5.35854 21.5822 8.63654C21.6722 9.23554 21.1902 9.77254 20.5842 9.77254H15.0832C14.5312 9.77254 14.0832 9.32454 14.0832 8.77254V3.27154C14.0832 2.66554 14.6212 2.18454 15.2202 2.27454Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.1842 17.5285C20.9032 16.5575 21.3952 15.4085 21.5822 14.1595C21.6722 13.5605 21.1902 13.0235 20.5842 13.0235H16.4972C15.6062 13.0235 15.1602 14.1005 15.7902 14.7305L18.6812 17.6215C19.1072 18.0465 19.8252 18.0125 20.1842 17.5285Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.70921 6.60554C5.57621 7.21954 2.53121 11.1685 3.39821 15.6275C3.97521 18.5945 6.37321 20.9815 9.34221 21.5465C11.5932 21.9745 13.7112 21.4075 15.3342 20.2085C15.8202 19.8495 15.8572 19.1295 15.4302 18.7025L11.1262 14.3985C10.9382 14.2105 10.8332 13.9565 10.8332 13.6915V7.60154C10.8332 7.00054 10.3042 6.51754 9.70921 6.60554Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 51 50", id: "pinterest-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M0.100098 25C0.100098 11.1929 11.293 0 25.1001 0C38.9072 0 50.1001 11.1929 50.1001 25C50.1001 38.8071 38.9072 50 25.1001 50C11.293 50 0.100098 38.8071 0.100098 25Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.6078 37.5465C18.4466 36.1771 18.3147 34.0658 18.6664 32.568C18.9888 31.2128 20.7474 23.952 20.7474 23.952C20.7474 23.952 20.2199 22.9106 20.2199 21.3842C20.2199 18.9734 21.6561 17.1761 23.444 17.1761C24.9682 17.1761 25.701 18.2887 25.701 19.6154C25.701 20.5707 25.2998 21.8337 24.8772 23.1644C24.6436 23.9 24.4034 24.6563 24.2208 25.3927C23.7958 27.1188 25.1148 28.531 26.8587 28.531C30.0243 28.531 32.4571 25.2786 32.4571 20.5997C32.4571 16.4485 29.3941 13.5527 25.0122 13.5527C19.9414 13.5527 16.9664 17.2474 16.9664 21.0704C16.9664 22.554 17.5526 24.1516 18.2854 25.0218C18.4319 25.193 18.4466 25.3499 18.4026 25.5211C18.3255 25.8379 18.1884 26.374 18.076 26.8132C17.9961 27.1255 17.9287 27.3889 17.9043 27.4897C17.831 27.8035 17.6405 27.8748 17.3034 27.7179C15.1051 26.6908 13.7275 23.524 13.7275 20.9848C13.7275 15.5213 17.8017 10.5 25.4958 10.5C31.6657 10.5 36.4726 14.7795 36.4726 20.5141C36.4726 26.4911 32.6036 31.2984 27.2398 31.2984C25.4372 31.2984 23.7371 30.3855 23.1656 29.3013C23.1656 29.3013 22.2716 32.6108 22.0518 33.4239C21.6561 34.936 20.5716 36.819 19.8388 37.9745C19.6355 38.2313 18.8452 39.5 18.8452 39.5C18.8452 39.5 18.6961 38.0616 18.6078 37.5465Z", fill: "#F2F2F2" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "play_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M21 12.2637C21 17.2342 16.9706 21.2637 12 21.2637C7.02944 21.2637 3 17.2342 3 12.2637C3 7.29311 7.02944 3.26367 12 3.26367C16.9706 3.26367 21 7.29311 21 12.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.75 10.2652C9.75002 9.90493 9.94381 9.57253 10.2573 9.39504C10.5708 9.21754 10.9555 9.22238 11.2645 9.40772L14.5953 11.4062C14.8964 11.5869 15.0807 11.9124 15.0807 12.2637C15.0807 12.6149 14.8964 12.9404 14.5953 13.1211L11.2645 15.1197C10.9555 15.305 10.5708 15.3099 10.2573 15.1324C9.94378 14.9548 9.75 14.6224 9.75 14.2622V10.2652Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "pool-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.75 16.8817C3.896 16.3727 5.204 16.3727 6.35 16.8817C7.496 17.3907 8.804 17.3907 9.95 16.8817C11.096 16.3727 12.404 16.3727 13.55 16.8817C14.696 17.3907 16.004 17.3907 17.15 16.8817C18.296 16.3727 19.604 16.3727 20.75 16.8817M7.75 8.26367H15.75M7.75 12.2637H15.75M15.75 14.2637V4.76367C15.75 3.93567 16.422 3.26367 17.25 3.26367C18.078 3.26367 18.75 3.93567 18.75 4.76367M7.75 14.2637V4.76367C7.75 3.93567 8.422 3.26367 9.25 3.26367C10.078 3.26367 10.75 3.93567 10.75 4.76367M2.75 20.8817C3.896 20.3727 5.204 20.3727 6.35 20.8817C7.496 21.3907 8.804 21.3907 9.95 20.8817C11.096 20.3727 12.404 20.3727 13.55 20.8817C14.696 21.3907 16.004 21.3907 17.15 20.8817C18.296 20.3727 19.604 20.3727 20.75 20.8817", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "porch-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M6.30664 9.63574C5.89243 9.63574 5.55664 9.97153 5.55664 10.3857C5.55664 10.8 5.89243 11.1357 6.30664 11.1357V9.63574ZM4.69267 17.1808C4.37185 16.9188 3.89938 16.9665 3.63737 17.2873C3.37536 17.6081 3.42304 18.0806 3.74385 18.3426L4.69267 17.1808ZM12.4773 20.7915L12.4627 21.5414L12.4773 20.7915ZM7.49365 15.8424L6.77486 16.0565C6.86876 16.3717 7.1571 16.589 7.48601 16.5923L7.49365 15.8424ZM3.75 3.274L3.71372 2.52488C3.48355 2.53602 3.27128 2.65236 3.13805 2.84039C3.00482 3.02841 2.96543 3.26725 3.03121 3.4881L3.75 3.274ZM7.38688 4.29008L6.6633 4.48742L7.38688 4.29008ZM9.84718 13.1155L9.1249 13.3175C9.21552 13.6415 9.51077 13.8655 9.84718 13.8655V13.1155ZM18.0839 15.9502L18.0762 16.7002C18.4283 16.7038 18.7355 16.4619 18.8147 16.1189L18.0839 15.9502ZM6.30664 11.1357L14.6548 11.1357V9.63574L6.30664 9.63574V11.1357ZM8.8531 15.4686L7.18384 19.2063L8.55346 19.818L10.2227 16.0802L8.8531 15.4686ZM14.7517 15.9329L16.3347 19.6016L17.7119 19.0073L16.129 15.3386L14.7517 15.9329ZM3.74385 18.3426C4.21396 18.7265 5.08994 19.5214 6.49583 20.2123C7.90809 20.9063 9.8365 21.4903 12.4627 21.5414L12.4919 20.0417C10.0844 19.9948 8.3719 19.4629 7.15741 18.8661C5.93655 18.2661 5.19991 17.5951 4.69267 17.1808L3.74385 18.3426ZM12.4627 21.5414C17.4214 21.6379 20.4421 19.6787 21.3496 19.0679L20.512 17.8235C19.7254 18.3529 17.0121 20.1296 12.4919 20.0417L12.4627 21.5414ZM8.21244 15.6283L4.46879 3.0599L3.03121 3.4881L6.77486 16.0565L8.21244 15.6283ZM3.78628 4.02312C4.30074 3.99821 5.08211 4.01715 5.74413 4.1453C6.07759 4.20985 6.33772 4.29417 6.51019 4.38703C6.68971 4.48369 6.67596 4.53381 6.6633 4.48742L8.11045 4.09274C7.96943 3.57568 7.57505 3.25677 7.2213 3.0663C6.86049 2.87203 6.43469 2.75113 6.0292 2.67264C5.21329 2.5147 4.30458 2.49626 3.71372 2.52488L3.78628 4.02312ZM6.6633 4.48742C6.92087 5.43182 8.41231 10.7699 9.1249 13.3175L10.5695 12.9135C9.85579 10.362 8.36634 5.03101 8.11045 4.09274L6.6633 4.48742ZM9.84718 13.8655H15.3561V12.3655H9.84718V13.8655ZM15.3561 13.8655C15.5194 13.8655 15.8365 13.904 16.1614 14.0293C16.4848 14.1539 16.7552 14.3402 16.9202 14.5939L18.1778 13.7765C17.7866 13.1745 17.2102 12.8259 16.7009 12.6296C16.1933 12.434 15.6921 12.3655 15.3561 12.3655V13.8655ZM16.9202 14.5939C17.1523 14.9511 17.264 15.2538 17.3145 15.4713C17.369 15.7059 17.3462 15.8114 17.3531 15.7816L18.8147 16.1189C18.9261 15.6359 18.8115 14.7513 18.1778 13.7765L16.9202 14.5939ZM18.0915 15.2003L7.50129 15.0924L7.48601 16.5923L18.0762 16.7002L18.0915 15.2003Z", fill: "currentColor" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "power-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10.48 12.0744V10.5744M13.48 12.0744V10.5744M8.04999 8.14442C10.221 5.97342 13.74 5.97342 15.91 8.14442M5.75 5.84442C9.191 2.40342 14.77 2.40342 18.211 5.84442M11.98 17.0744C10.107 17.0744 8.58795 15.5554 8.58795 13.6824V13.0744C8.58795 12.5224 9.03595 12.0744 9.58795 12.0744H14.372C14.924 12.0744 15.372 12.5224 15.372 13.0744V13.6824C15.372 15.5554 13.853 17.0744 11.98 17.0744ZM11.98 17.0744L11.98 20.8844", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "power_settings_new-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M17.907 6.60667C21.031 9.73067 21.031 14.7967 17.907 17.9207C14.783 21.0447 9.717 21.0447 6.593 17.9207C3.469 14.7967 3.469 9.73067 6.593 6.60667M12.25 4.26367V12.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "query_builder-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.6409 15.2637L11.7189 13.3277V6.99967M18.3639 5.89971C21.8787 9.41443 21.8787 15.1129 18.3639 18.6276C14.8492 22.1423 9.15074 22.1423 5.63604 18.6276C2.12132 15.1129 2.12132 9.41441 5.63604 5.89971C9.15076 2.38499 14.8492 2.38499 18.3639 5.89971Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "question_answer-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M18.5065 18.8343V20.7699C18.5065 20.9722 18.3846 21.1546 18.1977 21.232C18.0108 21.3094 17.7957 21.2667 17.6526 21.1236L15.3633 18.8343M18.0062 9.76636H18.51C19.8893 9.76636 21.0075 10.8845 21.0075 12.2639V16.3368C21.0075 17.7162 19.8893 18.8343 18.51 18.8343M15.3668 18.8343H12.5004C11.1211 18.8343 10.0029 17.7161 10.0029 16.3368V15.2686M7.00171 6.26492H10.003M7.00171 9.26614H8.00213M15.005 15.2686H17.0058M8.70843 12.2674L6.35495 14.621C6.21189 14.764 5.99674 14.8068 5.80982 14.7294C5.62291 14.652 5.50104 14.4696 5.50104 14.2673V12.2674H5.4975C4.83512 12.2674 4.19987 12.0043 3.73149 11.5359C3.26312 11.0675 3 10.4323 3 9.7699V5.76117C3 4.38184 4.11817 3.26367 5.4975 3.26367H12.5075C13.8868 3.26367 15.005 4.38184 15.005 5.76117V9.7699C15.005 10.4323 14.7419 11.0675 14.2735 11.5359C13.8051 12.0043 13.1699 12.2674 12.5075 12.2674H8.70843Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "quote-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M13.2499 12H15.7499C16.0259 12 16.2499 12.224 16.2499 12.5V14.5C16.2499 14.776 16.0259 15 15.7499 15H13.7499C13.4739 15 13.2499 14.776 13.2499 14.5V12ZM13.2499 12C13.2499 10 13.6249 9.667 14.7499 9M7.74994 12H10.2499C10.5259 12 10.7499 12.224 10.7499 12.5V14.5C10.7499 14.776 10.5259 15 10.2499 15H8.24994C7.97394 15 7.74994 14.776 7.74994 14.5V12ZM7.74994 12C7.74994 10 8.12494 9.667 9.24994 9M18.3639 5.63604C21.8787 9.15076 21.8787 14.8492 18.3639 18.3639C14.8492 21.8787 9.15074 21.8787 5.63604 18.3639C2.12132 14.8492 2.12132 9.15074 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.3639 5.63604Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "radio_button_unchecked-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12 23.25C5.78679 23.25 0.75 18.2132 0.75 12C0.75 5.78679 5.78679 0.75 12 0.75C18.2132 0.75 23.25 5.78679 23.25 12C23.25 18.2132 18.2132 23.25 12 23.25Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "real_estate_agent-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M6.75167 19.288V13.2855C6.75167 12.7332 6.30348 12.285 5.75125 12.285H3.75042C3.19819 12.285 2.75 12.7332 2.75 13.2855V19.288C2.75 19.8402 3.19819 20.2884 3.75042 20.2884H5.75125C6.30348 20.2884 6.75167 19.8402 6.75167 19.288ZM6.75167 19.288L8.26028 19.2879C8.58741 19.2879 8.91255 19.328 9.22968 19.408L11.8808 20.0703C12.456 20.2143 13.0553 20.2283 13.6365 20.1123L16.5677 19.526C17.3421 19.371 18.0544 18.9898 18.6126 18.4316L20.6865 16.3577C21.2787 15.7665 21.2787 14.8071 20.6865 14.2148C20.1532 13.6816 19.3089 13.6216 18.7056 14.0738L16.2886 15.8865C15.9425 16.1466 15.5213 16.2867 15.0881 16.2867H12.7541L14.2398 16.2867C15.0771 16.2867 15.7554 15.6084 15.7554 14.7711V14.4679C15.7554 13.7727 15.2822 13.1664 14.6079 12.9983L12.315 12.4251C11.9418 12.3321 11.5597 12.285 11.1755 12.285C10.2481 12.285 9.34073 12.5591 8.56941 13.0744L6.75165 14.2859M19.835 13.5138V8.32732C19.835 7.98031 19.6753 7.65261 19.4019 7.43883L15.8015 4.62288C15.1891 4.14393 14.3292 4.14393 13.7168 4.62288L10.1164 7.43883C9.84308 7.65261 9.68335 7.98031 9.68335 8.32732V12.17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "receipt-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16 7.26367H8M16.13 11.2637H8M13 15.2637H8M4 19.4547V4.26367C4 3.71167 4.448 3.26367 5 3.26367H19C19.552 3.26367 20 3.71167 20 4.26367V19.4547C20 19.8267 19.609 20.0677 19.276 19.9017L17.333 18.9297L14.89 20.1517C14.749 20.2217 14.584 20.2217 14.443 20.1517L12 18.9307L9.557 20.1527C9.416 20.2227 9.251 20.2227 9.11 20.1527L6.667 18.9307L4.724 19.9027C4.391 20.0677 4 19.8267 4 19.4547Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "receipt_long-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9 12.6638H10M13 12.6638H17M9 9.16378H10M13 9.16378H17M5 17.1638V4.83999C4.99999 4.48332 5.18995 4.15364 5.49854 3.97478L6.49145 3.3993C6.80037 3.22023 7.18134 3.21947 7.49098 3.3973L8.99582 4.26165L9.00062 4.26365C9.0273 4.24795 9.9133 3.73435 10.494 3.39776C10.8023 3.21915 11.1825 3.21896 11.491 3.39727L12.9958 4.26163H13.0042L14.509 3.39737C14.8186 3.21954 15.1996 3.2203 15.5085 3.39937L16.9958 4.26137H17.0042L18.509 3.39701C18.8186 3.21918 19.1996 3.21994 19.5085 3.39901L20.5014 3.9745C20.81 4.15334 21 4.48298 21 4.83963V19.6638C21 20.4922 20.3284 21.1638 19.5 21.1638M19.5 21.1638C18.6716 21.1638 18 20.4922 18 19.6638V18.1638C18 17.6115 17.5523 17.1638 17 17.1638H4C3.44772 17.1638 3 17.6115 3 18.1638V19.1638C3 20.2683 3.89543 21.1638 5 21.1638H19.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "recycling-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3.701 19.2197L6.91 13.2827L6.314 10.4637L3.462 10.9187L1.25 14.9417L4.872 21.2637H9.664V16.8067H5.005M18.04 16.8067L15.682 12.7837L19.412 10.5177L21.874 14.6277L18.241 21.2637H14.078L11.941 19.0357L13.969 16.8067H20.681M11.621 5.56967L9.361 9.54167L5.544 7.43867L7.864 3.26367H15.129L17.406 6.86367L16.29 9.56367L13.731 8.99967L10.203 3.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "refi-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M5.25669 14.2321L3.71269 15.7761C2.32569 12.4981 2.96169 8.56807 5.63369 5.89707C8.87969 2.65107 13.9847 2.40807 17.5157 5.15607", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M6 18.8837C9.533 21.6307 14.637 21.3897 17.882 18.1427C20.553 15.4717 21.19 11.5417 19.803 8.26367L18.259 9.80767", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M10 14.4637L14.2 10.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M14.6765 13.5872C14.7745 13.6852 14.7745 13.8432 14.6765 13.9402C14.5785 14.0382 14.4205 14.0382 14.3235 13.9402C14.2255 13.8422 14.2255 13.6842 14.3235 13.5872C14.4195 13.4892 14.5785 13.4892 14.6765 13.5872", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M9.677 9.5863C9.775 9.6843 9.775 9.8433 9.677 9.9403C9.579 10.0383 9.42 10.0383 9.323 9.9403C9.225 9.8423 9.225 9.6833 9.323 9.5863C9.421 9.4893 9.579 9.4893 9.677 9.5863", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "refresh-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19.488 4.90267V8.43867H15.953M19.027 8.43867C17.67 5.95167 15.032 4.26367 12 4.26367C7.582 4.26367 4 7.84567 4 12.2637C4 16.6817 7.582 20.2637 12 20.2637C16.418 20.2637 20 16.6817 20 12.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "remove-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7 12.2636H16.9995", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "remove_circle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7 12.2636H16.9995M3 12.2637C3 7.29267 7.029 3.26367 12 3.26367C16.971 3.26367 21 7.29267 21 12.2637C21 17.2347 16.971 21.2637 12 21.2637C7.029 21.2637 3 17.2347 3 12.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "restaurant-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3.25 3.34767V7.80967M3.25 7.80967V7.89967M3.25 7.80967C3.25 9.08367 3.775 10.2117 4.589 10.9417C4.987 11.2987 5.25 11.7807 5.25 12.3157V19.7637C5.25 20.5917 5.922 21.2637 6.75 21.2637C7.578 21.2637 8.25 20.5917 8.25 19.7637V12.3157C8.25 11.7807 8.513 11.2987 8.911 10.9417C9.725 10.2117 10.25 9.08367 10.25 7.80967V3.34767M6.75 8.26367V3.26367M20.25 4.31567C20.25 3.76367 19.802 3.31567 19.25 3.31567H18.25C16.593 3.31567 15.25 4.65867 15.25 6.31567V12.3157C15.25 13.6197 16.087 14.7187 17.25 15.1317V19.7637C17.25 20.5917 17.922 21.2637 18.75 21.2637C19.578 21.2637 20.25 20.5917 20.25 19.7637V4.31567Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "reviews-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8 9.26367H5C3.34315 9.26367 2 10.6068 2 12.2637V16.2637C2 17.9205 3.34315 19.2637 5 19.2637V20.7627C5 20.9557 5.11106 21.1315 5.28536 21.2143C5.45966 21.2971 5.66607 21.2723 5.81572 21.1504L8.13269 19.2637H11C12.6569 19.2637 14 17.9205 14 16.2637V15.2637M14.2153 5.50156C14.3627 5.20285 14.6669 5.01373 15 5.01373C15.3331 5.01373 15.6373 5.20285 15.7847 5.50156L16.2299 6.40404C16.3573 6.66235 16.6037 6.8414 16.8887 6.88282L17.8846 7.02757C18.2141 7.0755 18.4878 7.30629 18.5908 7.62295C18.6937 7.93962 18.608 8.28726 18.3696 8.51978L17.6487 9.22294C17.4426 9.42396 17.3486 9.71349 17.3973 9.99723L17.5674 10.9889C17.6237 11.3171 17.4887 11.6488 17.2193 11.8446C16.9499 12.0403 16.5928 12.0662 16.298 11.9113L15.407 11.443C15.1522 11.3091 14.8478 11.3091 14.5929 11.443L13.702 11.9113C13.4072 12.0662 13.05 12.0403 12.7806 11.8446C12.5112 11.6488 12.3763 11.3171 12.4326 10.9889L12.6027 9.99723C12.6514 9.71349 12.5573 9.42396 12.3512 9.22294L11.6303 8.51978C11.392 8.28726 11.3063 7.93962 11.4092 7.62295C11.5122 7.30629 11.7859 7.0755 12.1154 7.02757L13.1113 6.88282C13.3963 6.8414 13.6427 6.66235 13.7701 6.40404L14.2153 5.50156ZM15.8673 15.2637H11C9.34315 15.2637 8 13.9205 8 12.2637V5.26367C8 3.60682 9.34315 2.26367 11 2.26367H19C20.6569 2.26367 22 3.60682 22 5.26367V12.2637C22 13.9205 20.6569 15.2637 19 15.2637V16.7627C19 16.9557 18.8889 17.1315 18.7146 17.2143C18.5403 17.2971 18.3339 17.2723 18.1843 17.1504L15.8673 15.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "rewards-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M12 3C12 7.97301 16.0279 12.0009 21.0009 12.0009C21.0009 7.02791 16.973 3 12 3Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M21.0009 12C16.0279 12 12 16.0279 12 21.0009C16.973 21.0009 21.0009 16.973 21.0009 12Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M3 12C3 16.973 7.02791 21.0009 12.0009 21.0009C12.0009 16.0279 7.973 12 3 12Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M12.0009 3C7.02791 3 3 7.02791 3 12.0009C7.973 12.0009 12.0009 7.97301 12.0009 3Z", stroke: "currentColor" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "rocket-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.1287 12.6429V22.6414M9.04009 18.4737L6.01297 20.344C5.67992 20.5498 5.25071 20.3101 5.25 19.9191L5.25 16.0243C5.25 15.7627 5.35253 15.5103 5.53709 15.3229L7.71356 13.1082M7.9667 7.83037C10.7152 7.31065 13.5422 7.31065 16.2908 7.83037M15.2167 18.4744L18.2438 20.3447C18.5768 20.5505 19.0061 20.3108 19.0068 19.9198V16.025C19.0068 15.7634 18.9042 15.511 18.7197 15.3236L16.5432 13.1089M15.561 6.26201L13.3831 2.94143C12.7906 2.03775 11.4669 2.03775 10.8743 2.94143L8.69644 6.26201C8.05509 7.23994 7.71356 8.38333 7.71427 9.55217L7.71356 14.0628C7.71356 15.7839 8.26935 17.4597 9.29677 18.8407L9.34061 18.9001C9.99751 19.7805 11.0306 20.2988 12.1287 20.2995C13.2262 20.2995 14.26 19.7805 14.9161 18.8994L14.96 18.84C15.9881 17.4598 16.5432 15.7832 16.5432 14.0621V9.55217C16.5439 8.38333 16.2024 7.23994 15.561 6.26201Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 32 32", id: "rocket_assist-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.57438 11.8322C3.41551 7.98806 7.73147 3.66172 11.5773 5.79816C12.628 1.08075 19.3867 1.08552 20.4259 5.81244C24.2799 3.64151 28.6221 7.98372 26.4512 11.8378C31.1782 12.8769 31.1829 19.6357 26.4655 20.6864C28.6019 24.5322 24.2756 28.8481 20.4315 26.6893C19.4093 31.4504 12.6054 31.4551 11.5716 26.7036C7.7358 28.8279 3.43575 24.5279 5.56007 20.692C0.808547 19.6582 0.813315 12.8544 5.57438 11.8322ZM11.2211 7.5356C11.2449 7.4192 11.1955 7.30003 11.0964 7.23456C8.41135 5.46143 5.22648 8.6463 6.99961 11.3313C7.07311 11.4426 7.2069 11.498 7.33757 11.4713L8.59478 11.2142C9.78092 10.9715 10.7079 10.0446 10.9505 8.85846L11.2211 7.5356ZM6.59642 19.095C6.50265 19.237 6.33195 19.3077 6.16523 19.2736L5.92839 19.2251C2.70571 18.5659 2.70571 13.9614 5.9284 13.3022L6.18196 13.2504C6.34868 13.2163 6.51938 13.287 6.61315 13.429L7.39962 14.6199C8.05223 15.6081 8.05223 16.8904 7.39962 17.8787L6.59642 19.095ZM8.00206 19.6493L8.6333 18.6934C9.61222 17.211 9.61222 15.2876 8.6333 13.8052L8.01879 12.8746L8.89766 12.6949C10.6769 12.3309 12.0673 10.9405 12.4312 9.16133L12.6196 8.24044L13.5703 8.86825C15.0526 9.84717 16.9761 9.84717 18.4584 8.86825L19.3838 8.25713L19.5688 9.16133C19.9327 10.9405 21.3231 12.3309 23.1023 12.6949L24.0065 12.8798L23.3954 13.8052C22.4165 15.2876 22.4165 17.211 23.3954 18.6934L24.0232 19.6441L23.1023 19.8325C21.3231 20.1964 19.9327 21.5868 19.5688 23.366L19.389 24.2449L18.4584 23.6303C16.9761 22.6514 15.0526 22.6514 13.5703 23.6303L12.6144 24.2616L12.4312 23.366C12.0673 21.5868 10.6769 20.1964 8.89766 19.8325L8.00206 19.6493ZM7.2911 21.0465C7.1784 21.0235 7.063 21.0713 6.99961 21.1673C5.22648 23.8523 8.41135 27.0372 11.0964 25.264C11.1924 25.2006 11.2402 25.0852 11.2171 24.9725L10.9505 23.6689C10.7079 22.4828 9.78092 21.5558 8.59478 21.3132L7.2911 21.0465ZM13.1687 25.6672C13.0267 25.761 12.956 25.9317 12.9901 26.0984L13.0386 26.3353C13.6977 29.558 18.3023 29.558 18.9614 26.3353L19.0133 26.0817C19.0474 25.915 18.9767 25.7443 18.8347 25.6505L17.6437 24.864C16.6555 24.2114 15.3732 24.2114 14.385 24.864L13.1687 25.6672ZM20.7924 24.9261C20.7656 25.0568 20.821 25.1905 20.9323 25.264C23.6173 27.0372 26.8022 23.8523 25.0291 21.1673C24.9636 21.0682 24.8445 21.0188 24.7281 21.0426L23.4052 21.3132C22.2191 21.5558 21.2921 22.4828 21.0495 23.6689L20.7924 24.9261ZM25.4289 19.0898C25.5226 19.2318 25.6933 19.3025 25.86 19.2684L26.0716 19.2251C29.2943 18.5659 29.2943 13.9614 26.0716 13.3022L25.8433 13.2555C25.6766 13.2214 25.5059 13.2921 25.4121 13.4341L24.6291 14.6199C23.9765 15.6081 23.9765 16.8904 24.6291 17.8787L25.4289 19.0898ZM24.6816 11.4752C24.816 11.5027 24.9535 11.4457 25.0291 11.3313C26.8022 8.6463 23.6173 5.46143 20.9323 7.23456C20.8179 7.31011 20.7609 7.44764 20.7884 7.58197L21.0495 8.85846C21.2921 10.0446 22.2191 10.9715 23.4052 11.2142L24.6816 11.4752ZM18.8295 6.8515C18.9715 6.75773 19.0422 6.58703 19.0081 6.42031L18.9614 6.19207C18.3023 2.96938 13.6977 2.96938 13.0386 6.19207L12.9953 6.40362C12.9612 6.57034 13.0319 6.74104 13.1739 6.83481L14.385 7.63457C15.3732 8.28718 16.6555 8.28718 17.6437 7.63457L18.8295 6.8515Z", fill: "currentColor" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "rocket_launch-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16.2554 13.2678V17.6517C16.2554 18.0306 16.0413 18.377 15.7024 18.5465L13.2855 19.755C13.0261 19.8847 12.7232 19.8954 12.4552 19.7844C12.1873 19.6734 11.9807 19.4516 11.889 19.1765L11.2533 17.2695M7.25167 13.2678L5.34471 12.6322C5.06958 12.5405 4.84779 12.3339 4.73681 12.066C4.62583 11.798 4.63658 11.4951 4.76627 11.2357L5.97477 8.81878C6.14423 8.47987 6.4906 8.26575 6.86951 8.26575H11.2533M17.3515 12.3909L11.9525 16.7101C11.5545 17.0286 10.9806 16.9968 10.6202 16.6364L7.88482 13.901C7.52437 13.5405 7.49258 12.9667 7.81103 12.5686L12.1302 7.16964C14.1053 4.70083 17.0955 3.26367 20.2571 3.26367C20.8096 3.26367 21.2575 3.71157 21.2575 4.26409C21.2575 7.4257 19.8203 10.4159 17.3515 12.3909ZM6.00125 20.8578L3.25 21.2712L3.66332 18.5199C3.7974 17.6274 4.49802 16.9268 5.39053 16.7927C6.03548 16.6958 6.68815 16.9107 7.14932 17.3719C7.61049 17.8331 7.82542 18.4857 7.72851 19.1307C7.5944 20.0232 6.89376 20.7238 6.00125 20.8578Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "roofing-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19.471 12.8784V7.26409C19.471 6.71157 19.0231 6.26367 18.4705 6.26367H16.6128C16.0603 6.26367 15.6124 6.71157 15.6124 7.26409V9.57105M2.75 13.9809L10.4532 7.37813C11.202 6.73769 12.3055 6.73769 13.0543 7.37813L20.7575 13.9809M10.229 17.0952V17.6961C10.229 18.2505 10.6911 18.7125 11.2455 18.7125H12.262C12.8164 18.7125 13.2784 18.2505 13.2784 17.6961L13.2784 17.0952M13.2784 17.2522L13.2785 16.135C13.2785 15.5805 12.8164 15.1185 12.262 15.1185H11.2455C10.6911 15.1185 10.2291 15.5805 10.2291 16.135L10.229 17.2522", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "rotate_90_degrees_ccw-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14 2L11 5M11 5L14 8M11 5H17C19.209 5 21 6.791 21 9V13M3 13V20C3 21.105 3.895 22 5 22H12C13.105 22 14 21.105 14 20V13C14 11.895 13.105 11 12 11H5C3.895 11 3 11.895 3 13Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "rotate_90_degrees_cw-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10 2L13 5M13 5L10 8M13 5L7 5C4.791 5 3 6.791 3 9L3 13M21 13V20C21 21.105 20.105 22 19 22H12C10.895 22 10 21.105 10 20L10 13C10 11.895 10.895 11 12 11L19 11C20.105 11 21 11.895 21 13Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "route-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8 6.51368L14.757 6.50068C16.42 6.49768 17.769 7.84868 17.762 9.51168V9.52568C17.755 11.1777 16.414 12.5137 14.763 12.5137H9.749C8.093 12.5137 6.75 13.8567 6.75 15.5127C6.75 17.1697 8.094 18.5127 9.751 18.5117L19.75 18.5087M19.75 18.5087L17.7531 20.5057M19.75 18.5087L17.7531 16.5107M7.34099 4.92268C8.21967 5.80136 8.21967 7.22598 7.34099 8.10466C6.46231 8.98334 5.03769 8.98334 4.15901 8.10466C3.28033 7.22598 3.28033 5.80136 4.15901 4.92268C5.03769 4.044 6.46231 4.044 7.34099 4.92268Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "saved_search-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.99555 4.3516C6.27809 4.91792 3.6574 8.29934 4.03641 12.0405C4.41542 15.7817 7.66102 18.5689 11.4165 18.3781C15.172 18.1874 18.1186 15.0858 18.1166 11.3254M19.9997 20.2703L16.048 16.3186M15.416 4.79689L15.5983 4.98203L15.7965 4.78427C16.1329 4.44977 16.5886 4.26293 17.0629 4.265C17.5373 4.26706 17.9914 4.45786 18.3248 4.79527C19.024 5.51365 19.024 6.6582 18.3248 7.37657L16.6525 9.0744C16.3744 9.35682 15.9946 9.51586 15.5983 9.51586C15.2019 9.51586 14.8221 9.35682 14.5441 9.0744L12.8704 7.37537C12.1719 6.65771 12.1719 5.5143 12.8704 4.79664C13.2062 4.45563 13.6647 4.26367 14.1433 4.26367C14.6218 4.26367 15.0803 4.45582 15.416 4.79689Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "savings-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.78815 8.26367C2.17027 8.61928 1.86898 9.34611 2.05405 10.0346C2.23913 10.723 2.86425 11.2008 3.57715 11.1987H4.50015M17.5037 10.2602V10.2672H17.4966V10.2602H17.5037ZM19.0002 4.26367V6.81767C19.7281 7.46694 20.2863 8.28433 20.6262 9.19867H21.5002C22.0524 9.19887 22.5 9.64647 22.5002 10.1987V13.2637C22.5 13.8159 22.0524 14.2635 21.5002 14.2637H20.1892C19.6625 15.172 18.908 15.9272 18.0002 16.4547V18.2637C18 18.8159 17.5524 19.2635 17.0002 19.2637H15.0002C14.4479 19.2635 14.0003 18.8159 14.0002 18.2637V17.2637H10.5002V18.1317C10.5 18.6839 10.0524 19.1315 9.50015 19.1317H7.50015C6.94795 19.1315 6.50035 18.6839 6.50015 18.1317V15.7268C4.64586 14.0698 4.00732 11.4399 4.89532 9.11713C5.78332 6.79432 8.01339 5.26109 10.5002 5.26367H15.0266C15.4553 5.26334 15.8722 5.12321 16.2141 4.86453C16.7278 4.47452 17.3551 4.26348 18.0002 4.26367H19.0002Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "scatter_plot-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M14.3125 6.31055C14.3125 7.99329 12.9484 9.35742 11.2656 9.35742C9.58288 9.35742 8.21875 7.99329 8.21875 6.31055C8.21875 4.6278 9.58288 3.26367 11.2656 3.26367C12.9484 3.26367 14.3125 4.6278 14.3125 6.31055Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M10.3438 14.3105C10.3438 15.9933 8.97962 17.3574 7.29688 17.3574C5.61413 17.3574 4.25 15.9933 4.25 14.3105C4.25 12.6278 5.61413 11.2637 7.29688 11.2637C8.97962 11.2637 10.3438 12.6278 10.3438 14.3105Z", stroke: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M19.9375 17.873C19.9375 19.5558 18.5734 20.9199 16.8906 20.9199C15.2079 20.9199 13.8438 19.5558 13.8438 17.873C13.8438 16.1903 15.2079 14.8262 16.8906 14.8262C18.5734 14.8262 19.9375 16.1903 19.9375 17.873Z", stroke: "currentColor" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "school-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5.6855 11.9634V15.8874C5.6855 16.8364 6.1605 17.7214 6.9495 18.2464L8.5565 19.3154C10.4575 20.5794 12.9315 20.5794 14.8315 19.3154L16.4385 18.2464C17.2285 17.7214 17.7025 16.8354 17.7025 15.8874V11.9634M9.3975 3.85842L3.2235 7.28842C1.9255 8.00942 1.9255 9.87542 3.2235 10.5964L9.3975 14.0264C10.8255 14.8194 12.5625 14.8194 13.9915 14.0264L20.1655 10.5964C21.4635 9.87542 21.4635 8.00942 20.1655 7.28842L13.9915 3.85842C12.5625 3.06542 10.8265 3.06542 9.3975 3.85842Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "school_house-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M10.5 20.7498V17.2498C10.5 16.4214 11.1716 15.7498 12 15.7498C12.8284 15.7498 13.5 16.4214 13.5 17.2498V20.7498M7 20.7498V11.2498C7 10.5675 7.34804 9.93226 7.923 9.56482L10.923 7.64782C11.5797 7.22815 12.4203 7.22815 13.077 7.64782L16.077 9.56482C16.652 9.93226 17 10.5675 17 11.2498V20.7498M12 5.24982H16V2.74982H12L12.0002 7.33282M17 14.205H19.0008M17 17.205H19.0008M5 14.205H7.00083M5 17.205H7.00083M2 20.75H22M3 20.7498V11.7498C3 11.1975 3.44772 10.7498 4 10.7498H7M21 20.7498V11.7498C21 11.1975 20.5523 10.7498 20 10.7498H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M12.0002 11.0829C11.908 11.0835 11.8337 11.1585 11.8341 11.2506C11.8345 11.3428 11.9094 11.4172 12.0015 11.417C12.0937 11.4169 12.1683 11.3421 12.1683 11.25C12.1685 11.2054 12.1509 11.1626 12.1193 11.1312C12.0877 11.0998 12.0447 11.0824 12.0002 11.0829", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "search-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M20.0068 20.2703L16.0552 16.3187M18.1239 11.3256C18.1239 15.2258 14.9621 18.3876 11.0619 18.3876C7.16174 18.3876 4 15.2258 4 11.3256C4 7.42541 7.16174 4.26367 11.0619 4.26367C14.9621 4.26367 18.1239 7.42541 18.1239 11.3256Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "security-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.0932 3.26367V21.2637M19.6864 11.5057C19.6864 15.8737 16.69 19.9677 12.5868 21.1917C12.266 21.2877 11.9205 21.2877 11.5997 21.1917C7.49647 19.9687 4.5 15.8737 4.5 11.5057V7.47767C4.5 6.66567 4.96603 5.93367 5.6798 5.62667L10.2965 3.63667C11.4487 3.13967 12.7396 3.13967 13.8909 3.63667L18.5076 5.62667C19.2204 5.93367 19.6864 6.66567 19.6864 7.47767V11.5057Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "send-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12.0764 9.03017L8.07642 11.212M8.07642 11.212L9.61264 18.1927C9.78909 18.9942 10.4374 19.6066 11.2477 19.7372C12.058 19.8678 12.8658 19.49 13.2852 18.7845L20.7124 6.28541C21.0798 5.66729 21.087 4.89956 20.7314 4.2746C20.3758 3.64965 19.7121 3.26367 18.9931 3.26367H5.00011C4.19291 3.26365 3.46483 3.74886 3.15414 4.49387C2.84345 5.23888 3.01107 6.09763 3.57911 6.67112L8.07642 11.212Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "sentiment_dissatisfied-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.75 9.26367V10.2637M15.75 9.26367V10.2637M8.75 16.2637C8.75 16.2637 10.063 14.9517 12.25 14.9517C14.438 14.9517 15.75 16.2637 15.75 16.2637M18.6139 5.89971C22.1287 9.41443 22.1287 15.1129 18.6139 18.6276C15.0992 22.1423 9.40074 22.1423 5.88604 18.6276C2.37132 15.1129 2.37132 9.41441 5.88604 5.89971C9.40076 2.38499 15.0992 2.38499 18.6139 5.89971Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "sentiment_neutral-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M9.25 15.2637H15.25M21.25 12.2637C21.25 7.30167 17.212 3.26367 12.25 3.26367C7.287 3.26367 3.25 7.30067 3.25 12.2637C3.25 17.2267 7.287 21.2637 12.25 21.2637C17.213 21.2637 21.25 17.2257 21.25 12.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M8.26 9.26367L8.255 9.26867L8.25 9.26367M15.0974 9.26367L15.0924 9.26867L15.0874 9.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "sentiment_satisfied_alt-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.75 14.9517C15.75 14.9517 14.437 16.2637 12.25 16.2637C10.062 16.2637 8.75 14.9517 8.75 14.9517M8.87549 8.78915V9.78915M15.8755 8.78915V9.78915M18.6139 5.89971C22.1287 9.41443 22.1287 15.1129 18.6139 18.6276C15.0992 22.1423 9.40074 22.1423 5.88604 18.6276C2.37132 15.1129 2.37132 9.41441 5.88604 5.89971C9.40076 2.38499 15.0992 2.38499 18.6139 5.89971Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "sentiment_very_dissatisfied-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.75 16.2637C8.75 16.2637 10.063 14.9517 12.25 14.9517C14.438 14.9517 15.75 16.2637 15.75 16.2637M7.25 10.2637C7.645 9.77867 8.185 9.50367 8.75 9.50367C9.315 9.50367 9.84 9.77867 10.25 10.2637M14.25 10.2637C14.645 9.77867 15.185 9.50367 15.75 9.50367C16.315 9.50367 16.84 9.77867 17.25 10.2637M18.6139 5.89971C22.1287 9.41443 22.1287 15.1129 18.6139 18.6276C15.0992 22.1423 9.40074 22.1423 5.88604 18.6276C2.37132 15.1129 2.37132 9.41441 5.88604 5.89971C9.40076 2.38499 15.0992 2.38499 18.6139 5.89971Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "sentiment_very_satisfied-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7.25 10.2637C7.645 9.77867 8.185 9.50367 8.75 9.50367C9.315 9.50367 9.84 9.77867 10.25 10.2637M14.25 10.2637C14.645 9.77867 15.185 9.50367 15.75 9.50367C16.315 9.50367 16.84 9.77867 17.25 10.2637M15.75 14.9517C15.75 14.9517 14.437 16.2637 12.25 16.2637C10.062 16.2637 8.75 14.9517 8.75 14.9517M18.6139 5.89971C22.1287 9.41443 22.1287 15.1129 18.6139 18.6276C15.0992 22.1423 9.40074 22.1423 5.88604 18.6276C2.37132 15.1129 2.37132 9.41441 5.88604 5.89971C9.40076 2.38499 15.0992 2.38499 18.6139 5.89971Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "settings-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M15.5 12.2637C15.5 14.1967 13.933 15.7637 12 15.7637C10.067 15.7637 8.5 14.1967 8.5 12.2637C8.5 10.3307 10.067 8.76367 12 8.76367C13.933 8.76367 15.5 10.3307 15.5 12.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5857 3.26367C11.2105 3.26367 10.8669 3.47362 10.6958 3.80743L9.47975 6.17923L6.94275 5.36199C6.58568 5.24696 6.19426 5.34145 5.929 5.60672L5.343 6.19272C5.07776 6.45798 4.98328 6.84938 5.0983 7.20643L5.91551 9.74343L3.54378 10.9594C3.20995 11.1306 2.99999 11.4742 3 11.8493V12.678C3 13.0532 3.20995 13.3968 3.54376 13.5679L5.91556 14.7839L5.09832 17.3209C4.98329 17.678 5.07779 18.0694 5.34308 18.3347L5.92908 18.9207C6.19433 19.1859 6.58573 19.2804 6.94279 19.1654L9.47973 18.3482L10.6957 20.7199C10.8669 21.0538 11.2105 21.2637 11.5856 21.2637H12.4144C12.7895 21.2637 13.1331 21.0537 13.3042 20.7199L14.5202 18.3481L17.0572 19.1654C17.4143 19.2804 17.8057 19.1859 18.0709 18.9206L18.6569 18.3346C18.9222 18.0694 19.0167 17.678 18.9017 17.3209L18.0845 14.7839L20.4562 13.5679C20.79 13.3968 21 13.0532 21 12.678V11.8493C21 11.4742 20.7901 11.1306 20.4562 10.9594L18.0844 9.74344L18.9017 7.20644C19.0167 6.84936 18.9222 6.45794 18.6569 6.19267L18.0709 5.60667C17.8057 5.34142 17.4143 5.24693 17.0572 5.36194L14.5203 6.17913L13.3043 3.8074C13.1331 3.47359 12.7895 3.26365 12.4144 3.26367H11.5857Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "shield-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14.0269 11.3884V10.0404C14.0269 9.19743 13.3429 8.51343 12.4999 8.51343C11.6569 8.51343 10.9729 9.19743 10.9729 10.0404V11.3884M14.25 11.3894H10.75C10.198 11.3894 9.75 11.8374 9.75 12.3894V14.5134C9.75 15.0654 10.198 15.5134 10.75 15.5134H14.25C14.802 15.5134 15.25 15.0654 15.25 14.5134V12.3894C15.25 11.8374 14.802 11.3894 14.25 11.3894ZM20.5 11.5054C20.5 15.8734 17.343 19.9674 13.02 21.1914C12.682 21.2874 12.318 21.2874 11.98 21.1914C7.657 19.9684 4.5 15.8734 4.5 11.5054V7.47742C4.5 6.66542 4.991 5.93342 5.743 5.62642L10.607 3.63642C11.821 3.13942 13.181 3.13942 14.394 3.63642L19.258 5.62642C20.009 5.93342 20.5 6.66542 20.5 7.47742V11.5054Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "shield_star-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.93 20.8862C6.31736 19.9637 2.99707 15.9136 2.99707 11.2096V8.00398C2.99707 5.24531 5.23341 3.00897 7.99208 3.00897H15.9841C18.7427 3.00897 20.9791 5.24531 20.9791 8.00398V11.2095C20.9791 15.9135 17.6589 19.9635 13.0463 20.8862C12.3479 21.0259 11.6285 21.0259 10.93 20.8862Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.38817 12.3886L8.31035 11.3129C8.04511 11.0482 7.95032 10.6573 8.06483 10.3005C8.17934 9.94369 8.48389 9.68098 8.85363 9.62006L10.2766 9.3856L11.1305 7.78382C11.304 7.45816 11.643 7.25471 12.0121 7.25471C12.3811 7.25471 12.7201 7.45816 12.8936 7.78382L13.7475 9.3856L15.1705 9.62008C15.5402 9.68101 15.8447 9.94372 15.9592 10.3005C16.0737 10.6573 15.979 11.0481 15.7138 11.3128L14.6359 12.3886L14.8949 14.0961C14.9506 14.4631 14.7981 14.8307 14.499 15.0507C14.2 15.2706 13.8036 15.3065 13.4699 15.144L12.0121 14.4343L10.5543 15.144C10.2205 15.3065 9.82414 15.2706 9.52507 15.0506C9.22601 14.8307 9.07356 14.4631 9.12921 14.0961L9.38817 12.3886Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "shopping_cart-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M18.6467 17.2637C17.6803 17.2637 16.8967 18.0472 16.8967 19.0137C16.8967 19.9802 17.6803 20.7637 18.6467 20.7637C19.6132 20.7637 20.3967 19.9802 20.3967 19.0137C20.3967 18.0472 19.6132 17.2637 18.6467 17.2637ZM18.6467 17.2637H7.0007C6.03448 17.2637 5.25109 16.4806 5.2507 15.5144C5.25015 15.0503 5.43411 14.605 5.76205 14.2766C6.08999 13.9483 6.53502 13.7637 6.9991 13.7637H18.6431C19.0954 13.7636 19.4911 13.4595 19.6077 13.0225L21.2154 7.02249C21.2958 6.7222 21.2321 6.40156 21.0428 6.15491C20.8535 5.90827 20.5603 5.76367 20.2495 5.76367H5.91987M8.063 13.7637L5.25 3.26367H3.25M10.0496 19.0137C10.0496 19.9802 9.2661 20.7637 8.2996 20.7637C7.3331 20.7637 6.5496 19.9802 6.5496 19.0137C6.5496 18.0472 7.3331 17.2637 8.2996 17.2637C9.2661 17.2637 10.0496 18.0472 10.0496 19.0137Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "shower-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.75 8.26367C9.75 5.50267 11.989 3.26367 14.75 3.26367C17.511 3.26367 19.75 5.50267 19.75 8.26367V21.2637M9.75 20.2637V21.2637M9.75 17.2637V16.2637M15.75 19.9137L15.2 19.0837M12.99 15.7637L13.54 16.5937M6.51 15.7637L5.96 16.5937M4.3 19.0837L3.75 19.9137M12.166 13.0117H7.334C6.254 13.0117 5.491 11.9537 5.833 10.9287C6.363 9.33667 7.852 8.26367 9.53 8.26367H9.97C11.647 8.26367 13.137 9.33667 13.667 10.9287C14.009 11.9537 13.246 13.0117 12.166 13.0117Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "show_chart-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M18.25 10.3277L14.25 14.2637L10.25 11.2637L6.25 15.1997M5.25 3.26367H19.25C20.355 3.26367 21.25 4.15867 21.25 5.26367V19.2637C21.25 20.3687 20.355 21.2637 19.25 21.2637H5.25C4.145 21.2637 3.25 20.3687 3.25 19.2637V5.26367C3.25 4.15867 4.145 3.26367 5.25 3.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "shuffle-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19 18.9791L21 16.9791M21 16.9791L19 14.9791M21 16.9791L17.024 16.9961C16.381 16.9981 15.776 16.6921 15.398 16.1721L13.818 14.0001M10.182 9.00006L8.602 6.82806C8.224 6.30806 7.619 6.00206 6.976 6.00406L3 6.02106M19 8.00006L21 6.00006L19 4.00006M21 6.02106L17.024 6.00406C16.381 6.00106 15.776 6.30806 15.398 6.82806L8.602 16.1721C8.224 16.6921 7.619 16.9981 6.976 16.9961L3 16.9791", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "signature-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M13.5094 19H19.5094M3.53453 8.05078C3.1786 7.45535 2.99364 6.77335 2.99998 6.07968C2.85728 4.54411 3.96788 3.176 5.49998 3C8.2614 3 10.5 7.02944 10.5 12C10.5 16.9706 8.48527 21 5.99998 21H6.00204C4.62019 21 3.49998 19.2091 3.49998 17C3.50086 14.8774 4.3449 12.8421 5.84642 11.3418C7.34795 9.84149 9.38396 8.99913 11.5066 9H11.5C13.567 9.14749 15.129 10.9333 15 13.0016C14.9899 14.021 14.8209 15.0327 14.4989 16H14.5C16.2993 10.5865 18.0006 10 19.0004 10C19.5308 10.0001 20.0394 10.2108 20.4144 10.5859C20.7894 10.9609 21 11.4696 21 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "sort-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M4 17.2635H12M4 11.7636H16M4 6.26367H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "sort_by_alpha-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16.395 14.2637H20.606L16.395 19.2637H20.606M21 9.26367L18.5 4.26367L16 9.26367M16.419 8.42567H20.581M12 19.2637H3M12 14.2637H3M12 9.26367H3M12 4.26367H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "space_dashboard-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 8.01367C2.25 4.83803 4.82436 2.26367 8 2.26367H16C19.1756 2.26367 21.75 4.83803 21.75 8.01367V16.0137C21.75 19.1893 19.1756 21.7637 16 21.7637H8C4.82436 21.7637 2.25 19.1893 2.25 16.0137V8.01367ZM8 3.76367C5.65279 3.76367 3.75 5.66646 3.75 8.01367V16.0137C3.75 18.3609 5.65279 20.2637 8 20.2637H16C18.3472 20.2637 20.25 18.3609 20.25 16.0137V8.01367C20.25 5.66646 18.3472 3.76367 16 3.76367H8Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M3.13074 11.2637H20.75M11.9404 11.2637V20.8149", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "square_foot-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19.1691 16.8532L17.7563 18.266M14.755 15.2648L16.1678 13.852M8.7525 9.26229L10.1653 7.84946M11.7538 12.2635L13.1666 10.8507M5.75125 6.28743L7.17729 4.8614M7.60561 12.411L11.6063 16.4117C11.7493 16.5548 11.7921 16.7699 11.7147 16.9568C11.6373 17.1438 11.4549 17.2656 11.2525 17.2656H7.25187C6.97561 17.2656 6.75166 17.0417 6.75166 16.7654V12.7647C6.75166 12.5624 6.87352 12.38 7.06045 12.3026C7.24739 12.2251 7.46255 12.2679 7.60561 12.411ZM6.16569 3.84982L20.1675 17.8516C20.7397 18.4239 20.9109 19.2845 20.6012 20.0321C20.2915 20.7798 19.5619 21.2673 18.7527 21.2673H4.75083C3.6458 21.2673 2.75 20.3715 2.75 19.2664V5.26462C2.75 4.45533 3.23748 3.72572 3.98516 3.41603C4.73284 3.10633 5.59346 3.27754 6.16569 3.84982Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "stacks-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M6 6.26367H18M8 3.26367H16M17 21.2637V18.2637C17 17.7117 17.448 17.2637 18 17.2637H21M18.586 20.6777L20.414 18.8497C20.789 18.4747 21 17.9657 21 17.4357V11.2637C21 10.1587 20.105 9.26367 19 9.26367H5C3.895 9.26367 3 10.1587 3 11.2637V19.2637C3 20.3687 3.895 21.2637 5 21.2637H17.172C17.702 21.2637 18.211 21.0527 18.586 20.6777Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "stairs-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.75 20.2637H16.75M7.24999 15.2637L7.24989 9.52557M17.75 9.26366V2.34579M20.75 2.26367H18.3748C17.9679 2.26367 17.5708 2.38773 17.2363 2.61929L4.75 11.2637M20.75 19.2637V10.2637C20.75 9.71139 20.3023 9.26367 19.75 9.26367H15.75C15.1977 9.26367 14.75 9.71139 14.75 10.2637V12.2637H11.75C11.1977 12.2637 10.75 12.7114 10.75 13.2637V15.2637H5.75C5.19772 15.2637 4.75 15.7114 4.75 16.2637V19.2637C4.75 19.816 5.19772 20.2637 5.75 20.2637H19.75C20.3023 20.2637 20.75 19.816 20.75 19.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "star_shining-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M21.0327 9.06505L20.029 9.39118M3.97099 14.6088L2.96729 14.9348M12 21.5V20.4445M12 2.49997V3.55553M17.5784 19.678L16.9586 18.8249M6.42163 4.32194L7.0414 5.17507M2.96729 9.06505L3.97099 9.39118M21.0327 14.9349L20.029 14.6088M17.5784 4.32194L16.9586 5.17507M6.42163 19.678L7.0414 18.8249M11.0802 7.38858C11.2529 7.03839 11.6095 6.81666 12 6.81666C12.3905 6.81666 12.7471 7.03839 12.9199 7.38858L13.6702 8.90968C13.8196 9.21247 14.1084 9.42236 14.4425 9.47093L16.1208 9.71485C16.507 9.77099 16.828 10.0415 16.9487 10.4128C17.0693 10.784 16.9688 11.1915 16.6894 11.4641L15.4747 12.6488C15.2331 12.8845 15.1229 13.2239 15.18 13.5565L15.4667 15.2277C15.5326 15.6125 15.3745 16.0013 15.0587 16.2308C14.7429 16.4603 14.3242 16.4906 13.9786 16.309L12.4772 15.52C12.1785 15.363 11.8216 15.363 11.5228 15.52L10.0214 16.3091C9.67587 16.4907 9.25716 16.4604 8.94134 16.2309C8.62552 16.0014 8.46737 15.6125 8.53338 15.2278L8.82001 13.5565C8.87708 13.2239 8.76686 12.8845 8.52528 12.6488L7.31065 11.4641C7.0312 11.1915 6.9307 10.784 7.05137 10.4128C7.17205 10.0415 7.49299 9.77099 7.87928 9.71485L9.55751 9.47093C9.89163 9.42236 10.1805 9.21247 10.3298 8.90968L11.0802 7.38858Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "star_striker-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8 21H13C17.4183 21 21 17.4183 21 13M8 21C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V13M8 21H12C13.1046 21 14 20.1046 14 19V18C14 16.3431 15.3431 15 17 15H19C20.1046 15 21 14.1046 21 13M11.4185 15.6848L10.1458 16.3537C9.72465 16.5751 9.21434 16.5381 8.82944 16.2584C8.44453 15.9788 8.25179 15.5048 8.33225 15.0359L8.57525 13.6194C8.64478 13.214 8.51045 12.8004 8.216 12.5132L7.18624 11.5088C6.84567 11.1766 6.72318 10.6799 6.87025 10.2275C7.01732 9.77507 7.40845 9.44534 7.87924 9.37692L9.30178 9.17017C9.70898 9.11099 10.061 8.85519 10.243 8.48617L10.879 7.197C11.0895 6.7702 11.5241 6.49996 12 6.49996C12.4759 6.49996 12.9106 6.7702 13.1211 7.197L13.757 8.48615C13.939 8.85517 14.291 9.11097 14.6982 9.17015L16.1208 9.3769C16.5916 9.44532 16.9827 9.77505 17.1298 10.2275C17.2768 10.6799 17.1544 11.1766 16.8138 11.5088L15.784 12.5132", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "stay_current_portrait-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M10.75 6.26367H13.25M16 21.2637H8C6.895 21.2637 6 20.3687 6 19.2637V5.26367C6 4.15867 6.895 3.26367 8 3.26367H16C17.105 3.26367 18 4.15867 18 5.26367V19.2637C18 20.3687 17.105 21.2637 16 21.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M12.01 17.2637L12.005 17.2687L12 17.2637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "storefront-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.25 20.2637V14.2637H14.25V20.2637M19.75 20.2637V11.2127M3.75 20.2637V11.2127M21.75 20.2637H1.75M6.75 8.76367C6.75 10.1444 5.63071 11.2637 4.25 11.2637C2.86929 11.2637 1.75 10.1444 1.75 8.76367V7.59458C1.75001 7.44914 1.78175 7.30544 1.843 7.17352L3.58473 3.42152C3.91253 2.71542 4.62027 2.26368 5.39876 2.26367H18.1012C18.8798 2.26367 19.5875 2.71542 19.9153 3.42154L21.657 7.17343C21.7183 7.30536 21.75 7.44905 21.75 7.5945V8.76367C21.75 10.1444 20.6307 11.2637 19.25 11.2637C17.8693 11.2637 16.75 10.1444 16.75 8.76367C16.75 10.1444 15.6307 11.2637 14.25 11.2637C12.8693 11.2637 11.75 10.1444 11.75 8.76367C11.75 10.1444 10.6307 11.2637 9.25 11.2637C7.86929 11.2637 6.75 10.1444 6.75 8.76367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "street_parking-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M20 19V5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M6 19V5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20C5.55228 20 6 19.5523 6 19Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M13 7V5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V7C11 7.55228 11.4477 8 12 8C12.5523 8 13 7.55228 13 7Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M13 13V11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M13 19V17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19Z", fill: "currentColor" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "street_view-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M10.3032 21.2716L11.5037 20.0711M11.5037 20.0711L10.3032 18.8706M11.5037 20.0711C6.53065 20.0711 2.5 18.5034 2.5 16.5696C2.5 15.5352 3.66448 14.6118 5.50125 13.9725M17.5062 13.9725C19.343 14.6118 20.5075 15.5352 20.5075 16.5696C20.5075 18.0422 18.1665 19.3008 14.8551 19.818M12.7043 3.7643C12.7043 4.59307 12.0324 5.26492 11.2036 5.26492C10.3749 5.26492 9.703 4.59307 9.703 3.7643C9.703 2.93552 10.3749 2.26367 11.2036 2.26367C12.0324 2.26367 12.7043 2.93552 12.7043 3.7643ZM10.5033 16.2695H12.104C12.7042 16.2695 13.1044 15.8693 13.1044 15.2691V12.5179L14.1048 11.3174C14.2048 11.1174 14.3049 10.9173 14.3049 10.7172V8.51628C14.3049 7.91603 13.9047 7.51586 13.3045 7.51586H9.30278C8.70253 7.51586 8.30237 7.91603 8.30237 8.51628V10.7172C8.30237 10.9173 8.40241 11.1174 8.50245 11.3174L9.50287 12.5179V15.2691C9.50287 15.8693 9.90303 16.2695 10.5033 16.2695Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "summarize-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11 3.26408H7C4.79086 3.26408 3 5.05494 3 7.26408V17.2641C3 19.4732 4.79086 21.2641 7 21.2641H17C19.2091 21.2641 21 19.4732 21 17.2641V13.2641M7 12.2641H8.5M7 16.2641H17M7 8.26408H8.5M17.5 6.76408L12 12.2641M18.7475 10.3916C20.2149 8.87689 21.0245 6.84373 20.9999 4.73491C20.9932 3.92546 20.3386 3.27091 19.5292 3.26422C17.4203 3.2396 15.3872 4.04914 13.8724 5.51656C12.2553 7.13371 12.0357 9.53597 13.3819 10.8822C14.7281 12.2284 17.1304 12.0088 18.7475 10.3916Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "swap_horizontal-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14.6622 6.26367H17C19.2091 6.26367 21 8.05453 21 10.2637V17.2637C21 19.4728 19.2091 21.2637 17 21.2637H9.53876C9.20026 21.2637 8.88475 21.0924 8.7003 20.8086C8.51586 20.5247 8.48752 20.1669 8.625 19.8575L15.3751 4.66981C15.5126 4.36047 15.4842 4.00258 15.2998 3.71874C15.1153 3.4349 14.7998 3.26366 14.4612 3.26367H7C4.79086 3.26367 3 5.05453 3 7.26367V14.2637C3 16.4728 4.79086 18.2637 7 18.2637H9.345M15.5 13.7637L17 15.2637L15.5 16.7637M8.5 10.7637L7 9.26367L8.5 7.76367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "sync-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M19.988 12.2957C19.98 14.3327 19.207 16.3667 17.653 17.9207C14.529 21.0447 9.463 21.0447 6.339 17.9207C5.783 17.3647 5.331 16.7457 4.973 16.0897M4 12.1337C4.032 10.1297 4.81 8.13567 6.339 6.60667C9.463 3.48267 14.529 3.48267 17.653 6.60667C18.209 7.16267 18.661 7.78167 19.019 8.43767M15.949 8.43867H19.484V4.90267M8.043 16.0887H4.508V19.6247", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "sync_objects-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M21.0036 14.0009V19.0029C21.0036 20.1084 20.1082 21.0038 19.0028 21.0038H14.0007M2.99609 15.7516H9.99901L8.24828 14.0009M9.99901 19.253H2.99609L4.74682 21.0038M2.99609 9.99919L2.99609 4.99711C2.99609 3.89165 3.89147 2.99628 4.99693 2.99628L9.99901 2.99628M18.7807 6.10857L16.5577 8.3315L15.2232 6.99794M19.0028 10.9996H15.0011C13.8956 10.9996 13.0003 10.1042 13.0003 8.99878V4.99711C13.0003 3.89165 13.8956 2.99628 15.0011 2.99628H19.0028C20.1082 2.99628 21.0036 3.89165 21.0036 4.99711V8.99878C21.0036 10.1042 20.1082 10.9996 19.0028 10.9996Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "table-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5.90582 13.4417L5.13988 19.2072M5.90582 13.4417H18.3893M5.90582 13.4417L6.4031 9.69855M18.3893 13.4417L19.2616 19.2072M18.3893 13.4417L17.823 9.69855M4.25063 9.40096H19.9925C20.6593 9.40096 21.1393 8.76075 20.9524 8.12069L20.0364 4.9834C19.9119 4.55687 19.5209 4.26367 19.0765 4.26367H5.16824C4.72408 4.26367 4.33314 4.55664 4.20845 4.98295L3.29084 8.12023C3.1036 8.76039 3.58365 9.40096 4.25063 9.40096Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "table_chart-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3.25 9.26367H21.1546M15.8104 3.26367H6.25C4.59315 3.26367 3.25 4.60682 3.25 6.26367V18.2637C3.25 19.9205 4.59315 21.2637 6.25 21.2637H18.25C19.9069 21.2637 21.25 19.9205 21.25 18.2637V7.61597M3.25 15.2637H21.25M15.19 21.2637V3.27627M9.19 21.2637V3.26367M21.25 9.26367V5.26367C21.25 4.1591 20.3546 3.26367 19.25 3.26367H15.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "task-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8.00171 4.26451L9.30225 2.63883C9.49233 2.40173 9.77945 2.26367 10.0836 2.26367H13.9242C14.2283 2.26367 14.5154 2.40173 14.7055 2.63883L16.005 4.26451M8.00171 4.26451V5.26492C8.00171 5.81715 8.4499 6.26534 9.00213 6.26534H15.0046C15.5569 6.26534 16.005 5.81715 16.005 5.26492V4.26451M8.00171 4.26451L6.00083 4.26447C4.89537 4.26447 4 5.15984 4 6.2653V19.2707C4 20.3762 4.89537 21.2715 6.00083 21.2715H18.0058C19.1113 21.2715 20.0067 20.3762 20.0067 19.2707V6.2653C20.0067 5.15984 19.1113 4.26447 18.0058 4.26447L16.005 4.26451M14.0042 12.768L11.5031 15.269L10.0025 13.7684", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "thumbs_up_down-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M5.68623 9.89966L6.74069 10.7743C6.95915 10.9556 7.23442 11.0546 7.51843 11.0546H11.0627C11.469 11.0546 11.8266 10.7852 11.938 10.3941L12.715 7.67569C12.7885 7.41863 12.7448 7.14117 12.5963 6.91907L12.3487 6.54986C12.1797 6.29717 11.8957 6.14643 11.5921 6.14643H9.77226L9.77736 4.48755C9.781 3.25541 8.16217 2.79736 7.51988 3.8489L5.68623 6.85062M18.8138 14.6277L17.7593 13.7531C17.5408 13.5718 17.2656 13.4727 16.9816 13.4727H13.4373C13.031 13.4727 12.6734 13.7422 12.562 14.1332L11.785 16.8517C11.7115 17.1087 11.7552 17.3862 11.9037 17.6083L12.1513 17.9775C12.3203 18.2302 12.6043 18.3809 12.9079 18.3809H14.7277L14.7226 20.0398C14.719 21.2719 16.3378 21.73 16.9801 20.6784L18.8138 17.6767M5.14118 11.0546H3.79471C3.49395 11.0546 3.25 10.8107 3.25 10.5099V6.24037C3.25 5.93962 3.49395 5.69566 3.79471 5.69566H5.14118C5.44193 5.69566 5.68589 5.93962 5.68589 6.28115V10.5507C5.68589 10.8107 5.44193 11.0546 5.14118 11.0546ZM19.3588 13.4727H20.7053C21.006 13.4727 21.25 13.7167 21.25 14.0174V18.287C21.25 18.5877 21.006 18.8317 20.7053 18.8317H19.3588C19.0581 18.8317 18.8141 18.5877 18.8141 18.2462V13.9767C18.8141 13.7167 19.0581 13.4727 19.3588 13.4727Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "thumb_down-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.74861 14.7649V17.7375C9.74861 19.2335 10.6994 20.5641 12.1146 21.0487L12.5046 21.1823C12.8826 21.3118 13.2966 21.2851 13.6548 21.1082C14.013 20.9313 14.2858 20.6188 14.4128 20.24L16.2486 14.7637M16.2486 14.7637H19.8111C20.605 14.7637 21.2486 14.1201 21.2486 13.3262V4.70117C21.2486 3.90726 20.605 3.26367 19.8111 3.26367H6.56253C5.24328 3.26367 4.09333 4.16153 3.77337 5.44138L2.33587 11.1914C2.12115 12.0503 2.3141 12.9602 2.85894 13.658C3.40377 14.3558 4.23971 14.7637 5.12503 14.7637H9.74861M16.2486 14.7637L16.2485 3.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "thumb_up_off_alt-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M13.75 9.76201V6.78936C13.75 5.29341 12.7992 3.96284 11.384 3.47816L10.994 3.34459C10.616 3.21514 10.202 3.24183 9.84383 3.41873C9.48561 3.59563 9.21276 3.90812 9.08578 4.28692L7.25 9.76323M7.25 9.76323H3.6875C2.89359 9.76323 2.25 10.4068 2.25 11.2007V19.8257C2.25 20.6196 2.89359 21.2632 3.6875 21.2632H16.9361C18.2553 21.2632 19.4053 20.3654 19.7252 19.0855L21.1627 13.3355C21.3775 12.4766 21.1845 11.5667 20.6397 10.8689C20.0948 10.1711 19.2589 9.76323 18.3736 9.76323H13.75M7.25 9.76323V21.2632", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 51 50", id: "tiktok-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M0.100098 25C0.100098 11.1929 11.293 0 25.1001 0C38.9072 0 50.1001 11.1929 50.1001 25C50.1001 38.8071 38.9072 50 25.1001 50C11.293 50 0.100098 38.8071 0.100098 25Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.3224 29.6554C31.3283 34.7909 27.1846 38.9664 22.0492 38.9998C16.9139 39.0332 12.7162 34.9117 12.6555 29.7766C12.5947 24.6415 16.6936 20.422 21.8284 20.3338H21.9945V25.7785H21.9218C20.7305 25.7981 19.6137 26.3621 18.891 27.3093C18.1682 28.2565 17.919 29.4825 18.2146 30.6367C18.5425 31.9628 19.551 33.0143 20.8622 33.3971C22.0421 33.7483 23.3186 33.5221 24.306 32.7869C25.2934 32.0516 25.8759 30.8936 25.8777 29.6625H25.8835V11.7778C25.8835 11.3482 26.2317 11 26.6613 11H31.3282V11.2677C31.3283 14.4207 33.6885 17.0744 36.82 17.4424C37.2229 17.4744 37.5361 17.8063 37.5449 18.2104V22.2239C37.5473 22.4396 37.4596 22.6465 37.303 22.7948C37.1464 22.9431 36.9351 23.0194 36.7198 23.0053C34.77 22.8257 32.9059 22.118 31.3282 20.9582V29.6676L31.3224 29.6554Z", fill: "#F2F2F2" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "timeline-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M20.105 11.7707V19.7707M14.805 14.4407V19.7707M4.10499 16.7707V19.7707M9.40499 13.3707V19.7707M18.875 6.13068L16.145 8.40067M13.345 8.55068L10.855 6.88068M5.34499 9.30068L8.06499 7.03068M16.0444 8.27924C16.7278 8.96265 16.7278 10.0707 16.0444 10.7541C15.361 11.4375 14.2529 11.4375 13.5695 10.7541C12.8861 10.0707 12.8861 8.96265 13.5695 8.27924C14.2529 7.59582 15.361 7.59582 16.0444 8.27924ZM21.4474 3.77624C22.1308 4.45965 22.1308 5.5677 21.4474 6.25111C20.764 6.93452 19.6559 6.93452 18.9725 6.25111C18.2891 5.56769 18.2891 4.45965 18.9725 3.77624C19.6559 3.09282 20.764 3.09282 21.4474 3.77624ZM5.23743 9.17324C5.92085 9.85665 5.92085 10.9647 5.23743 11.6481C4.55402 12.3315 3.44597 12.3315 2.76256 11.6481C2.07915 10.9647 2.07915 9.85665 2.76256 9.17324C3.44598 8.48982 4.55402 8.48982 5.23743 9.17324ZM10.6414 4.67124C11.3248 5.35465 11.3248 6.4627 10.6414 7.14611C9.95798 7.82952 8.84993 7.82952 8.16652 7.14611C7.48311 6.46269 7.48311 5.35465 8.16652 4.67124C8.84994 3.98782 9.95798 3.98782 10.6414 4.67124Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "timer-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M17.657 7.343C20.781 10.467 20.781 15.533 17.657 18.657C14.533 21.781 9.467 21.781 6.343 18.657C3.219 15.533 3.219 10.467 6.343 7.343C9.467 4.219 14.533 4.219 17.657 7.343ZM17.657 7.343L20 5L19 4L21 6M12 9V13M10 2H14M12.5 12.998C12.5 12.722 12.276 12.499 12 12.5C11.724 12.501 11.5 12.725 11.5 13.001C11.5 13.277 11.723 13.5 11.999 13.5C12.275 13.5 12.499 13.275 12.5 12.998Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "timer_off-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.35258 2.26367H13.3526M17.0096 18.9207C13.8856 22.0447 8.81958 22.0447 5.69558 18.9207C2.57158 15.7967 2.57158 10.7307 5.69558 7.60667M8.39479 5.82824C11.2729 4.68511 14.6808 5.27792 17.0096 7.60667C19.3715 9.96864 19.9477 13.4407 18.738 16.3443M11.3526 5.26367V2.26367M13.303 11.3039L14.3528 10.2637M19.0126 5.60367L17.0126 7.60367M18.0126 4.60367L20.0126 6.60367M19 20.8888L3 4.8888M9.85258 13.2637C9.85258 14.0917 10.5246 14.7637 11.3526 14.7637C11.5965 14.7637 11.8268 14.7054 12.0305 14.6019L10.0778 12.4735C9.93496 12.703 9.85258 12.9738 9.85258 13.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "today-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M7 7.10767H17M12 16.2707L13.504 17.0607C13.797 17.2147 14.139 16.9657 14.083 16.6397L13.796 14.9647L15.013 13.7797C15.25 13.5487 15.119 13.1467 14.792 13.0987L13.11 12.8547L12.358 11.3297C12.212 11.0327 11.788 11.0327 11.642 11.3297L10.89 12.8547L9.208 13.0997C8.881 13.1467 8.75 13.5497 8.987 13.7807L10.204 14.9657L9.917 16.6407C9.861 16.9667 10.203 17.2157 10.496 17.0617L12 16.2707ZM19 3.26367H5C3.895 3.26367 3 4.15867 3 5.26367V19.1077C3 20.2127 3.895 21.1077 5 21.1077H19C20.105 21.1077 21 20.2127 21 19.1077V5.26367C21 4.15867 20.105 3.26367 19 3.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "tooltip-small", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12.9163 15.06C12.9163 14.95 12.8463 14.86 12.7363 14.86H12.315C12.205 14.86 12.135 14.77 12.135 14.61C12.135 14.3803 12.3691 13.3824 12.5684 12.5325C12.7163 11.9022 12.845 11.3533 12.845 11.2596C12.845 11.0996 12.745 10.9996 12.585 10.9996C12.525 10.9996 12.2211 11.001 11.9166 11.0435C11.7032 11.0685 11.624 11.0757 11.5693 11.0807C11.4928 11.0877 11.4644 11.0902 11.1846 11.131C10.9546 11.161 10.6722 11.2539 10.6722 11.4739C10.6722 11.6619 10.7808 11.7175 10.8933 11.775C11.0141 11.8368 11.1394 11.9009 11.1394 12.1339C11.1394 12.3477 11.0175 12.8415 10.887 13.37C10.7367 13.9787 10.575 14.6335 10.575 14.96C10.575 15.6 10.955 15.85 11.435 15.85C12.245 15.85 12.9163 15.38 12.9163 15.06ZM12.365 10.06C12.705 10.06 13.425 9.44 13.425 9.12C13.425 8.8 12.885 8.15 12.585 8.15C12.255 8.15 11.525 8.77 11.525 9.09C11.525 9.41 12.065 10.06 12.365 10.06Z", fill: "currentColor" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "townhouse-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M20.7579 20.2708V4.26409C20.7579 3.71157 20.31 3.26367 19.7575 3.26367H3.75084C3.19833 3.26367 2.75043 3.71157 2.75043 4.26409V20.2708M13.2548 20.2708V17.2695H10.2535V20.2708M9.75336 17.2695H13.755M1.75 20.2708H21.7583M9.75336 13.2678H13.755M20.7579 9.26618H16.6802M16.6802 9.26618L12.1924 6.57406C11.8755 6.38397 11.4797 6.38397 11.1629 6.57406L6.67606 9.26618M16.6802 9.26618L16.6802 20.2708M6.67606 9.26618H2.75043M6.67606 9.26618L6.67605 20.2708M11.6991 9.7778C11.4601 9.7788 11.2661 9.9728 11.2671 10.2118C11.2671 10.4508 11.4621 10.6448 11.7011 10.6438C11.9401 10.6438 12.1341 10.4498 12.1341 10.2108C12.1341 9.9718 11.9401 9.7778 11.7011 9.7778", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "trending_down-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.25 6.26367L8.31289 12.3266C8.78037 12.794 9.53718 12.794 10.0035 12.3266L12.5632 9.76678C13.0307 9.2993 13.7875 9.2993 14.2538 9.76678L21.3796 16.8914M21.3796 16.8914H18.1909M21.3796 16.8914L21.3796 13.7027", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "trending_up-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M2.25 16.8914L8.31289 10.8285C8.78037 10.361 9.53718 10.361 10.0035 10.8285L12.5632 13.3883C13.0307 13.8557 13.7875 13.8557 14.2538 13.3883L21.3796 6.26367M21.3796 6.26367H18.1909M21.3796 6.26367L21.3796 9.45234", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "unfold_less-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16 19.2637L12 15.2637L8 19.2637M8 5.26367L12 9.26367L16 5.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "unfold_more-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M8 15.2637L12 19.2637L16 15.2637M16 9.26367L12 5.26367L8 9.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "verified-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14.803 10.8657L11.302 14.3667L9.19897 12.2657M3.495 13.7287L4.69 15.2927L4.948 17.2397C5.091 18.3197 5.94 19.1697 7.02 19.3137L8.972 19.5747L10.535 20.7687C11.4 21.4297 12.599 21.4297 13.464 20.7687L15.028 19.5737H15.026L16.974 19.3157C18.054 19.1727 18.904 18.3237 19.048 17.2437L19.308 15.2917C19.308 15.2927 19.912 14.5017 20.503 13.7287C21.164 12.8637 21.163 11.6647 20.503 10.7997L19.31 9.23467L19.052 7.28767C18.909 6.20767 18.06 5.35767 16.98 5.21367L15.027 4.95367L13.464 3.75967C12.599 3.09867 11.4 3.09867 10.535 3.75967L8.971 4.95367H8.973L7.025 5.21267C5.945 5.35567 5.095 6.20467 4.951 7.28467L4.69 9.23667C4.69 9.23567 4.086 10.0267 3.495 10.7997C2.835 11.6637 2.835 12.8637 3.495 13.7287Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "verified_user-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14 10.7637L11.5 13.2637L10 11.7637M20.5 12.7552C20.5 16.9435 15.0329 20.0121 12.8678 21.0631C12.3202 21.3305 11.6798 21.3305 11.1322 21.0631C8.96714 20.0121 3.5 16.9435 3.5 12.7552V7.7012C3.49999 6.8675 4.01713 6.12125 4.79775 5.82851L11.2977 3.39101C11.7505 3.22122 12.2495 3.22122 12.7023 3.39101L19.2023 5.82851C19.9829 6.12124 20.5 6.86749 20.5 7.70117V12.7722", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "view_ar-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M16 21H18C19.6569 21 21 19.6569 21 18V16M16 3H18C19.6569 3 21 4.34315 21 6V8M3 16V18C3 19.6569 4.34315 21 6 21H8M3 8V6C3 4.34315 4.34315 3 6 3H8M16.8325 9.29L12.625 11.7193C12.2382 11.9425 11.7618 11.9425 11.375 11.7193L7.16747 9.29M12 17.5V11.8856M7 9.91505C7 9.46847 7.23825 9.05581 7.625 8.83252L11.375 6.66747C11.7618 6.44418 12.2382 6.44418 12.625 6.66747L16.375 8.83252C16.7618 9.05581 17 9.46847 17 9.91505V14.085C17 14.5316 16.7618 14.9442 16.375 15.1675L12.625 17.3325C12.2382 17.5558 11.7618 17.5558 11.375 17.3325L7.625 15.1675C7.23825 14.9442 7 14.5316 7 14.085V9.91505Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "visibility-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.6218 10.1437C15.7928 11.3147 15.7928 13.2157 14.6218 14.3887C13.4508 15.5597 11.5498 15.5597 10.3768 14.3887C9.20579 13.2177 9.20579 11.3167 10.3768 10.1437C11.5498 8.97067 13.4498 8.97067 14.6218 10.1437Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 12.2637C3.5 11.6047 3.652 10.9527 3.946 10.3517C5.461 7.25467 8.809 5.26367 12.5 5.26367C16.191 5.26367 19.539 7.25467 21.054 10.3517C21.348 10.9527 21.5 11.6047 21.5 12.2637C21.5 12.9227 21.348 13.5747 21.054 14.1757C19.539 17.2727 16.191 19.2637 12.5 19.2637C8.809 19.2637 5.461 17.2727 3.946 14.1757C3.652 13.5747 3.5 12.9227 3.5 12.2637Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "visibility_off-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.99575 18.7687C10.8148 19.0857 11.6578 19.2637 12.4998 19.2637C15.9948 19.2637 19.4898 16.2307 21.3818 12.7317C21.5388 12.4407 21.5388 12.0877 21.3818 11.7967C20.8838 10.8757 20.2698 9.99367 19.5788 9.18467M5.49975 19.2637L19.4998 5.26367M10.2728 14.4907C9.04275 13.2607 9.04275 11.2657 10.2728 10.0357C11.5028 8.80567 13.4978 8.80567 14.7278 10.0357M17.5437 7.21967C15.9967 6.02267 14.2478 5.26367 12.4998 5.26367C9.00475 5.26367 5.50975 8.29667 3.61775 11.7967C3.46075 12.0877 3.46075 12.4407 3.61775 12.7317C4.56375 14.4807 5.90975 16.1127 7.45575 17.3087", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "volume_up-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M15.287 16.3057C16.449 15.5837 17.25 14.0817 17.25 12.3327C17.25 10.5837 16.449 9.08067 15.287 8.34967M18.255 19.3927C20.063 17.8377 21.25 15.2577 21.25 12.3307C21.25 9.39967 20.061 6.81767 18.25 5.26367M5.625 8.95267H3.25C2.698 8.95267 2.25 9.40067 2.25 9.95267V14.7027C2.25 15.2547 2.698 15.7027 3.25 15.7027H5.625L9.604 19.0737C10.254 19.6247 11.25 19.1627 11.25 18.3107V6.34467C11.25 5.49267 10.253 5.03067 9.604 5.58167L5.625 8.95267Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "vpn_key-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14.63 8.64198C14.391 8.64298 14.197 8.83698 14.198 9.07598C14.198 9.31498 14.393 9.50898 14.632 9.50798C14.871 9.50798 15.065 9.31398 15.065 9.07498C15.065 8.83598 14.871 8.64198 14.632 8.64198M9.672 17.121V15.707H11.44L12.941 14.206L15.013 15.086C15.764 15.405 16.633 15.236 17.209 14.659L20.152 11.716C20.729 11.139 20.897 10.27 20.579 9.51998L19.077 5.98398C18.875 5.50698 18.495 5.12798 18.018 4.92498L14.482 3.42298C13.731 3.10398 12.863 3.27298 12.286 3.84998L9.343 6.79298C8.767 7.36898 8.598 8.23798 8.917 8.98898L9.774 11.008L3.75 17.032V20.214H6.932L8.258 18.888V17.12H9.672V17.121Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "warehouse-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M9.75 8.15267H13.75M11.75 18.8187V20.4857C11.75 20.8547 12.048 21.1527 12.416 21.1527H14.083C14.452 21.1527 14.75 20.8547 14.75 20.4867V18.8197C14.75 18.4507 14.452 18.1527 14.084 18.1527H12.417C12.048 18.1527 11.75 18.4507 11.75 18.8187ZM11.75 18.8187C11.75 18.4497 11.452 18.1527 11.084 18.1527H9.417C9.048 18.1527 8.75 18.4507 8.75 18.8187V20.4857C8.75 20.8547 9.048 21.1527 9.417 21.1527H11.083C11.452 21.1527 11.75 20.8547 11.75 20.4867V18.8187ZM20.75 21.1527H17.75V12.1527H5.75V21.1527H2.75V8.15267C2.75 7.42667 3.144 6.75667 3.778 6.40467L10.778 2.51567C11.382 2.17967 12.117 2.17967 12.721 2.51567L19.721 6.40467C20.356 6.75667 20.75 7.42667 20.75 8.15267V21.1527ZM12.583 18.1527H10.916C10.548 18.1527 10.249 17.8547 10.249 17.4857V15.8187C10.249 15.4507 10.547 15.1517 10.916 15.1517H12.583C12.951 15.1517 13.25 15.4497 13.25 15.8187V17.4857C13.25 17.8547 12.952 18.1527 12.583 18.1527Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "warning_amber-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M12.4371 13.5991V9.09912M10.7299 5.22142L3.29692 17.3854C2.48192 18.7184 3.44092 20.4284 5.00292 20.4284H19.8709C21.4329 20.4284 22.3919 18.7184 21.5779 17.3854L14.1439 5.22142C13.3639 3.94442 11.5099 3.94442 10.7299 5.22142Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntime.exports.jsx("path", { d: "M12.4739 16.0841C12.3819 16.0841 12.3069 16.1591 12.3079 16.2511C12.3079 16.3431 12.3829 16.4181 12.4749 16.4181C12.5669 16.4181 12.6419 16.3431 12.6419 16.2511C12.6419 16.1591 12.5669 16.0841 12.4739 16.0841", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "waves-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M18.4245 6.22223C17.1827 5.28165 15.5572 5.01357 14.0791 5.50562L10.1701 6.80812C8.69229 7.30061 7.06674 7.03313 5.8247 6.09308M19.9997 12.4733C18.4472 11.2978 16.4151 10.9632 14.5677 11.5787L9.68524 13.2072C7.83687 13.8242 5.80314 13.4894 4.25 12.3126M18.4245 18.6929C17.1827 17.7523 15.5572 17.4842 14.0791 17.9763L10.1701 19.2788C8.69229 19.7713 7.06674 19.5038 5.8247 18.5637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "wb_sunny-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M12 18.2637V20.7637M12 3.26367V5.76367M7.58 16.4337L5.81 18.2037M18.19 5.82367L16.42 7.59367M5.75 12.0137H3.25M20.75 12.0137H18.25M7.58 7.59367L5.81 5.82367M18.19 18.2037L16.42 16.4337M12 15.0137C13.6569 15.0137 15 13.6705 15 12.0137C15 10.3568 13.6569 9.01367 12 9.01367C10.3431 9.01367 9 10.3568 9 12.0137C9 13.6705 10.3431 15.0137 12 15.0137Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 24 24", id: "widgets-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.2537 14.0174C11.2537 12.4986 12.485 11.2674 14.0037 11.2674H19.0075C20.5263 11.2674 21.7575 12.4986 21.7575 14.0174V19.0212C21.7575 20.54 20.5263 21.7712 19.0075 21.7712H14.0037C12.485 21.7712 11.2537 20.54 11.2537 19.0212V14.0174ZM14.0037 12.7674C13.3134 12.7674 12.7537 13.3271 12.7537 14.0174V19.0212C12.7537 19.7115 13.3134 20.2712 14.0037 20.2712H19.0075C19.6979 20.2712 20.2575 19.7115 20.2575 19.0212V14.0174C20.2575 13.3271 19.6979 12.7674 19.0075 12.7674H14.0037Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 14.0174C2.25 12.4986 3.48122 11.2674 5 11.2674H10.0038C11.5225 11.2674 12.7537 12.4986 12.7537 14.0174V19.0212C12.7537 20.54 11.5225 21.7712 10.0037 21.7712H5C3.48122 21.7712 2.25 20.54 2.25 19.0212V14.0174ZM5 12.7674C4.30964 12.7674 3.75 13.3271 3.75 14.0174V19.0212C3.75 19.7115 4.30964 20.2712 5 20.2712H10.0037C10.6941 20.2712 11.2537 19.7115 11.2537 19.0212V14.0174C11.2537 13.3271 10.6941 12.7674 10.0038 12.7674H5Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.75187 5.01367C6.75187 3.49489 7.98309 2.26367 9.50187 2.26367H14.5056C16.0244 2.26367 17.2556 3.49489 17.2556 5.01367V10.0174C17.2556 11.5362 16.0244 12.7674 14.5056 12.7674H9.50187C7.98309 12.7674 6.75187 11.5362 6.75187 10.0174V5.01367ZM9.50187 3.76367C8.81152 3.76367 8.25187 4.32332 8.25187 5.01367V10.0174C8.25187 10.7078 8.81152 11.2674 9.50187 11.2674H14.5056C15.196 11.2674 15.7556 10.7078 15.7556 10.0174V5.01367C15.7556 4.32332 15.196 3.76367 14.5056 3.76367H9.50187Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M6.25 15.2637V14.5137C5.83579 14.5137 5.5 14.8495 5.5 15.2637H6.25ZM8.75104 15.2637H9.50104C9.50104 14.8495 9.16526 14.5137 8.75104 14.5137V15.2637ZM8.75104 17.7647V18.5147C9.16526 18.5147 9.50104 18.1789 9.50104 17.7647H8.75104ZM6.25 17.7647H5.5C5.5 18.1789 5.83579 18.5147 6.25 18.5147V17.7647ZM6.25 16.0137H8.75104V14.5137H6.25V16.0137ZM8.00104 15.2637V17.7647H9.50104V15.2637H8.00104ZM8.75104 17.0147H6.25V18.5147H8.75104V17.0147ZM7 17.7647V15.2637H5.5V17.7647H7Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M16.7091 17.4319C16.3181 17.4319 16 17.1138 16 16.7228H14.5C14.5 17.9422 15.4897 18.9319 16.7091 18.9319V17.4319ZM17.4182 16.7228C17.4182 17.1138 17.1001 17.4319 16.7091 17.4319V18.9319C17.9286 18.9319 18.9182 17.9422 18.9182 16.7228H17.4182ZM16.7091 16.0137C17.1001 16.0137 17.4182 16.3318 17.4182 16.7228H18.9182C18.9182 15.5033 17.9286 14.5137 16.7091 14.5137V16.0137ZM16.7091 14.5137C15.4897 14.5137 14.5 15.5033 14.5 16.7228H16C16 16.3318 16.3181 16.0137 16.7091 16.0137V14.5137Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.25 7.26367L12.0185 5.49517L13.787 7.26367L12.0185 9.03218L10.25 7.26367Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "wifi-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M11.655 19.5137C11.863 19.5137 12.031 19.6817 12.031 19.8887C12.031 20.0957 11.863 20.2637 11.656 20.2637C11.5884 20.2484 11.293 20.2188 11.293 19.8887C11.293 19.7344 11.375 19.5137 11.6328 19.5137M4.247 12.2637C8.339 8.51067 14.972 8.51067 19.064 12.2637M1.25 8.06767C6.997 2.99567 16.315 2.99567 22.062 8.06767M7.235 16.0847C9.676 13.6567 13.635 13.6567 16.076 16.0847", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "work_outline-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M3.25 9.26367V18.2637C3.25 19.3687 4.145 20.2637 5.25 20.2637H19.25C20.355 20.2637 21.25 19.3687 21.25 18.2637V9.26367M3.25 9.26367C3.25 8.15867 4.145 7.26367 5.25 7.26367H19.25C20.355 7.26367 21.25 8.15867 21.25 9.26367M3.25 9.26367L9.601 13.4547C9.928 13.6707 10.311 13.7857 10.703 13.7857H13.797C14.189 13.7857 14.572 13.6707 14.899 13.4547L21.25 9.26367M16.4239 7.26367V5.26367C16.4239 4.15867 15.5289 3.26367 14.4239 3.26367H10.0759C8.97093 3.26367 8.07593 4.15867 8.07593 5.26367V7.26367", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 51 50", id: "x-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M0.100098 25C0.100098 11.1929 11.293 0 25.1001 0C38.9072 0 50.1001 11.1929 50.1001 25C50.1001 38.8071 38.9072 50 25.1001 50C11.293 50 0.100098 38.8071 0.100098 25Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35.6758 11.8933C36.5349 11.8933 36.9941 12.9052 36.4284 13.5518L28.7004 22.3845C28.3882 22.7412 28.3695 23.2681 28.6554 23.6462L38.3807 36.5034C38.879 37.1621 38.4091 38.1067 37.5832 38.1067H31.1387C30.8273 38.1067 30.5336 37.9616 30.3444 37.7142L24.3778 29.9132C23.994 29.4114 23.247 29.3868 22.831 29.8621L15.9144 37.7652C15.7245 37.9822 15.4502 38.1067 15.1619 38.1067H13.3697C12.5106 38.1067 12.0514 37.0948 12.6171 36.4482L21.0185 26.8459C21.3319 26.4876 21.3494 25.9581 21.0602 25.58L11.8227 13.5008C11.3195 12.8428 11.7887 11.8933 12.6171 11.8933H19.272C19.5853 11.8933 19.8805 12.0402 20.0695 12.2901L25.3638 19.2896C25.7462 19.7952 26.4966 19.8219 26.914 19.3447L33.1338 12.2349C33.3237 12.0179 33.5981 11.8933 33.8865 11.8933H35.6758ZM18.954 15.3407C18.6184 14.902 17.9908 14.8184 17.5521 15.154C17.1135 15.4895 17.0298 16.1171 17.3654 16.5558L31.317 34.7958C31.6526 35.2344 32.2802 35.318 32.7189 34.9825C33.1575 34.647 33.2411 34.0193 32.9056 33.5807L18.954 15.3407Z", fill: "#F2F2F2" })] })), jsxRuntime.exports.jsxs("symbol", Object.assign({ viewBox: "0 0 51 50", id: "youtube-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("path", { d: "M0.100098 25C0.100098 11.1929 11.293 0 25.1001 0C38.9072 0 50.1001 11.1929 50.1001 25C50.1001 38.8071 38.9072 50 25.1001 50C11.293 50 0.100098 38.8071 0.100098 25Z", fill: "currentColor" }), jsxRuntime.exports.jsx("path", { d: "M23.1668 27.6757V22.3244L27.801 25.0001L23.1668 27.6757Z", fill: "#F2F2F2" }), jsxRuntime.exports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.4304 13.8423C37.6803 14.2367 38.6634 15.3851 38.9954 16.8409C39.6001 19.4828 39.6001 25 39.6001 25C39.6001 25 39.6001 30.5173 38.9954 33.1592C38.659 34.6208 37.6759 35.7692 36.4304 36.1578C34.1698 36.8639 25.1001 36.8639 25.1001 36.8639C25.1001 36.8639 16.0347 36.8639 13.7698 36.1578C12.5199 35.7634 11.5368 34.615 11.2047 33.1592C10.6001 30.5173 10.6001 25 10.6001 25C10.6001 25 10.6001 19.4828 11.2047 16.8409C11.5411 15.3793 12.5242 14.2309 13.7698 13.8423C16.0347 13.1361 25.1001 13.1361 25.1001 13.1361C25.1001 13.1361 34.1698 13.1361 36.4304 13.8423ZM22.6834 19.8129C22.3844 19.6402 22.0159 19.6402 21.7168 19.8129C21.4177 19.9856 21.2334 20.3047 21.2334 20.6501V29.3501C21.2334 29.6954 21.4177 30.0145 21.7168 30.1872C22.0159 30.3599 22.3844 30.3599 22.6834 30.1872L30.2176 25.8372C30.5167 25.6645 30.701 25.3454 30.701 25.0001C30.701 24.6547 30.5167 24.3356 30.2176 24.1629L22.6834 19.8129Z", fill: "#F2F2F2" })] })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "zoom_in-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14.1499 14.4907L19.9999 20.4207M8 10.4307H12M10 12.4307V8.43066M14.1931 6.01254C16.525 8.34436 16.525 12.125 14.1931 14.4568C11.8613 16.7886 8.08069 16.7886 5.74887 14.4568C3.41704 12.125 3.41704 8.34436 5.74887 6.01254C8.08069 3.68072 11.8613 3.68072 14.1931 6.01254Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) })), jsxRuntime.exports.jsx("symbol", Object.assign({ viewBox: "0 0 24 24", id: "zoom_out-default", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsxRuntime.exports.jsx("path", { d: "M14.1499 14.4907L19.9999 20.4207M8 10.4307H12M14.1931 6.01254C16.525 8.34436 16.525 12.125 14.1931 14.4568C11.8613 16.7886 8.08069 16.7886 5.74887 14.4568C3.41704 12.125 3.41704 8.34436 5.74887 6.01254C8.08069 3.68072 11.8613 3.68072 14.1931 6.01254Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }) }))] })));
};

const RadioIconDefault = () => {
    return (jsxRuntime.exports.jsx(SvgIcon$1, { children: jsxRuntime.exports.jsxs("svg", Object.assign({ fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("clipPath", Object.assign({ id: "a" }, { children: jsxRuntime.exports.jsx("path", { d: "m0 0h24v24h-24z" }) })), jsxRuntime.exports.jsx("g", Object.assign({ clipPath: "url(#a)" }, { children: jsxRuntime.exports.jsx("path", { d: "m12 23.25c-6.21321 0-11.25-5.0368-11.25-11.25 0-6.21321 5.03679-11.25 11.25-11.25 6.2132 0 11.25 5.03679 11.25 11.25 0 6.2132-5.0368 11.25-11.25 11.25z", stroke: "#949494", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5" }) }))] })) }));
};
const RadioIconChecked = () => {
    return (jsxRuntime.exports.jsx(SvgIcon$1, { children: jsxRuntime.exports.jsxs("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxRuntime.exports.jsx("rect", { width: "24", height: "24", rx: "12", fill: "#0A9142" }), jsxRuntime.exports.jsx("rect", { x: "5.25", y: "5.25", width: "13.5", height: "13.5", rx: "6.75", stroke: "white", strokeWidth: "1.5" })] })) }));
};

exports.CheckboxIcon = CheckboxIcon;
exports.CheckedIcon = CheckedIcon;
exports.IndeterminateIcon = IndeterminateIcon;
exports.RadioIconChecked = RadioIconChecked;
exports.RadioIconDefault = RadioIconDefault;
exports.RktBanner = RktBanner;
exports.RktIcon = RktIcon;
exports.RktIconSprite = RktIconSprite;
exports.RktMasthead = RktMasthead;
exports.RktSidenav = RktSidenav;
exports.RktSidenavIconMenu = RktSidenavIconMenu;
exports.RktSidenavIconMenuItem = RktSidenavIconMenuItem;
exports.RktStack = RktStack;
exports.RktStackItem = RktStackItem;
exports.RktTag = RktTag;
exports.RktThemeToggle = RktThemeToggle;
exports.RktToggle = RktToggle;
exports.rktAddDarkModeClass = rktAddDarkModeClass;
exports.rktAddLightModeClass = rktAddLightModeClass;
exports.rktAddPageLockClasses = rktAddPageLockClasses;
exports.rktDarkModeClassName = rktDarkModeClassName;
exports.rktFocusFirstEl = rktFocusFirstEl;
exports.rktFocusTrap = rktFocusTrap;
exports.rktGetFocusableEls = rktGetFocusableEls;
exports.rktIsScrolled = rktIsScrolled;
exports.rktLightModeClassName = rktLightModeClassName;
exports.rktRemoveDarkModeClass = rktRemoveDarkModeClass;
exports.rktRemoveLightModeClass = rktRemoveLightModeClass;
exports.rktRemovePageLockClasses = rktRemovePageLockClasses;
exports.rktTheme = rktTheme;
exports.rktToggleDarkModeClass = rktToggleDarkModeClass;
